import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export enum Aggregation {
  AvgDegree = 'AVG_DEGREE',
  Last = 'LAST',
  Avg = 'avg',
  Count = 'count',
  Max = 'max',
  Min = 'min',
  Sum = 'sum'
}

/** Alarms */
export type Alarms = {
  __typename?: 'ALARMS';
  /** Park identifier */
  PARK?: Maybe<Park>;
  /** Portfolio identifier */
  PORTFOLIO?: Maybe<Portfolio>;
  /** Turbine identifier */
  TURBINE?: Maybe<Turbine>;
  /** Alarm unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** Alarm category */
  alarmCategory?: Maybe<Scalars['Int']['output']>;
  /** Alarm duration in seconds */
  alarmCount?: Maybe<Scalars['Float']['output']>;
  /** Time when the alarm is closed in unix timestamp */
  closeTS?: Maybe<Scalars['Float']['output']>;
  /** Alarm code */
  code?: Maybe<Scalars['String']['output']>;
  /** Time when the alarm is created in unix timestamp */
  createTS?: Maybe<Scalars['Float']['output']>;
  /** Alarm description */
  description?: Maybe<Scalars['String']['output']>;
  /** Alarm duration in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Duration description */
  durationLong?: Maybe<Scalars['String']['output']>;
  /** Duration description */
  durationShort?: Maybe<Scalars['String']['output']>;
  /** 1 => Alarm is still open. 0 => Alarm is closed. */
  isOpen?: Maybe<Scalars['Int']['output']>;
  /** Power loss during the alarm */
  powerLosses?: Maybe<Scalars['Float']['output']>;
  /** Alarm duration in seconds */
  powerLossesAvg?: Maybe<Scalars['Float']['output']>;
  /** Alarm duration in seconds */
  powerLossesSum?: Maybe<Scalars['Float']['output']>;
  /** Tclass */
  tcu?: Maybe<Scalars['String']['output']>;
  /** Active Power during the alarm */
  totalActPower?: Maybe<Scalars['Float']['output']>;
  /** Revenue losses due to alarm */
  totalRevenueLoss?: Maybe<Scalars['Float']['output']>;
  /** Theoretical Power during the alarm */
  totalTheoPower?: Maybe<Scalars['Float']['output']>;
  /** Alarm turbine code */
  turbineCode?: Maybe<Scalars['String']['output']>;
};


/** Alarms */
export type Alarms_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Alarms */
export type AlarmsAlarmCategoryArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsAlarmCountArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsCloseTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsCodeArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Alarms */
export type AlarmsCreateTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsDescriptionArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Alarms */
export type AlarmsDurationArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsDurationLongArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Alarms */
export type AlarmsDurationShortArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Alarms */
export type AlarmsIsOpenArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsPowerLossesArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsPowerLossesAvgArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsPowerLossesSumArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsTcuArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Alarms */
export type AlarmsTotalActPowerArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsTotalRevenueLossArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsTotalTheoPowerArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Alarms */
export type AlarmsTurbineCodeArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};

/** Perform aggregations to the data */
export type AggregateInput = {
  aggregators?: InputMaybe<Array<Aggregator>>;
};

export type Aggregator = {
  align?: InputMaybe<Align>;
  name: Aggregation;
  sampling?: InputMaybe<Sampling>;
};

/** Array operators */
export type ArrayInput = {
  /** Check if the string is in the array */
  CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** Check if all the strings are in the array */
  CONTAINS_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Check if any of the strings are in the array */
  CONTAINS_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Budget Information */
export type Budget = {
  __typename?: 'BUDGET';
  /** Park identifier */
  _id_park?: Maybe<Scalars['String']['output']>;
  /** Time when budget was updated for the last time */
  lastUpdatedTs?: Maybe<Scalars['Float']['output']>;
  /** The last user that update the table */
  lastUpdatedUser?: Maybe<Scalars['String']['output']>;
  /** Month identifier */
  month?: Maybe<Scalars['Int']['output']>;
  /** Production Budget KWh */
  production?: Maybe<Scalars['Float']['output']>;
  /** Revenue identifier */
  revenue?: Maybe<Scalars['Float']['output']>;
  /** Year identifier */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Budget Information */
export type Budget_Id_ParkArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget Information */
export type BudgetLastUpdatedTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget Information */
export type BudgetLastUpdatedUserArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget Information */
export type BudgetMonthArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget Information */
export type BudgetProductionArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget Information */
export type BudgetRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget Information */
export type BudgetYearArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};

/** Budget */
export type Budget_By_Country = {
  __typename?: 'BUDGET_BY_COUNTRY';
  /** COUNTRY identifier */
  COUNTRY?: Maybe<Country>;
  /** Plant identifier */
  PARK?: Maybe<Park>;
  /** unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  commentText?: Maybe<Scalars['String']['output']>;
  /** day */
  day?: Maybe<Scalars['Int']['output']>;
  /** files */
  files?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  isInvoiceCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  isInvoiceDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  lastUpdatedTs?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  lastUpdatedUser?: Maybe<Scalars['String']['output']>;
  /** month */
  month?: Maybe<Scalars['Int']['output']>;
  /** production */
  production?: Maybe<Scalars['Float']['output']>;
  /** production accumulated */
  productionAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudget?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget year to  date */
  productionBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpected?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoretical?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue */
  revenue?: Maybe<Scalars['Float']['output']>;
  /** revenue accumulated */
  revenueAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudget?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpected?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoretical?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** Generic effective revenue when Revenues V2 is selected */
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  /** Generic effective accumulated revenue when Revenues V2 is selected */
  totalRevenueAcc?: Maybe<Scalars['Float']['output']>;
  /** year */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Budget */
export type Budget_By_Country_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_CountryCommentTextArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_CountryDayArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryFilesArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_CountryIsInvoiceCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryIsInvoiceDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryLastUpdatedTsArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_CountryLastUpdatedUserArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_CountryMonthArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryProductionTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryRevenueTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryTotalRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryTotalRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_CountryYearArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};

/** Budget */
export type Budget_By_Country_Month = {
  __typename?: 'BUDGET_BY_COUNTRY_MONTH';
  /** COUNTRY identifier */
  COUNTRY?: Maybe<Country>;
  /** Plant identifier */
  PARK?: Maybe<Park>;
  /** unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  commentText?: Maybe<Scalars['String']['output']>;
  /** day */
  day?: Maybe<Scalars['Int']['output']>;
  /** files */
  files?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  isInvoiceCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  isInvoiceDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  lastUpdatedTs?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  lastUpdatedUser?: Maybe<Scalars['String']['output']>;
  /** month */
  month?: Maybe<Scalars['Int']['output']>;
  /** production */
  production?: Maybe<Scalars['Float']['output']>;
  /** production accumulated */
  productionAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudget?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget year to  date */
  productionBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpected?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoretical?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue */
  revenue?: Maybe<Scalars['Float']['output']>;
  /** revenue accumulated */
  revenueAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudget?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpected?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoretical?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** Generic effective revenue when Revenues V2 is selected */
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  /** Generic effective accumulated revenue when Revenues V2 is selected */
  totalRevenueAcc?: Maybe<Scalars['Float']['output']>;
  /** year */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Budget */
export type Budget_By_Country_Month_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthCommentTextArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthDayArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthFilesArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthIsInvoiceCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthIsInvoiceDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthLastUpdatedTsArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthLastUpdatedUserArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthMonthArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthProductionTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthRevenueTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthTotalRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthTotalRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Country_MonthYearArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};

/** Budget */
export type Budget_By_Day = {
  __typename?: 'BUDGET_BY_DAY';
  /** COUNTRY identifier */
  COUNTRY?: Maybe<Country>;
  /** Plant identifier */
  PARK?: Maybe<Park>;
  /** unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  commentText?: Maybe<Scalars['String']['output']>;
  /** day */
  day?: Maybe<Scalars['Int']['output']>;
  /** files */
  files?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  isInvoiceCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  isInvoiceDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  lastUpdatedTs?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  lastUpdatedUser?: Maybe<Scalars['String']['output']>;
  /** month */
  month?: Maybe<Scalars['Int']['output']>;
  /** production */
  production?: Maybe<Scalars['Float']['output']>;
  /** production accumulated */
  productionAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudget?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget year to  date */
  productionBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpected?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoretical?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue */
  revenue?: Maybe<Scalars['Float']['output']>;
  /** revenue accumulated */
  revenueAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudget?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpected?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoretical?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** Generic effective revenue when Revenues V2 is selected */
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  /** Generic effective accumulated revenue when Revenues V2 is selected */
  totalRevenueAcc?: Maybe<Scalars['Float']['output']>;
  /** year */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Budget */
export type Budget_By_Day_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_DayCommentTextArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_DayDayArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayFilesArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_DayIsInvoiceCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayIsInvoiceDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayLastUpdatedTsArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_DayLastUpdatedUserArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_DayMonthArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayProductionTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayRevenueTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayTotalRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayTotalRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_DayYearArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};

/** Budget */
export type Budget_By_Month = {
  __typename?: 'BUDGET_BY_MONTH';
  /** COUNTRY identifier */
  COUNTRY?: Maybe<Country>;
  /** Plant identifier */
  PARK?: Maybe<Park>;
  /** unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  commentText?: Maybe<Scalars['String']['output']>;
  /** day */
  day?: Maybe<Scalars['Int']['output']>;
  /** files */
  files?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  isInvoiceCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  isInvoiceDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  lastUpdatedTs?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  lastUpdatedUser?: Maybe<Scalars['String']['output']>;
  /** month */
  month?: Maybe<Scalars['Int']['output']>;
  /** production */
  production?: Maybe<Scalars['Float']['output']>;
  /** production accumulated */
  productionAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudget?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget year to  date */
  productionBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpected?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoretical?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue */
  revenue?: Maybe<Scalars['Float']['output']>;
  /** revenue accumulated */
  revenueAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudget?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpected?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoretical?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** Generic effective revenue when Revenues V2 is selected */
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  /** Generic effective accumulated revenue when Revenues V2 is selected */
  totalRevenueAcc?: Maybe<Scalars['Float']['output']>;
  /** year */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Budget */
export type Budget_By_Month_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_MonthCommentTextArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_MonthDayArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthFilesArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_MonthIsInvoiceCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthIsInvoiceDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthLastUpdatedTsArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_MonthLastUpdatedUserArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_MonthMonthArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthProductionTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthRevenueTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthTotalRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthTotalRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_MonthYearArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};

/** Budget */
export type Budget_By_Park = {
  __typename?: 'BUDGET_BY_PARK';
  /** COUNTRY identifier */
  COUNTRY?: Maybe<Country>;
  /** Plant identifier */
  PARK?: Maybe<Park>;
  /** unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  commentText?: Maybe<Scalars['String']['output']>;
  /** day */
  day?: Maybe<Scalars['Int']['output']>;
  /** files */
  files?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  isInvoiceCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  isInvoiceDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  lastUpdatedTs?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  lastUpdatedUser?: Maybe<Scalars['String']['output']>;
  /** month */
  month?: Maybe<Scalars['Int']['output']>;
  /** production */
  production?: Maybe<Scalars['Float']['output']>;
  /** production accumulated */
  productionAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudget?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget year to  date */
  productionBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpected?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoretical?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue */
  revenue?: Maybe<Scalars['Float']['output']>;
  /** revenue accumulated */
  revenueAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudget?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpected?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoretical?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** Generic effective revenue when Revenues V2 is selected */
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  /** Generic effective accumulated revenue when Revenues V2 is selected */
  totalRevenueAcc?: Maybe<Scalars['Float']['output']>;
  /** year */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Budget */
export type Budget_By_Park_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_ParkCommentTextArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_ParkDayArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkFilesArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_ParkIsInvoiceCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkIsInvoiceDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkLastUpdatedTsArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_ParkLastUpdatedUserArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_ParkMonthArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkProductionTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkRevenueTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkTotalRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkTotalRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_ParkYearArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};

/** Budget */
export type Budget_By_Park_Month = {
  __typename?: 'BUDGET_BY_PARK_MONTH';
  /** COUNTRY identifier */
  COUNTRY?: Maybe<Country>;
  /** Plant identifier */
  PARK?: Maybe<Park>;
  /** unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  commentText?: Maybe<Scalars['String']['output']>;
  /** day */
  day?: Maybe<Scalars['Int']['output']>;
  /** files */
  files?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  isInvoiceCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  isInvoiceDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  lastUpdatedTs?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  lastUpdatedUser?: Maybe<Scalars['String']['output']>;
  /** month */
  month?: Maybe<Scalars['Int']['output']>;
  /** production */
  production?: Maybe<Scalars['Float']['output']>;
  /** production accumulated */
  productionAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudget?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget year to  date */
  productionBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpected?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoretical?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue */
  revenue?: Maybe<Scalars['Float']['output']>;
  /** revenue accumulated */
  revenueAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudget?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpected?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoretical?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** Generic effective revenue when Revenues V2 is selected */
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  /** Generic effective accumulated revenue when Revenues V2 is selected */
  totalRevenueAcc?: Maybe<Scalars['Float']['output']>;
  /** year */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Budget */
export type Budget_By_Park_Month_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthCommentTextArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthDayArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthFilesArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthIsInvoiceCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthIsInvoiceDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthLastUpdatedTsArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthLastUpdatedUserArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthMonthArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthProductionTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthRevenueTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthTotalRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthTotalRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_By_Park_MonthYearArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};

export type Budget_Summary = {
  __typename?: 'BUDGET_SUMMARY';
  byPark?: Maybe<Array<Maybe<Budget_Summary_By_Park>>>;
  total?: Maybe<Budget_Summary_Values>;
};

export type Budget_Summary_By_Park = {
  __typename?: 'BUDGET_SUMMARY_BY_PARK';
  _id_park?: Maybe<Scalars['String']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
  productionBudget?: Maybe<Scalars['Float']['output']>;
  productionTheoretical?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueBudget?: Maybe<Scalars['Float']['output']>;
  revenueTheoretical?: Maybe<Scalars['Float']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
  windSpeedBudget?: Maybe<Scalars['Float']['output']>;
};

export type Budget_Summary_Values = {
  __typename?: 'BUDGET_SUMMARY_VALUES';
  production?: Maybe<Scalars['Float']['output']>;
  productionBudget?: Maybe<Scalars['Float']['output']>;
  productionTheoretical?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueBudget?: Maybe<Scalars['Float']['output']>;
  revenueTheoretical?: Maybe<Scalars['Float']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
  windSpeedBudget?: Maybe<Scalars['Float']['output']>;
};

/** Budget */
export type Budget_Total = {
  __typename?: 'BUDGET_TOTAL';
  /** COUNTRY identifier */
  COUNTRY?: Maybe<Country>;
  /** Plant identifier */
  PARK?: Maybe<Park>;
  /** unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  commentText?: Maybe<Scalars['String']['output']>;
  /** day */
  day?: Maybe<Scalars['Int']['output']>;
  /** files */
  files?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  isInvoiceCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  isInvoiceDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  lastUpdatedTs?: Maybe<Scalars['String']['output']>;
  /** revenue budget year to  date */
  lastUpdatedUser?: Maybe<Scalars['String']['output']>;
  /** month */
  month?: Maybe<Scalars['Int']['output']>;
  /** production */
  production?: Maybe<Scalars['Float']['output']>;
  /** production accumulated */
  productionAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudget?: Maybe<Scalars['Float']['output']>;
  /** production budget */
  productionBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** production budget year to  date */
  productionBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpected?: Maybe<Scalars['Float']['output']>;
  /** production expected */
  productionExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  productionScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoretical?: Maybe<Scalars['Float']['output']>;
  /** production theoretical */
  productionTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue */
  revenue?: Maybe<Scalars['Float']['output']>;
  /** revenue accumulated */
  revenueAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudget?: Maybe<Scalars['Float']['output']>;
  /** revenue budget */
  revenueBudgetAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueBudgetYTD?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensated?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueCompensatedInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDelivered?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoiced?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueDeliveredInvoicedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpected?: Maybe<Scalars['Float']['output']>;
  /** revenue expected */
  revenueExpectedAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGrid?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueGridAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbook?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueLossLogbookAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScada?: Maybe<Scalars['Float']['output']>;
  /** revenue budget year to  date */
  revenueScadaAcc?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoretical?: Maybe<Scalars['Float']['output']>;
  /** revenue theoretical */
  revenueTheoreticalAcc?: Maybe<Scalars['Float']['output']>;
  /** Generic effective revenue when Revenues V2 is selected */
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  /** Generic effective accumulated revenue when Revenues V2 is selected */
  totalRevenueAcc?: Maybe<Scalars['Float']['output']>;
  /** year */
  year?: Maybe<Scalars['Int']['output']>;
};


/** Budget */
export type Budget_Total_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_TotalCommentTextArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_TotalDayArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalFilesArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_TotalIsInvoiceCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalIsInvoiceDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalLastUpdatedTsArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_TotalLastUpdatedUserArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Budget */
export type Budget_TotalMonthArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalProductionTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueBudgetArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueBudgetAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueBudgetYtdArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueCompensatedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueCompensatedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueCompensatedInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueCompensatedInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueDeliveredArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueDeliveredAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueDeliveredInvoicedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueDeliveredInvoicedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueExpectedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueExpectedAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueGridArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueGridAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueLossLogbookArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueLossLogbookAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueScadaArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueScadaAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueTheoreticalArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalRevenueTheoreticalAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalTotalRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalTotalRevenueAccArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Budget */
export type Budget_TotalYearArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};

export type BudgetSummaryRangeInput = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

/** Converter description */
export type Cnv_10M = {
  __typename?: 'CNV_10M';
  /** Measured temperature of the converter’s choke coil phase 2 */
  CnvTmpChokeCoil2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the converter’s choke coil phase 3 */
  CnvTmpChokeCoil3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the converter’s choke coil */
  CnvTmpChokeCoil_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter */
  CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature fo the converter’s cooling water */
  CnvTmpWater_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 2 */
  WCNV2_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 3 */
  WCNV3_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 4 */
  WCNV4_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 5 */
  WCNV5_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 6 */
  WCNV6_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 7 */
  WCNV7_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 8 */
  WCNV8_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 9 */
  WCNV9_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 10 */
  WCNV10_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 11 */
  WCNV11_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 12 */
  WCNV12_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 13 */
  WCNV13_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 14 */
  WCNV14_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
};


/** Converter description */
export type Cnv_10MCnvTmpChokeCoil2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MCnvTmpChokeCoil3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MCnvTmpChokeCoil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MCnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MCnvTmpWater_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv2_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv3_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv4_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv5_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv6_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv7_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv8_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv9_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv10_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv11_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv12_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv13_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_10MWcnv14_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Converter description */
export type Cnv_30S = {
  __typename?: 'CNV_30S';
  /** Measured temperature of the converter’s choke coil phase 2 */
  CnvTmpChokeCoil2_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the converter’s choke coil phase 3 */
  CnvTmpChokeCoil3_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the converter’s choke coil */
  CnvTmpChokeCoil_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter */
  CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature fo the converter’s cooling water */
  CnvTmpWater_mag_f?: Maybe<Snapshot_Result>;
  /** Grid side 3 phase power factor */
  GriPF_mag_f?: Maybe<Snapshot_Result>;
  /** Frequency value */
  Hz_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 2 */
  WCNV2_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 3 */
  WCNV3_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 4 */
  WCNV4_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 5 */
  WCNV5_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 6 */
  WCNV6_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 7 */
  WCNV7_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 8 */
  WCNV8_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 9 */
  WCNV9_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 10 */
  WCNV10_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 11 */
  WCNV11_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 12 */
  WCNV12_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 13 */
  WCNV13_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 14 */
  WCNV14_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
};


/** Converter description */
export type Cnv_30SCnvTmpChokeCoil2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SCnvTmpChokeCoil3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SCnvTmpChokeCoil_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SCnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SCnvTmpWater_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SGriPf_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Converter description */
export type Cnv_30SHz_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Converter description */
export type Cnv_30SWcnv2_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv3_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv4_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv5_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv6_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv7_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv8_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv9_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv10_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv11_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv12_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv13_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Converter description */
export type Cnv_30SWcnv14_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Description of controller */
export type Controller = {
  __typename?: 'CONTROLLER';
  /** Internal ID */
  _id: Scalars['ID']['output'];
  /** Controller name */
  name: Scalars['String']['output'];
};

export type ControllerSortInput = {
  _id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type ControllerWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ControllerWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ControllerWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
};

/** Description of country */
export type Country = {
  __typename?: 'COUNTRY';
  /** Data Description */
  DATA?: Maybe<Data_Country>;
  /** Description of park */
  PARKS?: Maybe<Array<Maybe<Park>>>;
  /** Internal ID */
  _id: Scalars['ID']['output'];
  /** Country code */
  code: Scalars['String']['output'];
  /** Country Image */
  countryImage?: Maybe<Scalars['String']['output']>;
  /** Currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Energy Meter Available */
  energyMeterAvailable?: Maybe<Scalars['String']['output']>;
  /** Country name */
  name: Scalars['String']['output'];
};


/** Description of country */
export type CountryParksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ParkSortInput>;
  turbines?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<ParkWhereInput>;
};

export type CountrySortInput = {
  _id?: InputMaybe<Sort>;
  code?: InputMaybe<Sort>;
  countryImage?: InputMaybe<Sort>;
  currency?: InputMaybe<Sort>;
  energyMeterAvailable?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type CountryWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<CountryWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<CountryWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  code?: InputMaybe<StringInput>;
  countryImage?: InputMaybe<StringInput>;
  currency?: InputMaybe<StringInput>;
  energyMeterAvailable?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
};

export enum Celsius {
  Fahrenheit = 'FAHRENHEIT',
  Kelvin = 'KELVIN'
}

export type CompensatedInput = {
  isAvailable: Scalars['Boolean']['input'];
  production: Scalars['Float']['input'];
  revenue: Scalars['Float']['input'];
};

/** 10 minutes Data Stream */
export type Data_10M = {
  __typename?: 'DATA_10M';
  /** Converter description */
  CONVERTER?: Maybe<Cnv_10M>;
  /** Common description */
  GENERAL?: Maybe<Grl_10M>;
  /** Generator Description */
  GENERATOR?: Maybe<Gen_10M>;
  /** MXU description */
  MXU?: Maybe<Mxu_10M>;
  /** Nacelle description */
  NACELLE?: Maybe<Nac_10M>;
  /** Rotor description */
  ROTOR?: Maybe<Rot_10M>;
  /** Temperature description */
  TEMPERATURE?: Maybe<Tmp_10M>;
  /** Turbine temperature deviation from the park average */
  TEMPERATURE_DEVIATION?: Maybe<Tmd_10M>;
  /** Tower description */
  TOWER?: Maybe<Tow_10M>;
  /** Trafo description */
  TRAFO?: Maybe<Trf_10M>;
  /** Trm description */
  TRM?: Maybe<Trm_10M>;
  /** Turbine description */
  TURBINE?: Maybe<Tur_10M>;
  /** Yaw description */
  YAW?: Maybe<Yaw_10M>;
};

/** 30 seconds Data Stream */
export type Data_30S = {
  __typename?: 'DATA_30S';
  /** Converter description */
  CONVERTER?: Maybe<Cnv_30S>;
  /** Common description */
  GENERAL?: Maybe<Grl_30S>;
  /** Generator Description */
  GENERATOR?: Maybe<Gen_30S>;
  /** MXU description */
  MXU?: Maybe<Mxu_30S>;
  /** Nacelle description */
  NACELLE?: Maybe<Nac_30S>;
  /** Rotor description */
  ROTOR?: Maybe<Rot_30S>;
  /** Temperature description */
  TEMPERATURE?: Maybe<Tmp_30S>;
  /** Tower description */
  TOWER?: Maybe<Tow_30S>;
  /** Trafo description */
  TRAFO?: Maybe<Trf_30S>;
  /** Trm description */
  TRM?: Maybe<Trm_30S>;
  /** Turbine description */
  TURBINE?: Maybe<Tur_30S>;
  /** Yaw description */
  YAW?: Maybe<Yaw_30S>;
};

export type Data_Alx_OrderByInput = {
  _id?: InputMaybe<Sort>;
  alarmCategory?: InputMaybe<Sort>;
  alarmCount?: InputMaybe<Sort>;
  closeTS?: InputMaybe<Sort>;
  code?: InputMaybe<Sort>;
  createTS?: InputMaybe<Sort>;
  description?: InputMaybe<Sort>;
  duration?: InputMaybe<Sort>;
  durationLong?: InputMaybe<Sort>;
  durationShort?: InputMaybe<Sort>;
  isOpen?: InputMaybe<Sort>;
  powerLosses?: InputMaybe<Sort>;
  powerLossesAvg?: InputMaybe<Sort>;
  powerLossesSum?: InputMaybe<Sort>;
  tcu?: InputMaybe<Sort>;
  totalActPower?: InputMaybe<Sort>;
  totalRevenueLoss?: InputMaybe<Sort>;
  totalTheoPower?: InputMaybe<Sort>;
  turbineCode?: InputMaybe<Sort>;
};

export type Data_Alx_TableWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Data_Alx_TableWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Data_Alx_TableWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  alarmCategory?: InputMaybe<IntInput>;
  alarmCount?: InputMaybe<FloatInput>;
  closeTS?: InputMaybe<FloatInput>;
  code?: InputMaybe<StringInput>;
  createTS?: InputMaybe<FloatInput>;
  description?: InputMaybe<StringInput>;
  duration?: InputMaybe<FloatInput>;
  durationLong?: InputMaybe<StringInput>;
  durationShort?: InputMaybe<StringInput>;
  isOpen?: InputMaybe<IntInput>;
  powerLosses?: InputMaybe<FloatInput>;
  powerLossesAvg?: InputMaybe<FloatInput>;
  powerLossesSum?: InputMaybe<FloatInput>;
  tcu?: InputMaybe<StringInput>;
  totalActPower?: InputMaybe<FloatInput>;
  totalRevenueLoss?: InputMaybe<FloatInput>;
  totalTheoPower?: InputMaybe<FloatInput>;
  turbineCode?: InputMaybe<StringInput>;
};

export type Data_Bdg_OrderByInput = {
  _id_park?: InputMaybe<Sort>;
  lastUpdatedTs?: InputMaybe<Sort>;
  lastUpdatedUser?: InputMaybe<Sort>;
  month?: InputMaybe<Sort>;
  production?: InputMaybe<Sort>;
  revenue?: InputMaybe<Sort>;
  year?: InputMaybe<Sort>;
};

export type Data_Bdg_TableWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Data_Bdg_TableWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Data_Bdg_TableWhereInput>>>;
  _id_park?: InputMaybe<StringInput>;
  lastUpdatedTs?: InputMaybe<FloatInput>;
  lastUpdatedUser?: InputMaybe<StringInput>;
  month?: InputMaybe<IntInput>;
  production?: InputMaybe<FloatInput>;
  revenue?: InputMaybe<FloatInput>;
  year?: InputMaybe<IntInput>;
};

export type Data_Bgd2_OrderByInput = {
  _id?: InputMaybe<Sort>;
  commentText?: InputMaybe<Sort>;
  day?: InputMaybe<Sort>;
  files?: InputMaybe<Sort>;
  isInvoiceCompensated?: InputMaybe<Sort>;
  isInvoiceDelivered?: InputMaybe<Sort>;
  lastUpdatedTs?: InputMaybe<Sort>;
  lastUpdatedUser?: InputMaybe<Sort>;
  month?: InputMaybe<Sort>;
  production?: InputMaybe<Sort>;
  productionAcc?: InputMaybe<Sort>;
  productionBudget?: InputMaybe<Sort>;
  productionBudgetAcc?: InputMaybe<Sort>;
  productionBudgetYTD?: InputMaybe<Sort>;
  productionCompensated?: InputMaybe<Sort>;
  productionCompensatedAcc?: InputMaybe<Sort>;
  productionCompensatedInvoiced?: InputMaybe<Sort>;
  productionCompensatedInvoicedAcc?: InputMaybe<Sort>;
  productionDelivered?: InputMaybe<Sort>;
  productionDeliveredAcc?: InputMaybe<Sort>;
  productionDeliveredInvoiced?: InputMaybe<Sort>;
  productionDeliveredInvoicedAcc?: InputMaybe<Sort>;
  productionExpected?: InputMaybe<Sort>;
  productionExpectedAcc?: InputMaybe<Sort>;
  productionGrid?: InputMaybe<Sort>;
  productionGridAcc?: InputMaybe<Sort>;
  productionLossLogbook?: InputMaybe<Sort>;
  productionLossLogbookAcc?: InputMaybe<Sort>;
  productionScada?: InputMaybe<Sort>;
  productionScadaAcc?: InputMaybe<Sort>;
  productionTheoretical?: InputMaybe<Sort>;
  productionTheoreticalAcc?: InputMaybe<Sort>;
  revenue?: InputMaybe<Sort>;
  revenueAcc?: InputMaybe<Sort>;
  revenueBudget?: InputMaybe<Sort>;
  revenueBudgetAcc?: InputMaybe<Sort>;
  revenueBudgetYTD?: InputMaybe<Sort>;
  revenueCompensated?: InputMaybe<Sort>;
  revenueCompensatedAcc?: InputMaybe<Sort>;
  revenueCompensatedInvoiced?: InputMaybe<Sort>;
  revenueCompensatedInvoicedAcc?: InputMaybe<Sort>;
  revenueDelivered?: InputMaybe<Sort>;
  revenueDeliveredAcc?: InputMaybe<Sort>;
  revenueDeliveredInvoiced?: InputMaybe<Sort>;
  revenueDeliveredInvoicedAcc?: InputMaybe<Sort>;
  revenueExpected?: InputMaybe<Sort>;
  revenueExpectedAcc?: InputMaybe<Sort>;
  revenueGrid?: InputMaybe<Sort>;
  revenueGridAcc?: InputMaybe<Sort>;
  revenueLossLogbook?: InputMaybe<Sort>;
  revenueLossLogbookAcc?: InputMaybe<Sort>;
  revenueScada?: InputMaybe<Sort>;
  revenueScadaAcc?: InputMaybe<Sort>;
  revenueTheoretical?: InputMaybe<Sort>;
  revenueTheoreticalAcc?: InputMaybe<Sort>;
  totalRevenue?: InputMaybe<Sort>;
  totalRevenueAcc?: InputMaybe<Sort>;
  year?: InputMaybe<Sort>;
};

export type Data_Bgd2_TableWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Data_Bgd2_TableWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Data_Bgd2_TableWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  commentText?: InputMaybe<StringInput>;
  day?: InputMaybe<IntInput>;
  files?: InputMaybe<StringInput>;
  isInvoiceCompensated?: InputMaybe<FloatInput>;
  isInvoiceDelivered?: InputMaybe<FloatInput>;
  lastUpdatedTs?: InputMaybe<StringInput>;
  lastUpdatedUser?: InputMaybe<StringInput>;
  month?: InputMaybe<IntInput>;
  production?: InputMaybe<FloatInput>;
  productionAcc?: InputMaybe<FloatInput>;
  productionBudget?: InputMaybe<FloatInput>;
  productionBudgetAcc?: InputMaybe<FloatInput>;
  productionBudgetYTD?: InputMaybe<FloatInput>;
  productionCompensated?: InputMaybe<FloatInput>;
  productionCompensatedAcc?: InputMaybe<FloatInput>;
  productionCompensatedInvoiced?: InputMaybe<FloatInput>;
  productionCompensatedInvoicedAcc?: InputMaybe<FloatInput>;
  productionDelivered?: InputMaybe<FloatInput>;
  productionDeliveredAcc?: InputMaybe<FloatInput>;
  productionDeliveredInvoiced?: InputMaybe<FloatInput>;
  productionDeliveredInvoicedAcc?: InputMaybe<FloatInput>;
  productionExpected?: InputMaybe<FloatInput>;
  productionExpectedAcc?: InputMaybe<FloatInput>;
  productionGrid?: InputMaybe<FloatInput>;
  productionGridAcc?: InputMaybe<FloatInput>;
  productionLossLogbook?: InputMaybe<FloatInput>;
  productionLossLogbookAcc?: InputMaybe<FloatInput>;
  productionScada?: InputMaybe<FloatInput>;
  productionScadaAcc?: InputMaybe<FloatInput>;
  productionTheoretical?: InputMaybe<FloatInput>;
  productionTheoreticalAcc?: InputMaybe<FloatInput>;
  revenue?: InputMaybe<FloatInput>;
  revenueAcc?: InputMaybe<FloatInput>;
  revenueBudget?: InputMaybe<FloatInput>;
  revenueBudgetAcc?: InputMaybe<FloatInput>;
  revenueBudgetYTD?: InputMaybe<FloatInput>;
  revenueCompensated?: InputMaybe<FloatInput>;
  revenueCompensatedAcc?: InputMaybe<FloatInput>;
  revenueCompensatedInvoiced?: InputMaybe<FloatInput>;
  revenueCompensatedInvoicedAcc?: InputMaybe<FloatInput>;
  revenueDelivered?: InputMaybe<FloatInput>;
  revenueDeliveredAcc?: InputMaybe<FloatInput>;
  revenueDeliveredInvoiced?: InputMaybe<FloatInput>;
  revenueDeliveredInvoicedAcc?: InputMaybe<FloatInput>;
  revenueExpected?: InputMaybe<FloatInput>;
  revenueExpectedAcc?: InputMaybe<FloatInput>;
  revenueGrid?: InputMaybe<FloatInput>;
  revenueGridAcc?: InputMaybe<FloatInput>;
  revenueLossLogbook?: InputMaybe<FloatInput>;
  revenueLossLogbookAcc?: InputMaybe<FloatInput>;
  revenueScada?: InputMaybe<FloatInput>;
  revenueScadaAcc?: InputMaybe<FloatInput>;
  revenueTheoretical?: InputMaybe<FloatInput>;
  revenueTheoreticalAcc?: InputMaybe<FloatInput>;
  totalRevenue?: InputMaybe<FloatInput>;
  totalRevenueAcc?: InputMaybe<FloatInput>;
  year?: InputMaybe<IntInput>;
};

export type Data_Bgd_OrderByInput = {
  _id?: InputMaybe<Sort>;
  commentText?: InputMaybe<Sort>;
  day?: InputMaybe<Sort>;
  files?: InputMaybe<Sort>;
  isInvoiceCompensated?: InputMaybe<Sort>;
  isInvoiceDelivered?: InputMaybe<Sort>;
  lastUpdatedTs?: InputMaybe<Sort>;
  lastUpdatedUser?: InputMaybe<Sort>;
  month?: InputMaybe<Sort>;
  production?: InputMaybe<Sort>;
  productionAcc?: InputMaybe<Sort>;
  productionBudget?: InputMaybe<Sort>;
  productionBudgetAcc?: InputMaybe<Sort>;
  productionBudgetYTD?: InputMaybe<Sort>;
  productionCompensated?: InputMaybe<Sort>;
  productionCompensatedAcc?: InputMaybe<Sort>;
  productionCompensatedInvoiced?: InputMaybe<Sort>;
  productionCompensatedInvoicedAcc?: InputMaybe<Sort>;
  productionDelivered?: InputMaybe<Sort>;
  productionDeliveredAcc?: InputMaybe<Sort>;
  productionDeliveredInvoiced?: InputMaybe<Sort>;
  productionDeliveredInvoicedAcc?: InputMaybe<Sort>;
  productionExpected?: InputMaybe<Sort>;
  productionExpectedAcc?: InputMaybe<Sort>;
  productionGrid?: InputMaybe<Sort>;
  productionGridAcc?: InputMaybe<Sort>;
  productionLossLogbook?: InputMaybe<Sort>;
  productionLossLogbookAcc?: InputMaybe<Sort>;
  productionScada?: InputMaybe<Sort>;
  productionScadaAcc?: InputMaybe<Sort>;
  productionTheoretical?: InputMaybe<Sort>;
  productionTheoreticalAcc?: InputMaybe<Sort>;
  revenue?: InputMaybe<Sort>;
  revenueAcc?: InputMaybe<Sort>;
  revenueBudget?: InputMaybe<Sort>;
  revenueBudgetAcc?: InputMaybe<Sort>;
  revenueBudgetYTD?: InputMaybe<Sort>;
  revenueCompensated?: InputMaybe<Sort>;
  revenueCompensatedAcc?: InputMaybe<Sort>;
  revenueCompensatedInvoiced?: InputMaybe<Sort>;
  revenueCompensatedInvoicedAcc?: InputMaybe<Sort>;
  revenueDelivered?: InputMaybe<Sort>;
  revenueDeliveredAcc?: InputMaybe<Sort>;
  revenueDeliveredInvoiced?: InputMaybe<Sort>;
  revenueDeliveredInvoicedAcc?: InputMaybe<Sort>;
  revenueExpected?: InputMaybe<Sort>;
  revenueExpectedAcc?: InputMaybe<Sort>;
  revenueGrid?: InputMaybe<Sort>;
  revenueGridAcc?: InputMaybe<Sort>;
  revenueLossLogbook?: InputMaybe<Sort>;
  revenueLossLogbookAcc?: InputMaybe<Sort>;
  revenueScada?: InputMaybe<Sort>;
  revenueScadaAcc?: InputMaybe<Sort>;
  revenueTheoretical?: InputMaybe<Sort>;
  revenueTheoreticalAcc?: InputMaybe<Sort>;
  totalRevenue?: InputMaybe<Sort>;
  totalRevenueAcc?: InputMaybe<Sort>;
  year?: InputMaybe<Sort>;
};

export type Data_Bgd_TableWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Data_Bgd_TableWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Data_Bgd_TableWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  commentText?: InputMaybe<StringInput>;
  day?: InputMaybe<IntInput>;
  files?: InputMaybe<StringInput>;
  isInvoiceCompensated?: InputMaybe<FloatInput>;
  isInvoiceDelivered?: InputMaybe<FloatInput>;
  lastUpdatedTs?: InputMaybe<StringInput>;
  lastUpdatedUser?: InputMaybe<StringInput>;
  month?: InputMaybe<IntInput>;
  production?: InputMaybe<FloatInput>;
  productionAcc?: InputMaybe<FloatInput>;
  productionBudget?: InputMaybe<FloatInput>;
  productionBudgetAcc?: InputMaybe<FloatInput>;
  productionBudgetYTD?: InputMaybe<FloatInput>;
  productionCompensated?: InputMaybe<FloatInput>;
  productionCompensatedAcc?: InputMaybe<FloatInput>;
  productionCompensatedInvoiced?: InputMaybe<FloatInput>;
  productionCompensatedInvoicedAcc?: InputMaybe<FloatInput>;
  productionDelivered?: InputMaybe<FloatInput>;
  productionDeliveredAcc?: InputMaybe<FloatInput>;
  productionDeliveredInvoiced?: InputMaybe<FloatInput>;
  productionDeliveredInvoicedAcc?: InputMaybe<FloatInput>;
  productionExpected?: InputMaybe<FloatInput>;
  productionExpectedAcc?: InputMaybe<FloatInput>;
  productionGrid?: InputMaybe<FloatInput>;
  productionGridAcc?: InputMaybe<FloatInput>;
  productionLossLogbook?: InputMaybe<FloatInput>;
  productionLossLogbookAcc?: InputMaybe<FloatInput>;
  productionScada?: InputMaybe<FloatInput>;
  productionScadaAcc?: InputMaybe<FloatInput>;
  productionTheoretical?: InputMaybe<FloatInput>;
  productionTheoreticalAcc?: InputMaybe<FloatInput>;
  revenue?: InputMaybe<FloatInput>;
  revenueAcc?: InputMaybe<FloatInput>;
  revenueBudget?: InputMaybe<FloatInput>;
  revenueBudgetAcc?: InputMaybe<FloatInput>;
  revenueBudgetYTD?: InputMaybe<FloatInput>;
  revenueCompensated?: InputMaybe<FloatInput>;
  revenueCompensatedAcc?: InputMaybe<FloatInput>;
  revenueCompensatedInvoiced?: InputMaybe<FloatInput>;
  revenueCompensatedInvoicedAcc?: InputMaybe<FloatInput>;
  revenueDelivered?: InputMaybe<FloatInput>;
  revenueDeliveredAcc?: InputMaybe<FloatInput>;
  revenueDeliveredInvoiced?: InputMaybe<FloatInput>;
  revenueDeliveredInvoicedAcc?: InputMaybe<FloatInput>;
  revenueExpected?: InputMaybe<FloatInput>;
  revenueExpectedAcc?: InputMaybe<FloatInput>;
  revenueGrid?: InputMaybe<FloatInput>;
  revenueGridAcc?: InputMaybe<FloatInput>;
  revenueLossLogbook?: InputMaybe<FloatInput>;
  revenueLossLogbookAcc?: InputMaybe<FloatInput>;
  revenueScada?: InputMaybe<FloatInput>;
  revenueScadaAcc?: InputMaybe<FloatInput>;
  revenueTheoretical?: InputMaybe<FloatInput>;
  revenueTheoreticalAcc?: InputMaybe<FloatInput>;
  totalRevenue?: InputMaybe<FloatInput>;
  totalRevenueAcc?: InputMaybe<FloatInput>;
  year?: InputMaybe<IntInput>;
};

/** Data description */
export type Data_Country = {
  __typename?: 'DATA_COUNTRY';
  /** Snapshot of last arrived data. */
  SNAPSHOT?: Maybe<Snapshot_Country>;
  /** Table */
  TABLE?: Maybe<Table_Country>;
  /** Timeseries */
  TIMESERIES?: Maybe<Timeseries_Country>;
};

export type Data_Lgb_OrderByInput = {
  _id?: InputMaybe<Sort>;
  _id_park?: InputMaybe<Sort>;
  _id_portfolio?: InputMaybe<Sort>;
  _id_process?: InputMaybe<Sort>;
  _id_turbine?: InputMaybe<Sort>;
  deleted?: InputMaybe<Sort>;
  duration?: InputMaybe<Sort>;
  endTS?: InputMaybe<Sort>;
  startTS?: InputMaybe<Sort>;
  tcu?: InputMaybe<Sort>;
  totalProductionLoss?: InputMaybe<Sort>;
  totalRevenueLoss?: InputMaybe<Sort>;
};

export type Data_Lgb_TableWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Data_Lgb_TableWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Data_Lgb_TableWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  _id_park?: InputMaybe<StringInput>;
  _id_portfolio?: InputMaybe<StringInput>;
  _id_process?: InputMaybe<StringInput>;
  _id_turbine?: InputMaybe<StringInput>;
  deleted?: InputMaybe<IntInput>;
  duration?: InputMaybe<FloatInput>;
  endTS?: InputMaybe<FloatInput>;
  startTS?: InputMaybe<FloatInput>;
  tcu?: InputMaybe<StringInput>;
  totalProductionLoss?: InputMaybe<FloatInput>;
  totalRevenueLoss?: InputMaybe<FloatInput>;
};

export type Data_Lgm_OrderByInput = {
  _id?: InputMaybe<Sort>;
  _id_park?: InputMaybe<Sort>;
  _id_portfolio?: InputMaybe<Sort>;
  _id_process?: InputMaybe<Sort>;
  _id_turbine?: InputMaybe<Sort>;
  duration?: InputMaybe<Sort>;
  endTS?: InputMaybe<Sort>;
  log?: InputMaybe<Sort>;
  mutTS?: InputMaybe<Sort>;
  startTS?: InputMaybe<Sort>;
  tcu?: InputMaybe<Sort>;
  totalActualProduction?: InputMaybe<Sort>;
  totalProductionLoss?: InputMaybe<Sort>;
  totalRevenue?: InputMaybe<Sort>;
  totalRevenueLoss?: InputMaybe<Sort>;
  userComment?: InputMaybe<Sort>;
  windInLimits?: InputMaybe<Sort>;
  windOutLimits?: InputMaybe<Sort>;
};

export type Data_Lgm_TableWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Data_Lgm_TableWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Data_Lgm_TableWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  _id_park?: InputMaybe<StringInput>;
  _id_portfolio?: InputMaybe<StringInput>;
  _id_process?: InputMaybe<StringInput>;
  _id_turbine?: InputMaybe<StringInput>;
  duration?: InputMaybe<FloatInput>;
  endTS?: InputMaybe<FloatInput>;
  log?: InputMaybe<StringInput>;
  mutTS?: InputMaybe<FloatInput>;
  startTS?: InputMaybe<FloatInput>;
  tcu?: InputMaybe<StringInput>;
  totalActualProduction?: InputMaybe<FloatInput>;
  totalProductionLoss?: InputMaybe<FloatInput>;
  totalRevenue?: InputMaybe<FloatInput>;
  totalRevenueLoss?: InputMaybe<FloatInput>;
  userComment?: InputMaybe<StringInput>;
  windInLimits?: InputMaybe<FloatInput>;
  windOutLimits?: InputMaybe<FloatInput>;
};

/** Data description */
export type Data_Park = {
  __typename?: 'DATA_PARK';
  /** Snapshot of last arrived data. */
  SNAPSHOT?: Maybe<Snapshot_Park>;
  /** Table */
  TABLE?: Maybe<Table_Park>;
  /** Timeseries */
  TIMESERIES?: Maybe<Timeseries_Park>;
};

/** Data description */
export type Data_Park_Subtype = {
  __typename?: 'DATA_PARK_SUBTYPE';
  /** Timeseries */
  TIMESERIES?: Maybe<Timeseries_Park_Subtype>;
};

export type Data_Ple_OrderByInput = {
  _id?: InputMaybe<Sort>;
  _id_alarm?: InputMaybe<Sort>;
  _id_group?: InputMaybe<Sort>;
  _id_park?: InputMaybe<Sort>;
  _id_process?: InputMaybe<Sort>;
  _id_turbine?: InputMaybe<Sort>;
  category?: InputMaybe<Sort>;
  creationTs?: InputMaybe<Sort>;
  description?: InputMaybe<Sort>;
  duration?: InputMaybe<Sort>;
  durationLong?: InputMaybe<Sort>;
  durationShort?: InputMaybe<Sort>;
  endDate?: InputMaybe<Sort>;
  endTs?: InputMaybe<Sort>;
  isRecurring?: InputMaybe<Sort>;
  lastEditedTs?: InputMaybe<Sort>;
  lastUpdatedTs?: InputMaybe<Sort>;
  limitedTo?: InputMaybe<Sort>;
  notificationTime?: InputMaybe<Sort>;
  plannedTCU?: InputMaybe<Sort>;
  productionLoss?: InputMaybe<Sort>;
  provider?: InputMaybe<Sort>;
  recipients?: InputMaybe<Sort>;
  revenueLoss?: InputMaybe<Sort>;
  startDate?: InputMaybe<Sort>;
  startTs?: InputMaybe<Sort>;
  title?: InputMaybe<Sort>;
};

export type Data_Ple_TableWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Data_Ple_TableWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Data_Ple_TableWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  _id_alarm?: InputMaybe<StringInput>;
  _id_group?: InputMaybe<StringInput>;
  _id_park?: InputMaybe<StringInput>;
  _id_process?: InputMaybe<StringInput>;
  _id_turbine?: InputMaybe<StringInput>;
  category?: InputMaybe<StringInput>;
  creationTs?: InputMaybe<FloatInput>;
  description?: InputMaybe<StringInput>;
  duration?: InputMaybe<FloatInput>;
  durationLong?: InputMaybe<StringInput>;
  durationShort?: InputMaybe<StringInput>;
  endDate?: InputMaybe<StringInput>;
  endTs?: InputMaybe<FloatInput>;
  isRecurring?: InputMaybe<IntInput>;
  lastEditedTs?: InputMaybe<FloatInput>;
  lastUpdatedTs?: InputMaybe<FloatInput>;
  limitedTo?: InputMaybe<FloatInput>;
  notificationTime?: InputMaybe<StringInput>;
  plannedTCU?: InputMaybe<StringInput>;
  productionLoss?: InputMaybe<FloatInput>;
  provider?: InputMaybe<StringInput>;
  recipients?: InputMaybe<StringInput>;
  revenueLoss?: InputMaybe<FloatInput>;
  startDate?: InputMaybe<StringInput>;
  startTs?: InputMaybe<FloatInput>;
  title?: InputMaybe<StringInput>;
};

/** Data description */
export type Data_Portfolio = {
  __typename?: 'DATA_PORTFOLIO';
  /** Snapshot of last arrived data. */
  SNAPSHOT?: Maybe<Snapshot_Portfolio>;
  /** Table */
  TABLE?: Maybe<Table_Portfolio>;
  /** Timeseries */
  TIMESERIES?: Maybe<Timeseries_Portfolio>;
};

export type Data_Pra_OrderByInput = {
  _id?: InputMaybe<Sort>;
  _id_parks?: InputMaybe<Sort>;
  _id_plannedEvents?: InputMaybe<Sort>;
  _id_tClassBlocks?: InputMaybe<Sort>;
  color?: InputMaybe<Sort>;
  creationTs?: InputMaybe<Sort>;
  description?: InputMaybe<Sort>;
  durationPlanned?: InputMaybe<Sort>;
  durationPlannedLong?: InputMaybe<Sort>;
  durationPlannedShort?: InputMaybe<Sort>;
  durationRealized?: InputMaybe<Sort>;
  durationRealizedLong?: InputMaybe<Sort>;
  durationRealizedShort?: InputMaybe<Sort>;
  estimatedEndTs?: InputMaybe<Sort>;
  estimatedStartTs?: InputMaybe<Sort>;
  lastEditedTs?: InputMaybe<Sort>;
  productionLossPlanned?: InputMaybe<Sort>;
  productionLossRealized?: InputMaybe<Sort>;
  revenueLossPlanned?: InputMaybe<Sort>;
  revenueLossRealized?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  title?: InputMaybe<Sort>;
};

export type Data_Pra_TableWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Data_Pra_TableWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Data_Pra_TableWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  _id_parks?: InputMaybe<ArrayInput>;
  _id_plannedEvents?: InputMaybe<ArrayInput>;
  _id_tClassBlocks?: InputMaybe<ArrayInput>;
  color?: InputMaybe<StringInput>;
  creationTs?: InputMaybe<FloatInput>;
  description?: InputMaybe<StringInput>;
  durationPlanned?: InputMaybe<FloatInput>;
  durationPlannedLong?: InputMaybe<StringInput>;
  durationPlannedShort?: InputMaybe<StringInput>;
  durationRealized?: InputMaybe<FloatInput>;
  durationRealizedLong?: InputMaybe<StringInput>;
  durationRealizedShort?: InputMaybe<StringInput>;
  estimatedEndTs?: InputMaybe<FloatInput>;
  estimatedStartTs?: InputMaybe<FloatInput>;
  lastEditedTs?: InputMaybe<FloatInput>;
  productionLossPlanned?: InputMaybe<FloatInput>;
  productionLossRealized?: InputMaybe<FloatInput>;
  revenueLossPlanned?: InputMaybe<FloatInput>;
  revenueLossRealized?: InputMaybe<FloatInput>;
  status?: InputMaybe<IntInput>;
  title?: InputMaybe<StringInput>;
};

export type Data_Prc_OrderByInput = {
  _id?: InputMaybe<Sort>;
  _id_parks?: InputMaybe<Sort>;
  _id_plannedEvents?: InputMaybe<Sort>;
  _id_tClassBlocks?: InputMaybe<Sort>;
  color?: InputMaybe<Sort>;
  creationTs?: InputMaybe<Sort>;
  description?: InputMaybe<Sort>;
  estimatedEndTs?: InputMaybe<Sort>;
  estimatedStartTs?: InputMaybe<Sort>;
  lastEditedTs?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  title?: InputMaybe<Sort>;
};

export type Data_Prc_TableWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Data_Prc_TableWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Data_Prc_TableWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  _id_parks?: InputMaybe<ArrayInput>;
  _id_plannedEvents?: InputMaybe<ArrayInput>;
  _id_tClassBlocks?: InputMaybe<ArrayInput>;
  color?: InputMaybe<StringInput>;
  creationTs?: InputMaybe<FloatInput>;
  description?: InputMaybe<StringInput>;
  estimatedEndTs?: InputMaybe<FloatInput>;
  estimatedStartTs?: InputMaybe<FloatInput>;
  lastEditedTs?: InputMaybe<FloatInput>;
  status?: InputMaybe<IntInput>;
  title?: InputMaybe<StringInput>;
};

/** Data description */
export type Data_Turbine = {
  __typename?: 'DATA_TURBINE';
  /** Snapshot of last arrived data. */
  SNAPSHOT?: Maybe<Snapshot_Turbine>;
  /** Table */
  TABLE?: Maybe<Table_Turbine>;
  /** Timeseries */
  TIMESERIES?: Maybe<Timeseries_Turbine>;
};

export type DeliveredInput = {
  isAvailable: Scalars['Boolean']['input'];
  production: Scalars['Float']['input'];
  revenue: Scalars['Float']['input'];
};

/** Description of errorCatalog */
export type Error_Catalog = {
  __typename?: 'ERROR_CATALOG';
  /** Internal ID */
  _id: Scalars['ID']['output'];
  /** Error list */
  errors?: Maybe<Array<Maybe<Errors>>>;
  /** Error catalog name */
  name: Scalars['String']['output'];
};

export type Error_CatalogSortInput = {
  _id?: InputMaybe<Sort>;
  errors?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type Error_CatalogWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Error_CatalogWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Error_CatalogWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
};

export type FilesInput = {
  _id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

/** Float operators */
export type FloatInput = {
  /** Equality operator (=). {$fieldName: {EQ: Float}} */
  EQ?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than operator (>). {$fieldName: {GT: Float}} */
  GT?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal operator (>=). {$fieldName: {GTE: Float}} */
  GTE?: InputMaybe<Scalars['Float']['input']>;
  /** In operator (in). {$fieldName: {IN: [Float1, Float2]}} */
  IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Less than operator (<). {$fieldName: {LT: Float}} */
  LT?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal operator (<=). {$fieldName: {LTE: Float}} */
  LTE?: InputMaybe<Scalars['Float']['input']>;
  /** Not equality operator (!=). {$fieldName: {NEQ: Float}} */
  NEQ?: InputMaybe<Scalars['Float']['input']>;
  /** Not in operator (not in). {$fieldName: {NIN: [Float1, Float2]}} */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export enum Gb_Agr {
  Count = 'COUNT'
}

/** Generator Description */
export type Gen_10M = {
  __typename?: 'GEN_10M';
  /** Measured temperature of generator bearing 1 */
  GnTmpBrg1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator bearing 2 */
  GnTmpBrg2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurement for inlet air/water temperature at generator */
  GnTmpInlet_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurement for outlet air/water temperature at generator */
  GnTmpOutlet_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 1 */
  GnTmpPhase1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 2 */
  GnTmpPhase2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 3 */
  GnTmpPhase3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator rotor */
  GnTmpRtr_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator slipring 1 */
  GnTmpSlpRing1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator slipring 2 */
  GnTmpSlpRing2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 2 */
  GnTmpSta2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 3 */
  GnTmpSta3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 4 */
  GnTmpSta4_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 5 */
  GnTmpSta5_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 6 */
  GnTmpSta6_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator */
  GnTmpSta_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Generator speed */
  Spd_avg_mag_f?: Maybe<Snapshot_Result>;
};


/** Generator Description */
export type Gen_10MGnTmpBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpInlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpOutlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpRtr_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpSlpRing1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpSlpRing2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpSta2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpSta3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpSta4_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpSta5_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpSta6_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MGnTmpSta_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_10MSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

/** Generator Description */
export type Gen_30S = {
  __typename?: 'GEN_30S';
  /** Measured temperature of generator bearing 1 */
  GnTmpBrg1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator bearing 2 */
  GnTmpBrg2_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurement for inlet air/water temperature at generator */
  GnTmpInlet_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurement for outlet air/water temperature at generator */
  GnTmpOutlet_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 1 */
  GnTmpPhase1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 2 */
  GnTmpPhase2_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 3 */
  GnTmpPhase3_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator rotor */
  GnTmpRtr_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator slipring 1 */
  GnTmpSlpRing1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator slipring 2 */
  GnTmpSlpRing2_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 2 */
  GnTmpSta2_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 3 */
  GnTmpSta3_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 4 */
  GnTmpSta4_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 5 */
  GnTmpSta5_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 6 */
  GnTmpSta6_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator */
  GnTmpSta_mag_f?: Maybe<Snapshot_Result>;
  /** Generator speed */
  Spd_mag_f?: Maybe<Snapshot_Result>;
};


/** Generator Description */
export type Gen_30SGnTmpBrg1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpBrg2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpInlet_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpOutlet_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpPhase1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpPhase2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpPhase3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpRtr_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpSlpRing1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpSlpRing2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpSta2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpSta3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpSta4_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpSta5_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpSta6_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SGnTmpSta_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Generator Description */
export type Gen_30SSpd_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

/** Common description */
export type Grl_10M = {
  __typename?: 'GRL_10M';
  /** Turbine control system time (can be any timezone) */
  LTIM1_TmUTC_setTm?: Maybe<Snapshot_Result>;
};


/** Common description */
export type Grl_10MLtim1_TmUtc_SetTmArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

/** Common description */
export type Grl_30S = {
  __typename?: 'GRL_30S';
  /** Timestamp generated by data acquisition system in UTC */
  LDAT1_TmUTC_setTm?: Maybe<Snapshot_Result>;
  /** Physical device health (inherited from IEC 61850-7-4) 1 -> Ok (No problems, normal operation) 2 -> Warning (Minor problems, but in safe operation mode) 3 -> Alarm (Severe problem, no operation possible) */
  LPHD1_PhyHealth_stVal?: Maybe<Snapshot_Result>;
};


/** Common description */
export type Grl_30SLdat1_TmUtc_SetTmArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Common description */
export type Grl_30SLphd1_PhyHealth_StValArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

export enum Gr_Agr {
  Avg = 'AVG',
  Count = 'COUNT',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

/** List of invoice */
export type Invoice = {
  __typename?: 'INVOICE';
  /** Internal ID country */
  _id_country: Scalars['ID']['output'];
  /** Internal ID plant */
  _id_park: Scalars['ID']['output'];
  /** commentLastUpdatedBy */
  commentLastUpdatedBy?: Maybe<Scalars['Int']['output']>;
  /** commentLastUpdatedTs */
  commentLastUpdatedTs?: Maybe<Scalars['Int']['output']>;
  /** commentText */
  commentText?: Maybe<Scalars['String']['output']>;
  /** compensatedProduction */
  compensatedProduction?: Maybe<Scalars['Int']['output']>;
  /** compensatedRevenue */
  compensatedRevenue?: Maybe<Scalars['Int']['output']>;
  /** day */
  day?: Maybe<Scalars['Int']['output']>;
  /** deliveredProduction */
  deliveredProduction?: Maybe<Scalars['Int']['output']>;
  /** deliveredRevenue */
  deliveredRevenue?: Maybe<Scalars['Int']['output']>;
  /** hour */
  hour?: Maybe<Scalars['Int']['output']>;
  /** isCompensatedAvailable */
  isCompensatedAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** isDeliveredAvailable */
  isDeliveredAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** lastUpdatedTs */
  lastUpdatedTs?: Maybe<Scalars['Int']['output']>;
  /** lastUpdatedUser */
  lastUpdatedUser?: Maybe<Scalars['Int']['output']>;
  /** month */
  month?: Maybe<Scalars['Int']['output']>;
  /** source */
  source?: Maybe<Scalars['String']['output']>;
  /** valuesLastUpdatedBy */
  valuesLastUpdatedBy?: Maybe<Scalars['Int']['output']>;
  /** valuesLastUpdatedTs */
  valuesLastUpdatedTs?: Maybe<Scalars['Int']['output']>;
  /** Year */
  year?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceSortInput = {
  _id_country?: InputMaybe<Sort>;
  _id_park?: InputMaybe<Sort>;
  commentLastUpdatedBy?: InputMaybe<Sort>;
  commentLastUpdatedTs?: InputMaybe<Sort>;
  commentText?: InputMaybe<Sort>;
  compensatedProduction?: InputMaybe<Sort>;
  compensatedRevenue?: InputMaybe<Sort>;
  day?: InputMaybe<Sort>;
  deliveredProduction?: InputMaybe<Sort>;
  deliveredRevenue?: InputMaybe<Sort>;
  hour?: InputMaybe<Sort>;
  isCompensatedAvailable?: InputMaybe<Sort>;
  isDeliveredAvailable?: InputMaybe<Sort>;
  lastUpdatedTs?: InputMaybe<Sort>;
  lastUpdatedUser?: InputMaybe<Sort>;
  month?: InputMaybe<Sort>;
  source?: InputMaybe<Sort>;
  valuesLastUpdatedBy?: InputMaybe<Sort>;
  valuesLastUpdatedTs?: InputMaybe<Sort>;
  year?: InputMaybe<Sort>;
};

export type InvoiceWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<InvoiceWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<InvoiceWhereInput>>>;
  _id_country?: InputMaybe<StringInput>;
  _id_park?: InputMaybe<StringInput>;
  commentLastUpdatedBy?: InputMaybe<IntInput>;
  commentLastUpdatedTs?: InputMaybe<IntInput>;
  commentText?: InputMaybe<StringInput>;
  compensatedProduction?: InputMaybe<IntInput>;
  compensatedRevenue?: InputMaybe<IntInput>;
  day?: InputMaybe<IntInput>;
  deliveredProduction?: InputMaybe<IntInput>;
  deliveredRevenue?: InputMaybe<IntInput>;
  hour?: InputMaybe<IntInput>;
  lastUpdatedTs?: InputMaybe<IntInput>;
  lastUpdatedUser?: InputMaybe<IntInput>;
  month?: InputMaybe<IntInput>;
  source?: InputMaybe<StringInput>;
  valuesLastUpdatedBy?: InputMaybe<IntInput>;
  valuesLastUpdatedTs?: InputMaybe<IntInput>;
  year?: InputMaybe<IntInput>;
};

/** Custom configuration to retrieve specific date value with some step back */
export type ImbalanceConfigurationInput = {
  /** Kind of analyze of forecast */
  analyzeType?: InputMaybe<AnalyzeTypeEnum>;
  /** Hour value */
  hoursToLookBehind: Scalars['Int']['input'];
};

/** Integer operators */
export type IntInput = {
  /** Equality operator (=). {$fieldName: {EQ: Int}} */
  EQ?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than operator (>). {$fieldName: {GT: Int}} */
  GT?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal operator (>=). {$fieldName: {GTE: Int}} */
  GTE?: InputMaybe<Scalars['Int']['input']>;
  /** In operator (in). {$fieldName: {IN: [Int1, Int2]}} */
  IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Less than operator (<). {$fieldName: {LT: Int}} */
  LT?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal operator (<=). {$fieldName: {LTE: Int}} */
  LTE?: InputMaybe<Scalars['Int']['input']>;
  /** Not equality operator (!=). {$fieldName: {NEQ: Int}} */
  NEQ?: InputMaybe<Scalars['Int']['input']>;
  /** Not in operator (not in). {$fieldName: {NIN: [Int1, Int2]}} */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type InvoiceInput = {
  _id_country: Scalars['String']['input'];
  _id_park: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  compensated: CompensatedInput;
  delivered: DeliveredInput;
  files?: InputMaybe<Array<InputMaybe<FilesInput>>>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

/** Keep alive message endpoint */
export type Keep_Alive = {
  __typename?: 'KEEP_ALIVE';
  /** Message */
  message: Scalars['String']['output'];
};

export type Keep_AliveSortInput = {
  message?: InputMaybe<Sort>;
};

export type Keep_AliveWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Keep_AliveWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Keep_AliveWhereInput>>>;
  message?: InputMaybe<StringInput>;
};

/** Logbook description */
export type Logbook = {
  __typename?: 'LOGBOOK';
  /** Alarm unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** Park identifier */
  _id_park?: Maybe<Scalars['String']['output']>;
  /** Portfolio identifier */
  _id_portfolio?: Maybe<Scalars['String']['output']>;
  /** Process identifier */
  _id_process?: Maybe<Scalars['String']['output']>;
  /** Turbine identifier */
  _id_turbine?: Maybe<Scalars['String']['output']>;
  /** Deleted flag */
  deleted?: Maybe<Scalars['Int']['output']>;
  /** Alarm duration in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Time when the alarm is closed in unix timestamp */
  endTS?: Maybe<Scalars['Float']['output']>;
  /** Time when the alarm is created in unix timestamp */
  startTS?: Maybe<Scalars['Float']['output']>;
  /** Alarm code */
  tcu?: Maybe<Scalars['String']['output']>;
  /** Active Power during the alarm */
  totalProductionLoss?: Maybe<Scalars['Float']['output']>;
  /** Revenue losses due to alarm */
  totalRevenueLoss?: Maybe<Scalars['Float']['output']>;
};


/** Logbook description */
export type Logbook_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_Id_ParkArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_Id_PortfolioArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_Id_ProcessArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_Id_TurbineArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type LogbookDeletedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type LogbookDurationArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type LogbookEndTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type LogbookStartTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type LogbookTcuArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type LogbookTotalProductionLossArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type LogbookTotalRevenueLossArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};

/** Logbook description */
export type Logbook_Monthly = {
  __typename?: 'LOGBOOK_MONTHLY';
  /** Alarm unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** Park identifier */
  _id_park?: Maybe<Scalars['String']['output']>;
  /** Portfolio identifier */
  _id_portfolio?: Maybe<Scalars['String']['output']>;
  /** Process identifier */
  _id_process?: Maybe<Scalars['String']['output']>;
  /** Turbine identifier */
  _id_turbine?: Maybe<Scalars['String']['output']>;
  /** SubBlock duration in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Time when the subBlock is closed in unix timestamp */
  endTS?: Maybe<Scalars['Float']['output']>;
  /** Alarm log */
  log?: Maybe<Scalars['String']['output']>;
  /** Time when the is generated in unix timestamp */
  mutTS?: Maybe<Scalars['Float']['output']>;
  /** Time when the subBlock is created in unix timestamp */
  startTS?: Maybe<Scalars['Float']['output']>;
  /** Alarm code */
  tcu?: Maybe<Scalars['String']['output']>;
  /** Actual production due to subBlock */
  totalActualProduction?: Maybe<Scalars['Float']['output']>;
  /** Production Losses during the subBlock */
  totalProductionLoss?: Maybe<Scalars['Float']['output']>;
  /** Revenue due to subBlock */
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  /** Revenue losses due to subBlock */
  totalRevenueLoss?: Maybe<Scalars['Float']['output']>;
  /** user comment */
  userComment?: Maybe<Scalars['String']['output']>;
  /** Wind speed inside the limits during the alarm */
  windInLimits?: Maybe<Scalars['Float']['output']>;
  /** Wind speed outside the limits during the alarm */
  windOutLimits?: Maybe<Scalars['Float']['output']>;
};


/** Logbook description */
export type Logbook_Monthly_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_Monthly_Id_ParkArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_Monthly_Id_PortfolioArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_Monthly_Id_ProcessArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_Monthly_Id_TurbineArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyDurationArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyEndTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyLogArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyMutTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyStartTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyTcuArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyTotalActualProductionArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyTotalProductionLossArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyTotalRevenueArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyTotalRevenueLossArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyUserCommentArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyWindInLimitsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Logbook description */
export type Logbook_MonthlyWindOutLimitsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};

export enum Locale {
  De = 'DE',
  En = 'EN'
}

/** Description of manufacturer */
export type Manufacturer = {
  __typename?: 'MANUFACTURER';
  /** Internal ID */
  _id: Scalars['ID']['output'];
  /** Manufacturer name */
  name: Scalars['String']['output'];
};

export type ManufacturerSortInput = {
  _id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type ManufacturerWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ManufacturerWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ManufacturerWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
};

/** MXU description */
export type Mxu_10M = {
  __typename?: 'MXU_10M';
  /** Phase current IL1 */
  A_phsA_cVal_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Phase current IL2 */
  A_phsB_cVal_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Phase current IL3 */
  A_phsC_cVal_avg_mag_f?: Maybe<Snapshot_Result>;
  /** The frequency of a power system in Hz. */
  Hz_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Phase to ground voltage VL1ER */
  PhV_phsA_cVal_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Phase to ground voltage VL2ER */
  PhV_phsB_cVal_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Phase to ground voltage VL3ER */
  PhV_phsC_cVal_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Average power factor for a three-phase circuit. */
  TotPF_avg_mag_f?: Maybe<Snapshot_Result>;
};


/** MXU description */
export type Mxu_10Ma_PhsA_CVal_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_10Ma_PhsB_CVal_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_10Ma_PhsC_CVal_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_10MHz_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_10MPhV_PhsA_CVal_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_10MPhV_PhsB_CVal_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_10MPhV_PhsC_CVal_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_10MTotPf_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

/** MXU description */
export type Mxu_30S = {
  __typename?: 'MXU_30S';
  /** Phase current IL1 */
  A_phsA_cVal_mag_f?: Maybe<Snapshot_Result>;
  /** Phase current IL2 */
  A_phsB_cVal_mag_f?: Maybe<Snapshot_Result>;
  /** Phase current IL3 */
  A_phsC_cVal_mag_f?: Maybe<Snapshot_Result>;
  /** The frequency of a power system in Hz. */
  Hz_mag_f?: Maybe<Snapshot_Result>;
  /** Phase to ground voltage VL1ER */
  PhV_phsA_cVal_mag_f?: Maybe<Snapshot_Result>;
  /** Phase to ground voltage VL2ER */
  PhV_phsB_cVal_mag_f?: Maybe<Snapshot_Result>;
  /** Phase to ground voltage VL3ER */
  PhV_phsC_cVal_mag_f?: Maybe<Snapshot_Result>;
  /** Average power factor for a three-phase circuit. */
  TotPF_mag_f?: Maybe<Snapshot_Result>;
};


/** MXU description */
export type Mxu_30Sa_PhsA_CVal_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_30Sa_PhsB_CVal_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_30Sa_PhsC_CVal_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_30SHz_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_30SPhV_PhsA_CVal_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_30SPhV_PhsB_CVal_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_30SPhV_PhsC_CVal_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** MXU description */
export type Mxu_30STotPf_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

export enum MeterPerSecond {
  Kmh = 'KMH'
}

export type Mutation = {
  __typename?: 'Mutation';
  createCustomTurbineGroup?: Maybe<CreateCustomTurbineGroupResponse>;
  deleteCustomTurbineGroup?: Maybe<DeleteCustomTurbineGroupResponse>;
  deletePlannedEvent?: Maybe<DeletePlannedEventResponse>;
  deleteProcess?: Maybe<DeleteProcessResponse>;
  insertInvoice?: Maybe<InsertInvoiceResponse>;
  newPlannedEvent?: Maybe<NewPlannedEventResponse>;
  newPlannedEvents?: Maybe<NewPlannedEventsResponse>;
  newProcess?: Maybe<NewProcessResponse>;
  updateCustomTurbineGroup?: Maybe<UpdateCustomTurbineGroupResponse>;
  updatePlannedEvent?: Maybe<UpdatePlannedEventResponse>;
  updateProcess?: Maybe<UpdateProcessResponse>;
};


export type MutationCreateCustomTurbineGroupArgs = {
  _id_park: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  turbines: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCustomTurbineGroupArgs = {
  _id_group: Scalars['ID']['input'];
  _id_park: Scalars['ID']['input'];
};


export type MutationDeletePlannedEventArgs = {
  _id: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProcessArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationInsertInvoiceArgs = {
  invoice?: InputMaybe<InvoiceInput>;
};


export type MutationNewPlannedEventArgs = {
  _id_alarm?: InputMaybe<Scalars['ID']['input']>;
  _id_process?: InputMaybe<Scalars['ID']['input']>;
  _id_turbine: Array<Scalars['ID']['input']>;
  category: Scalars['String']['input'];
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  endTs: Scalars['Float']['input'];
  endTsFullRange?: InputMaybe<Scalars['Float']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  limitedTo?: InputMaybe<Scalars['Float']['input']>;
  plannedTCU?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  reminderSettings?: InputMaybe<ReminderSettingsInput>;
  startTs: Scalars['Float']['input'];
  startTsFullRange?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};


export type MutationNewPlannedEventsArgs = {
  newPlannedEvents: Array<NewPlannedEventsInput>;
};


export type MutationNewProcessArgs = {
  _id_parks: Array<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  estimatedEndTs?: InputMaybe<Scalars['Float']['input']>;
  estimatedStartTs?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};


export type MutationUpdateCustomTurbineGroupArgs = {
  _id_group: Scalars['ID']['input'];
  _id_park: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  turbines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdatePlannedEventArgs = {
  _id: Array<Scalars['ID']['input']>;
  _id_process?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTs?: InputMaybe<Scalars['Float']['input']>;
  endTsFullRange?: InputMaybe<Scalars['Float']['input']>;
  limitedTo?: InputMaybe<Scalars['Float']['input']>;
  plannedTCU?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  reminderSettings?: InputMaybe<ReminderSettingsInput>;
  startTs?: InputMaybe<Scalars['Float']['input']>;
  startTsFullRange?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProcessArgs = {
  _id: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedEndTs?: InputMaybe<Scalars['Float']['input']>;
  estimatedStartTs?: InputMaybe<Scalars['Float']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Nacelle description */
export type Nac_10M = {
  __typename?: 'NAC_10M';
  /** Measured temperature inside nacelle control cabinet */
  CtrCabTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Nacelle orientation */
  Dir_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature outside nacelle */
  ExTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside nacelle */
  IntlTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Wind direction outside nacelle */
  WdDir_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Wind speed outside nacelle */
  WdSpd_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Corrected wind speed outside nacelle */
  WdSpd_c_avg_mag_f?: Maybe<Snapshot_Result>;
};


/** Nacelle description */
export type Nac_10MCtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Nacelle description */
export type Nac_10MDir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Nacelle description */
export type Nac_10MExTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Nacelle description */
export type Nac_10MIntlTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Nacelle description */
export type Nac_10MWdDir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Nacelle description */
export type Nac_10MWdSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<MeterPerSecond>;
};


/** Nacelle description */
export type Nac_10MWdSpd_C_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<MeterPerSecond>;
};

/** Nacelle description */
export type Nac_30S = {
  __typename?: 'NAC_30S';
  /** Measured temperature inside nacelle control cabinet */
  CtrCabTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Nacelle orientation */
  Dir_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature outside nacelle */
  ExTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside nacelle */
  IntlTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Wind direction outside nacelle */
  WdDir_mag_f?: Maybe<Snapshot_Result>;
  /** Corrected wind speed outside nacelle */
  WdSpd_c_mag_f?: Maybe<Snapshot_Result>;
  /** Wind speed outside nacelle */
  WdSpd_mag_f?: Maybe<Snapshot_Result>;
};


/** Nacelle description */
export type Nac_30SCtrCabTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Nacelle description */
export type Nac_30SDir_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Nacelle description */
export type Nac_30SExTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Nacelle description */
export type Nac_30SIntlTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Nacelle description */
export type Nac_30SWdDir_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Nacelle description */
export type Nac_30SWdSpd_C_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<MeterPerSecond>;
};


/** Nacelle description */
export type Nac_30SWdSpd_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<MeterPerSecond>;
};

export type NewPlannedEventsInput = {
  _id_alarm?: InputMaybe<Scalars['ID']['input']>;
  _id_process?: InputMaybe<Scalars['ID']['input']>;
  _id_turbine: Array<InputMaybe<Scalars['ID']['input']>>;
  category: Scalars['String']['input'];
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  endTs: Scalars['Float']['input'];
  endTsFullRange?: InputMaybe<Scalars['Float']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  limitedTo?: InputMaybe<Scalars['Float']['input']>;
  plannedTCU?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  reminderSettings?: InputMaybe<ReminderSettingsInput>;
  startTs: Scalars['Float']['input'];
  startTsFullRange?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

/** Description of park */
export type Park = {
  __typename?: 'PARK';
  /** Description of country */
  COUNTRY?: Maybe<Country>;
  /** Data Description */
  DATA?: Maybe<Data_Park>;
  /** List of invoice */
  INVOICES?: Maybe<Array<Maybe<Invoice>>>;
  /** Park Subtype */
  PARK_SUBTYPES?: Maybe<Array<Maybe<Park_Subtype>>>;
  /** Description of portfolio */
  PORTFOLIO?: Maybe<Portfolio>;
  /** Description of turbine */
  TURBINES?: Maybe<Array<Maybe<Turbine>>>;
  /** Internal ID */
  _id: Scalars['ID']['output'];
  /** Park code */
  code: Scalars['String']['output'];
  /** Park data delay */
  dataDelay: Scalars['Int']['output'];
  /** Park Data Granularity */
  dataGranularity: Scalars['Int']['output'];
  /** Park code to display */
  displayCode?: Maybe<Scalars['String']['output']>;
  /** Park name to display */
  displayName: Scalars['String']['output'];
  /** Unix timestamp of the fist arrived data */
  firstAvailableTs: Scalars['Float']['output'];
  /** Park latitude */
  latitude: Scalars['Float']['output'];
  /** Park longitude */
  longitude: Scalars['Float']['output'];
  /** Park name */
  name: Scalars['String']['output'];
  /** Park timezone */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Whether budgets use Revenues V2 by default */
  useRevenuesV2InBudgets?: Maybe<Scalars['Boolean']['output']>;
};


/** Description of park */
export type ParkCountryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<CountrySortInput>;
  where?: InputMaybe<CountryWhereInput>;
};


/** Description of park */
export type ParkInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<Range_Input>;
  sort?: InputMaybe<InvoiceSortInput>;
  where?: InputMaybe<InvoiceWhereInput>;
};


/** Description of park */
export type ParkPark_SubtypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Park_SubtypeSortInput>;
  where?: InputMaybe<Park_SubtypeWhereInput>;
};


/** Description of park */
export type ParkPortfolioArgs = {
  parks?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<PortfolioWhereInput>;
};


/** Description of park */
export type ParkTurbinesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TurbineSortInput>;
  where?: InputMaybe<TurbineWhereInput>;
};

export type ParkSortInput = {
  _id?: InputMaybe<Sort>;
  code?: InputMaybe<Sort>;
  dataDelay?: InputMaybe<Sort>;
  dataGranularity?: InputMaybe<Sort>;
  displayCode?: InputMaybe<Sort>;
  displayName?: InputMaybe<Sort>;
  firstAvailableTs?: InputMaybe<Sort>;
  latitude?: InputMaybe<Sort>;
  longitude?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  timezone?: InputMaybe<Sort>;
  useRevenuesV2InBudgets?: InputMaybe<Sort>;
};

export type ParkWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<ParkWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<ParkWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  code?: InputMaybe<StringInput>;
  dataDelay?: InputMaybe<IntInput>;
  dataGranularity?: InputMaybe<IntInput>;
  displayCode?: InputMaybe<StringInput>;
  displayName?: InputMaybe<StringInput>;
  firstAvailableTs?: InputMaybe<FloatInput>;
  latitude?: InputMaybe<FloatInput>;
  longitude?: InputMaybe<FloatInput>;
  name?: InputMaybe<StringInput>;
  timezone?: InputMaybe<StringInput>;
};

/** Park Subtype */
export type Park_Subtype = {
  __typename?: 'PARK_SUBTYPE';
  /** Data Description */
  DATA?: Maybe<Data_Park_Subtype>;
  /** Description of turbine */
  TURBINES?: Maybe<Array<Maybe<Turbine>>>;
  /** Internal ID */
  _id: Scalars['ID']['output'];
  /** Error catalog name */
  _id_park: Scalars['String']['output'];
  /** Error list */
  _id_turbineSubtype: Scalars['String']['output'];
  /** Error catalog name */
  name: Scalars['String']['output'];
};


/** Park Subtype */
export type Park_SubtypeTurbinesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TurbineSortInput>;
  where?: InputMaybe<TurbineWhereInput>;
};

export type Park_SubtypeSortInput = {
  _id?: InputMaybe<Sort>;
  _id_park?: InputMaybe<Sort>;
  _id_turbineSubtype?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type Park_SubtypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Park_SubtypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Park_SubtypeWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  _id_park?: InputMaybe<StringInput>;
  _id_turbineSubtype?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
};

/** Planned events related with maintenances */
export type Planned_Events = {
  __typename?: 'PLANNED_EVENTS';
  /** Event unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** Alarm unique identifier */
  _id_alarm?: Maybe<Scalars['String']['output']>;
  /** Event grouping unique identifier */
  _id_group?: Maybe<Scalars['String']['output']>;
  /** Park unique identifier */
  _id_park?: Maybe<Scalars['String']['output']>;
  /** Process unique identifier */
  _id_process?: Maybe<Scalars['String']['output']>;
  /** Turbine unique identifier */
  _id_turbine?: Maybe<Scalars['String']['output']>;
  /** Event category */
  category?: Maybe<Scalars['String']['output']>;
  /** Time when the event was created in unix timestamp */
  creationTs?: Maybe<Scalars['Float']['output']>;
  /** Event description */
  description?: Maybe<Scalars['String']['output']>;
  /** Event duration in seconds */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Event duration */
  durationLong?: Maybe<Scalars['String']['output']>;
  /** Event duration */
  durationShort?: Maybe<Scalars['String']['output']>;
  /** Starting time of the event in UTC */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Ending time of the event in unix timestamp */
  endTs?: Maybe<Scalars['Float']['output']>;
  isRecurring?: Maybe<Scalars['Int']['output']>;
  /** Time when the event was last edited by the user in unix timestamp */
  lastEditedTs?: Maybe<Scalars['Float']['output']>;
  /** Time when the event was last updated in unix timestamp */
  lastUpdatedTs?: Maybe<Scalars['Float']['output']>;
  /** Turbine limitation in kW */
  limitedTo?: Maybe<Scalars['Float']['output']>;
  /** Planned TCU */
  plannedTCU?: Maybe<Scalars['String']['output']>;
  /** Forecasted production losses due to the event */
  productionLoss?: Maybe<Scalars['Float']['output']>;
  /** Turbine limitation in kW */
  provider?: Maybe<Scalars['String']['output']>;
  /** Reminder settings */
  reminderSettings?: Maybe<ReminderSettings>;
  /** Forecasted revenue losses due to the event */
  revenueLoss?: Maybe<Scalars['Float']['output']>;
  /** Starting time of the event in UTC */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Starting time of the event in unix timestamp */
  startTs?: Maybe<Scalars['Float']['output']>;
  /** Event title */
  title?: Maybe<Scalars['String']['output']>;
};


/** Planned events related with maintenances */
export type Planned_Events_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_Events_Id_AlarmArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_Events_Id_GroupArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_Events_Id_ParkArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_Events_Id_ProcessArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_Events_Id_TurbineArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsCategoryArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsCreationTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsDescriptionArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsDurationArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsDurationLongArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsDurationShortArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsEndDateArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsEndTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsIsRecurringArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsLastEditedTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsLastUpdatedTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsLimitedToArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsPlannedTcuArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsProductionLossArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsProviderArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsReminderSettingsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsRevenueLossArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsStartDateArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsStartTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Planned events related with maintenances */
export type Planned_EventsTitleArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};

/** Description of portfolio */
export type Portfolio = {
  __typename?: 'PORTFOLIO';
  /** Description of country */
  COUNTRIES?: Maybe<Array<Maybe<Country>>>;
  /** Data Description */
  DATA?: Maybe<Data_Portfolio>;
  /** Description of park */
  PARKS?: Maybe<Array<Maybe<Park>>>;
  /** Custom turbine groups defined by user */
  USER_TURBINE_GROUPS?: Maybe<Array<Maybe<User_Turbine_Group>>>;
  /** Internal ID */
  _id: Scalars['ID']['output'];
  /** Portfolio name */
  name: Scalars['String']['output'];
};


/** Description of portfolio */
export type PortfolioCountriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<CountrySortInput>;
  where?: InputMaybe<CountryWhereInput>;
};


/** Description of portfolio */
export type PortfolioParksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ParkSortInput>;
  turbines?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<ParkWhereInput>;
};


/** Description of portfolio */
export type PortfolioUser_Turbine_GroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<User_Turbine_GroupSortInput>;
  where?: InputMaybe<User_Turbine_GroupWhereInput>;
};

/** Description of powerCurve */
export type Power_Curve = {
  __typename?: 'POWER_CURVE';
  /** Internal ID */
  _id: Scalars['ID']['output'];
  /** Big power curve */
  bigPowerCurve?: Maybe<Array<Maybe<BigPc>>>;
  /** Power curve name */
  name: Scalars['String']['output'];
  /** Small power curve */
  smallPowerCurve?: Maybe<Array<Maybe<SmallPc>>>;
};

export type Power_CurveSortInput = {
  _id?: InputMaybe<Sort>;
  bigPowerCurve?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  smallPowerCurve?: InputMaybe<Sort>;
};

export type Power_CurveWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Power_CurveWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Power_CurveWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
};

/** Processes */
export type Processes = {
  __typename?: 'PROCESSES';
  /** Event unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** Elegible park identifiers */
  _id_parks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of _ids from the events attached to this process */
  _id_plannedEvents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of T-Class Blocks attached to this process */
  _id_tClassBlocks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Process color */
  color?: Maybe<Scalars['String']['output']>;
  /** Time when the event was created in unix timestamp */
  creationTs?: Maybe<Scalars['Float']['output']>;
  /** Process description */
  description?: Maybe<Scalars['String']['output']>;
  /** Estimated end in unix timestamp */
  estimatedEndTs?: Maybe<Scalars['Float']['output']>;
  /** Estimated start in unix timestamp */
  estimatedStartTs?: Maybe<Scalars['Float']['output']>;
  /** Time when the event was last edited by the user in unix timestamp */
  lastEditedTs?: Maybe<Scalars['Float']['output']>;
  /** 0 => Process is closed. 1 => Process is open */
  status?: Maybe<Scalars['Int']['output']>;
  /** Process title */
  title?: Maybe<Scalars['String']['output']>;
};


/** Processes */
export type Processes_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes */
export type Processes_Id_ParksArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes */
export type Processes_Id_PlannedEventsArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes */
export type Processes_Id_TClassBlocksArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes */
export type ProcessesColorArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes */
export type ProcessesCreationTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes */
export type ProcessesDescriptionArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes */
export type ProcessesEstimatedEndTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes */
export type ProcessesEstimatedStartTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes */
export type ProcessesLastEditedTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes */
export type ProcessesStatusArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes */
export type ProcessesTitleArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};

/** Processes Analytics */
export type Processes_Analytics = {
  __typename?: 'PROCESSES_ANALYTICS';
  /** Event unique identifier */
  _id?: Maybe<Scalars['String']['output']>;
  /** Elegible park identifiers */
  _id_parks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of _ids from the events attached to this process */
  _id_plannedEvents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of T-Class Blocks attached to this process */
  _id_tClassBlocks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Process color */
  color?: Maybe<Scalars['String']['output']>;
  /** Time when the event was created in unix timestamp */
  creationTs?: Maybe<Scalars['Float']['output']>;
  /** Process description */
  description?: Maybe<Scalars['String']['output']>;
  /** Planned duration in seconds */
  durationPlanned?: Maybe<Scalars['Float']['output']>;
  /** Planned duration in long format */
  durationPlannedLong?: Maybe<Scalars['String']['output']>;
  /** Planned duration in short format */
  durationPlannedShort?: Maybe<Scalars['String']['output']>;
  /** Realized duration in seconds */
  durationRealized?: Maybe<Scalars['Float']['output']>;
  /** Realized duration in long format */
  durationRealizedLong?: Maybe<Scalars['String']['output']>;
  /** Realized duration in short format */
  durationRealizedShort?: Maybe<Scalars['String']['output']>;
  /** Estimated end in unix timestamp */
  estimatedEndTs?: Maybe<Scalars['Float']['output']>;
  /** Estimated start in unix timestamp */
  estimatedStartTs?: Maybe<Scalars['Float']['output']>;
  /** Time when the event was last edited by the user in unix timestamp */
  lastEditedTs?: Maybe<Scalars['Float']['output']>;
  /** Forecasted production losses due to the planned events */
  productionLossPlanned?: Maybe<Scalars['Float']['output']>;
  /** Realized production losses due to the t-class blocks */
  productionLossRealized?: Maybe<Scalars['Float']['output']>;
  /** Forecasted revenue losses due to the planned events */
  revenueLossPlanned?: Maybe<Scalars['Float']['output']>;
  /** Realized revenue losses due to the t-class blocks */
  revenueLossRealized?: Maybe<Scalars['Float']['output']>;
  /** 0 => Process is closed. 1 => Process is open */
  status?: Maybe<Scalars['Int']['output']>;
  /** Process title */
  title?: Maybe<Scalars['String']['output']>;
};


/** Processes Analytics */
export type Processes_Analytics_IdArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes Analytics */
export type Processes_Analytics_Id_ParksArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes Analytics */
export type Processes_Analytics_Id_PlannedEventsArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes Analytics */
export type Processes_Analytics_Id_TClassBlocksArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsColorArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsCreationTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsDescriptionArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsDurationPlannedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsDurationPlannedLongArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsDurationPlannedShortArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsDurationRealizedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsDurationRealizedLongArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsDurationRealizedShortArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsEstimatedEndTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsEstimatedStartTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsLastEditedTsArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsProductionLossPlannedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsProductionLossRealizedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsRevenueLossPlannedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsRevenueLossRealizedArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsStatusArgs = {
  aggregation?: InputMaybe<Gr_Agr>;
};


/** Processes Analytics */
export type Processes_AnalyticsTitleArgs = {
  aggregation?: InputMaybe<Gb_Agr>;
};

export type PortfolioWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
};

export type ProductionArrWithTime = {
  __typename?: 'ProductionArrWithTime';
  time: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type ProductionLossArrWithTime = {
  __typename?: 'ProductionLossArrWithTime';
  time: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Description of controller */
  CONTROLLERS?: Maybe<Array<Maybe<Controller>>>;
  /** Description of country */
  COUNTRIES?: Maybe<Array<Maybe<Country>>>;
  /** Keep alive message endpoint */
  KEEP_ALIVE?: Maybe<Array<Maybe<Keep_Alive>>>;
  /** Description of manufacturer */
  MANUFACTURERS?: Maybe<Array<Maybe<Manufacturer>>>;
  /** Description of park */
  PARKS?: Maybe<Array<Maybe<Park>>>;
  /** Park Subtype */
  PARK_SUBTYPES?: Maybe<Array<Maybe<Park_Subtype>>>;
  /** Description of portfolio */
  PORTFOLIO?: Maybe<Portfolio>;
  /** Description of turbine */
  TURBINES?: Maybe<Array<Maybe<Turbine>>>;
  /** Description of subtype */
  TURBINE_SUBTYPES?: Maybe<Array<Maybe<Turbine_Subtype>>>;
};


export type QueryControllersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ControllerSortInput>;
  where?: InputMaybe<ControllerWhereInput>;
};


export type QueryCountriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<CountrySortInput>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryKeep_AliveArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Keep_AliveSortInput>;
  where?: InputMaybe<Keep_AliveWhereInput>;
};


export type QueryManufacturersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ManufacturerSortInput>;
  where?: InputMaybe<ManufacturerWhereInput>;
};


export type QueryParksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ParkSortInput>;
  turbines?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<ParkWhereInput>;
};


export type QueryPark_SubtypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Park_SubtypeSortInput>;
  where?: InputMaybe<Park_SubtypeWhereInput>;
};


export type QueryPortfolioArgs = {
  parks?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<PortfolioWhereInput>;
};


export type QueryTurbinesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TurbineSortInput>;
  where?: InputMaybe<TurbineWhereInput>;
};


export type QueryTurbine_SubtypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Turbine_SubtypeSortInput>;
  where?: InputMaybe<Turbine_SubtypeWhereInput>;
};

/** Rotor description */
export type Rot_10M = {
  __typename?: 'ROT_10M';
  /** Temperature inside 2nd rotor hub control cabinet */
  CtrCabTmp2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside 3rd rotor hub control cabinet */
  CtrCabTmp3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside rotor hub control cabinet */
  CtrCabTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature in the rotor hub */
  HubTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Pitch angle for blade 1 */
  PtAngValBl1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Pitch angle for blade 2 */
  PtAngValBl2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Pitch angle for blade 3 */
  PtAngValBl3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Oil temperature of hydraulic pitch system */
  PtHyOilTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Pressure of hydraulic pitch system for blade 1 */
  PtHyPresBl1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Pressure of hydraulic pitch system for blade 2 */
  PtHyPresBl2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Pressure of hydraulic pitch system for blade 3 */
  PtHyPresBl3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Value of rotor speed at rotor side */
  RotSpd_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 1 */
  TmpBl1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 2 */
  TmpBl2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 3 */
  TmpBl3_avg_mag_f?: Maybe<Snapshot_Result>;
};


/** Rotor description */
export type Rot_10MCtrCabTmp2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_10MCtrCabTmp3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_10MCtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_10MHubTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_10MPtAngValBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_10MPtAngValBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_10MPtAngValBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_10MPtHyOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_10MPtHyPresBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_10MPtHyPresBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_10MPtHyPresBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_10MRotSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_10MTmpBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_10MTmpBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_10MTmpBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Rotor description */
export type Rot_30S = {
  __typename?: 'ROT_30S';
  /** Temperature inside 2nd rotor hub control cabinet */
  CtrCabTmp2_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside 3rd rotor hub control cabinet */
  CtrCabTmp3_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside rotor hub control cabinet */
  CtrCabTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature in the rotor hub */
  HubTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Pitch angle blades average */
  PtAngValAvg_mag_f?: Maybe<Snapshot_Result>;
  /** Pitch angle for blade 1 */
  PtAngValBl1_mag_f?: Maybe<Snapshot_Result>;
  /** Pitch angle for blade 2 */
  PtAngValBl2_mag_f?: Maybe<Snapshot_Result>;
  /** Pitch angle for blade 3 */
  PtAngValBl3_mag_f?: Maybe<Snapshot_Result>;
  /** Oil temperature of hydraulic pitch system */
  PtHyOilTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Pressure of hydraulic pitch system blades average */
  PtHyPresAvg_mag_f?: Maybe<Snapshot_Result>;
  /** Pressure of hydraulic pitch system for blade 1 */
  PtHyPresBl1_mag_f?: Maybe<Snapshot_Result>;
  /** Pressure of hydraulic pitch system for blade 2 */
  PtHyPresBl2_mag_f?: Maybe<Snapshot_Result>;
  /** Pressure of hydraulic pitch system for blade 3 */
  PtHyPresBl3_mag_f?: Maybe<Snapshot_Result>;
  /** Value of rotor speed at rotor side */
  RotSpd_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 1 */
  TmpBl1_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 2 */
  TmpBl2_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 3 */
  TmpBl3_mag_f?: Maybe<Snapshot_Result>;
};


/** Rotor description */
export type Rot_30SCtrCabTmp2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_30SCtrCabTmp3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_30SCtrCabTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_30SHubTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_30SPtAngValAvg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_30SPtAngValBl1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_30SPtAngValBl2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_30SPtAngValBl3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_30SPtHyOilTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_30SPtHyPresAvg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_30SPtHyPresBl1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_30SPtHyPresBl2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_30SPtHyPresBl3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_30SRotSpd_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Rotor description */
export type Rot_30STmpBl1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_30STmpBl2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Rotor description */
export type Rot_30STmpBl3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Range Input parameter to describe time range from-to timestamp */
export type RangeInput = {
  /** Range end */
  end: Scalars['Float']['input'];
  /** If set to true the returned data won't include the end limit of the range */
  excludeExtreme?: InputMaybe<Scalars['Boolean']['input']>;
  /** Range start */
  start: Scalars['Float']['input'];
};

/** Get timeseries by relative values in hours */
export type RelativeInput = {
  /** Time unit */
  timeUnit: UnitEnum;
  /** Offset ending point in terms of time unit upwards. Negative backwards in time and positive forward in time */
  timeUnitOffset?: InputMaybe<Scalars['Float']['input']>;
  /** Time Range in terms of units of time back. */
  timeUnitRange: Scalars['Float']['input'];
};

export type ReminderSettings = {
  __typename?: 'ReminderSettings';
  recipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timeGranularity?: Maybe<TimeGranularity>;
  timeValue?: Maybe<Scalars['Int']['output']>;
};

export type ReminderSettingsInput = {
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeGranularity?: InputMaybe<TimeGranularity>;
  timeValue?: InputMaybe<Scalars['Int']['input']>;
};

/** SnapshotType description */
export type Snapshot_Country = {
  __typename?: 'SNAPSHOT_COUNTRY';
  /** 10 minutes Data Stream */
  DATA_10M?: Maybe<Data_10M>;
  /** 30 seconds Data Stream */
  DATA_30S?: Maybe<Data_30S>;
};

/** SnapshotType description */
export type Snapshot_Park = {
  __typename?: 'SNAPSHOT_PARK';
  /** 10 minutes Data Stream */
  DATA_10M?: Maybe<Data_10M>;
  /** 30 seconds Data Stream */
  DATA_30S?: Maybe<Data_30S>;
};

/** SnapshotType description */
export type Snapshot_Portfolio = {
  __typename?: 'SNAPSHOT_PORTFOLIO';
  /** 10 minutes Data Stream */
  DATA_10M?: Maybe<Data_10M>;
  /** 30 seconds Data Stream */
  DATA_30S?: Maybe<Data_30S>;
};

/** SNAPSHOT_RESULT */
export type Snapshot_Result = {
  __typename?: 'SNAPSHOT_RESULT';
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  signalName?: Maybe<Scalars['String']['output']>;
  standardUnit?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};


/** SNAPSHOT_RESULT */
export type Snapshot_ResultDisplayNameArgs = {
  locale?: InputMaybe<Locale>;
};

/** SnapshotType description */
export type Snapshot_Turbine = {
  __typename?: 'SNAPSHOT_TURBINE';
  /** 10 minutes Data Stream */
  DATA_10M?: Maybe<Data_10M>;
  /** 30 seconds Data Stream */
  DATA_30S?: Maybe<Data_30S>;
};

export type Sampling = {
  /** Sampling unit */
  unit: UnitEnum;
  /** Sampling value */
  value: Scalars['Float']['input'];
};

/** Custom sampling interval. Allows you scale a timeserie up or down */
export type SamplingIntervalInput = {
  /** Time unit */
  unit: UnitEnum;
  /** Time value */
  value: Scalars['Float']['input'];
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** String operators */
export type StringInput = {
  /** Equality operator (=). {$fieldName: {EQ: "String"}} */
  EQ?: InputMaybe<Scalars['String']['input']>;
  /** In operator (in). {$fieldName: {IN: ["String1", "String2"]}} */
  IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equality operator (!=). {$fieldName: {NEQ: "String"}} */
  NEQ?: InputMaybe<Scalars['String']['input']>;
  /** Not in operator (not in). {$fieldName: {NIN: ["String1", "String2"]}} */
  NIN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Regular Expression. {$fieldName: {REGEX: "/wind-log/"}} */
  REGEX?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Description of controller */
  CONTROLLERS: Array<Controller>;
  /** Description of country */
  COUNTRIES: Array<Country>;
  /** Keep alive message endpoint */
  KEEP_ALIVE: Array<Keep_Alive>;
  /** Description of manufacturer */
  MANUFACTURERS: Array<Manufacturer>;
  /** Description of park */
  PARKS: Array<Park>;
  /** Park Subtype */
  PARK_SUBTYPES: Array<Park_Subtype>;
  /** Description of portfolio */
  PORTFOLIO: Portfolio;
  /** Description of turbine */
  TURBINES: Array<Turbine>;
  /** Description of subtype */
  TURBINE_SUBTYPES: Array<Turbine_Subtype>;
};


export type SubscriptionControllersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ControllerSortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ControllerWhereInput>;
};


export type SubscriptionCountriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<CountrySortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type SubscriptionKeep_AliveArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Keep_AliveSortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Keep_AliveWhereInput>;
};


export type SubscriptionManufacturersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ManufacturerSortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ManufacturerWhereInput>;
};


export type SubscriptionParksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ParkSortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  turbines?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<ParkWhereInput>;
};


export type SubscriptionPark_SubtypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Park_SubtypeSortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Park_SubtypeWhereInput>;
};


export type SubscriptionPortfolioArgs = {
  parks?: InputMaybe<Array<Scalars['String']['input']>>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PortfolioWhereInput>;
};


export type SubscriptionTurbinesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TurbineSortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TurbineWhereInput>;
};


export type SubscriptionTurbine_SubtypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Turbine_SubtypeSortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Turbine_SubtypeWhereInput>;
};

/** Table type data */
export type Table_Country = {
  __typename?: 'TABLE_COUNTRY';
  /** Alarms Data Stream */
  DATA_ALX?: Maybe<Table_Data_Alx>;
  /** Logbook Data Stream */
  DATA_LGB?: Maybe<Table_Data_Lgb>;
  /** Planning Data Stream */
  DATA_PLN?: Maybe<Table_Data_Pln>;
};

/** Alarms Data Stream */
export type Table_Data_Alx = {
  __typename?: 'TABLE_DATA_ALX';
  /** Alarms */
  alarms?: Maybe<Array<Maybe<Alarms>>>;
};


/** Alarms Data Stream */
export type Table_Data_AlxAlarmsArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Alx_OrderByInput>;
  where?: InputMaybe<Data_Alx_TableWhereInput>;
};

/** Alarms Data Stream */
export type Table_Data_Alx_Daily = {
  __typename?: 'TABLE_DATA_ALX_DAILY';
  /** Alarms */
  alarms?: Maybe<Array<Maybe<Alarms>>>;
};


/** Alarms Data Stream */
export type Table_Data_Alx_DailyAlarmsArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Alx_OrderByInput>;
  where?: InputMaybe<Data_Alx_TableWhereInput>;
};

/** Budget Data Stream */
export type Table_Data_Bdg = {
  __typename?: 'TABLE_DATA_BDG';
  /** Budget Information */
  budget?: Maybe<Array<Maybe<Budget>>>;
};


/** Budget Data Stream */
export type Table_Data_BdgBudgetArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Bdg_OrderByInput>;
  where?: InputMaybe<Data_Bdg_TableWhereInput>;
};

/** Budget Data Stream */
export type Table_Data_Bgd = {
  __typename?: 'TABLE_DATA_BGD';
  /** Budget */
  budget_by_country?: Maybe<Array<Maybe<Budget_By_Country>>>;
  /** Budget */
  budget_by_country_month?: Maybe<Array<Maybe<Budget_By_Country_Month>>>;
  /** Budget */
  budget_by_day?: Maybe<Array<Maybe<Budget_By_Day>>>;
  /** Budget */
  budget_by_month?: Maybe<Array<Maybe<Budget_By_Month>>>;
  /** Budget */
  budget_by_park?: Maybe<Array<Maybe<Budget_By_Park>>>;
  /** Budget */
  budget_by_park_month?: Maybe<Array<Maybe<Budget_By_Park_Month>>>;
  /** Budget summary */
  budget_summary?: Maybe<Budget_Summary>;
  /** Budget */
  budget_total?: Maybe<Array<Maybe<Budget_Total>>>;
};


/** Budget Data Stream */
export type Table_Data_BgdBudget_By_CountryArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Bgd2_OrderByInput>;
  where?: InputMaybe<Data_Bgd2_TableWhereInput>;
};


/** Budget Data Stream */
export type Table_Data_BgdBudget_By_Country_MonthArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Bgd2_OrderByInput>;
  where?: InputMaybe<Data_Bgd2_TableWhereInput>;
};


/** Budget Data Stream */
export type Table_Data_BgdBudget_By_DayArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Budget Data Stream */
export type Table_Data_BgdBudget_By_MonthArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Bgd2_OrderByInput>;
  where?: InputMaybe<Data_Bgd2_TableWhereInput>;
};


/** Budget Data Stream */
export type Table_Data_BgdBudget_By_ParkArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Bgd2_OrderByInput>;
  where?: InputMaybe<Data_Bgd2_TableWhereInput>;
};


/** Budget Data Stream */
export type Table_Data_BgdBudget_By_Park_MonthArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Bgd2_OrderByInput>;
  where?: InputMaybe<Data_Bgd2_TableWhereInput>;
};


/** Budget Data Stream */
export type Table_Data_BgdBudget_SummaryArgs = {
  range: BudgetSummaryRangeInput;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Budget Data Stream */
export type Table_Data_BgdBudget_TotalArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Bgd_OrderByInput>;
  where?: InputMaybe<Data_Bgd_TableWhereInput>;
};

/** Logbook Data Stream */
export type Table_Data_Lgb = {
  __typename?: 'TABLE_DATA_LGB';
  /** Logbook description */
  logbook?: Maybe<Array<Maybe<Logbook>>>;
  /** Logbook description */
  logbook_monthly?: Maybe<Array<Maybe<Logbook_Monthly>>>;
};


/** Logbook Data Stream */
export type Table_Data_LgbLogbookArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Lgb_OrderByInput>;
  where?: InputMaybe<Data_Lgb_TableWhereInput>;
};


/** Logbook Data Stream */
export type Table_Data_LgbLogbook_MonthlyArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Lgm_OrderByInput>;
  where?: InputMaybe<Data_Lgm_TableWhereInput>;
};

/** Planning Data Stream */
export type Table_Data_Pln = {
  __typename?: 'TABLE_DATA_PLN';
  /** Planned events related with maintenances */
  planned_events?: Maybe<Array<Maybe<Planned_Events>>>;
  /** Processes */
  processes?: Maybe<Array<Maybe<Processes>>>;
  /** Processes Analytics */
  processes_analytics?: Maybe<Array<Maybe<Processes_Analytics>>>;
};


/** Planning Data Stream */
export type Table_Data_PlnPlanned_EventsArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Ple_OrderByInput>;
  splittedLosess?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Data_Ple_TableWhereInput>;
};


/** Planning Data Stream */
export type Table_Data_PlnProcessesArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Prc_OrderByInput>;
  where?: InputMaybe<Data_Prc_TableWhereInput>;
};


/** Planning Data Stream */
export type Table_Data_PlnProcesses_AnalyticsArgs = {
  aggrLimit?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Data_Pra_OrderByInput>;
  where?: InputMaybe<Data_Pra_TableWhereInput>;
};

/** Table type data */
export type Table_Park = {
  __typename?: 'TABLE_PARK';
  /** Alarms Data Stream */
  DATA_ALX?: Maybe<Table_Data_Alx>;
  /** Alarms Data Stream */
  DATA_ALX_DAILY?: Maybe<Table_Data_Alx_Daily>;
  /** Budget Data Stream */
  DATA_BDG?: Maybe<Table_Data_Bdg>;
  /** Budget Data Stream */
  DATA_BGD?: Maybe<Table_Data_Bgd>;
  /** Logbook Data Stream */
  DATA_LGB?: Maybe<Table_Data_Lgb>;
  /** Planning Data Stream */
  DATA_PLN?: Maybe<Table_Data_Pln>;
};


/** Table type data */
export type Table_ParkData_BgdArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Table type data */
export type Table_Portfolio = {
  __typename?: 'TABLE_PORTFOLIO';
  /** Alarms Data Stream */
  DATA_ALX?: Maybe<Table_Data_Alx>;
  /** Alarms Data Stream */
  DATA_ALX_DAILY?: Maybe<Table_Data_Alx_Daily>;
  /** Budget Data Stream */
  DATA_BGD?: Maybe<Table_Data_Bgd>;
  /** Logbook Data Stream */
  DATA_LGB?: Maybe<Table_Data_Lgb>;
  /** Planning Data Stream */
  DATA_PLN?: Maybe<Table_Data_Pln>;
};


/** Table type data */
export type Table_PortfolioData_BgdArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Table type data */
export type Table_Turbine = {
  __typename?: 'TABLE_TURBINE';
  /** Alarms Data Stream */
  DATA_ALX?: Maybe<Table_Data_Alx>;
  /** Alarms Data Stream */
  DATA_ALX_DAILY?: Maybe<Table_Data_Alx_Daily>;
  /** Logbook Data Stream */
  DATA_LGB?: Maybe<Table_Data_Lgb>;
  /** Planning Data Stream */
  DATA_PLN?: Maybe<Table_Data_Pln>;
};

/** Timeseries description */
export type Timeseries_Country = {
  __typename?: 'TIMESERIES_COUNTRY';
  /** 10 minutes Data Stream */
  DATA_10M?: Maybe<Ts_Data_10M>;
  /** 30 seconds Data Stream */
  DATA_30S?: Maybe<Ts_Data_30S>;
  /** Planning Data */
  DATA_PLN?: Maybe<Ts_Data_Pln>;
  /** Weather Forecast Data */
  DATA_WFC?: Maybe<Ts_Data_Wfc>;
};

/** Timeseries description */
export type Timeseries_Park = {
  __typename?: 'TIMESERIES_PARK';
  /** 10 minutes Data Stream */
  DATA_10M?: Maybe<Ts_Data_10M>;
  /** 30 seconds Data Stream */
  DATA_30S?: Maybe<Ts_Data_30S>;
  /** Planning Data */
  DATA_PLN?: Maybe<Ts_Data_Pln>;
  /** Weather Forecast Data */
  DATA_WFC?: Maybe<Ts_Data_Wfc>;
};

/** Timeseries description */
export type Timeseries_Park_Subtype = {
  __typename?: 'TIMESERIES_PARK_SUBTYPE';
  /** 10 minutes Data Stream */
  DATA_10M?: Maybe<Ts_Data_10M>;
};

/** Timeseries description */
export type Timeseries_Portfolio = {
  __typename?: 'TIMESERIES_PORTFOLIO';
  /** 10 minutes Data Stream */
  DATA_10M?: Maybe<Ts_Data_10M>;
  /** 30 seconds Data Stream */
  DATA_30S?: Maybe<Ts_Data_30S>;
  /** Planning Data */
  DATA_PLN?: Maybe<Ts_Data_Pln>;
  /** Weather Forecast Data */
  DATA_WFC?: Maybe<Ts_Data_Wfc>;
};

/** Timeseries result */
export type Timeseries_Result = {
  __typename?: 'TIMESERIES_RESULT';
  count?: Maybe<Scalars['Int']['output']>;
  dataJSON?: Maybe<Array<Maybe<JsonMap>>>;
  dataKeyValue?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  dataTimestamp?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  dataValue?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  displayName?: Maybe<Scalars['String']['output']>;
  endTS?: Maybe<Scalars['Float']['output']>;
  interval?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  signalName?: Maybe<Scalars['String']['output']>;
  standardUnit?: Maybe<Scalars['String']['output']>;
  startTS?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};


/** Timeseries result */
export type Timeseries_ResultDisplayNameArgs = {
  locale?: InputMaybe<Locale>;
};

/** Timeseries description */
export type Timeseries_Turbine = {
  __typename?: 'TIMESERIES_TURBINE';
  /** 10 minutes Data Stream */
  DATA_10M?: Maybe<Ts_Data_10M>;
  /** 30 seconds Data Stream */
  DATA_30S?: Maybe<Ts_Data_30S>;
  /** Planning Data */
  DATA_PLN?: Maybe<Ts_Data_Pln>;
  /** Weather Forecast Data */
  DATA_WFC?: Maybe<Ts_Data_Wfc>;
};

/** Turbine temperature deviation from the park average */
export type Tmd_10M = {
  __typename?: 'TMD_10M';
  /** Measured temperature of the converter’s choke coil phase 2 */
  WCNV1_CnvTmpChokeCoil2_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the converter’s choke coil phase 3 */
  WCNV1_CnvTmpChokeCoil3_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the converter’s choke coil */
  WCNV1_CnvTmpChokeCoil_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter */
  WCNV1_CnvTmpDclink_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature fo the converter’s cooling water */
  WCNV1_CnvTmpWater_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator bearing 1 */
  WGEN1_GnTmpBrg1_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator bearing 2 */
  WGEN1_GnTmpBrg2_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature measurement for inlet air/water temperature at generator */
  WGEN1_GnTmpInlet_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature measurement for outlet air/water temperature at generator */
  WGEN1_GnTmpOutlet_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 1 */
  WGEN1_GnTmpPhase1_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 2 */
  WGEN1_GnTmpPhase2_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 3 */
  WGEN1_GnTmpPhase3_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator rotor */
  WGEN1_GnTmpRtr_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator slipring 1 */
  WGEN1_GnTmpSlpRing1_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 2 */
  WGEN1_GnTmpSta2_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 3 */
  WGEN1_GnTmpSta3_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 4 */
  WGEN1_GnTmpSta4_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 5 */
  WGEN1_GnTmpSta5_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 6 */
  WGEN1_GnTmpSta6_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator */
  WGEN1_GnTmpSta_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature inside nacelle control cabinet */
  WNAC1_CtrCabTmp_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature outside nacelle */
  WNAC1_ExTmp_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature inside nacelle */
  WNAC1_IntlTmp_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WNAC1_TopCtrCabTmp1_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature inside rotor hub control cabinet */
  WROT1_CtrCabTmp_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature in the rotor hub */
  WROT1_HubTmp_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Oil temperature of hydraulic pitch system */
  WROT1_PtHyOilTmp_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTF1_TrfAuxTmp_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Temperature inside control cabinet at the bottom of the tower */
  WTOW1_CtrCabTmp_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer room */
  WTRF1_RoomTmp_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp1_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp2_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp3_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfOilTmp_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 1 */
  WTRF1_TrfTmpPhase1_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 2 */
  WTRF1_TrfTmpPhase2_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 3 */
  WTRF1_TrfTmpPhase3_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 1 */
  WTRM1_TrmTmpGbxBrg1_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 2 */
  WTRM1_TrmTmpGbxBrg2_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 3 */
  WTRM1_TrmTmpGbxBrg3_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpGbxBrg4_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpGbxBrg5_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox oil */
  WTRM1_TrmTmpGbxOil_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft bearing 1 */
  WTRM1_TrmTmpShfBrg1_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft bearing 2 */
  WTRM1_TrmTmpShfBrg2_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpWtr_avg_per_deviation?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTUR1_TurTmpUPS_avg_per_deviation?: Maybe<Snapshot_Result>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWcnv1_CnvTmpChokeCoil2_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWcnv1_CnvTmpChokeCoil3_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWcnv1_CnvTmpChokeCoil_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWcnv1_CnvTmpDclink_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWcnv1_CnvTmpWater_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpBrg1_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpBrg2_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpInlet_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpOutlet_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpPhase1_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpPhase2_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpPhase3_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpRtr_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpSlpRing1_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpSta2_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpSta3_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpSta4_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpSta5_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpSta6_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWgen1_GnTmpSta_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWnac1_CtrCabTmp_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWnac1_ExTmp_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWnac1_IntlTmp_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWnac1_TopCtrCabTmp1_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWrot1_CtrCabTmp_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWrot1_HubTmp_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWrot1_PtHyOilTmp_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtf1_TrfAuxTmp_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtow1_CtrCabTmp_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrf1_RoomTmp_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrf1_TrfCoreTmp1_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrf1_TrfCoreTmp2_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrf1_TrfCoreTmp3_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrf1_TrfOilTmp_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrf1_TrfTmpPhase1_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrf1_TrfTmpPhase2_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrf1_TrfTmpPhase3_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrm1_TrmTmpGbxBrg1_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrm1_TrmTmpGbxBrg2_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrm1_TrmTmpGbxBrg3_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrm1_TrmTmpGbxBrg4_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrm1_TrmTmpGbxBrg5_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrm1_TrmTmpGbxOil_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrm1_TrmTmpShfBrg1_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrm1_TrmTmpShfBrg2_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtrm1_TrmTmpWtr_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine temperature deviation from the park average */
export type Tmd_10MWtur1_TurTmpUps_Avg_Per_DeviationArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

/** Temperature description */
export type Tmp_10M = {
  __typename?: 'TMP_10M';
  /** Measured temperature of the converter’s choke coil phase 2 */
  WCNV1_CnvTmpChokeCoil2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the converter’s choke coil phase 3 */
  WCNV1_CnvTmpChokeCoil3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the converter’s choke coil */
  WCNV1_CnvTmpChokeCoil_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter */
  WCNV1_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature fo the converter’s cooling water */
  WCNV1_CnvTmpWater_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 2 */
  WCNV2_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 3 */
  WCNV3_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 4 */
  WCNV4_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 5 */
  WCNV5_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 6 */
  WCNV6_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 7 */
  WCNV7_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 8 */
  WCNV8_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 9 */
  WCNV9_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 10 */
  WCNV10_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 11 */
  WCNV11_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 12 */
  WCNV12_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 13 */
  WCNV13_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 14 */
  WCNV14_CnvTmpDclink_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator bearing 1 */
  WGEN1_GnTmpBrg1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator bearing 2 */
  WGEN1_GnTmpBrg2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurement for inlet air/water temperature at generator */
  WGEN1_GnTmpInlet_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurement for outlet air/water temperature at generator */
  WGEN1_GnTmpOutlet_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 1 */
  WGEN1_GnTmpPhase1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 2 */
  WGEN1_GnTmpPhase2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 3 */
  WGEN1_GnTmpPhase3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator rotor, phase 3 */
  WGEN1_GnTmpRtr3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator rotor */
  WGEN1_GnTmpRtr_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator slipring 1 */
  WGEN1_GnTmpSlpRing1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator slipring 2 */
  WGEN1_GnTmpSlpRing2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 2 */
  WGEN1_GnTmpSta2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 3 */
  WGEN1_GnTmpSta3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 4 */
  WGEN1_GnTmpSta4_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 5 */
  WGEN1_GnTmpSta5_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 6 */
  WGEN1_GnTmpSta6_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator */
  WGEN1_GnTmpSta_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature inside nacelle control cabinet */
  WNAC1_CtrCabTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature outside nacelle */
  WNAC1_ExTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside nacelle */
  WNAC1_IntlTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WNAC1_TopCtrCabTmp1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside 2nd rotor hub control cabinet */
  WROT1_CtrCabTmp2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside 3rd rotor hub control cabinet */
  WROT1_CtrCabTmp3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside rotor hub control cabinet */
  WROT1_CtrCabTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature in the rotor hub */
  WROT1_HubTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Oil temperature of hydraulic pitch system */
  WROT1_PtHyOilTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 1 */
  WROT1_TmpBl1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 2 */
  WROT1_TmpBl2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 3 */
  WROT1_TmpBl3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTF1_TrfAuxTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside control cabinet at the bottom of the tower */
  WTOW1_CtrCabTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer room */
  WTRF1_RoomTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfOilTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 1 */
  WTRF1_TrfTmpPhase1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 2 */
  WTRF1_TrfTmpPhase2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 3 */
  WTRF1_TrfTmpPhase3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 1 */
  WTRM1_TrmTmpGbxBrg1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 2 */
  WTRM1_TrmTmpGbxBrg2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 3 */
  WTRM1_TrmTmpGbxBrg3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpGbxBrg4_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpGbxBrg5_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox oil */
  WTRM1_TrmTmpGbxOil_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft bearing 1 */
  WTRM1_TrmTmpShfBrg1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft bearing 2 */
  WTRM1_TrmTmpShfBrg2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft brake */
  WTRM1_TrmTmpShfBrk_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpWtr_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTUR1_TurTmpUPS_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside yaw control cabinet */
  WYAW1_CtrCabTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 2 temperature */
  WYAW1_Tmp2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 3 temperature */
  WYAW1_Tmp3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 4 temperature */
  WYAW1_Tmp4_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 5 temperature */
  WYAW1_Tmp5_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 6 temperature */
  WYAW1_Tmp6_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear temperature */
  WYAW1_Tmp_avg_mag_f?: Maybe<Snapshot_Result>;
};


/** Temperature description */
export type Tmp_10MWcnv1_CnvTmpChokeCoil2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv1_CnvTmpChokeCoil3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv1_CnvTmpChokeCoil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv1_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv1_CnvTmpWater_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv2_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv3_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv4_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv5_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv6_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv7_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv8_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv9_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv10_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv11_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv12_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv13_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWcnv14_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpInlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpOutlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpRtr3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpRtr_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpSlpRing1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpSlpRing2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpSta2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpSta3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpSta4_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpSta5_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpSta6_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWgen1_GnTmpSta_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWnac1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWnac1_ExTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWnac1_IntlTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWnac1_TopCtrCabTmp1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Temperature description */
export type Tmp_10MWrot1_CtrCabTmp2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWrot1_CtrCabTmp3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWrot1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWrot1_HubTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWrot1_PtHyOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWrot1_TmpBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWrot1_TmpBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWrot1_TmpBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtf1_TrfAuxTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Temperature description */
export type Tmp_10MWtow1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrf1_RoomTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrf1_TrfCoreTmp1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Temperature description */
export type Tmp_10MWtrf1_TrfCoreTmp2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Temperature description */
export type Tmp_10MWtrf1_TrfCoreTmp3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Temperature description */
export type Tmp_10MWtrf1_TrfOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrf1_TrfTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrf1_TrfTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrf1_TrfTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrm1_TrmTmpGbxBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrm1_TrmTmpGbxBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrm1_TrmTmpGbxBrg3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrm1_TrmTmpGbxBrg4_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Temperature description */
export type Tmp_10MWtrm1_TrmTmpGbxBrg5_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Temperature description */
export type Tmp_10MWtrm1_TrmTmpGbxOil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrm1_TrmTmpShfBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrm1_TrmTmpShfBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrm1_TrmTmpShfBrk_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWtrm1_TrmTmpWtr_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Temperature description */
export type Tmp_10MWtur1_TurTmpUps_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Temperature description */
export type Tmp_10MWyaw1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWyaw1_Tmp2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWyaw1_Tmp3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWyaw1_Tmp4_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWyaw1_Tmp5_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWyaw1_Tmp6_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_10MWyaw1_Tmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Temperature description */
export type Tmp_30S = {
  __typename?: 'TMP_30S';
  /** Measured temperature of the converter’s choke coil phase 2 */
  WCNV1_CnvTmpChokeCoil2_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the converter’s choke coil phase 3 */
  WCNV1_CnvTmpChokeCoil3_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the converter’s choke coil */
  WCNV1_CnvTmpChokeCoil_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter */
  WCNV1_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature fo the converter’s cooling water */
  WCNV1_CnvTmpWater_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 2 */
  WCNV2_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 3 */
  WCNV3_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 4 */
  WCNV4_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 5 */
  WCNV5_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 6 */
  WCNV6_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 7 */
  WCNV7_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 8 */
  WCNV8_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 9 */
  WCNV9_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 10 */
  WCNV10_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 11 */
  WCNV11_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 12 */
  WCNV12_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 13 */
  WCNV13_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside the converter number 14 */
  WCNV14_CnvTmpDclink_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator bearing 1 */
  WGEN1_GnTmpBrg1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator bearing 2 */
  WGEN1_GnTmpBrg2_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurement for inlet air/water temperature at generator */
  WGEN1_GnTmpInlet_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurement for outlet air/water temperature at generator */
  WGEN1_GnTmpOutlet_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 1 */
  WGEN1_GnTmpPhase1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 2 */
  WGEN1_GnTmpPhase2_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator phase 3 */
  WGEN1_GnTmpPhase3_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator rotor */
  WGEN1_GnTmpRtr_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator slipring 1 */
  WGEN1_GnTmpSlpRing1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of generator slipring 2 */
  WGEN1_GnTmpSlpRing2_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 2 */
  WGEN1_GnTmpSta2_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 3 */
  WGEN1_GnTmpSta3_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 4 */
  WGEN1_GnTmpSta4_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 5 */
  WGEN1_GnTmpSta5_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator segment 6 */
  WGEN1_GnTmpSta6_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature measurements for generator stator */
  WGEN1_GnTmpSta_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature inside nacelle control cabinet */
  WNAC1_CtrCabTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature outside nacelle */
  WNAC1_ExTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside nacelle */
  WNAC1_IntlTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside 2nd rotor hub control cabinet */
  WROT1_CtrCabTmp2_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside 3rd rotor hub control cabinet */
  WROT1_CtrCabTmp3_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside rotor hub control cabinet */
  WROT1_CtrCabTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature in the rotor hub */
  WROT1_HubTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Oil temperature of hydraulic pitch system */
  WROT1_PtHyOilTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 1 */
  WROT1_TmpBl1_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 2 */
  WROT1_TmpBl2_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature of rotor blade 3 */
  WROT1_TmpBl3_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside control cabinet at the bottom of the tower */
  WTOW1_CtrCabTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer room */
  WTRF1_RoomTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfOilTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 1 */
  WTRF1_TrfTmpPhase1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 2 */
  WTRF1_TrfTmpPhase2_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 3 */
  WTRF1_TrfTmpPhase3_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 1 */
  WTRM1_TrmTmpGbxBrg1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 2 */
  WTRM1_TrmTmpGbxBrg2_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 3 */
  WTRM1_TrmTmpGbxBrg3_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox oil */
  WTRM1_TrmTmpGbxOil_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft bearing 1 */
  WTRM1_TrmTmpShfBrg1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft bearing 2 */
  WTRM1_TrmTmpShfBrg2_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft brake */
  WTRM1_TrmTmpShfBrk_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside yaw control cabinet */
  WYAW1_CtrCabTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 2 temperature */
  WYAW1_Tmp2_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 3 temperature */
  WYAW1_Tmp3_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 4 temperature */
  WYAW1_Tmp4_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 5 temperature */
  WYAW1_Tmp5_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 6 temperature */
  WYAW1_Tmp6_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear temperature */
  WYAW1_Tmp_mag_f?: Maybe<Snapshot_Result>;
};


/** Temperature description */
export type Tmp_30SWcnv1_CnvTmpChokeCoil2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv1_CnvTmpChokeCoil3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv1_CnvTmpChokeCoil_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv1_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv1_CnvTmpWater_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv2_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv3_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv4_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv5_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv6_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv7_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv8_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv9_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv10_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv11_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv12_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv13_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWcnv14_CnvTmpDclink_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpBrg1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpBrg2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpInlet_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpOutlet_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpPhase1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpPhase2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpPhase3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpRtr_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpSlpRing1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpSlpRing2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpSta2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpSta3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpSta4_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpSta5_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpSta6_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWgen1_GnTmpSta_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWnac1_CtrCabTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWnac1_ExTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWnac1_IntlTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWrot1_CtrCabTmp2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWrot1_CtrCabTmp3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWrot1_CtrCabTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWrot1_HubTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWrot1_PtHyOilTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWrot1_TmpBl1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWrot1_TmpBl2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWrot1_TmpBl3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtow1_CtrCabTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrf1_RoomTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrf1_TrfOilTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrf1_TrfTmpPhase1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrf1_TrfTmpPhase2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrf1_TrfTmpPhase3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrm1_TrmTmpGbxBrg1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrm1_TrmTmpGbxBrg2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrm1_TrmTmpGbxBrg3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrm1_TrmTmpGbxOil_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrm1_TrmTmpShfBrg1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrm1_TrmTmpShfBrg2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWtrm1_TrmTmpShfBrk_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWyaw1_CtrCabTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWyaw1_Tmp2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWyaw1_Tmp3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWyaw1_Tmp4_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWyaw1_Tmp5_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWyaw1_Tmp6_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Temperature description */
export type Tmp_30SWyaw1_Tmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Tower description */
export type Tow_10M = {
  __typename?: 'TOW_10M';
  /** Temperature inside control cabinet at the bottom of the tower */
  CtrCabTmp_avg_mag_f?: Maybe<Snapshot_Result>;
};


/** Tower description */
export type Tow_10MCtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Tower description */
export type Tow_30S = {
  __typename?: 'TOW_30S';
  /** Temperature inside control cabinet at the bottom of the tower */
  CtrCabTmp_mag_f?: Maybe<Snapshot_Result>;
};


/** Tower description */
export type Tow_30SCtrCabTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Trafo description */
export type Trf_10M = {
  __typename?: 'TRF_10M';
  /** Measured temperature of the transformer room */
  RoomTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  TrfOilTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 1 */
  TrfTmpPhase1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 2 */
  TrfTmpPhase2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 3 */
  TrfTmpPhase3_avg_mag_f?: Maybe<Snapshot_Result>;
};


/** Trafo description */
export type Trf_10MRoomTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trafo description */
export type Trf_10MTrfOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trafo description */
export type Trf_10MTrfTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trafo description */
export type Trf_10MTrfTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trafo description */
export type Trf_10MTrfTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Trafo description */
export type Trf_30S = {
  __typename?: 'TRF_30S';
  /** Measured temperature of the transformer room */
  RoomTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of the transformer oil */
  TrfOilTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 1 */
  TrfTmpPhase1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 2 */
  TrfTmpPhase2_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of transformer phase 3 */
  TrfTmpPhase3_mag_f?: Maybe<Snapshot_Result>;
};


/** Trafo description */
export type Trf_30SRoomTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trafo description */
export type Trf_30STrfOilTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trafo description */
export type Trf_30STrfTmpPhase1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trafo description */
export type Trf_30STrfTmpPhase2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trafo description */
export type Trf_30STrfTmpPhase3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Trm description */
export type Trm_10M = {
  __typename?: 'TRM_10M';
  /** Hydraulic pressure for shaft brake */
  BrkHyPres_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Oil level in gearbox sump */
  GbxOilLev_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Gear oil pressure */
  GbxOilPres_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 1 */
  TrmTmpGbxBrg1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 2 */
  TrmTmpGbxBrg2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 3 */
  TrmTmpGbxBrg3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox oil */
  TrmTmpGbxOil_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft bearing 1 */
  TrmTmpShfBrg1_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft bearing 2 */
  TrmTmpShfBrg2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft brake */
  TrmTmpShfBrk_avg_mag_f?: Maybe<Snapshot_Result>;
};


/** Trm description */
export type Trm_10MBrkHyPres_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Trm description */
export type Trm_10MGbxOilLev_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Trm description */
export type Trm_10MGbxOilPres_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Trm description */
export type Trm_10MTrmTmpGbxBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_10MTrmTmpGbxBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_10MTrmTmpGbxBrg3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_10MTrmTmpGbxOil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_10MTrmTmpShfBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_10MTrmTmpShfBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_10MTrmTmpShfBrk_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

/** Trm description */
export type Trm_30S = {
  __typename?: 'TRM_30S';
  /** Hydraulic pressure for shaft brake */
  BrkHyPres_mag_f?: Maybe<Snapshot_Result>;
  /** Oil level in gearbox sump */
  GbxOilLev_mag_f?: Maybe<Snapshot_Result>;
  /** Gear oil pressure */
  GbxOilPres_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 1 */
  TrmTmpGbxBrg1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 2 */
  TrmTmpGbxBrg2_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox bearing 3 */
  TrmTmpGbxBrg3_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of gearbox oil */
  TrmTmpGbxOil_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft bearing 1 */
  TrmTmpShfBrg1_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft bearing 2 */
  TrmTmpShfBrg2_mag_f?: Maybe<Snapshot_Result>;
  /** Measured temperature of shaft brake */
  TrmTmpShfBrk_mag_f?: Maybe<Snapshot_Result>;
};


/** Trm description */
export type Trm_30SBrkHyPres_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Trm description */
export type Trm_30SGbxOilLev_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Trm description */
export type Trm_30SGbxOilPres_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Trm description */
export type Trm_30STrmTmpGbxBrg1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_30STrmTmpGbxBrg2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_30STrmTmpGbxBrg3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_30STrmTmpGbxOil_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_30STrmTmpShfBrg1_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_30STrmTmpShfBrg2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Trm description */
export type Trm_30STrmTmpShfBrk_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};

export enum Ts_Aggregation {
  Avg = 'AVG',
  AvgDegree = 'AVG_DEGREE',
  AvgOverTime = 'AVG_OVER_TIME',
  Count = 'COUNT',
  CountOverTime = 'COUNT_OVER_TIME',
  Diff = 'DIFF',
  First = 'FIRST',
  Last = 'LAST',
  Max = 'MAX',
  MaxOverTime = 'MAX_OVER_TIME',
  Min = 'MIN',
  MinOverTime = 'MIN_OVER_TIME',
  Sum = 'SUM',
  SumOverTime = 'SUM_OVER_TIME'
}

/** Availability declarations for planning module */
export type Ts_Avl_Pln = {
  __typename?: 'TS_AVL_PLN';
  /** Availability (%) */
  availability?: Maybe<Timeseries_Result>;
  /** Available power (kW) */
  availablePower?: Maybe<Timeseries_Result>;
  /** Number of turbines derated due to planned events */
  deratedTurbines?: Maybe<Timeseries_Result>;
  /** Number of turbines not available due to planned events */
  unavailableTurbines?: Maybe<Timeseries_Result>;
};


/** Availability declarations for planning module */
export type Ts_Avl_PlnAvailabilityArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Availability declarations for planning module */
export type Ts_Avl_PlnAvailablePowerArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Availability declarations for planning module */
export type Ts_Avl_PlnDeratedTurbinesArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Availability declarations for planning module */
export type Ts_Avl_PlnUnavailableTurbinesArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Converter description */
export type Ts_Cnv_10M = {
  __typename?: 'TS_CNV_10M';
  /** Measured temperature of the converter’s choke coil phase 2 */
  CnvTmpChokeCoil2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the converter’s choke coil phase 3 */
  CnvTmpChokeCoil3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the converter’s choke coil */
  CnvTmpChokeCoil_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter */
  CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature fo the converter’s cooling water */
  CnvTmpWater_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 2 */
  WCNV2_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 3 */
  WCNV3_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 4 */
  WCNV4_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 5 */
  WCNV5_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 6 */
  WCNV6_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 7 */
  WCNV7_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 8 */
  WCNV8_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 9 */
  WCNV9_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 10 */
  WCNV10_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 11 */
  WCNV11_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 12 */
  WCNV12_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 13 */
  WCNV13_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 14 */
  WCNV14_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
};


/** Converter description */
export type Ts_Cnv_10MCnvTmpChokeCoil2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MCnvTmpChokeCoil3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MCnvTmpChokeCoil_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MCnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MCnvTmpWater_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv2_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv3_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv4_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv5_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv6_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv7_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv8_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv9_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv10_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv11_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv12_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv13_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Converter description */
export type Ts_Cnv_10MWcnv14_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** 10 minutes Data Stream */
export type Ts_Data_10M = {
  __typename?: 'TS_DATA_10M';
  /** Converter description */
  CONVERTER?: Maybe<Ts_Cnv_10M>;
  /** Common description */
  GENERAL?: Maybe<Ts_Grl_10M>;
  /** Generator Description */
  GENERATOR?: Maybe<Ts_Gen_10M>;
  /** MXU description */
  MXU?: Maybe<Ts_Mxu_10M>;
  /** Nacelle description */
  NACELLE?: Maybe<Ts_Nac_10M>;
  /** Rotor description */
  ROTOR?: Maybe<Ts_Rot_10M>;
  /** Temperature description */
  TEMPERATURE?: Maybe<Ts_Tmp_10M>;
  /** Turbine temperature deviation from the park average */
  TEMPERATURE_DEVIATION?: Maybe<Ts_Tmd_10M>;
  /** Tower description */
  TOWER?: Maybe<Ts_Tow_10M>;
  /** Trafo description */
  TRAFO?: Maybe<Ts_Trf_10M>;
  /** Trm description */
  TRM?: Maybe<Ts_Trm_10M>;
  /** Turbine description */
  TURBINE?: Maybe<Ts_Tur_10M>;
  /** Yaw description */
  YAW?: Maybe<Ts_Yaw_10M>;
};

/** 30 seconds Data Stream */
export type Ts_Data_30S = {
  __typename?: 'TS_DATA_30S';
  /** Common description */
  GENERAL?: Maybe<Ts_Grl_30S>;
  /** Nacelle description */
  NACELLE?: Maybe<Ts_Nac_30S>;
  /** Turbine description */
  TURBINE?: Maybe<Ts_Tur_30S>;
};

/** Planning Data */
export type Ts_Data_Pln = {
  __typename?: 'TS_DATA_PLN';
  /** Availability declarations for planning module */
  AVAILABILITY?: Maybe<Ts_Avl_Pln>;
  /** Losses due to planned events */
  LOSSES?: Maybe<Ts_Lss_Pln>;
};

/** Weather Forecast Data */
export type Ts_Data_Wfc = {
  __typename?: 'TS_DATA_WFC';
  /** Forecast information from DNV forecaster provider */
  DNV_FORECASTER?: Maybe<Ts_Dnvf_Wfc>;
  /** Forecast information from Meteoblue provider */
  METEOBLUE?: Maybe<Ts_Mtb_Wfc>;
  /** Forecast information from meteologica */
  METEOLOGICA?: Maybe<Ts_Mlg_Wfc>;
  /** Forecast information from Open Weather provider */
  OPEN_WEATHER?: Maybe<Ts_Opw_Wfc>;
  /** Forecast information from trading */
  TRADING?: Maybe<Ts_Trd_Wfc>;
  /** Forecast information from Wind-Log provider */
  WIND_LOG?: Maybe<Ts_Wlg_Wfc>;
};

/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_Wfc = {
  __typename?: 'TS_DNVF_WFC';
  /** Imbalance (actual power / forecasted power) */
  imbalance?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power predicted) */
  imbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power) (not considering planning) */
  imbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) */
  negativeImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power predicted) */
  negativeImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) (not considering planning) */
  negativeImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance */
  negativeOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for grouped imbalance */
  negativeOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance (not considering planning) */
  negativeOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance */
  negativeOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance (not considering planning) */
  negativeOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance */
  negativePeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for grouped imbalance */
  negativePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance (not considering planning) */
  negativePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance */
  negativePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance (not considering planning) */
  negativePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance */
  negativeRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance (not considering planning) */
  negativeRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) */
  positiveImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power predicted) */
  positiveImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) (not considering planning) */
  positiveImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance */
  positiveOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for grouped imbalance */
  positiveOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance (not considering planning) */
  positiveOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance */
  positiveOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance (not considering planning) */
  positiveOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance */
  positivePeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for grouped imbalance */
  positivePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance (not considering planning) */
  positivePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance */
  positivePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance (not considering planning) */
  positivePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance */
  positiveRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance (not considering planning) */
  positiveRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance */
  revenueImbalance?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance (not considering planning) */
  revenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Forecast revenues */
  revenues?: Maybe<Timeseries_Result>;
  /** Forecast revenues considering the planned events */
  revenuesAmended?: Maybe<Timeseries_Result>;
  /** Temperature */
  temperature?: Maybe<Timeseries_Result>;
  /** Theoretical Power */
  theoreticalPower?: Maybe<Timeseries_Result>;
  /** Theoretical power considering the planned events */
  theoreticalPowerAmended?: Maybe<Timeseries_Result>;
  /** Theoretical power grouped by predicted date considering the planned events */
  theoreticalPowerAmendedPredicted?: Maybe<Timeseries_Result>;
  /** Theoretical Power Grouped By Predicted Date */
  theoreticalPowerPredicted?: Maybe<Timeseries_Result>;
  /** Weather icon */
  weather?: Maybe<Timeseries_Result>;
  /** Wind Direction */
  windDirection?: Maybe<Timeseries_Result>;
  /** Wind Speed */
  windSpeed?: Maybe<Timeseries_Result>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativeImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativeImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativeImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativeOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativeOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativeOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativeOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativeOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativeRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcNegativeRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositiveImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositiveImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositiveImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositiveOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositiveOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositiveOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositiveOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositiveOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositivePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositivePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositivePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositivePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositivePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositiveRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcPositiveRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcRevenuesArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcRevenuesAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcTemperatureArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcTheoreticalPowerArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcTheoreticalPowerAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcTheoreticalPowerAmendedPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcTheoreticalPowerPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcWeatherArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcWindDirectionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from DNV forecaster provider */
export type Ts_Dnvf_WfcWindSpeedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Generator Description */
export type Ts_Gen_10M = {
  __typename?: 'TS_GEN_10M';
  /** Measured temperature of generator bearing 1 */
  GnTmpBrg1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator bearing 2 */
  GnTmpBrg2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurement for inlet air/water temperature at generator */
  GnTmpInlet_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurement for outlet air/water temperature at generator */
  GnTmpOutlet_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator phase 1 */
  GnTmpPhase1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator phase 2 */
  GnTmpPhase2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator phase 3 */
  GnTmpPhase3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator rotor */
  GnTmpRtr_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator slipring 1 */
  GnTmpSlpRing1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator slipring 2 */
  GnTmpSlpRing2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 2 */
  GnTmpSta2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 3 */
  GnTmpSta3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 4 */
  GnTmpSta4_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 5 */
  GnTmpSta5_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 6 */
  GnTmpSta6_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator */
  GnTmpSta_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Generator speed */
  Spd_avg_mag_f?: Maybe<Timeseries_Result>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpBrg1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpBrg2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpInlet_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpOutlet_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpPhase1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpPhase2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpPhase3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpRtr_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpSlpRing1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpSlpRing2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpSta2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpSta3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpSta4_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpSta5_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpSta6_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MGnTmpSta_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Generator Description */
export type Ts_Gen_10MSpd_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Common description */
export type Ts_Grl_10M = {
  __typename?: 'TS_GRL_10M';
  /** Turbine control system time (can be any timezone) */
  LTIM1_TmUTC_setTm?: Maybe<Timeseries_Result>;
};


/** Common description */
export type Ts_Grl_10MLtim1_TmUtc_SetTmArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Common description */
export type Ts_Grl_30S = {
  __typename?: 'TS_GRL_30S';
  /** Physical device health (inherited from IEC 61850-7-4) 1 -> Ok (No problems, normal operation) 2 -> Warning (Minor problems, but in safe operation mode) 3 -> Alarm (Severe problem, no operation possible) */
  LPHD1_PhyHealth_stVal?: Maybe<Timeseries_Result>;
};


/** Common description */
export type Ts_Grl_30SLphd1_PhyHealth_StValArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Losses due to planned events */
export type Ts_Lss_Pln = {
  __typename?: 'TS_LSS_PLN';
  /** Production Loss due to Environmental events (kW) */
  productionLossEnvironmental?: Maybe<Timeseries_Result>;
  /** Production Loss due to Grid Limitation events (kW) */
  productionLossGridLimitation?: Maybe<Timeseries_Result>;
  /** Production Loss due to Inspection events (kW) */
  productionLossInspection?: Maybe<Timeseries_Result>;
  /** Production Loss due to Maintenance events (kW) */
  productionLossMaintenance?: Maybe<Timeseries_Result>;
  /** Production Loss due to Repairs events (kW) */
  productionLossRepairs?: Maybe<Timeseries_Result>;
  /** Production Loss due to all events (kW) */
  productionLossTotal?: Maybe<Timeseries_Result>;
  /** Revenue Loss due to Environmental events (kW) */
  revenueLossEnvironmental?: Maybe<Timeseries_Result>;
  /** Revenue Loss due to Grid Limitation events (kW) */
  revenueLossGridLimitation?: Maybe<Timeseries_Result>;
  /** Revenue Loss due to Inspection events (kW) */
  revenueLossInspection?: Maybe<Timeseries_Result>;
  /** Revenue Loss due to Maintenance events (kW) */
  revenueLossMaintenance?: Maybe<Timeseries_Result>;
  /** Revenue Loss due to Repairs events (kW) */
  revenueLossRepairs?: Maybe<Timeseries_Result>;
  /** Revenue Loss due to all events (kW) */
  revenueLossTotal?: Maybe<Timeseries_Result>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnProductionLossEnvironmentalArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnProductionLossGridLimitationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnProductionLossInspectionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnProductionLossMaintenanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnProductionLossRepairsArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnProductionLossTotalArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnRevenueLossEnvironmentalArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnRevenueLossGridLimitationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnRevenueLossInspectionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnRevenueLossMaintenanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnRevenueLossRepairsArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Losses due to planned events */
export type Ts_Lss_PlnRevenueLossTotalArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Forecast information from meteologica */
export type Ts_Mlg_Wfc = {
  __typename?: 'TS_MLG_WFC';
  /** Imbalance (actual power / forecasted power) */
  imbalance?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power predicted) */
  imbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power) (not considering planning) */
  imbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) */
  negativeImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power predicted) */
  negativeImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) (not considering planning) */
  negativeImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance */
  negativeOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for grouped imbalance */
  negativeOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance (not considering planning) */
  negativeOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance */
  negativeOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance (not considering planning) */
  negativeOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance */
  negativePeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for grouped imbalance */
  negativePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance (not considering planning) */
  negativePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance */
  negativePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance (not considering planning) */
  negativePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance */
  negativeRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance (not considering planning) */
  negativeRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) */
  positiveImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power predicted) */
  positiveImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) (not considering planning) */
  positiveImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance */
  positiveOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for grouped imbalance */
  positiveOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance (not considering planning) */
  positiveOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance */
  positiveOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance (not considering planning) */
  positiveOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance */
  positivePeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for grouped imbalance */
  positivePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance (not considering planning) */
  positivePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance */
  positivePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance (not considering planning) */
  positivePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance */
  positiveRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance (not considering planning) */
  positiveRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance */
  revenueImbalance?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance (not considering planning) */
  revenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Forecast revenues */
  revenues?: Maybe<Timeseries_Result>;
  /** Forecast revenues considering the planned events */
  revenuesAmended?: Maybe<Timeseries_Result>;
  /** Temperature */
  temperature?: Maybe<Timeseries_Result>;
  /** Theoretical Power */
  theoreticalPower?: Maybe<Timeseries_Result>;
  /** Theoretical power considering the planned events */
  theoreticalPowerAmended?: Maybe<Timeseries_Result>;
  /** Theoretical power grouped by predicted date considering the planned events */
  theoreticalPowerAmendedPredicted?: Maybe<Timeseries_Result>;
  /** Theoretical Power Grouped By Predicted Date */
  theoreticalPowerPredicted?: Maybe<Timeseries_Result>;
  /** Weather icon */
  weather?: Maybe<Timeseries_Result>;
  /** Wind Direction */
  windDirection?: Maybe<Timeseries_Result>;
  /** Wind Speed */
  windSpeed?: Maybe<Timeseries_Result>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativeImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativeImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativeImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativeOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativeOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativeOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativeOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativeOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativeRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcNegativeRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositiveImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositiveImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositiveImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositiveOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositiveOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositiveOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositiveOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositiveOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositivePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositivePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositivePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositivePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositivePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositiveRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcPositiveRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcRevenuesArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcRevenuesAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcTemperatureArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcTheoreticalPowerArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcTheoreticalPowerAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcTheoreticalPowerAmendedPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcTheoreticalPowerPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcWeatherArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcWindDirectionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from meteologica */
export type Ts_Mlg_WfcWindSpeedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Forecast information from Meteoblue provider */
export type Ts_Mtb_Wfc = {
  __typename?: 'TS_MTB_WFC';
  /** Imbalance (actual power / forecasted power) */
  imbalance?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power predicted) */
  imbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power) (not considering planning) */
  imbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) */
  negativeImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power predicted) */
  negativeImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) (not considering planning) */
  negativeImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance */
  negativeOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for grouped imbalance */
  negativeOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance (not considering planning) */
  negativeOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance */
  negativeOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance (not considering planning) */
  negativeOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance */
  negativePeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for grouped imbalance */
  negativePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance (not considering planning) */
  negativePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance */
  negativePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance (not considering planning) */
  negativePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance */
  negativeRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance (not considering planning) */
  negativeRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) */
  positiveImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power predicted) */
  positiveImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) (not considering planning) */
  positiveImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance */
  positiveOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for grouped imbalance */
  positiveOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance (not considering planning) */
  positiveOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance */
  positiveOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance (not considering planning) */
  positiveOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance */
  positivePeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for grouped imbalance */
  positivePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance (not considering planning) */
  positivePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance */
  positivePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance (not considering planning) */
  positivePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance */
  positiveRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance (not considering planning) */
  positiveRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance */
  revenueImbalance?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance (not considering planning) */
  revenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Forecast revenues */
  revenues?: Maybe<Timeseries_Result>;
  /** Forecast revenues considering the planned events */
  revenuesAmended?: Maybe<Timeseries_Result>;
  /** Temperature */
  temperature?: Maybe<Timeseries_Result>;
  /** Theoretical Power */
  theoreticalPower?: Maybe<Timeseries_Result>;
  /** Theoretical power considering the planned events */
  theoreticalPowerAmended?: Maybe<Timeseries_Result>;
  /** Theoretical power grouped by predicted date considering the planned events */
  theoreticalPowerAmendedPredicted?: Maybe<Timeseries_Result>;
  /** Theoretical Power Grouped By Predicted Date */
  theoreticalPowerPredicted?: Maybe<Timeseries_Result>;
  /** Weather icon */
  weather?: Maybe<Timeseries_Result>;
  /** Wind Direction */
  windDirection?: Maybe<Timeseries_Result>;
  /** Wind Speed */
  windSpeed?: Maybe<Timeseries_Result>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativeImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativeImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativeImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativeOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativeOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativeOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativeOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativeOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativeRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcNegativeRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositiveImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositiveImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositiveImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositiveOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositiveOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositiveOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositiveOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositiveOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositivePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositivePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositivePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositivePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositivePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositiveRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcPositiveRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcRevenuesArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcRevenuesAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcTemperatureArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcTheoreticalPowerArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcTheoreticalPowerAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcTheoreticalPowerAmendedPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcTheoreticalPowerPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcWeatherArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcWindDirectionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Meteoblue provider */
export type Ts_Mtb_WfcWindSpeedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** MXU description */
export type Ts_Mxu_10M = {
  __typename?: 'TS_MXU_10M';
  /** Phase current IL1 */
  A_phsA_cVal_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Phase current IL2 */
  A_phsB_cVal_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Phase current IL3 */
  A_phsC_cVal_avg_mag_f?: Maybe<Timeseries_Result>;
  /** The frequency of a power system in Hz. */
  Hz_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Phase to ground voltage VL1ER */
  PhV_phsA_cVal_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Phase to ground voltage VL2ER */
  PhV_phsB_cVal_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Phase to ground voltage VL3ER */
  PhV_phsC_cVal_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Average power factor for a three-phase circuit. */
  TotPF_avg_mag_f?: Maybe<Timeseries_Result>;
};


/** MXU description */
export type Ts_Mxu_10Ma_PhsA_CVal_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** MXU description */
export type Ts_Mxu_10Ma_PhsB_CVal_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** MXU description */
export type Ts_Mxu_10Ma_PhsC_CVal_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** MXU description */
export type Ts_Mxu_10MHz_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** MXU description */
export type Ts_Mxu_10MPhV_PhsA_CVal_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** MXU description */
export type Ts_Mxu_10MPhV_PhsB_CVal_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** MXU description */
export type Ts_Mxu_10MPhV_PhsC_CVal_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** MXU description */
export type Ts_Mxu_10MTotPf_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Nacelle description */
export type Ts_Nac_10M = {
  __typename?: 'TS_NAC_10M';
  /** Measured temperature inside nacelle control cabinet */
  CtrCabTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Nacelle orientation */
  Dir_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature outside nacelle */
  ExTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside nacelle */
  IntlTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Wind direction outside nacelle */
  WdDir_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Wind speed outside nacelle */
  WdSpd_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Corrected wind speed outside nacelle */
  WdSpd_c_avg_mag_f?: Maybe<Timeseries_Result>;
};


/** Nacelle description */
export type Ts_Nac_10MCtrCabTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Nacelle description */
export type Ts_Nac_10MDir_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Nacelle description */
export type Ts_Nac_10MExTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Nacelle description */
export type Ts_Nac_10MIntlTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Nacelle description */
export type Ts_Nac_10MWdDir_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Nacelle description */
export type Ts_Nac_10MWdSpd_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<MeterPerSecond>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Nacelle description */
export type Ts_Nac_10MWdSpd_C_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<MeterPerSecond>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Nacelle description */
export type Ts_Nac_30S = {
  __typename?: 'TS_NAC_30S';
  /** Temperature outside nacelle */
  ExTmp_mag_f?: Maybe<Timeseries_Result>;
  /** Wind direction outside nacelle */
  WdDir_mag_f?: Maybe<Timeseries_Result>;
  /** Wind speed outside nacelle */
  WdSpd_mag_f?: Maybe<Timeseries_Result>;
};


/** Nacelle description */
export type Ts_Nac_30SExTmp_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Nacelle description */
export type Ts_Nac_30SWdDir_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Nacelle description */
export type Ts_Nac_30SWdSpd_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<MeterPerSecond>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Forecast information from Open Weather provider */
export type Ts_Opw_Wfc = {
  __typename?: 'TS_OPW_WFC';
  /** Imbalance (actual power / forecasted power) */
  imbalance?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power predicted) */
  imbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power) (not considering planning) */
  imbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) */
  negativeImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power predicted) */
  negativeImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) (not considering planning) */
  negativeImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance */
  negativeOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for grouped imbalance */
  negativeOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance (not considering planning) */
  negativeOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance */
  negativeOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance (not considering planning) */
  negativeOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance */
  negativePeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for grouped imbalance */
  negativePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance (not considering planning) */
  negativePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance */
  negativePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance (not considering planning) */
  negativePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance */
  negativeRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance (not considering planning) */
  negativeRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) */
  positiveImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power predicted) */
  positiveImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) (not considering planning) */
  positiveImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance */
  positiveOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for grouped imbalance */
  positiveOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance (not considering planning) */
  positiveOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance */
  positiveOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance (not considering planning) */
  positiveOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance */
  positivePeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for grouped imbalance */
  positivePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance (not considering planning) */
  positivePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance */
  positivePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance (not considering planning) */
  positivePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance */
  positiveRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance (not considering planning) */
  positiveRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance */
  revenueImbalance?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance (not considering planning) */
  revenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Forecast revenues */
  revenues?: Maybe<Timeseries_Result>;
  /** Forecast revenues considering the planned events */
  revenuesAmended?: Maybe<Timeseries_Result>;
  /** Temperature */
  temperature?: Maybe<Timeseries_Result>;
  /** Theoretical Power */
  theoreticalPower?: Maybe<Timeseries_Result>;
  /** Theoretical power considering the planned events */
  theoreticalPowerAmended?: Maybe<Timeseries_Result>;
  /** Theoretical power grouped by predicted date considering the planned events */
  theoreticalPowerAmendedPredicted?: Maybe<Timeseries_Result>;
  /** Theoretical Power Grouped By Predicted Date */
  theoreticalPowerPredicted?: Maybe<Timeseries_Result>;
  /** Weather icon */
  weather?: Maybe<Timeseries_Result>;
  /** Wind Direction */
  windDirection?: Maybe<Timeseries_Result>;
  /** Wind Speed */
  windSpeed?: Maybe<Timeseries_Result>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativeImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativeImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativeImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativeOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativeOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativeOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativeOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativeOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativeRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcNegativeRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositiveImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositiveImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositiveImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositiveOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositiveOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositiveOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositiveOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositiveOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositivePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositivePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositivePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositivePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositivePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositiveRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcPositiveRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcRevenuesArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcRevenuesAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcTemperatureArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcTheoreticalPowerArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcTheoreticalPowerAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcTheoreticalPowerAmendedPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcTheoreticalPowerPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcWeatherArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcWindDirectionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Open Weather provider */
export type Ts_Opw_WfcWindSpeedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Rotor description */
export type Ts_Rot_10M = {
  __typename?: 'TS_ROT_10M';
  /** Temperature inside 2nd rotor hub control cabinet */
  CtrCabTmp2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside 3rd rotor hub control cabinet */
  CtrCabTmp3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside rotor hub control cabinet */
  CtrCabTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature in the rotor hub */
  HubTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Pitch angle for blade 1 */
  PtAngValBl1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Pitch angle for blade 2 */
  PtAngValBl2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Pitch angle for blade 3 */
  PtAngValBl3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Oil temperature of hydraulic pitch system */
  PtHyOilTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Pressure of hydraulic pitch system for blade 1 */
  PtHyPresBl1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Pressure of hydraulic pitch system for blade 2 */
  PtHyPresBl2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Pressure of hydraulic pitch system for blade 3 */
  PtHyPresBl3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Value of rotor speed at rotor side */
  RotSpd_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature of rotor blade 1 */
  TmpBl1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature of rotor blade 2 */
  TmpBl2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature of rotor blade 3 */
  TmpBl3_avg_mag_f?: Maybe<Timeseries_Result>;
};


/** Rotor description */
export type Ts_Rot_10MCtrCabTmp2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MCtrCabTmp3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MCtrCabTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MHubTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MPtAngValBl1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MPtAngValBl2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MPtAngValBl3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MPtHyOilTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MPtHyPresBl1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MPtHyPresBl2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MPtHyPresBl3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MRotSpd_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MTmpBl1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MTmpBl2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Rotor description */
export type Ts_Rot_10MTmpBl3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10M = {
  __typename?: 'TS_TMD_10M';
  /** Measured temperature of the converter’s choke coil phase 2 */
  WCNV1_CnvTmpChokeCoil2_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the converter’s choke coil phase 3 */
  WCNV1_CnvTmpChokeCoil3_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the converter’s choke coil */
  WCNV1_CnvTmpChokeCoil_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter */
  WCNV1_CnvTmpDclink_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature fo the converter’s cooling water */
  WCNV1_CnvTmpWater_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator bearing 1 */
  WGEN1_GnTmpBrg1_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator bearing 2 */
  WGEN1_GnTmpBrg2_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature measurement for inlet air/water temperature at generator */
  WGEN1_GnTmpInlet_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature measurement for outlet air/water temperature at generator */
  WGEN1_GnTmpOutlet_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator phase 1 */
  WGEN1_GnTmpPhase1_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator phase 2 */
  WGEN1_GnTmpPhase2_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator phase 3 */
  WGEN1_GnTmpPhase3_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator rotor */
  WGEN1_GnTmpRtr_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator slipring 1 */
  WGEN1_GnTmpSlpRing1_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 2 */
  WGEN1_GnTmpSta2_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 3 */
  WGEN1_GnTmpSta3_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 4 */
  WGEN1_GnTmpSta4_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 5 */
  WGEN1_GnTmpSta5_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 6 */
  WGEN1_GnTmpSta6_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator */
  WGEN1_GnTmpSta_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature inside nacelle control cabinet */
  WNAC1_CtrCabTmp_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature outside nacelle */
  WNAC1_ExTmp_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature inside nacelle */
  WNAC1_IntlTmp_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WNAC1_TopCtrCabTmp1_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature inside rotor hub control cabinet */
  WROT1_CtrCabTmp_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature in the rotor hub */
  WROT1_HubTmp_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Oil temperature of hydraulic pitch system */
  WROT1_PtHyOilTmp_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTF1_TrfAuxTmp_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Temperature inside control cabinet at the bottom of the tower */
  WTOW1_CtrCabTmp_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer room */
  WTRF1_RoomTmp_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp1_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp2_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp3_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfOilTmp_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of transformer phase 1 */
  WTRF1_TrfTmpPhase1_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of transformer phase 2 */
  WTRF1_TrfTmpPhase2_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of transformer phase 3 */
  WTRF1_TrfTmpPhase3_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox bearing 1 */
  WTRM1_TrmTmpGbxBrg1_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox bearing 2 */
  WTRM1_TrmTmpGbxBrg2_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox bearing 3 */
  WTRM1_TrmTmpGbxBrg3_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpGbxBrg4_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpGbxBrg5_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox oil */
  WTRM1_TrmTmpGbxOil_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of shaft bearing 1 */
  WTRM1_TrmTmpShfBrg1_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of shaft bearing 2 */
  WTRM1_TrmTmpShfBrg2_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpWtr_avg_per_deviation?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTUR1_TurTmpUPS_avg_per_deviation?: Maybe<Timeseries_Result>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWcnv1_CnvTmpChokeCoil2_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWcnv1_CnvTmpChokeCoil3_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWcnv1_CnvTmpChokeCoil_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWcnv1_CnvTmpDclink_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWcnv1_CnvTmpWater_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpBrg1_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpBrg2_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpInlet_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpOutlet_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpPhase1_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpPhase2_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpPhase3_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpRtr_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpSlpRing1_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpSta2_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpSta3_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpSta4_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpSta5_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpSta6_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWgen1_GnTmpSta_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWnac1_CtrCabTmp_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWnac1_ExTmp_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWnac1_IntlTmp_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWnac1_TopCtrCabTmp1_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWrot1_CtrCabTmp_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWrot1_HubTmp_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWrot1_PtHyOilTmp_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtf1_TrfAuxTmp_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtow1_CtrCabTmp_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrf1_RoomTmp_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrf1_TrfCoreTmp1_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrf1_TrfCoreTmp2_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrf1_TrfCoreTmp3_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrf1_TrfOilTmp_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrf1_TrfTmpPhase1_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrf1_TrfTmpPhase2_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrf1_TrfTmpPhase3_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrm1_TrmTmpGbxBrg1_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrm1_TrmTmpGbxBrg2_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrm1_TrmTmpGbxBrg3_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrm1_TrmTmpGbxBrg4_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrm1_TrmTmpGbxBrg5_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrm1_TrmTmpGbxOil_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrm1_TrmTmpShfBrg1_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrm1_TrmTmpShfBrg2_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtrm1_TrmTmpWtr_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine temperature deviation from the park average */
export type Ts_Tmd_10MWtur1_TurTmpUps_Avg_Per_DeviationArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Temperature description */
export type Ts_Tmp_10M = {
  __typename?: 'TS_TMP_10M';
  /** Measured temperature of the converter’s choke coil phase 2 */
  WCNV1_CnvTmpChokeCoil2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the converter’s choke coil phase 3 */
  WCNV1_CnvTmpChokeCoil3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the converter’s choke coil */
  WCNV1_CnvTmpChokeCoil_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter */
  WCNV1_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature fo the converter’s cooling water */
  WCNV1_CnvTmpWater_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 2 */
  WCNV2_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 3 */
  WCNV3_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 4 */
  WCNV4_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 5 */
  WCNV5_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 6 */
  WCNV6_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 7 */
  WCNV7_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 8 */
  WCNV8_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 9 */
  WCNV9_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 10 */
  WCNV10_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 11 */
  WCNV11_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 12 */
  WCNV12_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 13 */
  WCNV13_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside the converter number 14 */
  WCNV14_CnvTmpDclink_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator bearing 1 */
  WGEN1_GnTmpBrg1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator bearing 2 */
  WGEN1_GnTmpBrg2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurement for inlet air/water temperature at generator */
  WGEN1_GnTmpInlet_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurement for outlet air/water temperature at generator */
  WGEN1_GnTmpOutlet_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator phase 1 */
  WGEN1_GnTmpPhase1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator phase 2 */
  WGEN1_GnTmpPhase2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator phase 3 */
  WGEN1_GnTmpPhase3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator rotor, phase 3 */
  WGEN1_GnTmpRtr3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator rotor */
  WGEN1_GnTmpRtr_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator slipring 1 */
  WGEN1_GnTmpSlpRing1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of generator slipring 2 */
  WGEN1_GnTmpSlpRing2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 2 */
  WGEN1_GnTmpSta2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 3 */
  WGEN1_GnTmpSta3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 4 */
  WGEN1_GnTmpSta4_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 5 */
  WGEN1_GnTmpSta5_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator segment 6 */
  WGEN1_GnTmpSta6_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature measurements for generator stator */
  WGEN1_GnTmpSta_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature inside nacelle control cabinet */
  WNAC1_CtrCabTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature outside nacelle */
  WNAC1_ExTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside nacelle */
  WNAC1_IntlTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WNAC1_TopCtrCabTmp1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside 2nd rotor hub control cabinet */
  WROT1_CtrCabTmp2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside 3rd rotor hub control cabinet */
  WROT1_CtrCabTmp3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside rotor hub control cabinet */
  WROT1_CtrCabTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature in the rotor hub */
  WROT1_HubTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Oil temperature of hydraulic pitch system */
  WROT1_PtHyOilTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature of rotor blade 1 */
  WROT1_TmpBl1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature of rotor blade 2 */
  WROT1_TmpBl2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature of rotor blade 3 */
  WROT1_TmpBl3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTF1_TrfAuxTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside control cabinet at the bottom of the tower */
  WTOW1_CtrCabTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer room */
  WTRF1_RoomTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfCoreTmp3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRF1_TrfOilTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of transformer phase 1 */
  WTRF1_TrfTmpPhase1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of transformer phase 2 */
  WTRF1_TrfTmpPhase2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of transformer phase 3 */
  WTRF1_TrfTmpPhase3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox bearing 1 */
  WTRM1_TrmTmpGbxBrg1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox bearing 2 */
  WTRM1_TrmTmpGbxBrg2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox bearing 3 */
  WTRM1_TrmTmpGbxBrg3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpGbxBrg4_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpGbxBrg5_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox oil */
  WTRM1_TrmTmpGbxOil_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of shaft bearing 1 */
  WTRM1_TrmTmpShfBrg1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of shaft bearing 2 */
  WTRM1_TrmTmpShfBrg2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of shaft brake */
  WTRM1_TrmTmpShfBrk_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTRM1_TrmTmpWtr_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  WTUR1_TurTmpUPS_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside yaw control cabinet */
  WYAW1_CtrCabTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear 2 temperature */
  WYAW1_Tmp2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear 3 temperature */
  WYAW1_Tmp3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear 4 temperature */
  WYAW1_Tmp4_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear 5 temperature */
  WYAW1_Tmp5_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear 6 temperature */
  WYAW1_Tmp6_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear temperature */
  WYAW1_Tmp_avg_mag_f?: Maybe<Timeseries_Result>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv1_CnvTmpChokeCoil2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv1_CnvTmpChokeCoil3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv1_CnvTmpChokeCoil_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv1_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv1_CnvTmpWater_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv2_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv3_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv4_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv5_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv6_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv7_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv8_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv9_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv10_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv11_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv12_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv13_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWcnv14_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpBrg1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpBrg2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpInlet_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpOutlet_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpPhase1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpPhase2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpPhase3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpRtr3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpRtr_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpSlpRing1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpSlpRing2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpSta2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpSta3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpSta4_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpSta5_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpSta6_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWgen1_GnTmpSta_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWnac1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWnac1_ExTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWnac1_IntlTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWnac1_TopCtrCabTmp1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWrot1_CtrCabTmp2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWrot1_CtrCabTmp3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWrot1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWrot1_HubTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWrot1_PtHyOilTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWrot1_TmpBl1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWrot1_TmpBl2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWrot1_TmpBl3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtf1_TrfAuxTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtow1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrf1_RoomTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrf1_TrfCoreTmp1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrf1_TrfCoreTmp2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrf1_TrfCoreTmp3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrf1_TrfOilTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrf1_TrfTmpPhase1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrf1_TrfTmpPhase2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrf1_TrfTmpPhase3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrm1_TrmTmpGbxBrg1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrm1_TrmTmpGbxBrg2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrm1_TrmTmpGbxBrg3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrm1_TrmTmpGbxBrg4_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrm1_TrmTmpGbxBrg5_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrm1_TrmTmpGbxOil_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrm1_TrmTmpShfBrg1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrm1_TrmTmpShfBrg2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrm1_TrmTmpShfBrk_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtrm1_TrmTmpWtr_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWtur1_TurTmpUps_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWyaw1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWyaw1_Tmp2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWyaw1_Tmp3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWyaw1_Tmp4_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWyaw1_Tmp5_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWyaw1_Tmp6_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Temperature description */
export type Ts_Tmp_10MWyaw1_Tmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Tower description */
export type Ts_Tow_10M = {
  __typename?: 'TS_TOW_10M';
  /** Temperature inside control cabinet at the bottom of the tower */
  CtrCabTmp_avg_mag_f?: Maybe<Timeseries_Result>;
};


/** Tower description */
export type Ts_Tow_10MCtrCabTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Forecast information from trading */
export type Ts_Trd_Wfc = {
  __typename?: 'TS_TRD_WFC';
  /** Imbalance (actual power / forecasted power) */
  imbalance?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power predicted) */
  imbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power) (not considering planning) */
  imbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) */
  negativeImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power predicted) */
  negativeImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) (not considering planning) */
  negativeImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance */
  negativeOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for grouped imbalance */
  negativeOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance (not considering planning) */
  negativeOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance */
  negativeOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance (not considering planning) */
  negativeOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance */
  negativePeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for grouped imbalance */
  negativePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance (not considering planning) */
  negativePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance */
  negativePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance (not considering planning) */
  negativePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance */
  negativeRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance (not considering planning) */
  negativeRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) */
  positiveImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power predicted) */
  positiveImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) (not considering planning) */
  positiveImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance */
  positiveOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for grouped imbalance */
  positiveOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance (not considering planning) */
  positiveOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance */
  positiveOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance (not considering planning) */
  positiveOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance */
  positivePeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for grouped imbalance */
  positivePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance (not considering planning) */
  positivePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance */
  positivePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance (not considering planning) */
  positivePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance */
  positiveRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance (not considering planning) */
  positiveRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance */
  revenueImbalance?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance (not considering planning) */
  revenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Forecast revenues */
  revenues?: Maybe<Timeseries_Result>;
  /** Forecast revenues considering the planned events */
  revenuesAmended?: Maybe<Timeseries_Result>;
  /** Temperature */
  temperature?: Maybe<Timeseries_Result>;
  /** Theoretical Power */
  theoreticalPower?: Maybe<Timeseries_Result>;
  /** Theoretical power considering the planned events */
  theoreticalPowerAmended?: Maybe<Timeseries_Result>;
  /** Theoretical power grouped by predicted date considering the planned events */
  theoreticalPowerAmendedPredicted?: Maybe<Timeseries_Result>;
  /** Theoretical Power Grouped By Predicted Date */
  theoreticalPowerPredicted?: Maybe<Timeseries_Result>;
  /** Weather icon */
  weather?: Maybe<Timeseries_Result>;
  /** Wind Direction */
  windDirection?: Maybe<Timeseries_Result>;
  /** Wind Speed */
  windSpeed?: Maybe<Timeseries_Result>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativeImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativeImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativeImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativeOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativeOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativeOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativeOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativeOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativeRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcNegativeRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositiveImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositiveImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositiveImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositiveOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositiveOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositiveOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositiveOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositiveOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositivePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositivePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositivePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositivePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositivePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositiveRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcPositiveRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcRevenuesArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcRevenuesAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcTemperatureArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcTheoreticalPowerArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcTheoreticalPowerAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcTheoreticalPowerAmendedPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcTheoreticalPowerPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcWeatherArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcWindDirectionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from trading */
export type Ts_Trd_WfcWindSpeedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Trafo description */
export type Ts_Trf_10M = {
  __typename?: 'TS_TRF_10M';
  /** Measured temperature of the transformer room */
  RoomTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of the transformer oil */
  TrfOilTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of transformer phase 1 */
  TrfTmpPhase1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of transformer phase 2 */
  TrfTmpPhase2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of transformer phase 3 */
  TrfTmpPhase3_avg_mag_f?: Maybe<Timeseries_Result>;
};


/** Trafo description */
export type Ts_Trf_10MRoomTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trafo description */
export type Ts_Trf_10MTrfOilTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trafo description */
export type Ts_Trf_10MTrfTmpPhase1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trafo description */
export type Ts_Trf_10MTrfTmpPhase2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trafo description */
export type Ts_Trf_10MTrfTmpPhase3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Trm description */
export type Ts_Trm_10M = {
  __typename?: 'TS_TRM_10M';
  /** Hydraulic pressure for shaft brake */
  BrkHyPres_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Oil level in gearbox sump */
  GbxOilLev_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Gear oil pressure */
  GbxOilPres_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox bearing 1 */
  TrmTmpGbxBrg1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox bearing 2 */
  TrmTmpGbxBrg2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox bearing 3 */
  TrmTmpGbxBrg3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of gearbox oil */
  TrmTmpGbxOil_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of shaft bearing 1 */
  TrmTmpShfBrg1_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of shaft bearing 2 */
  TrmTmpShfBrg2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Measured temperature of shaft brake */
  TrmTmpShfBrk_avg_mag_f?: Maybe<Timeseries_Result>;
};


/** Trm description */
export type Ts_Trm_10MBrkHyPres_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trm description */
export type Ts_Trm_10MGbxOilLev_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trm description */
export type Ts_Trm_10MGbxOilPres_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trm description */
export type Ts_Trm_10MTrmTmpGbxBrg1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trm description */
export type Ts_Trm_10MTrmTmpGbxBrg2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trm description */
export type Ts_Trm_10MTrmTmpGbxBrg3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trm description */
export type Ts_Trm_10MTrmTmpGbxOil_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trm description */
export type Ts_Trm_10MTrmTmpShfBrg1_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trm description */
export type Ts_Trm_10MTrmTmpShfBrg2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Trm description */
export type Ts_Trm_10MTrmTmpShfBrk_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Turbine description */
export type Ts_Tur_10M = {
  __typename?: 'TS_TUR_10M';
  /** Reactive power generation */
  VAr_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Power Losses (Difference beetwen theoretical power and actual power) */
  W_avg_loss?: Maybe<Timeseries_Result>;
  /** Active power generation */
  W_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Active power generation filling the gaps with the counter data interpolation */
  W_avg_mag_f_filled?: Maybe<Timeseries_Result>;
  /** Theoretical power generation */
  W_avg_theoretical?: Maybe<Timeseries_Result>;
  /** Theoretical power generation filling the gaps with the counter data interpolation */
  W_avg_theoretical_filled?: Maybe<Timeseries_Result>;
  /** Energy produced */
  Wh_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Energy produced */
  Wh_avg_mag_f_corrected?: Maybe<Timeseries_Result>;
  /** CO2 Avoided */
  co2Avoided?: Maybe<Timeseries_Result>;
  /** Time-based availability % */
  per_avg_availability?: Maybe<Timeseries_Result>;
  /** Efficiency % (Ratio of the actual power divided by the theoretical power) */
  per_avg_efficiency?: Maybe<Timeseries_Result>;
  /** Load Factor % (Ratio of the actual power divided by the rated power) */
  per_avg_loadFactor?: Maybe<Timeseries_Result>;
  /** Revenue */
  revenue?: Maybe<Timeseries_Result>;
  /** Revenue losses */
  revenueLosses?: Maybe<Timeseries_Result>;
  /** Revenues */
  revenue_filled?: Maybe<Timeseries_Result>;
  /** Turbine Status (1 => Limited operation, 2 => Alarm stop, 3 => Underperforming, 4 => In service, 5 => Wind under cut-in, 6 => Starting operation, 7 => Performing OK, 8 => No data) */
  status?: Maybe<Timeseries_Result>;
};


/** Turbine description */
export type Ts_Tur_10MvAr_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10Mw_Avg_LossArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10Mw_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10Mw_Avg_Mag_F_FilledArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10Mw_Avg_TheoreticalArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10Mw_Avg_Theoretical_FilledArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10MWh_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<WattHour>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10MWh_Avg_Mag_F_CorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<WattHour>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10MCo2AvoidedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10MPer_Avg_AvailabilityArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10MPer_Avg_EfficiencyArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10MPer_Avg_LoadFactorArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10MRevenueArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10MRevenueLossesArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10MRevenue_FilledArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_10MStatusArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Turbine description */
export type Ts_Tur_30S = {
  __typename?: 'TS_TUR_30S';
  /** Total (net) active energy production */
  TotWh_actVal?: Maybe<Timeseries_Result>;
  /** Total (net) active energy production (corrected) */
  TotWh_actVal_corrected?: Maybe<Timeseries_Result>;
  /** Turbine status 1 -> Stop (Turbine stopped) 2 -> Stdby (Turbine is in standby) 3 -> Str (Turbine is starting) 4 -> Run (Turbine is running in normal operation) 5 -> Free (Turbine is in freerun with the generator disconnected) 6 -> Brk (Turbine is braking) */
  TurSt_actSt_stVal?: Maybe<Timeseries_Result>;
  /** Active power generation */
  W_mag_f?: Maybe<Timeseries_Result>;
  /** Theoretical power generation */
  W_theoretical?: Maybe<Timeseries_Result>;
  /** Turbine Status (1 => Limited operation, 2 => Alarm stop, 3 => Underperforming, 4 => In service, 5 => Wind under cut-in, 6 => Starting operation, 7 => Performing OK, 8 => No data) */
  status?: Maybe<Timeseries_Result>;
};


/** Turbine description */
export type Ts_Tur_30STotWh_ActValArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<WattHour>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_30STotWh_ActVal_CorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<WattHour>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_30STurSt_ActSt_StValArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_30Sw_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_30Sw_TheoreticalArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Turbine description */
export type Ts_Tur_30SStatusArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Forecast information from Wind-Log provider */
export type Ts_Wlg_Wfc = {
  __typename?: 'TS_WLG_WFC';
  /** Imbalance (actual power / forecasted power) */
  imbalance?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power predicted) */
  imbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Imbalance (actual power / forecasted power) (not considering planning) */
  imbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) */
  negativeImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power predicted) */
  negativeImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative values for imbalance (actual power / forecasted power) (not considering planning) */
  negativeImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance */
  negativeOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for grouped imbalance */
  negativeOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for imbalance (not considering planning) */
  negativeOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance */
  negativeOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative off-peak values for revenue imbalance (not considering planning) */
  negativeOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance */
  negativePeakImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for grouped imbalance */
  negativePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Negative peak values for imbalance (not considering planning) */
  negativePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance */
  negativePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative peak values for revenue imbalance (not considering planning) */
  negativePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance */
  negativeRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Negative values for revenue imbalance (not considering planning) */
  negativeRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) */
  positiveImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power predicted) */
  positiveImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive values for imbalance (actual power / forecasted power) (not considering planning) */
  positiveImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance */
  positiveOffPeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for grouped imbalance */
  positiveOffPeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for imbalance (not considering planning) */
  positiveOffPeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance */
  positiveOffPeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive off-peak values for revenue imbalance (not considering planning) */
  positiveOffPeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance */
  positivePeakImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for grouped imbalance */
  positivePeakImbalanceGroupedByPrediction?: Maybe<Timeseries_Result>;
  /** Positive peak values for imbalance (not considering planning) */
  positivePeakImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance */
  positivePeakRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive peak values for revenue imbalance (not considering planning) */
  positivePeakRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance */
  positiveRevenueImbalance?: Maybe<Timeseries_Result>;
  /** Positive values for revenue imbalance (not considering planning) */
  positiveRevenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance */
  revenueImbalance?: Maybe<Timeseries_Result>;
  /** Revenue Imbalance (not considering planning) */
  revenueImbalanceNotCorrected?: Maybe<Timeseries_Result>;
  /** Forecast revenues */
  revenues?: Maybe<Timeseries_Result>;
  /** Forecast revenues considering the planned events */
  revenuesAmended?: Maybe<Timeseries_Result>;
  /** Temperature */
  temperature?: Maybe<Timeseries_Result>;
  /** Theoretical Power */
  theoreticalPower?: Maybe<Timeseries_Result>;
  /** Theoretical power considering the planned events */
  theoreticalPowerAmended?: Maybe<Timeseries_Result>;
  /** Theoretical power grouped by predicted date considering the planned events */
  theoreticalPowerAmendedPredicted?: Maybe<Timeseries_Result>;
  /** Theoretical Power Grouped By Predicted Date */
  theoreticalPowerPredicted?: Maybe<Timeseries_Result>;
  /** Weather icon */
  weather?: Maybe<Timeseries_Result>;
  /** Wind Direction */
  windDirection?: Maybe<Timeseries_Result>;
  /** Wind Speed */
  windSpeed?: Maybe<Timeseries_Result>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativeImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativeImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativeImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativeOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativeOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativeOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativeOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativeOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativeRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcNegativeRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositiveImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositiveImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositiveImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositiveOffPeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositiveOffPeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositiveOffPeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositiveOffPeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositiveOffPeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositivePeakImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositivePeakImbalanceGroupedByPredictionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositivePeakImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositivePeakRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositivePeakRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositiveRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcPositiveRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcRevenueImbalanceArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcRevenueImbalanceNotCorrectedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcRevenuesArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcRevenuesAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcTemperatureArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcTheoreticalPowerArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcTheoreticalPowerAmendedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcTheoreticalPowerAmendedPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcTheoreticalPowerPredictedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Watt>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcWeatherArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcWindDirectionArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Forecast information from Wind-Log provider */
export type Ts_Wlg_WfcWindSpeedArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Yaw description */
export type Ts_Yaw_10M = {
  __typename?: 'TS_YAW_10M';
  /** Yaw brake pressure */
  BrkPres_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Cable windup. Number of windings from calibration point. */
  CabWup_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Temperature inside yaw control cabinet */
  CtrCabTmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear 2 temperature */
  Tmp2_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear 3 temperature */
  Tmp3_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear 4 temperature */
  Tmp4_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear 5 temperature */
  Tmp5_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear 6 temperature */
  Tmp6_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yawing motor/gear temperature */
  Tmp_avg_mag_f?: Maybe<Timeseries_Result>;
  /** Yaw bearing rotation angle relative to nominal true North */
  YawAng_avg_mag_f?: Maybe<Timeseries_Result>;
};


/** Yaw description */
export type Ts_Yaw_10MBrkPres_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Yaw description */
export type Ts_Yaw_10MCabWup_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Yaw description */
export type Ts_Yaw_10MCtrCabTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Yaw description */
export type Ts_Yaw_10MTmp2_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Yaw description */
export type Ts_Yaw_10MTmp3_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Yaw description */
export type Ts_Yaw_10MTmp4_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Yaw description */
export type Ts_Yaw_10MTmp5_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Yaw description */
export type Ts_Yaw_10MTmp6_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Yaw description */
export type Ts_Yaw_10MTmp_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  convert?: InputMaybe<Celsius>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};


/** Yaw description */
export type Ts_Yaw_10MYawAng_Avg_Mag_FArgs = {
  aggregate?: InputMaybe<AggregateInput>;
  aggregation?: InputMaybe<Ts_Aggregation>;
  defaultValue?: InputMaybe<Scalars['Int']['input']>;
  imbalanceConfiguration?: InputMaybe<ImbalanceConfigurationInput>;
  range?: InputMaybe<RangeInput>;
  relativeRange?: InputMaybe<RelativeInput>;
  samplingInterval?: InputMaybe<SamplingIntervalInput>;
};

/** Description of turbine */
export type Turbine = {
  __typename?: 'TURBINE';
  /** Description of controller */
  CONTROLLER?: Maybe<Controller>;
  /** Data Description */
  DATA?: Maybe<Data_Turbine>;
  /** Description of errorCatalog */
  ERROR_CATALOG?: Maybe<Error_Catalog>;
  /** Description of manufacturer */
  MANUFACTURER?: Maybe<Manufacturer>;
  /** Description of park */
  PARK?: Maybe<Park>;
  /** Park Subtype */
  PARK_SUBTYPE?: Maybe<Park_Subtype>;
  /** Description of powerCurve */
  POWER_CURVE?: Maybe<Power_Curve>;
  /** Description of subtype */
  TURBINE_SUBTYPE?: Maybe<Turbine_Subtype>;
  /** Internal ID */
  _id: Scalars['ID']['output'];
  /** Turbine basement height in meters */
  basementHeight: Scalars['Float']['output'];
  /** Turbine code */
  code: Scalars['String']['output'];
  /** Turbine code display */
  codeDisplay: Scalars['String']['output'];
  /** Comissioning Date */
  comissioningDate: Scalars['String']['output'];
  /** Turbine diameter */
  diameter: Scalars['Float']['output'];
  /** Turbine hub height in meters */
  hubHeight: Scalars['Float']['output'];
  /** Turbine latitude */
  latitude: Scalars['Float']['output'];
  /** Turbine longitude */
  longitude: Scalars['Float']['output'];
  /** Turbine name */
  name: Scalars['String']['output'];
  /** Rated Power (kW) */
  ratedPower: Scalars['Float']['output'];
  /** Turbine serial */
  serial: Scalars['String']['output'];
  /** Turbine serialDisplay */
  serialDisplay: Scalars['String']['output'];
  /** Turbine serial numeric */
  serialNumeric: Scalars['Float']['output'];
  /** Turbine type */
  type: Scalars['String']['output'];
};


/** Description of turbine */
export type TurbineControllerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ControllerSortInput>;
  where?: InputMaybe<ControllerWhereInput>;
};


/** Description of turbine */
export type TurbineError_CatalogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Error_CatalogSortInput>;
  where?: InputMaybe<Error_CatalogWhereInput>;
};


/** Description of turbine */
export type TurbineManufacturerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ManufacturerSortInput>;
  where?: InputMaybe<ManufacturerWhereInput>;
};


/** Description of turbine */
export type TurbineParkArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ParkSortInput>;
  turbines?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<ParkWhereInput>;
};


/** Description of turbine */
export type TurbinePark_SubtypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Park_SubtypeSortInput>;
  where?: InputMaybe<Park_SubtypeWhereInput>;
};


/** Description of turbine */
export type TurbinePower_CurveArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Power_CurveSortInput>;
  where?: InputMaybe<Power_CurveWhereInput>;
};


/** Description of turbine */
export type TurbineTurbine_SubtypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Turbine_SubtypeSortInput>;
  where?: InputMaybe<Turbine_SubtypeWhereInput>;
};

export type TurbineSortInput = {
  _id?: InputMaybe<Sort>;
  basementHeight?: InputMaybe<Sort>;
  code?: InputMaybe<Sort>;
  codeDisplay?: InputMaybe<Sort>;
  comissioningDate?: InputMaybe<Sort>;
  diameter?: InputMaybe<Sort>;
  hubHeight?: InputMaybe<Sort>;
  latitude?: InputMaybe<Sort>;
  longitude?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  ratedPower?: InputMaybe<Sort>;
  serial?: InputMaybe<Sort>;
  serialDisplay?: InputMaybe<Sort>;
  serialNumeric?: InputMaybe<Sort>;
  type?: InputMaybe<Sort>;
};

export type TurbineWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<TurbineWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<TurbineWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  basementHeight?: InputMaybe<FloatInput>;
  code?: InputMaybe<StringInput>;
  codeDisplay?: InputMaybe<StringInput>;
  comissioningDate?: InputMaybe<StringInput>;
  diameter?: InputMaybe<FloatInput>;
  hubHeight?: InputMaybe<FloatInput>;
  latitude?: InputMaybe<FloatInput>;
  longitude?: InputMaybe<FloatInput>;
  name?: InputMaybe<StringInput>;
  ratedPower?: InputMaybe<FloatInput>;
  serial?: InputMaybe<StringInput>;
  serialDisplay?: InputMaybe<StringInput>;
  serialNumeric?: InputMaybe<FloatInput>;
  type?: InputMaybe<StringInput>;
};

/** Description of subtype */
export type Turbine_Subtype = {
  __typename?: 'TURBINE_SUBTYPE';
  /** Internal ID */
  _id: Scalars['ID']['output'];
  /** Subtype name */
  name: Scalars['String']['output'];
};

export type Turbine_SubtypeSortInput = {
  _id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type Turbine_SubtypeWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<Turbine_SubtypeWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<Turbine_SubtypeWhereInput>>>;
  _id?: InputMaybe<StringInput>;
  name?: InputMaybe<StringInput>;
};

/** Turbine description */
export type Tur_10M = {
  __typename?: 'TUR_10M';
  /** Reactive power generation */
  VAr_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Power Losses (Difference beetwen theoretical power and actual power) */
  W_avg_loss?: Maybe<Snapshot_Result>;
  /** Active power generation */
  W_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Active power generation filling the gaps with the counter data interpolation */
  W_avg_mag_f_filled?: Maybe<Snapshot_Result>;
  /** Theoretical power generation */
  W_avg_theoretical?: Maybe<Snapshot_Result>;
  /** Theoretical power generation filling the gaps with the counter data interpolation */
  W_avg_theoretical_filled?: Maybe<Snapshot_Result>;
  /** Energy produced */
  Wh_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Energy produced */
  Wh_avg_mag_f_corrected?: Maybe<Snapshot_Result>;
  /** CO2 Avoided */
  co2Avoided?: Maybe<Snapshot_Result>;
  /** Time-based availability % */
  per_avg_availability?: Maybe<Snapshot_Result>;
  /** Efficiency % (Ratio of the actual power divided by the theoretical power) */
  per_avg_efficiency?: Maybe<Snapshot_Result>;
  /** Load Factor % (Ratio of the actual power divided by the rated power) */
  per_avg_loadFactor?: Maybe<Snapshot_Result>;
  /** Revenue */
  revenue?: Maybe<Snapshot_Result>;
  /** Revenue losses */
  revenueLosses?: Maybe<Snapshot_Result>;
  /** Revenues */
  revenue_filled?: Maybe<Snapshot_Result>;
  /** Turbine Status (1 => Limited operation, 2 => Alarm stop, 3 => Underperforming, 4 => In service, 5 => Wind under cut-in, 6 => Starting operation, 7 => Performing OK, 8 => No data) */
  status?: Maybe<Snapshot_Result>;
};


/** Turbine description */
export type Tur_10MvAr_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_10Mw_Avg_LossArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Watt>;
};


/** Turbine description */
export type Tur_10Mw_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Watt>;
};


/** Turbine description */
export type Tur_10Mw_Avg_Mag_F_FilledArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Watt>;
};


/** Turbine description */
export type Tur_10Mw_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Watt>;
};


/** Turbine description */
export type Tur_10Mw_Avg_Theoretical_FilledArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Watt>;
};


/** Turbine description */
export type Tur_10MWh_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<WattHour>;
};


/** Turbine description */
export type Tur_10MWh_Avg_Mag_F_CorrectedArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<WattHour>;
};


/** Turbine description */
export type Tur_10MCo2AvoidedArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_10MPer_Avg_AvailabilityArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_10MPer_Avg_EfficiencyArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_10MPer_Avg_LoadFactorArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_10MRevenueArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_10MRevenueLossesArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_10MRevenue_FilledArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_10MStatusArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

/** Turbine description */
export type Tur_30S = {
  __typename?: 'TUR_30S';
  /** Total turbine availability time (vendor-specific) The precise semantic shall be defined and documented by the manufacturer of the turbine controller. */
  AvlTmRs_tmTot?: Maybe<Snapshot_Result>;
  /** Total operation time (vendor-specific) */
  OpTmRs_tmTot?: Maybe<Snapshot_Result>;
  /** Total (net) reactive energy production */
  TotVArh_actVal?: Maybe<Snapshot_Result>;
  /** Total (net) active energy production */
  TotWh_actVal?: Maybe<Snapshot_Result>;
  /** Total (net) active energy production (corrected) */
  TotWh_actVal_corrected?: Maybe<Snapshot_Result>;
  /** Turbine maintenance status 0 -> no maintenance 1 -> maintenance */
  TurMaint_actSt_stVal?: Maybe<Snapshot_Result>;
  /** Turbine status 1 -> Stop (Turbine stopped) 2 -> Stdby (Turbine is in standby) 3 -> Str (Turbine is starting) 4 -> Run (Turbine is running in normal operation) 5 -> Free (Turbine is in freerun with the generator disconnected) 6 -> Brk (Turbine is braking) */
  TurSt_actSt_stVal?: Maybe<Snapshot_Result>;
  /** Reactive power generation */
  VAr_mag_f?: Maybe<Snapshot_Result>;
  /** Power losses (theoretical power - active power) */
  W_loss?: Maybe<Snapshot_Result>;
  /** Active power generation */
  W_mag_f?: Maybe<Snapshot_Result>;
  /** Rated Power */
  W_rated?: Maybe<Snapshot_Result>;
  /** Theoretical power generation */
  W_theoretical?: Maybe<Snapshot_Result>;
  /** Efficiency (actual power / theoretical power) */
  per_efficiency?: Maybe<Snapshot_Result>;
  /** Load factor (actual power / rated power) */
  per_loadFactor?: Maybe<Snapshot_Result>;
  /** Signal Time */
  signal_time?: Maybe<Snapshot_Result>;
  /** Turbine Status (1 => Limited operation, 2 => Alarm stop, 3 => Underperforming, 4 => In service, 5 => Wind under cut-in, 6 => Starting operation, 7 => Performing OK, 8 => No data) */
  status?: Maybe<Snapshot_Result>;
};


/** Turbine description */
export type Tur_30SAvlTmRs_TmTotArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_30SOpTmRs_TmTotArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_30STotVArh_ActValArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_30STotWh_ActValArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<WattHour>;
};


/** Turbine description */
export type Tur_30STotWh_ActVal_CorrectedArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<WattHour>;
};


/** Turbine description */
export type Tur_30STurMaint_ActSt_StValArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_30STurSt_ActSt_StValArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_30SvAr_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<VAr>;
};


/** Turbine description */
export type Tur_30Sw_LossArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Watt>;
};


/** Turbine description */
export type Tur_30Sw_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Watt>;
};


/** Turbine description */
export type Tur_30Sw_RatedArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Watt>;
};


/** Turbine description */
export type Tur_30Sw_TheoreticalArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Watt>;
};


/** Turbine description */
export type Tur_30SPer_EfficiencyArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_30SPer_LoadFactorArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_30SSignal_TimeArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Turbine description */
export type Tur_30SStatusArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

export enum TimeGranularity {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Weeks = 'WEEKS'
}

export type Turbine_Groups = {
  __typename?: 'Turbine_groups';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  turbines: Array<Maybe<Scalars['ID']['output']>>;
};

/** Custom turbine groups defined by user */
export type User_Turbine_Group = {
  __typename?: 'USER_TURBINE_GROUP';
  /** Park ID */
  _id_park: Scalars['ID']['output'];
  /** Array of turbine groups for this park */
  turbine_groups?: Maybe<Array<Maybe<User_Turbine_Groups>>>;
};

export type User_Turbine_GroupSortInput = {
  _id_park?: InputMaybe<Sort>;
  turbine_groups?: InputMaybe<Sort>;
};

export type User_Turbine_GroupWhereInput = {
  AND?: InputMaybe<Array<InputMaybe<User_Turbine_GroupWhereInput>>>;
  OR?: InputMaybe<Array<InputMaybe<User_Turbine_GroupWhereInput>>>;
  _id_park?: InputMaybe<StringInput>;
};

export enum VAr {
  Gvar = 'GVAR',
  Kvar = 'KVAR',
  Mvar = 'MVAR'
}

export enum Watt {
  Gw = 'GW',
  Kw = 'KW',
  Mw = 'MW'
}

export enum WattHour {
  GWh = 'GWh',
  KWh = 'KWh',
  MWh = 'MWh'
}

/** Yaw description */
export type Yaw_10M = {
  __typename?: 'YAW_10M';
  /** Yaw brake pressure */
  BrkPres_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Cable windup. Number of windings from calibration point. */
  CabWup_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside yaw control cabinet */
  CtrCabTmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 2 temperature */
  Tmp2_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 3 temperature */
  Tmp3_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 4 temperature */
  Tmp4_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 5 temperature */
  Tmp5_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 6 temperature */
  Tmp6_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear temperature */
  Tmp_avg_mag_f?: Maybe<Snapshot_Result>;
  /** Yaw bearing rotation angle relative to nominal true North */
  YawAng_avg_mag_f?: Maybe<Snapshot_Result>;
};


/** Yaw description */
export type Yaw_10MBrkPres_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Yaw description */
export type Yaw_10MCabWup_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Yaw description */
export type Yaw_10MCtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_10MTmp2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_10MTmp3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_10MTmp4_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_10MTmp5_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_10MTmp6_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_10MTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_10MYawAng_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

/** Yaw description */
export type Yaw_30S = {
  __typename?: 'YAW_30S';
  /** Yaw brake pressure */
  BrkPres_mag_f?: Maybe<Snapshot_Result>;
  /** Cable windup. Number of windings from calibration point. */
  CabWup_mag_f?: Maybe<Snapshot_Result>;
  /** Temperature inside yaw control cabinet */
  CtrCabTmp_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 2 temperature */
  Tmp2_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 3 temperature */
  Tmp3_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 4 temperature */
  Tmp4_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 5 temperature */
  Tmp5_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear 6 temperature */
  Tmp6_mag_f?: Maybe<Snapshot_Result>;
  /** Yawing motor/gear temperature */
  Tmp_mag_f?: Maybe<Snapshot_Result>;
  /** Yaw bearing rotation angle relative to nominal true North */
  YawAng_mag_f?: Maybe<Snapshot_Result>;
};


/** Yaw description */
export type Yaw_30SBrkPres_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Yaw description */
export type Yaw_30SCabWup_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};


/** Yaw description */
export type Yaw_30SCtrCabTmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_30STmp2_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_30STmp3_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_30STmp4_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_30STmp5_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_30STmp6_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_30STmp_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
  convert?: InputMaybe<Celsius>;
};


/** Yaw description */
export type Yaw_30SYawAng_Mag_FArgs = {
  aggregation?: InputMaybe<Aggregation>;
};

export enum Align {
  End = 'END',
  Sample = 'SAMPLE',
  Start = 'START'
}

export enum AnalyzeTypeEnum {
  ModelAnalyze = 'MODEL_ANALYZE',
  SystemAnalyze = 'SYSTEM_ANALYZE'
}

/** Big power curve (0.01 wind speed granularity) */
export type BigPc = {
  __typename?: 'bigPC';
  /** Power (kW) */
  power: Scalars['Float']['output'];
  /** Wind Speed (m/s) */
  windSpeed: Scalars['Float']['output'];
};

export type CreateCustomTurbineGroupData = {
  __typename?: 'createCustomTurbineGroupData';
  _id_park: Scalars['ID']['output'];
  turbine_groups: Array<Maybe<Turbine_Groups>>;
};

export type CreateCustomTurbineGroupResponse = {
  __typename?: 'createCustomTurbineGroupResponse';
  data?: Maybe<CreateCustomTurbineGroupData>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteCustomTurbineGroupData = {
  __typename?: 'deleteCustomTurbineGroupData';
  _id_group: Scalars['ID']['output'];
};

export type DeleteCustomTurbineGroupResponse = {
  __typename?: 'deleteCustomTurbineGroupResponse';
  data?: Maybe<DeleteCustomTurbineGroupData>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletePlannedEventData = {
  __typename?: 'deletePlannedEventData';
  _id: Scalars['ID']['output'];
  _id_alarm?: Maybe<Scalars['ID']['output']>;
  _id_group?: Maybe<Scalars['ID']['output']>;
  _id_park: Scalars['ID']['output'];
  _id_process?: Maybe<Scalars['ID']['output']>;
  _id_turbine: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  creationTs: Scalars['Float']['output'];
  debugMode?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  endTs: Scalars['Float']['output'];
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  lastEditedTs: Scalars['Float']['output'];
  lastUpdatedTs: Scalars['Float']['output'];
  limitedTo?: Maybe<Scalars['Float']['output']>;
  plannedTCU?: Maybe<Scalars['String']['output']>;
  productionArrWithTime?: Maybe<Array<Maybe<ProductionArrWithTime>>>;
  productionLoss?: Maybe<Scalars['Float']['output']>;
  productionLossArrWithTime?: Maybe<Array<Maybe<ProductionLossArrWithTime>>>;
  provider: Scalars['String']['output'];
  reminderSettings?: Maybe<ReminderSettings>;
  revenueLoss?: Maybe<Scalars['Float']['output']>;
  startTs: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type DeletePlannedEventResponse = {
  __typename?: 'deletePlannedEventResponse';
  data?: Maybe<Array<Maybe<DeletePlannedEventData>>>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProcessData = {
  __typename?: 'deleteProcessData';
  _id: Scalars['ID']['output'];
};

export type DeleteProcessResponse = {
  __typename?: 'deleteProcessResponse';
  data?: Maybe<DeleteProcessData>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** error catalog list of errors */
export type Errors = {
  __typename?: 'errors';
  /** Error code */
  code: Scalars['String']['output'];
  /** Error description */
  description: Scalars['String']['output'];
};

export type InsertInvoiceData = {
  __typename?: 'insertInvoiceData';
  _id_country: Scalars['ID']['output'];
  _id_park: Scalars['ID']['output'];
  commentLastUpdatedBy?: Maybe<Scalars['Int']['output']>;
  commentLastUpdatedTs?: Maybe<Scalars['Int']['output']>;
  commentText?: Maybe<Scalars['String']['output']>;
  compensatedProduction?: Maybe<Scalars['Int']['output']>;
  compensatedRevenue?: Maybe<Scalars['Int']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  deliveredProduction?: Maybe<Scalars['Int']['output']>;
  deliveredRevenue?: Maybe<Scalars['Int']['output']>;
  hour?: Maybe<Scalars['Int']['output']>;
  isCompensatedAvailable?: Maybe<Scalars['Boolean']['output']>;
  isDeliveredAvailable?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedTs?: Maybe<Scalars['Int']['output']>;
  lastUpdatedUser?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  valuesLastUpdatedBy?: Maybe<Scalars['Int']['output']>;
  valuesLastUpdatedTs?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type InsertInvoiceResponse = {
  __typename?: 'insertInvoiceResponse';
  data?: Maybe<InsertInvoiceData>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type JsonMap = {
  __typename?: 'jsonMap';
  timestamp?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type NewPlannedEventData = {
  __typename?: 'newPlannedEventData';
  _id: Scalars['ID']['output'];
  _id_alarm?: Maybe<Scalars['ID']['output']>;
  _id_group?: Maybe<Scalars['ID']['output']>;
  _id_park: Scalars['ID']['output'];
  _id_process?: Maybe<Scalars['ID']['output']>;
  _id_turbine: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  creationTs: Scalars['Float']['output'];
  debugMode?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  endTs: Scalars['Float']['output'];
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  lastEditedTs: Scalars['Float']['output'];
  lastUpdatedTs: Scalars['Float']['output'];
  limitedTo?: Maybe<Scalars['Float']['output']>;
  plannedTCU?: Maybe<Scalars['String']['output']>;
  productionArrWithTime?: Maybe<Array<Maybe<ProductionArrWithTime>>>;
  productionLoss?: Maybe<Scalars['Float']['output']>;
  productionLossArrWithTime?: Maybe<Array<Maybe<ProductionLossArrWithTime>>>;
  provider: Scalars['String']['output'];
  reminderSettings?: Maybe<ReminderSettings>;
  revenueLoss?: Maybe<Scalars['Float']['output']>;
  startTs: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type NewPlannedEventResponse = {
  __typename?: 'newPlannedEventResponse';
  data?: Maybe<Array<Maybe<NewPlannedEventData>>>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type NewPlannedEventsData = {
  __typename?: 'newPlannedEventsData';
  _id: Scalars['ID']['output'];
  _id_alarm?: Maybe<Scalars['ID']['output']>;
  _id_group?: Maybe<Scalars['ID']['output']>;
  _id_park: Scalars['ID']['output'];
  _id_process?: Maybe<Scalars['ID']['output']>;
  _id_turbine: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  creationTs: Scalars['Float']['output'];
  debugMode?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  endTs: Scalars['Float']['output'];
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  lastEditedTs: Scalars['Float']['output'];
  lastUpdatedTs: Scalars['Float']['output'];
  limitedTo?: Maybe<Scalars['Float']['output']>;
  plannedTCU?: Maybe<Scalars['String']['output']>;
  productionArrWithTime?: Maybe<Array<Maybe<ProductionArrWithTime>>>;
  productionLoss?: Maybe<Scalars['Float']['output']>;
  productionLossArrWithTime?: Maybe<Array<Maybe<ProductionLossArrWithTime>>>;
  provider: Scalars['String']['output'];
  reminderSettings?: Maybe<ReminderSettings>;
  revenueLoss?: Maybe<Scalars['Float']['output']>;
  startTs: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type NewPlannedEventsResponse = {
  __typename?: 'newPlannedEventsResponse';
  data?: Maybe<Array<Maybe<NewPlannedEventsData>>>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type NewProcessData = {
  __typename?: 'newProcessData';
  _id: Scalars['ID']['output'];
  _id_parks: Scalars['ID']['output'];
  _id_plannedEvents?: Maybe<Scalars['String']['output']>;
  _id_tClassBlocks?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  creationTs: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  estimatedEndTs?: Maybe<Scalars['Float']['output']>;
  estimatedStartTs?: Maybe<Scalars['Float']['output']>;
  lastEditedTs: Scalars['Float']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type NewProcessResponse = {
  __typename?: 'newProcessResponse';
  data?: Maybe<NewProcessData>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** range period from to to timestamps */
export type Range_Input = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

/** Small power curve (0.5 wind speed granularity) */
export type SmallPc = {
  __typename?: 'smallPC';
  /** Power (kW) */
  power: Scalars['Float']['output'];
  /** Wind Speed (m/s) */
  windSpeed: Scalars['Float']['output'];
};

/** List of turbine IDs belonging to a group */
export type Turbines = {
  __typename?: 'turbines';
  /** Turbine ID */
  id: Scalars['ID']['output'];
};

export enum UnitEnum {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Seconds = 'SECONDS'
}

export type UpdateCustomTurbineGroupData = {
  __typename?: 'updateCustomTurbineGroupData';
  _id_park: Scalars['ID']['output'];
  turbine_groups: Array<Maybe<Turbine_Groups>>;
};

export type UpdateCustomTurbineGroupResponse = {
  __typename?: 'updateCustomTurbineGroupResponse';
  data?: Maybe<UpdateCustomTurbineGroupData>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdatePlannedEventData = {
  __typename?: 'updatePlannedEventData';
  _id: Scalars['ID']['output'];
  _id_alarm?: Maybe<Scalars['ID']['output']>;
  _id_group?: Maybe<Scalars['ID']['output']>;
  _id_park: Scalars['ID']['output'];
  _id_process?: Maybe<Scalars['ID']['output']>;
  _id_turbine: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  creationTs: Scalars['Float']['output'];
  debugMode?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  endTs: Scalars['Float']['output'];
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  lastEditedTs: Scalars['Float']['output'];
  lastUpdatedTs: Scalars['Float']['output'];
  limitedTo?: Maybe<Scalars['Float']['output']>;
  plannedTCU?: Maybe<Scalars['String']['output']>;
  productionArrWithTime?: Maybe<Array<Maybe<ProductionArrWithTime>>>;
  productionLoss?: Maybe<Scalars['Float']['output']>;
  productionLossArrWithTime?: Maybe<Array<Maybe<ProductionLossArrWithTime>>>;
  provider: Scalars['String']['output'];
  reminderSettings?: Maybe<ReminderSettings>;
  revenueLoss?: Maybe<Scalars['Float']['output']>;
  startTs: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type UpdatePlannedEventResponse = {
  __typename?: 'updatePlannedEventResponse';
  data?: Maybe<Array<Maybe<UpdatePlannedEventData>>>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateProcessData = {
  __typename?: 'updateProcessData';
  _id: Scalars['ID']['output'];
  _id_parks: Scalars['ID']['output'];
  _id_plannedEvents?: Maybe<Scalars['String']['output']>;
  _id_tClassBlocks?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  creationTs: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  estimatedEndTs?: Maybe<Scalars['Float']['output']>;
  estimatedStartTs?: Maybe<Scalars['Float']['output']>;
  lastEditedTs: Scalars['Float']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type UpdateProcessResponse = {
  __typename?: 'updateProcessResponse';
  data?: Maybe<UpdateProcessData>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom turbine groups for a park */
export type User_Turbine_Groups = {
  __typename?: 'user_turbine_groups';
  /** Unique ID of the turbine group */
  _id: Scalars['ID']['output'];
  /** Name of the turbine group */
  name: Scalars['String']['output'];
  /** Array of turbine IDs in this group */
  turbines?: Maybe<Array<Turbines>>;
};

export type BudgetFollowUpParkManagementMutationMutationVariables = Exact<{
  invoiceData?: InputMaybe<InvoiceInput>;
}>;


export type BudgetFollowUpParkManagementMutationMutation = { __typename?: 'Mutation', insertInvoice?: { __typename?: 'insertInvoiceResponse', success?: boolean | null, error?: string | null } | null };

export type BudgetFollowUpRevenuesConfigurationQueryVariables = Exact<{
  parkIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BudgetFollowUpRevenuesConfigurationQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', _id: string, useRevenuesV2InBudgets?: boolean | null } | null> | null };

export type BudgetFollowUpParkDashboardMainKpisQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  parkId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BudgetFollowUpParkDashboardMainKpisQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_by_month?: Array<{ __typename?: 'BUDGET_BY_MONTH', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionBudget?: number | null, productionBudgetAcc?: number | null, revenueBudget?: number | null, revenueBudgetAcc?: number | null, productionTheoretical?: number | null, productionTheoreticalAcc?: number | null, revenueTheoretical?: number | null, revenueTheoreticalAcc?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type BudgetFollowUpParkDataQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  parkId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type BudgetFollowUpParkDataQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, _id: string, COUNTRY?: { __typename?: 'COUNTRY', _id: string } | null, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_by_month?: Array<{ __typename?: 'BUDGET_BY_MONTH', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionExpectedAcc?: number | null, revenueExpectedAcc?: number | null, productionBudget?: number | null, productionBudgetAcc?: number | null, revenueBudget?: number | null, revenueBudgetAcc?: number | null, productionTheoretical?: number | null, productionTheoreticalAcc?: number | null, revenueTheoretical?: number | null, revenueTheoreticalAcc?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionScada?: number | null, productionScadaAcc?: number | null, productionGrid?: number | null, productionGridAcc?: number | null, revenueScada?: number | null, revenueScadaAcc?: number | null, revenueGrid?: number | null, revenueGridAcc?: number | null, isInvoiceDelivered?: number | null, isInvoiceCompensated?: number | null, productionCompensatedInvoiced?: number | null, productionCompensatedInvoicedAcc?: number | null, revenueCompensatedInvoiced?: number | null, revenueCompensatedInvoicedAcc?: number | null, productionDeliveredInvoiced?: number | null, productionDeliveredInvoicedAcc?: number | null, revenueDeliveredInvoiced?: number | null, revenueDeliveredInvoicedAcc?: number | null, commentText?: string | null, lastUpdatedUser?: string | null, lastUpdatedTs?: string | null, files?: string | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type BudgetFollowUpParkProductionVsBudgetByDayQueryVariables = Exact<{
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  parkId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BudgetFollowUpParkProductionVsBudgetByDayQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_by_day?: Array<{ __typename?: 'BUDGET_BY_DAY', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionExpectedAcc?: number | null, revenueExpectedAcc?: number | null, productionBudget?: number | null, productionBudgetAcc?: number | null, revenueBudget?: number | null, revenueBudgetAcc?: number | null, productionTheoretical?: number | null, revenueTheoretical?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionScada?: number | null, productionScadaAcc?: number | null, productionGrid?: number | null, productionGridAcc?: number | null, revenueScada?: number | null, revenueScadaAcc?: number | null, revenueGrid?: number | null, revenueGridAcc?: number | null, isInvoiceDelivered?: number | null, isInvoiceCompensated?: number | null, productionCompensatedInvoiced?: number | null, productionCompensatedInvoicedAcc?: number | null, revenueCompensatedInvoiced?: number | null, revenueCompensatedInvoicedAcc?: number | null, productionDeliveredInvoiced?: number | null, productionDeliveredInvoicedAcc?: number | null, revenueDeliveredInvoiced?: number | null, revenueDeliveredInvoicedAcc?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type BudgetFollowUpParkProductionVsBudgetQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  parkId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BudgetFollowUpParkProductionVsBudgetQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_by_month?: Array<{ __typename?: 'BUDGET_BY_MONTH', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionExpectedAcc?: number | null, revenueExpectedAcc?: number | null, productionBudget?: number | null, productionBudgetAcc?: number | null, revenueBudget?: number | null, revenueBudgetAcc?: number | null, productionTheoretical?: number | null, productionTheoreticalAcc?: number | null, revenueTheoretical?: number | null, revenueTheoreticalAcc?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionScada?: number | null, productionScadaAcc?: number | null, productionGrid?: number | null, productionGridAcc?: number | null, revenueScada?: number | null, revenueScadaAcc?: number | null, revenueGrid?: number | null, revenueGridAcc?: number | null, isInvoiceDelivered?: number | null, isInvoiceCompensated?: number | null, productionCompensatedInvoiced?: number | null, productionCompensatedInvoicedAcc?: number | null, revenueCompensatedInvoiced?: number | null, revenueCompensatedInvoicedAcc?: number | null, productionDeliveredInvoiced?: number | null, productionDeliveredInvoicedAcc?: number | null, revenueDeliveredInvoiced?: number | null, revenueDeliveredInvoicedAcc?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type BudgetFollowUpPortfolioDashboardMainKpisQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BudgetFollowUpPortfolioDashboardMainKpisQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_by_month?: Array<{ __typename?: 'BUDGET_BY_MONTH', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionBudget?: number | null, productionBudgetAcc?: number | null, revenueBudget?: number | null, revenueBudgetAcc?: number | null, productionTheoretical?: number | null, productionTheoreticalAcc?: number | null, revenueTheoretical?: number | null, revenueTheoreticalAcc?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null } | null> | null } | null } | null } | null } | null };

export type BudgetFollowUpPortfolioProductionVsBudgetByWindparkQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BudgetFollowUpPortfolioProductionVsBudgetByWindparkQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_by_park?: Array<{ __typename?: 'BUDGET_BY_PARK', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionBudget?: number | null, productionBudgetAcc?: number | null, revenueBudget?: number | null, revenueBudgetAcc?: number | null, productionTheoretical?: number | null, productionTheoreticalAcc?: number | null, revenueTheoretical?: number | null, revenueTheoreticalAcc?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionScada?: number | null, productionScadaAcc?: number | null, productionGrid?: number | null, productionGridAcc?: number | null, revenueScada?: number | null, revenueScadaAcc?: number | null, revenueGrid?: number | null, revenueGridAcc?: number | null, isInvoiceDelivered?: number | null, isInvoiceCompensated?: number | null, productionCompensatedInvoiced?: number | null, productionCompensatedInvoicedAcc?: number | null, revenueCompensatedInvoiced?: number | null, revenueCompensatedInvoicedAcc?: number | null, productionDeliveredInvoiced?: number | null, productionDeliveredInvoicedAcc?: number | null, revenueDeliveredInvoiced?: number | null, revenueDeliveredInvoicedAcc?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null, PARK?: { __typename?: 'PARK', _id: string, name: string, displayName: string, code: string, COUNTRY?: { __typename?: 'COUNTRY', code: string, name: string } | null } | null } | null> | null, budget_by_park_month?: Array<{ __typename?: 'BUDGET_BY_PARK_MONTH', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionBudget?: number | null, productionBudgetAcc?: number | null, revenueBudget?: number | null, revenueBudgetAcc?: number | null, productionTheoretical?: number | null, productionTheoreticalAcc?: number | null, revenueTheoretical?: number | null, revenueTheoreticalAcc?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionScada?: number | null, productionScadaAcc?: number | null, productionGrid?: number | null, productionGridAcc?: number | null, revenueScada?: number | null, revenueScadaAcc?: number | null, revenueGrid?: number | null, revenueGridAcc?: number | null, isInvoiceDelivered?: number | null, isInvoiceCompensated?: number | null, productionCompensatedInvoiced?: number | null, productionCompensatedInvoicedAcc?: number | null, revenueCompensatedInvoiced?: number | null, revenueCompensatedInvoicedAcc?: number | null, productionDeliveredInvoiced?: number | null, productionDeliveredInvoicedAcc?: number | null, revenueDeliveredInvoiced?: number | null, revenueDeliveredInvoicedAcc?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null, PARK?: { __typename?: 'PARK', _id: string, name: string, displayName: string, code: string, COUNTRY?: { __typename?: 'COUNTRY', code: string, name: string } | null } | null } | null> | null, budget_by_country?: Array<{ __typename?: 'BUDGET_BY_COUNTRY', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionBudget?: number | null, productionBudgetAcc?: number | null, revenueBudget?: number | null, revenueBudgetAcc?: number | null, productionTheoretical?: number | null, revenueTheoretical?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, isInvoiceDelivered?: number | null, isInvoiceCompensated?: number | null, productionCompensatedInvoiced?: number | null, productionCompensatedInvoicedAcc?: number | null, revenueCompensatedInvoiced?: number | null, revenueCompensatedInvoicedAcc?: number | null, productionDeliveredInvoiced?: number | null, productionDeliveredInvoicedAcc?: number | null, revenueDeliveredInvoiced?: number | null, revenueDeliveredInvoicedAcc?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null, COUNTRY?: { __typename?: 'COUNTRY', code: string, name: string } | null } | null> | null, budget_by_country_month?: Array<{ __typename?: 'BUDGET_BY_COUNTRY_MONTH', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionBudget?: number | null, productionBudgetAcc?: number | null, revenueBudget?: number | null, revenueBudgetAcc?: number | null, productionTheoretical?: number | null, revenueTheoretical?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, isInvoiceDelivered?: number | null, isInvoiceCompensated?: number | null, productionCompensatedInvoiced?: number | null, productionCompensatedInvoicedAcc?: number | null, revenueCompensatedInvoiced?: number | null, revenueCompensatedInvoicedAcc?: number | null, productionDeliveredInvoiced?: number | null, productionDeliveredInvoicedAcc?: number | null, revenueDeliveredInvoiced?: number | null, revenueDeliveredInvoicedAcc?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null, COUNTRY?: { __typename?: 'COUNTRY', code: string, name: string } | null } | null> | null } | null } | null } | null } | null };

export type BudgetFollowUpPortfolioProductionVsBudgetQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BudgetFollowUpPortfolioProductionVsBudgetQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_by_month?: Array<{ __typename?: 'BUDGET_BY_MONTH', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionExpectedAcc?: number | null, revenueExpectedAcc?: number | null, productionBudget?: number | null, productionBudgetAcc?: number | null, revenueBudget?: number | null, revenueBudgetAcc?: number | null, productionTheoretical?: number | null, productionTheoreticalAcc?: number | null, revenueTheoretical?: number | null, revenueTheoreticalAcc?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionScada?: number | null, productionScadaAcc?: number | null, productionGrid?: number | null, productionGridAcc?: number | null, revenueScada?: number | null, revenueScadaAcc?: number | null, revenueGrid?: number | null, revenueGridAcc?: number | null, isInvoiceDelivered?: number | null, isInvoiceCompensated?: number | null, productionCompensatedInvoiced?: number | null, productionCompensatedInvoicedAcc?: number | null, revenueCompensatedInvoiced?: number | null, revenueCompensatedInvoicedAcc?: number | null, productionDeliveredInvoiced?: number | null, productionDeliveredInvoicedAcc?: number | null, revenueDeliveredInvoiced?: number | null, revenueDeliveredInvoicedAcc?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null } | null> | null } | null } | null } | null } | null };

export type BudgetFollowUpPortfolioOverviewMainKpisQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BudgetFollowUpPortfolioOverviewMainKpisQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_by_country?: Array<{ __typename?: 'BUDGET_BY_COUNTRY', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionBudget?: number | null, revenueBudget?: number | null, productionTheoretical?: number | null, revenueTheoretical?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionBudgetAcc?: number | null, revenueBudgetAcc?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null, COUNTRY?: { __typename?: 'COUNTRY', name: string, code: string } | null, PARK?: { __typename?: 'PARK', name: string, code: string } | null } | null> | null, budget_total?: Array<{ __typename?: 'BUDGET_TOTAL', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionBudget?: number | null, revenueBudget?: number | null, productionTheoretical?: number | null, revenueTheoretical?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionBudgetAcc?: number | null, revenueBudgetAcc?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null } | null> | null } | null } | null } | null } | null };

export type BudgetFollowUpPortfolioOverviewParkKpisByCountryQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BudgetFollowUpPortfolioOverviewParkKpisByCountryQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_by_park?: Array<{ __typename?: 'BUDGET_BY_PARK', year?: number | null, month?: number | null, revenueAcc?: number | null, revenue?: number | null, totalRevenue?: number | null, totalRevenueAcc?: number | null, production?: number | null, productionAcc?: number | null, productionExpected?: number | null, revenueExpected?: number | null, productionBudget?: number | null, revenueBudget?: number | null, productionTheoretical?: number | null, revenueTheoretical?: number | null, productionBudgetYTD?: number | null, revenueBudgetYTD?: number | null, productionBudgetAcc?: number | null, revenueBudgetAcc?: number | null, productionDeliveredAcc?: number | null, productionDelivered?: number | null, revenueDeliveredAcc?: number | null, revenueDelivered?: number | null, productionCompensatedAcc?: number | null, productionCompensated?: number | null, revenueCompensatedAcc?: number | null, revenueCompensated?: number | null, productionLossLogbook?: number | null, productionLossLogbookAcc?: number | null, revenueLossLogbook?: number | null, revenueLossLogbookAcc?: number | null, PARK?: { __typename?: 'PARK', _id: string, name: string, displayName: string, code: string, COUNTRY?: { __typename?: 'COUNTRY', code: string, name: string } | null } | null } | null> | null } | null } | null } | null } | null };

export type BudgetFollowUpPortfolioOverviewSummaryKpisQueryVariables = Exact<{
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  useRevenuesV2?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BudgetFollowUpPortfolioOverviewSummaryKpisQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', _id: string, displayName: string } | null> | null, PORTFOLIO?: { __typename?: 'PORTFOLIO', DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_summary?: { __typename?: 'BUDGET_SUMMARY', total?: { __typename?: 'BUDGET_SUMMARY_VALUES', production?: number | null, productionBudget?: number | null, productionTheoretical?: number | null, revenue?: number | null, revenueBudget?: number | null, revenueTheoretical?: number | null, windSpeed?: number | null, windSpeedBudget?: number | null } | null, byPark?: Array<{ __typename?: 'BUDGET_SUMMARY_BY_PARK', _id_park?: string | null, production?: number | null, productionBudget?: number | null, productionTheoretical?: number | null, revenue?: number | null, revenueBudget?: number | null, revenueTheoretical?: number | null, windSpeed?: number | null, windSpeedBudget?: number | null } | null> | null } | null } | null } | null } | null } | null };

export type AlarmsPortfolioQueryVariables = Exact<{
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Data_Alx_OrderByInput;
  hideLimitedOperationAlarms: Scalars['Int']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', code: string } | null, PARK?: { __typename?: 'PARK', code: string } | null } | null> | null, totalsTen?: Array<{ __typename?: 'ALARMS', duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, isOpen?: number | null, tcu?: string | null } | null> | null, total?: Array<{ __typename?: 'ALARMS', duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, isOpen?: number | null, tcu?: string | null } | null> | null } | null } | null } | null } | null };

export type AlarmsParkQueryVariables = Exact<{
  parkCode: Scalars['String']['input'];
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Data_Alx_OrderByInput;
  hideLimitedOperationAlarms: Scalars['Int']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', turbineCode?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', code: string } | null } | null> | null, totalsTen?: Array<{ __typename?: 'ALARMS', duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, isOpen?: number | null, tcu?: string | null } | null> | null, total?: Array<{ __typename?: 'ALARMS', duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, isOpen?: number | null, tcu?: string | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbineQueryVariables = Exact<{
  serialNumeric: Scalars['Float']['input'];
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Data_Alx_OrderByInput;
  hideLimitedOperationAlarms: Scalars['Int']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', PARK?: { __typename?: 'PARK', code: string } | null, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', turbineCode?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', code: string } | null } | null> | null, totalsTen?: Array<{ __typename?: 'ALARMS', duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, isOpen?: number | null, tcu?: string | null } | null> | null, total?: Array<{ __typename?: 'ALARMS', duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, isOpen?: number | null, tcu?: string | null } | null> | null } | null } | null } | null } | null> | null };

export type MaxAlarmsPortQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MaxAlarmsPortQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', nAlarms?: string | null } | null> | null } | null } | null } | null } | null };

export type MaxAlarmsParkQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MaxAlarmsParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', nAlarms?: string | null } | null> | null } | null } | null } | null } | null> | null };

export type MaxAlarmsTurbineQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type MaxAlarmsTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', nAlarms?: string | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsPortfolioTcQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioTcQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null };

export type AlarmsPortfolioRlQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioRlQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null };

export type AlarmsPortfolioStQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioStQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null };

export type AlarmsPortfolioAcQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioAcQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null };

export type AlarmsPortfolioAdQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioAdQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null };

export type AlarmsPortfolioEtQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioEtQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null };

export type AlarmsPortfolioDurQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioDurQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null };

export type AlarmsPortfolioAsQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioAsQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null };

export type AlarmsPortfolioTcuQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioTcuQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null };

export type AlarmsPortfolioPlQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  tcus?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioPlQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null };

export type AlarmsParkTcQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkTcQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkStQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkStQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkAcQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkAcQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkAdQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkAdQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkEtQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkEtQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkDurQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkDurQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkAsQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkAsQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkTcuQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkTcuQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkPlQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkPlQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkRlQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  park: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkRlQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbineTcQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  turbine: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbineTcQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbineStQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  turbine: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbineStQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbineAcQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  turbine: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbineAcQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbineAdQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  turbine: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbineAdQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbineEtQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  turbine: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbineEtQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbineDurQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  turbine: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbineDurQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbineAsQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  turbine: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbineAsQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbineTcuQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  turbine: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbineTcuQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbinePlQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  turbine: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbinePlQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsTurbineRlQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Sort;
  turbine: Scalars['String']['input'];
  tcus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AlarmsTurbineRlQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, duration?: number | null, isOpen?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, tcu?: string | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type TornadoPortfolioQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type TornadoPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', turbineCode?: string | null, duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, nAlarms?: string | null, PARK?: { __typename?: 'PARK', code: string, displayCode?: string | null, name: string, displayName: string } | null } | null> | null } | null } | null } | null } | null };

export type TornadoParkQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type TornadoParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', turbineCode?: string | null, code?: string | null, description?: string | null, duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, nAlarms?: string | null } | null> | null } | null } | null } | null } | null> | null } | null> | null };

export type TornadoTurbineQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type TornadoTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', turbineCode?: string | null, code?: string | null, description?: string | null, duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, nAlarms?: string | null } | null> | null } | null } | null } | null } | null> | null };

export type LollipopParkQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type LollipopParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, alarmCategory?: number | null, isOpen?: number | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type LollipopTurbineQueryVariables = Exact<{
  minCreated: Scalars['Float']['input'];
  maxCreated: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type LollipopTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', _id?: string | null, alarmCategory?: number | null, isOpen?: number | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, TURBINE?: { __typename?: 'TURBINE', serial: string, serialDisplay: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type WindSpeedQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type WindSpeedQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', NACELLE?: { __typename?: 'TS_NAC_10M', windSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type WindDirQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type WindDirQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', NACELLE?: { __typename?: 'TS_NAC_10M', windDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type NacDirQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type NacDirQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', NACELLE?: { __typename?: 'TS_NAC_10M', nacDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type AmbTempQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AmbTempQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', NACELLE?: { __typename?: 'TS_NAC_10M', ambTemp?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type RotorSpeedQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RotorSpeedQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', ROTOR?: { __typename?: 'TS_ROT_10M', rotorSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type GeneratorSpeedQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GeneratorSpeedQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', GENERATOR?: { __typename?: 'TS_GEN_10M', generatorSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type PitchAngleParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PitchAngleParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', ROTOR?: { __typename?: 'TS_ROT_10M', pitchAngle1?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, pitchAngle2?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, pitchAngle3?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type WindSpeedTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type WindSpeedTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', NACELLE?: { __typename?: 'TS_NAC_10M', windSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type WindDirTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type WindDirTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', NACELLE?: { __typename?: 'TS_NAC_10M', windDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type NacDirTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type NacDirTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', NACELLE?: { __typename?: 'TS_NAC_10M', nacDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type AmbTempTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type AmbTempTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', NACELLE?: { __typename?: 'TS_NAC_10M', ambTemp?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type RotorSpeedTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type RotorSpeedTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', ROTOR?: { __typename?: 'TS_ROT_10M', rotorSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type GeneratorSpeedTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type GeneratorSpeedTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', GENERATOR?: { __typename?: 'TS_GEN_10M', generatorSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type PowerCurveQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type PowerCurveQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, POWER_CURVE?: { __typename?: 'POWER_CURVE', smallPowerCurve?: Array<{ __typename?: 'smallPC', windSpeed: number, power: number } | null> | null } | null, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', actualPower?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null, NACELLE?: { __typename?: 'TS_NAC_10M', ambTemp?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, windDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type NacVsWindQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type NacVsWindQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', NACELLE?: { __typename?: 'TS_NAC_10M', windDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, nacDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type RpmVsPowerQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type RpmVsPowerQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', actualPower?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null, ROTOR?: { __typename?: 'TS_ROT_10M', rotorSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type RpmVsPitchQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type RpmVsPitchQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', ROTOR?: { __typename?: 'TS_ROT_10M', pitchAngle1?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, pitchAngle2?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, pitchAngle3?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, rotorSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type PitchVsWindQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type PitchVsWindQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', NACELLE?: { __typename?: 'TS_NAC_10M', windSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null, ROTOR?: { __typename?: 'TS_ROT_10M', pitchAngle1?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, pitchAngle2?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, pitchAngle3?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type PitchAngleQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type PitchAngleQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', ROTOR?: { __typename?: 'TS_ROT_10M', pitchAngle1?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, pitchAngle2?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, pitchAngle3?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type TurbineTypeQueryVariables = Exact<{
  turbine: Scalars['String']['input'];
}>;


export type TurbineTypeQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', name: string, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, type: string } | null> | null } | null> | null } | null };

export type PortfolioKpiQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortfolioKpiQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_efficiency?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type PortfolioKpiTotalQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortfolioKpiTotalQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_efficiency?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null };

export type ParksKpiQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParksKpiQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_efficiency?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type ComparativeTableReportParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
}>;


export type ComparativeTableReportParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenue?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_efficiency?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type ComparativeTableReportPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type ComparativeTableReportPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_BDG?: { __typename?: 'TABLE_DATA_BDG', budget?: Array<{ __typename?: 'BUDGET', production?: number | null, revenue?: number | null } | null> | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenue?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_efficiency?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type ParksKpiTotalQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParksKpiTotalQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_efficiency?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type RevLossPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type RevLossPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type AvailabilityPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type AvailabilityPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', per_avg_availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type ProdLossPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type ProdLossPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type ProdPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type ProdPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type RevPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type RevPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenue?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type RevLossParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
}>;


export type RevLossParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type AvailabilityParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
}>;


export type AvailabilityParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', per_avg_availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type ProdLossParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
}>;


export type ProdLossParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type ProdParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
}>;


export type ProdParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type RevParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
}>;


export type RevParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenue?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type PerformancePortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PerformancePortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null };

export type PortfolioRatedQueryVariables = Exact<{
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortfolioRatedQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', ratedPower: number } | null> | null } | null> | null, DATA?: { __typename?: 'DATA_PORTFOLIO', SNAPSHOT?: { __typename?: 'SNAPSHOT_PORTFOLIO', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null } | null };

export type PerformanceParksQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PerformanceParksQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', ratedPower: number } | null> | null, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null, SNAPSHOT?: { __typename?: 'SNAPSHOT_PARK', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null } | null> | null };

export type ParkRatedQueryVariables = Exact<{
  park: Scalars['String']['input'];
}>;


export type ParkRatedQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', ratedPower: number } | null> | null, DATA?: { __typename?: 'DATA_PARK', SNAPSHOT?: { __typename?: 'SNAPSHOT_PARK', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null } | null> | null };

export type PerformanceTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  serial: Scalars['String']['input'];
}>;


export type PerformanceTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type PerformanceGraphTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  serial: Scalars['String']['input'];
}>;


export type PerformanceGraphTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, serialNumeric: number, ratedPower: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, status?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, NACELLE?: { __typename?: 'TS_NAC_10M', ambTemp?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDir?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, nacDir?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, ROTOR?: { __typename?: 'TS_ROT_10M', rotorSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null, SNAPSHOT?: { __typename?: 'SNAPSHOT_TURBINE', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null } | null> | null };

export type PowerPerTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PowerPerTurbineQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, serialNumeric: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null, SNAPSHOT?: { __typename?: 'SNAPSHOT_TURBINE', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type PerformanceTurbineByCodeQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  code: Scalars['String']['input'];
}>;


export type PerformanceTurbineByCodeQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, code: string, serial: string, serialNumeric: number, ratedPower: number, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, NACELLE?: { __typename?: 'TS_NAC_10M', ambTemp?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDir?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, nacDir?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, ROTOR?: { __typename?: 'TS_ROT_10M', rotorSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null, SNAPSHOT?: { __typename?: 'SNAPSHOT_TURBINE', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null } | null> | null };

export type TurbineRatedQueryVariables = Exact<{
  serial: Scalars['String']['input'];
}>;


export type TurbineRatedQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', ratedPower: number, DATA?: { __typename?: 'DATA_TURBINE', SNAPSHOT?: { __typename?: 'SNAPSHOT_TURBINE', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null } | null> | null };

export type TurbineRatedByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type TurbineRatedByCodeQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', ratedPower: number, DATA?: { __typename?: 'DATA_TURBINE', SNAPSHOT?: { __typename?: 'SNAPSHOT_TURBINE', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null } | null> | null };

export type ProductionByParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProductionByParkQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type RevenuesByParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RevenuesByParkQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenue?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type RevenuesByTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RevenuesByTurbineQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', revenue?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type ProductionByTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProductionByTurbineQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type FactsPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FactsPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, co2Avoided?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_loadFactor?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenue?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null };

export type FactsPortfolioFosenPpaModuleQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
}>;


export type FactsPortfolioFosenPpaModuleQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null };

export type QualityPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type QualityPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null, PARKS?: Array<{ __typename?: 'PARK', code: string, TURBINES?: Array<{ __typename?: 'TURBINE', code: string } | null> | null } | null> | null } | null };

export type FactsParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FactsParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', comissioningDate: string } | null> | null, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, co2Avoided?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_loadFactor?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenue?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type FactsParkFosenPpaModuleQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
}>;


export type FactsParkFosenPpaModuleQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type QualityParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type QualityParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', code: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', code: string } | null> | null } | null> | null };

export type FactsTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type FactsTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', type: string, comissioningDate: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', SNAPSHOT?: { __typename?: 'SNAPSHOT_TURBINE', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', TotWh_actVal?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_theoretical?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, W_avg_loss?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, co2Avoided?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, per_avg_loadFactor?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenue?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueLosses?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null, PARK?: { __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string } | null> | null } | null } | null> | null };

export type QualityTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type QualityTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ParkListQueryVariables = Exact<{
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParkListQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, displayName: string } | null> | null } | null };

export type TurbineListQueryVariables = Exact<{
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type TurbineListQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, code: string, codeDisplay: string, serial: string, serialNumeric: number } | null> | null } | null> | null } | null };

export type PowerCurveFlagQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
}>;


export type PowerCurveFlagQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, POWER_CURVE?: { __typename?: 'POWER_CURVE', smallPowerCurve?: Array<{ __typename?: 'smallPC', windSpeed: number, power: number } | null> | null } | null, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', actualPower?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null, NACELLE?: { __typename?: 'TS_NAC_10M', ambTemp?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, windDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type ToolTipInfoQueryVariables = Exact<{
  unixTs: Scalars['Float']['input'];
  turbineSerial: Scalars['String']['input'];
}>;


export type ToolTipInfoQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', status?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, actualPower?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, theoPower?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null, NACELLE?: { __typename?: 'TS_NAC_10M', ambTemp?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, windDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, nacDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null, ROTOR?: { __typename?: 'TS_ROT_10M', pitchAngle1?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, pitchAngle2?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, pitchAngle3?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, rotorSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type PowerCurveByTurbineQueryVariables = Exact<{
  turbine: Scalars['String']['input'];
}>;


export type PowerCurveByTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', code: string, codeDisplay: string, serial: string, serialDisplay: string, POWER_CURVE?: { __typename?: 'POWER_CURVE', smallPowerCurve?: Array<{ __typename?: 'smallPC', windSpeed: number, power: number } | null> | null } | null } | null> | null };

export type PowerCurveFlagByTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type PowerCurveFlagByTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, POWER_CURVE?: { __typename?: 'POWER_CURVE', smallPowerCurve?: Array<{ __typename?: 'smallPC', windSpeed: number, power: number } | null> | null } | null, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', status?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, actualPower?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null, NACELLE?: { __typename?: 'TS_NAC_10M', ambTemp?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null, windDir?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type StatusPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type StatusPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', status?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type StatusParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  parkName: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type StatusParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', status?: { __typename?: 'TIMESERIES_RESULT', count?: number | null, dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type LoadStatusPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type LoadStatusPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', code: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', per_avg_loadFactor?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type LoadStatusParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  parkName: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type LoadStatusParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', per_avg_loadFactor?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type HeatmapQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['Float']['input'];
}>;


export type HeatmapQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TEMPERATURE_DEVIATION?: { __typename?: 'TS_TMD_10M', WGEN1_GnTmpBrg1_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WGEN1_GnTmpBrg2_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WNAC1_IntlTmp_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRM1_TrmTmpGbxBrg1_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRM1_TrmTmpGbxOil_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WGEN1_GnTmpPhase1_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WGEN1_GnTmpPhase2_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WGEN1_GnTmpPhase3_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WCNV1_CnvTmpDclink_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WROT1_PtHyOilTmp_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WCNV1_CnvTmpWater_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRF1_TrfTmpPhase1_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRF1_TrfTmpPhase2_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRF1_TrfTmpPhase3_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WROT1_HubTmp_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WGEN1_GnTmpSta_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRM1_TrmTmpShfBrg1_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRM1_TrmTmpShfBrg2_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WCNV1_CnvTmpChokeCoil_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WGEN1_GnTmpInlet_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WNAC1_TopCtrCabTmp1_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WROT1_CtrCabTmp_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTF1_TrfAuxTmp_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRF1_TrfCoreTmp1_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRF1_TrfCoreTmp2_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRF1_TrfCoreTmp3_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRM1_TrmTmpWtr_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRM1_TrmTmpGbxBrg3_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRM1_TrmTmpGbxBrg4_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRM1_TrmTmpGbxBrg5_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTUR1_TurTmpUPS_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTRM1_TrmTmpGbxBrg2_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WNAC1_CtrCabTmp_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WGEN1_GnTmpOutlet_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WTOW1_CtrCabTmp_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WGEN1_GnTmpSlpRing1_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, WGEN1_GnTmpRtr_avg_per_deviation?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type KeepAliveSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type KeepAliveSubscription = { __typename?: 'Subscription', KEEP_ALIVE: Array<{ __typename?: 'KEEP_ALIVE', message: string }> };

export type GetUserTurbineGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTurbineGroupsQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', USER_TURBINE_GROUPS?: Array<{ __typename?: 'USER_TURBINE_GROUP', _id_park: string, turbine_groups?: Array<{ __typename?: 'user_turbine_groups', _id: string, name: string, turbines?: Array<{ __typename?: 'turbines', id: string }> | null } | null> | null } | null> | null } | null };

export type GetPlantsAndTurbinesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlantsAndTurbinesQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', _id: string, displayName: string, TURBINES?: Array<{ __typename?: 'TURBINE', _id: string, displayName: string } | null> | null } | null> | null };

export type CreateTurbineGroupMutationVariables = Exact<{
  _id_park: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  turbines: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateTurbineGroupMutation = { __typename?: 'Mutation', createCustomTurbineGroup?: { __typename?: 'createCustomTurbineGroupResponse', success?: boolean | null } | null };

export type UpdateTurbineGroupMutationVariables = Exact<{
  _id_park: Scalars['ID']['input'];
  _id_group: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type UpdateTurbineGroupMutation = { __typename?: 'Mutation', updateCustomTurbineGroup?: { __typename?: 'updateCustomTurbineGroupResponse', success?: boolean | null } | null };

export type DeleteTurbineGroupMutationVariables = Exact<{
  _id_park: Scalars['ID']['input'];
  _id_group: Scalars['ID']['input'];
}>;


export type DeleteTurbineGroupMutation = { __typename?: 'Mutation', deleteCustomTurbineGroup?: { __typename?: 'deleteCustomTurbineGroupResponse', success?: boolean | null } | null };

export type DimensionDataQueryVariables = Exact<{
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DimensionDataQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', _id: string, name: string, displayName: string, code: string, displayCode?: string | null, latitude: number, longitude: number, timezone?: string | null, useRevenuesV2InBudgets?: boolean | null, id: string, COUNTRY?: { __typename?: 'COUNTRY', _id: string, code: string, name: string, countryImage?: string | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', _id: string, name: string, code: string, codeDisplay: string, serialNumeric: number, serial: string, serialDisplay: string, ratedPower: number, latitude: number, longitude: number, type: string, id: string } | null> | null } | null> | null };

export type AllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCountriesQuery = { __typename?: 'Query', COUNTRIES?: Array<{ __typename?: 'COUNTRY', code: string, name: string } | null> | null };

export type DimensionDataCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type DimensionDataCountriesQuery = { __typename?: 'Query', COUNTRIES?: Array<{ __typename?: 'COUNTRY', name: string, id: string, parks?: Array<{ __typename?: 'PARK', name: string, id: string } | null> | null } | null> | null };

export type DimensionDataCountriesForPortfolioQueryVariables = Exact<{
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DimensionDataCountriesForPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, COUNTRIES?: Array<{ __typename?: 'COUNTRY', name: string, id: string, parks?: Array<{ __typename?: 'PARK', name: string, id: string } | null> | null } | null> | null } | null };

export type OneParkDimensionDataQueryVariables = Exact<{
  parkName: Scalars['String']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type OneParkDimensionDataQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', _id: string, name: string, displayName: string, code: string, latitude: number, longitude: number, COUNTRY?: { __typename?: 'COUNTRY', _id: string, name: string, code: string } | null, TURBINES?: Array<{ __typename?: 'TURBINE', _id: string, name: string, serialNumeric: number, serial: string, latitude: number, longitude: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', SNAPSHOT?: { __typename?: 'SNAPSHOT_TURBINE', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', status?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type OneParkDimensionDataByIdQueryVariables = Exact<{
  parkId: Scalars['String']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type OneParkDimensionDataByIdQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', _id: string, name: string, displayName: string, code: string, latitude: number, longitude: number, COUNTRY?: { __typename?: 'COUNTRY', _id: string, name: string, code: string } | null, TURBINES?: Array<{ __typename?: 'TURBINE', _id: string, name: string, serialNumeric: number, serial: string, latitude: number, longitude: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', SNAPSHOT?: { __typename?: 'SNAPSHOT_TURBINE', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', status?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type OneTurbineDimensionDataQueryVariables = Exact<{
  turbineSerial: Scalars['Float']['input'];
}>;


export type OneTurbineDimensionDataQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', _id: string, name: string, code: string, PARK?: { __typename?: 'PARK', _id: string, name: string, code: string, COUNTRY?: { __typename?: 'COUNTRY', _id: string, name: string, code: string } | null } | null } | null> | null };

export type DisplayNameByParkQueryVariables = Exact<{
  park: Scalars['String']['input'];
}>;


export type DisplayNameByParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', displayName: string } | null> | null };

export type GetAllParksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllParksQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', _id: string, displayName: string } | null> | null };

export type ForecastDataCountryQueryVariables = Exact<{
  code: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnit: UnitEnum;
  samplingValue: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ForecastDataCountryQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, COUNTRIES?: Array<{ __typename?: 'COUNTRY', DATA?: { __typename?: 'DATA_COUNTRY', SNAPSHOT?: { __typename?: 'SNAPSHOT_COUNTRY', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_COUNTRY', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOBLUE?: { __typename?: 'TS_MTB_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, TRADING?: { __typename?: 'TS_TRD_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOLOGICA?: { __typename?: 'TS_MLG_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, DNV_FORECASTER?: { __typename?: 'TS_DNVF_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type ForecastDataParkQueryVariables = Exact<{
  name: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnitWeather: UnitEnum;
  samplingValueWeather: Scalars['Float']['input'];
  samplingUnit: UnitEnum;
  samplingValue: Scalars['Float']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ForecastDataParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', SNAPSHOT?: { __typename?: 'SNAPSHOT_PARK', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_WFC?: { __typename?: 'TS_DATA_WFC', DNV_FORECASTER?: { __typename?: 'TS_DNVF_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOLOGICA?: { __typename?: 'TS_MLG_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, WIND_LOG?: { __typename?: 'TS_WLG_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOBLUE?: { __typename?: 'TS_MTB_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, TRADING?: { __typename?: 'TS_TRD_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ForecastDataParkReportWlQueryVariables = Exact<{
  code: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
}>;


export type ForecastDataParkReportWlQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', SNAPSHOT?: { __typename?: 'SNAPSHOT_PARK', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ForecastDataParkReportMbQueryVariables = Exact<{
  code: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
}>;


export type ForecastDataParkReportMbQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', SNAPSHOT?: { __typename?: 'SNAPSHOT_PARK', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_WFC?: { __typename?: 'TS_DATA_WFC', METEOBLUE?: { __typename?: 'TS_MTB_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ForecastDataParkReportOwQueryVariables = Exact<{
  code: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
}>;


export type ForecastDataParkReportOwQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', SNAPSHOT?: { __typename?: 'SNAPSHOT_PARK', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_WFC?: { __typename?: 'TS_DATA_WFC', OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ForecastDataPortfolioQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnit: UnitEnum;
  samplingValue: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ForecastDataPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', SNAPSHOT?: { __typename?: 'SNAPSHOT_PORTFOLIO', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOBLUE?: { __typename?: 'TS_MTB_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, TRADING?: { __typename?: 'TS_TRD_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOLOGICA?: { __typename?: 'TS_MLG_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, DNV_FORECASTER?: { __typename?: 'TS_DNVF_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null };

export type ForecastDataTurbineInclWeatherQueryVariables = Exact<{
  turbineSerial: Scalars['Float']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnitWeather: UnitEnum;
  samplingValueWeather: Scalars['Float']['input'];
  samplingUnit: UnitEnum;
  samplingValue: Scalars['Float']['input'];
}>;


export type ForecastDataTurbineInclWeatherQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', SNAPSHOT?: { __typename?: 'SNAPSHOT_TURBINE', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOBLUE?: { __typename?: 'TS_MTB_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, TRADING?: { __typename?: 'TS_TRD_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, DNV_FORECASTER?: { __typename?: 'TS_DNVF_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOLOGICA?: { __typename?: 'TS_MLG_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ForecastDataTurbineQueryVariables = Exact<{
  turbineSerial: Scalars['Float']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnit: UnitEnum;
  samplingValue: Scalars['Float']['input'];
}>;


export type ForecastDataTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', DATA?: { __typename?: 'DATA_TURBINE', SNAPSHOT?: { __typename?: 'SNAPSHOT_TURBINE', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOBLUE?: { __typename?: 'TS_MTB_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, TRADING?: { __typename?: 'TS_TRD_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOLOGICA?: { __typename?: 'TS_MLG_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, DNV_FORECASTER?: { __typename?: 'TS_DNVF_WFC', theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ForecastPerformanceFactsParkQueryVariables = Exact<{
  name: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  yearFirstTs: Scalars['Float']['input'];
  days: Scalars['Float']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  getWindLog: Scalars['Boolean']['input'];
  getOpenWeather: Scalars['Boolean']['input'];
  getMeteoBlue: Scalars['Boolean']['input'];
  getTrading: Scalars['Boolean']['input'];
  getMeteologica: Scalars['Boolean']['input'];
  getDNV: Scalars['Boolean']['input'];
}>;


export type ForecastPerformanceFactsParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOBLUE?: { __typename?: 'TS_MTB_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, TRADING?: { __typename?: 'TS_TRD_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOLOGICA?: { __typename?: 'TS_MLG_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, DNV_FORECASTER?: { __typename?: 'TS_DNVF_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', totalActualProduction?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ForecastPerformanceFactsPortfolioQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  yearFirstTs: Scalars['Float']['input'];
  days: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  getWindLog: Scalars['Boolean']['input'];
  getOpenWeather: Scalars['Boolean']['input'];
  getMeteoBlue: Scalars['Boolean']['input'];
  getTrading: Scalars['Boolean']['input'];
  getMeteologica: Scalars['Boolean']['input'];
  getDNV: Scalars['Boolean']['input'];
}>;


export type ForecastPerformanceFactsPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOBLUE?: { __typename?: 'TS_MTB_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, TRADING?: { __typename?: 'TS_TRD_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOLOGICA?: { __typename?: 'TS_MLG_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, DNV_FORECASTER?: { __typename?: 'TS_DNVF_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenuesAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', totalActualProduction?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null };

export type ForecastAndImbalanceDataParkQueryVariables = Exact<{
  name: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnitWeather: UnitEnum;
  samplingValueWeather: Scalars['Float']['input'];
  samplingUnit: UnitEnum;
  samplingValue: Scalars['Float']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ForecastAndImbalanceDataParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOBLUE?: { __typename?: 'TS_MTB_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, TRADING?: { __typename?: 'TS_TRD_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOLOGICA?: { __typename?: 'TS_MLG_WFC', weather?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, temperature?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windSpeed?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, windDirection?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenues?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, positiveImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, negativeImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ForecastImbalanceDataParkNoDetailsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnitTimeSeries: UnitEnum;
  samplingValueTimeSeries: Scalars['Float']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ForecastImbalanceDataParkNoDetailsQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_WFC?: { __typename?: 'TS_DATA_WFC', METEOBLUE?: { __typename?: 'TS_MTB_WFC', imbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ForecastImbalanceDataParkQueryVariables = Exact<{
  name: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnitTimeSeries: UnitEnum;
  samplingValueTimeSeries: Scalars['Float']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  hoursBefore: Scalars['Int']['input'];
  analyzeType?: InputMaybe<AnalyzeTypeEnum>;
}>;


export type ForecastImbalanceDataParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, timezone?: string | null, TURBINES?: Array<{ __typename?: 'TURBINE', ratedPower: number } | null> | null, DATA?: { __typename?: 'DATA_PARK', SNAPSHOT?: { __typename?: 'SNAPSHOT_PARK', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null, SUM?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', theoreticalPowerAmendedPredicted?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null, imbalanceGroupedByPrediction?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null } | null, OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', theoreticalPowerAmendedPredicted?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null, imbalanceGroupedByPrediction?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null } | null, METEOBLUE?: { __typename?: 'TS_MTB_WFC', theoreticalPowerAmendedPredicted?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null, imbalanceGroupedByPrediction?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null } | null, TRADING?: { __typename?: 'TS_TRD_WFC', theoreticalPowerAmendedPredicted?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null, imbalanceGroupedByPrediction?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null } | null, METEOLOGICA?: { __typename?: 'TS_MLG_WFC', theoreticalPowerAmendedPredicted?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null, imbalanceGroupedByPrediction?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null } | null, DNV_FORECASTER?: { __typename?: 'TS_DNVF_WFC', theoreticalPowerAmendedPredicted?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null, imbalanceGroupedByPrediction?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null, timestamp?: number | null } | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ForecastImbalanceDataPortfolioNoDetailsQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnitTimeSeries: UnitEnum;
  samplingValueTimeSeries: Scalars['Float']['input'];
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ForecastImbalanceDataPortfolioNoDetailsQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_WFC?: { __typename?: 'TS_DATA_WFC', METEOBLUE?: { __typename?: 'TS_MTB_WFC', imbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null } | null } | null } | null } | null };

export type ForecastImbalanceDataPortfolioNoDetailsForCustomPortfolioQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnitTimeSeries: UnitEnum;
  samplingValueTimeSeries: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ForecastImbalanceDataPortfolioNoDetailsForCustomPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_WFC?: { __typename?: 'TS_DATA_WFC', METEOBLUE?: { __typename?: 'TS_MTB_WFC', imbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null } | null } | null } | null } | null };

export type ForecastImbalanceDataPortfolioQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  hoursBefore: Scalars['Int']['input'];
  analyzeType: AnalyzeTypeEnum;
}>;


export type ForecastImbalanceDataPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', PARKS?: Array<{ __typename?: 'PARK', _id: string, name: string, code: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', SUM?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', imbalanceGroupedByPrediction?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, OPEN_WEATHER?: { __typename?: 'TS_OPW_WFC', imbalanceGroupedByPrediction?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOBLUE?: { __typename?: 'TS_MTB_WFC', imbalanceGroupedByPrediction?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, TRADING?: { __typename?: 'TS_TRD_WFC', imbalanceGroupedByPrediction?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, METEOLOGICA?: { __typename?: 'TS_MLG_WFC', imbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, DNV_FORECASTER?: { __typename?: 'TS_DNVF_WFC', imbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, revenueImbalance?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type ForecastMapParkQueryVariables = Exact<{
  parkName: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ForecastMapParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, displayName: string, code: string, latitude: number, longitude: number, COUNTRY?: { __typename?: 'COUNTRY', _id: string, name: string, code: string } | null, TURBINES?: Array<{ __typename?: 'TURBINE', _id: string, name: string, serialNumeric: number, serial: string, latitude: number, longitude: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', W_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null, DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, unavailableTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, deratedTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type ForecastMapPortfolioQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ForecastMapPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', name: string, displayName: string, code: string, displayCode?: string | null, latitude: number, longitude: number, COUNTRY?: { __typename?: 'COUNTRY', _id: string, name: string, code: string } | null, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_WFC?: { __typename?: 'TS_DATA_WFC', WIND_LOG?: { __typename?: 'TS_WLG_WFC', theoreticalPowerAmended?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null } | null, DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availablePower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, unavailableTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, deratedTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', _id: string, name: string, serialNumeric: number, serial: string, latitude: number, longitude: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', unavailableTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, deratedTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null } | null };

export type ProcessDetailScheduleQueryVariables = Exact<{
  startRange?: InputMaybe<Scalars['Float']['input']>;
  endRange?: InputMaybe<Scalars['Float']['input']>;
  plannedEvents?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  tclassBlocks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProcessDetailScheduleQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, id: string, code: string } | null> | null, PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', category?: string | null, startTs?: number | null, endTs?: number | null, id?: string | null, turbineId?: string | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', tcu?: string | null, id?: string | null, turbineId?: string | null, startTs?: number | null, endTs?: number | null } | null> | null } | null } | null } | null } | null };

export type ParkPlanningAnalyticsScheduleQueryVariables = Exact<{
  startRange?: InputMaybe<Scalars['Float']['input']>;
  endRange?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  parkName: Scalars['String']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParkPlanningAnalyticsScheduleQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', category?: string | null, startTs?: number | null, endTs?: number | null, turbineId?: string | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', turbineId?: string | null, startTs?: number | null, endTs?: number | null } | null> | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, id: string, code: string } | null> | null } | null> | null };

export type ParkPlanningAnalyticsQueryVariables = Exact<{
  parkId: Scalars['String']['input'];
  planned_events?: InputMaybe<Array<Data_Ple_TableWhereInput> | Data_Ple_TableWhereInput>;
  logbook_monthly?: InputMaybe<Array<Data_Lgm_TableWhereInput> | Data_Lgm_TableWhereInput>;
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParkPlanningAnalyticsQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', category?: string | null, plannedDuration?: number | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', totalProductionLoss?: number | null, totalRevenueLoss?: number | null, userComment?: string | null, realizedDuration?: number | null } | null> | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, id: string } | null> | null } | null> | null };

export type ParkPlanningEventsAndTClassBlocksQueryVariables = Exact<{
  endRange?: InputMaybe<Scalars['Float']['input']>;
  startRange?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  parkId: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParkPlanningEventsAndTClassBlocksQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', title?: string | null, category?: string | null, startTs?: number | null, endTs?: number | null, duration?: number | null, durationShort?: string | null, productionLoss?: number | null, revenueLoss?: number | null, creationTs?: number | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', tcu?: string | null, log?: string | null, startTS?: number | null, endTS?: number | null, duration?: number | null, totalProductionLoss?: number | null, totalRevenueLoss?: number | null, userComment?: string | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, serialNumeric: number, id: string, code: string } | null> | null } | null> | null };

export type ParkProcessesAnalyticsQueryVariables = Exact<{
  parkId: Scalars['String']['input'];
  status: Scalars['Int']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParkProcessesAnalyticsQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', processes_analytics?: Array<{ __typename?: 'PROCESSES_ANALYTICS', status?: number | null, _id_plannedEvents?: Array<string | null> | null, _id_tClassBlocks?: Array<string | null> | null, description?: string | null, estimatedStartTs?: number | null, estimatedEndTs?: number | null, color?: string | null, durationPlanned?: number | null, durationRealized?: number | null, productionLossRealized?: number | null, revenueLossRealized?: number | null, id?: string | null, name?: string | null } | null> | null } | null } | null } | null } | null> | null };

export type ParkProcessEventsAndTClassBlocksQueryVariables = Exact<{
  parkId: Scalars['String']['input'];
  plannedEvents?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  tclassBlocks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParkProcessEventsAndTClassBlocksQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', title?: string | null, description?: string | null, category?: string | null, startTs?: number | null, endTs?: number | null, duration?: number | null, productionLoss?: number | null, revenueLoss?: number | null, creationTs?: number | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', mutTS?: number | null, tcu?: string | null, log?: string | null, startTS?: number | null, endTS?: number | null, duration?: number | null, totalProductionLoss?: number | null, totalRevenueLoss?: number | null, userComment?: string | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, serialNumeric: number, id: string, code: string } | null> | null } | null> | null };

export type PlanningEventsAndTClassBlocksQueryVariables = Exact<{
  endRange?: InputMaybe<Scalars['Float']['input']>;
  startRange?: InputMaybe<Scalars['Float']['input']>;
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlanningEventsAndTClassBlocksQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', title?: string | null, category?: string | null, startTs?: number | null, endTs?: number | null, duration?: number | null, durationShort?: string | null, productionLoss?: number | null, revenueLoss?: number | null, creationTs?: number | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', tcu?: string | null, log?: string | null, startTS?: number | null, endTS?: number | null, duration?: number | null, totalProductionLoss?: number | null, totalRevenueLoss?: number | null, userComment?: string | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null } | null } | null, PARKS?: Array<{ __typename?: 'PARK', id: string, name: string, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, id: string, code: string } | null> | null } | null> | null } | null };

export type PortfolioPlanningAnalyticsQueryVariables = Exact<{
  endRange?: InputMaybe<Scalars['Float']['input']>;
  startRange?: InputMaybe<Scalars['Float']['input']>;
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortfolioPlanningAnalyticsQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', category?: string | null, plannedDuration?: number | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', totalProductionLoss?: number | null, totalRevenueLoss?: number | null, realizedDuration?: number | null } | null> | null } | null } | null } | null } | null };

export type PortfolioProcessAnalyticsQueryVariables = Exact<{
  status: Scalars['Int']['input'];
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortfolioProcessAnalyticsQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', processes_analytics?: Array<{ __typename?: 'PROCESSES_ANALYTICS', _id_parks?: Array<string | null> | null, _id_plannedEvents?: Array<string | null> | null, _id_tClassBlocks?: Array<string | null> | null, description?: string | null, estimatedStartTs?: number | null, status?: number | null, color?: string | null, estimatedEndTs?: number | null, durationPlanned?: number | null, durationRealized?: number | null, productionLossRealized?: number | null, revenueLossRealized?: number | null, id?: string | null, name?: string | null } | null> | null } | null } | null } | null, PARKS?: Array<{ __typename?: 'PARK', displayName: string, name: string, _id: string } | null> | null } | null };

export type ProcessEventsAndTClassBlocksQueryVariables = Exact<{
  plannedEvents?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  tclassBlocks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProcessEventsAndTClassBlocksQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', title?: string | null, description?: string | null, category?: string | null, startTs?: number | null, endTs?: number | null, duration?: number | null, productionLoss?: number | null, revenueLoss?: number | null, creationTs?: number | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', tcu?: string | null, log?: string | null, startTS?: number | null, endTS?: number | null, mutTS?: number | null, duration?: number | null, totalProductionLoss?: number | null, totalRevenueLoss?: number | null, userComment?: string | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null } | null } | null, PARKS?: Array<{ __typename?: 'PARK', id: string, name: string, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, serialNumeric: number, id: string, code: string } | null> | null } | null> | null } | null };

export type TurbinePlanningAnalyticsQueryVariables = Exact<{
  turbineId: Scalars['Float']['input'];
  planned_events?: InputMaybe<Array<Data_Ple_TableWhereInput> | Data_Ple_TableWhereInput>;
  logbook_monthly?: InputMaybe<Array<Data_Lgm_TableWhereInput> | Data_Lgm_TableWhereInput>;
}>;


export type TurbinePlanningAnalyticsQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, id: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', category?: string | null, plannedDuration?: number | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', totalProductionLoss?: number | null, totalRevenueLoss?: number | null, userComment?: string | null, realizedDuration?: number | null } | null> | null } | null } | null } | null, PARK?: { __typename?: 'PARK', name: string, parkName: string, id: string } | null } | null> | null };

export type TurbinePlanningEventsAndTClassBlocksQueryVariables = Exact<{
  endRange?: InputMaybe<Scalars['Float']['input']>;
  startRange?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  turbineId: Scalars['Float']['input'];
}>;


export type TurbinePlanningEventsAndTClassBlocksQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, id: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', title?: string | null, category?: string | null, startTs?: number | null, endTs?: number | null, durationShort?: string | null, productionLoss?: number | null, revenueLoss?: number | null, creationTs?: number | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', tcu?: string | null, log?: string | null, startTS?: number | null, endTS?: number | null, duration?: number | null, totalProductionLoss?: number | null, totalRevenueLoss?: number | null, userComment?: string | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null } | null } | null, PARK?: { __typename?: 'PARK', name: string, id: string } | null } | null> | null };

export type BudgetFollowUpPortfolioQueryVariables = Exact<{
  portfolioId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BudgetFollowUpPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_total?: Array<{ __typename?: 'BUDGET_TOTAL', production?: number | null, productionBudget?: number | null, productionBudgetYTD?: number | null } | null> | null } | null } | null } | null } | null };

export type BudgetFollowUpParkQueryVariables = Exact<{
  parkName: Scalars['String']['input'];
  year: Scalars['Int']['input'];
}>;


export type BudgetFollowUpParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_total?: Array<{ __typename?: 'BUDGET_TOTAL', production?: number | null, productionBudget?: number | null, productionBudgetYTD?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type TurbineYtdProductionQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
}>;


export type TurbineYtdProductionQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_10M?: { __typename?: 'TS_DATA_10M', TURBINE?: { __typename?: 'TS_TUR_10M', Wh_avg_mag_f?: { __typename?: 'TIMESERIES_RESULT', dataKeyValue?: Array<Array<number | null> | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ParkTurbinesAvailabilityQueryVariables = Exact<{
  name: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnit: UnitEnum;
  samplingValue: Scalars['Float']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParkTurbinesAvailabilityQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, displayName: string, DATA?: { __typename?: 'DATA_PARK', SNAPSHOT?: { __typename?: 'SNAPSHOT_PARK', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null, availablePower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', _id: string, name: string, serialNumeric: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null, unavailableTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null, deratedTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null> | null };

export type PortfolioParksAvailabilityQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnit: UnitEnum;
  samplingValue: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parkIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortfolioParksAvailabilityQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', SNAPSHOT?: { __typename?: 'SNAPSHOT_PORTFOLIO', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availablePower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null } | null } | null } | null, PARKS?: Array<{ __typename?: 'PARK', code: string, displayCode?: string | null, name: string, displayName: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null, unavailableTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null, deratedTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null, dataTimestamp?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type DailyAvailabilitiesParkQueryVariables = Exact<{
  name: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DailyAvailabilitiesParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, availablePower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, unavailableTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, deratedTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type DailyAvailabilitiesTurbineQueryVariables = Exact<{
  turbineSerial: Scalars['Float']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
}>;


export type DailyAvailabilitiesTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, availablePower?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, unavailableTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null, deratedTurbines?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ScheduleEventsParkQueryVariables = Exact<{
  name: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ScheduleEventsParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', _id?: string | null, _id_turbine?: string | null, _id_park?: string | null, _id_process?: string | null, category?: string | null, startTs?: number | null, endTs?: number | null, revenueLoss?: number | null, productionLoss?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type ScheduleEventsTurbineQueryVariables = Exact<{
  turbineSerial: Scalars['Float']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
}>;


export type ScheduleEventsTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', _id?: string | null, _id_turbine?: string | null, _id_park?: string | null, _id_process?: string | null, category?: string | null, startTs?: number | null, endTs?: number | null, revenueLoss?: number | null, productionLoss?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type TurbineAvailabilityQueryVariables = Exact<{
  turbineSerial: Scalars['Float']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  samplingUnit: UnitEnum;
  samplingValue: Scalars['Float']['input'];
}>;


export type TurbineAvailabilityQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', _id: string, name: string, code: string, DATA?: { __typename?: 'DATA_TURBINE', TIMESERIES?: { __typename?: 'TIMESERIES_TURBINE', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type AddNewPlannedEventMutationVariables = Exact<{
  title: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  category: Scalars['String']['input'];
  _id_turbine: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  debugMode: Scalars['Boolean']['input'];
  _id_process?: InputMaybe<Scalars['ID']['input']>;
  limitedTo?: InputMaybe<Scalars['Float']['input']>;
  reminderSettings?: InputMaybe<ReminderSettingsInput>;
  startTsFullRange?: InputMaybe<Scalars['Float']['input']>;
  endTsFullRange?: InputMaybe<Scalars['Float']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  plannedTCU?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddNewPlannedEventMutation = { __typename?: 'Mutation', newPlannedEvent?: { __typename?: 'newPlannedEventResponse', success?: boolean | null, error?: string | null, data?: Array<{ __typename?: 'newPlannedEventData', _id_turbine: string, title: string, revenueLoss?: number | null, productionLoss?: number | null, productionArrWithTime?: Array<{ __typename?: 'ProductionArrWithTime', time: number, value: number } | null> | null, productionLossArrWithTime?: Array<{ __typename?: 'ProductionLossArrWithTime', time: number, value: number } | null> | null } | null> | null } | null };

export type AddNewPlannedEventFromTroubleshootModuleMutationVariables = Exact<{
  title: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  category: Scalars['String']['input'];
  _id_turbine: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  debugMode: Scalars['Boolean']['input'];
  _id_process?: InputMaybe<Scalars['ID']['input']>;
  limitedTo?: InputMaybe<Scalars['Float']['input']>;
  reminderSettings?: InputMaybe<ReminderSettingsInput>;
  _id_alarm?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddNewPlannedEventFromTroubleshootModuleMutation = { __typename?: 'Mutation', newPlannedEvent?: { __typename?: 'newPlannedEventResponse', success?: boolean | null, error?: string | null, data?: Array<{ __typename?: 'newPlannedEventData', title: string, revenueLoss?: number | null, productionLoss?: number | null } | null> | null } | null };

export type UpdatePlannedEventMutationVariables = Exact<{
  _id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  _id_process?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  startTs?: InputMaybe<Scalars['Float']['input']>;
  endTs?: InputMaybe<Scalars['Float']['input']>;
  debugMode?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  reminderSettings?: InputMaybe<ReminderSettingsInput>;
  startTsFullRange?: InputMaybe<Scalars['Float']['input']>;
  endTsFullRange?: InputMaybe<Scalars['Float']['input']>;
  plannedTCU?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePlannedEventMutation = { __typename?: 'Mutation', updatePlannedEvent?: { __typename?: 'updatePlannedEventResponse', data?: Array<{ __typename?: 'updatePlannedEventData', _id: string, _id_turbine: string, title: string, revenueLoss?: number | null, productionLoss?: number | null, productionArrWithTime?: Array<{ __typename?: 'ProductionArrWithTime', time: number, value: number } | null> | null, productionLossArrWithTime?: Array<{ __typename?: 'ProductionLossArrWithTime', time: number, value: number } | null> | null } | null> | null } | null };

export type UpdatePlannedEventUnassignProcessMutationVariables = Exact<{
  _id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  _id_process?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdatePlannedEventUnassignProcessMutation = { __typename?: 'Mutation', updatePlannedEvent?: { __typename?: 'updatePlannedEventResponse', data?: Array<{ __typename?: 'updatePlannedEventData', _id: string, title: string } | null> | null } | null };

export type AddNewPlannedEventRecurringMutationVariables = Exact<{
  newPlannedEvents: Array<NewPlannedEventsInput> | NewPlannedEventsInput;
}>;


export type AddNewPlannedEventRecurringMutation = { __typename?: 'Mutation', newPlannedEvents?: { __typename?: 'newPlannedEventsResponse', success?: boolean | null, error?: string | null, data?: Array<{ __typename?: 'newPlannedEventsData', title: string, revenueLoss?: number | null, productionLoss?: number | null } | null> | null } | null };

export type EventsListQueryVariables = Exact<{
  park: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EventsListQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, displayName: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', _id?: string | null, _id_turbine?: string | null, _id_park?: string | null, _id_process?: string | null, creationTs?: number | null, durationShort?: string | null, duration?: number | null, description?: string | null, category?: string | null, title?: string | null, productionLoss?: number | null, revenueLoss?: number | null, provider?: string | null, startDate?: string | null, startTs?: number | null, endDate?: string | null, endTs?: number | null, limitedTo?: number | null, plannedTCU?: string | null, reminderSettings?: { __typename?: 'ReminderSettings', recipients?: Array<string | null> | null, timeValue?: number | null, timeGranularity?: TimeGranularity | null } | null } | null> | null, processes?: Array<{ __typename?: 'PROCESSES', _id?: string | null, title?: string | null, description?: string | null, _id_parks?: Array<string | null> | null, creationTs?: number | null, status?: number | null, _id_plannedEvents?: Array<string | null> | null, estimatedStartTs?: number | null, estimatedEndTs?: number | null } | null> | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, _id: string, ratedPower: number, code: string, PARK?: { __typename?: 'PARK', _id: string, name: string } | null } | null> | null } | null> | null };

export type EventsListByDatePortfolioQueryVariables = Exact<{
  endTs: Scalars['Float']['input'];
  startTs: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EventsListByDatePortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', _id?: string | null, _id_turbine?: string | null, _id_park?: string | null, _id_process?: string | null, creationTs?: number | null, durationShort?: string | null, description?: string | null, category?: string | null, title?: string | null, productionLoss?: number | null, revenueLoss?: number | null, startDate?: string | null, startTs?: number | null, endDate?: string | null, endTs?: number | null, limitedTo?: number | null, plannedTCU?: string | null, reminderSettings?: { __typename?: 'ReminderSettings', recipients?: Array<string | null> | null, timeValue?: number | null, timeGranularity?: TimeGranularity | null } | null } | null> | null } | null } | null } | null } | null };

export type EventsListByDateParkQueryVariables = Exact<{
  park: Scalars['String']['input'];
  endTs: Scalars['Float']['input'];
  startTs: Scalars['Float']['input'];
  turbineIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EventsListByDateParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, displayName: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', _id?: string | null, _id_turbine?: string | null, _id_park?: string | null, _id_process?: string | null, creationTs?: number | null, durationShort?: string | null, description?: string | null, category?: string | null, title?: string | null, productionLoss?: number | null, revenueLoss?: number | null, startDate?: string | null, startTs?: number | null, endDate?: string | null, endTs?: number | null, limitedTo?: number | null, plannedTCU?: string | null, reminderSettings?: { __typename?: 'ReminderSettings', recipients?: Array<string | null> | null, timeValue?: number | null, timeGranularity?: TimeGranularity | null } | null } | null> | null } | null } | null } | null } | null> | null };

export type DeletePlannedEventMutationVariables = Exact<{
  _id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePlannedEventMutation = { __typename?: 'Mutation', deletePlannedEvent?: { __typename?: 'deletePlannedEventResponse', success?: boolean | null } | null };

export type AssignProcessMutationVariables = Exact<{
  _id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  _id_process?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AssignProcessMutation = { __typename?: 'Mutation', updatePlannedEvent?: { __typename?: 'updatePlannedEventResponse', data?: Array<{ __typename?: 'updatePlannedEventData', _id: string, _id_process?: string | null, title: string } | null> | null } | null };

export type MassUpdateMutationVariables = Exact<{
  _id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  startTs?: InputMaybe<Scalars['Float']['input']>;
  endTs?: InputMaybe<Scalars['Float']['input']>;
}>;


export type MassUpdateMutation = { __typename?: 'Mutation', updatePlannedEvent?: { __typename?: 'updatePlannedEventResponse', data?: Array<{ __typename?: 'updatePlannedEventData', _id: string } | null> | null } | null };

export type PortfolioEventsListQueryVariables = Exact<{
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortfolioEventsListQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', _id?: string | null, _id_turbine?: string | null, _id_park?: string | null, _id_process?: string | null, creationTs?: number | null, durationShort?: string | null, description?: string | null, duration?: number | null, category?: string | null, title?: string | null, productionLoss?: number | null, revenueLoss?: number | null, provider?: string | null, startDate?: string | null, endDate?: string | null, startTs?: number | null, endTs?: number | null, limitedTo?: number | null, plannedTCU?: string | null, reminderSettings?: { __typename?: 'ReminderSettings', recipients?: Array<string | null> | null, timeValue?: number | null, timeGranularity?: TimeGranularity | null } | null } | null> | null, processes?: Array<{ __typename?: 'PROCESSES', _id?: string | null, title?: string | null, description?: string | null, _id_parks?: Array<string | null> | null, creationTs?: number | null, status?: number | null, _id_plannedEvents?: Array<string | null> | null, estimatedStartTs?: number | null, estimatedEndTs?: number | null } | null> | null } | null } | null } | null, PARKS?: Array<{ __typename?: 'PARK', _id: string, name: string, displayName: string, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, _id: string, ratedPower: number, code: string, PARK?: { __typename?: 'PARK', _id: string, displayName: string, name: string } | null } | null> | null, COUNTRY?: { __typename?: 'COUNTRY', name: string } | null, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null } | null } | null } | null } | null> | null } | null };

export type OverviewPortfolioEventsQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type OverviewPortfolioEventsQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', _id?: string | null, _id_turbine?: string | null, _id_park?: string | null, _id_process?: string | null, category?: string | null, startTs?: number | null, endTs?: number | null, revenueLoss?: number | null, productionLoss?: number | null } | null> | null } | null } | null } | null } | null };

export type OverviewPortfolioLossesQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type OverviewPortfolioLossesQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TIMESERIES?: { __typename?: 'TIMESERIES_PORTFOLIO', DATA_PLN?: { __typename?: 'TS_DATA_PLN', LOSSES?: { __typename?: 'TS_LSS_PLN', productionLossMaintenance?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, revenueLossMaintenance?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, productionLossRepairs?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, revenueLossRepairs?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, productionLossGridLimitation?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, revenueLossGridLimitation?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, productionLossEnvironmental?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, revenueLossEnvironmental?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, productionLossInspection?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, revenueLossInspection?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null } | null } | null } | null } | null } | null };

export type OverviewParkLossesQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  parkName: Scalars['String']['input'];
}>;


export type OverviewParkLossesQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', _id: string, name: string, DATA?: { __typename?: 'DATA_PARK', TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, LOSSES?: { __typename?: 'TS_LSS_PLN', productionLossMaintenance?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, revenueLossMaintenance?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, productionLossRepairs?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, revenueLossRepairs?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, productionLossGridLimitation?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, revenueLossGridLimitation?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, productionLossEnvironmental?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, revenueLossEnvironmental?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, productionLossInspection?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null, revenueLossInspection?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', timestamp?: number | null, value?: number | null } | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type ProcessListPortfolioQueryVariables = Exact<{
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProcessListPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', processes?: Array<{ __typename?: 'PROCESSES', _id?: string | null, title?: string | null, description?: string | null, _id_parks?: Array<string | null> | null, creationTs?: number | null, estimatedStartTs?: number | null, estimatedEndTs?: number | null, status?: number | null, id?: string | null, plannedEventsIds?: Array<string | null> | null, tClassBlocksIds?: Array<string | null> | null } | null> | null } | null } | null } | null } | null };

export type GetSelectedParksProcessesQueryVariables = Exact<{
  _id_parks: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetSelectedParksProcessesQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', processes?: Array<{ __typename?: 'PROCESSES', _id?: string | null, title?: string | null, estimatedStartTs?: number | null, estimatedEndTs?: number | null, description?: string | null, status?: number | null } | null> | null } | null } | null } | null } | null };

export type ProcessParkListQueryVariables = Exact<{
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProcessParkListQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', _id: string, name: string, displayName: string, COUNTRY?: { __typename?: 'COUNTRY', _id: string, name: string } | null } | null> | null } | null };

export type PortfolioProcessAnalyticsScheduleQueryVariables = Exact<{
  startRange?: InputMaybe<Scalars['Float']['input']>;
  endRange?: InputMaybe<Scalars['Float']['input']>;
  _id_process: Scalars['String']['input'];
}>;


export type PortfolioProcessAnalyticsScheduleQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', title?: string | null, description?: string | null, category?: string | null, startTs?: number | null, endTs?: number | null, duration?: number | null, productionLoss?: number | null, revenueLoss?: number | null, creationTs?: number | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', tcu?: string | null, log?: string | null, mutTS?: number | null, duration?: number | null, totalProductionLoss?: number | null, totalRevenueLoss?: number | null, id?: string | null, turbineId?: string | null, parkId?: string | null, startTs?: number | null, endTs?: number | null } | null> | null } | null } | null } | null, PARKS?: Array<{ __typename?: 'PARK', id: string, name: string, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, serialNumeric: number, id: string, code: string } | null> | null } | null> | null } | null };

export type ProcessAnalyticsStartDatesQueryVariables = Exact<{
  _id_process?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessAnalyticsStartDatesQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', startTs?: number | null, endTs?: number | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', startTs?: number | null, endTs?: number | null } | null> | null } | null } | null } | null } | null };

export type ParkProcessAnalyticsScheduleQueryVariables = Exact<{
  startRange?: InputMaybe<Scalars['Float']['input']>;
  endRange?: InputMaybe<Scalars['Float']['input']>;
  _id_process: Scalars['String']['input'];
  parkId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParkProcessAnalyticsScheduleQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', title?: string | null, description?: string | null, category?: string | null, startTs?: number | null, endTs?: number | null, duration?: number | null, productionLoss?: number | null, revenueLoss?: number | null, creationTs?: number | null, id?: string | null, turbineId?: string | null, parkId?: string | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', tcu?: string | null, log?: string | null, mutTS?: number | null, duration?: number | null, totalProductionLoss?: number | null, totalRevenueLoss?: number | null, id?: string | null, turbineId?: string | null, parkId?: string | null, startTs?: number | null, endTs?: number | null } | null> | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', name: string, serialNumeric: number, id: string, code: string } | null> | null } | null> | null };

export type ProcessAnalyticsStartDatesParkQueryVariables = Exact<{
  _id_process?: InputMaybe<Scalars['String']['input']>;
  parkId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessAnalyticsStartDatesParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', startTs?: number | null, endTs?: number | null } | null> | null } | null, DATA_LGB?: { __typename?: 'TABLE_DATA_LGB', logbook_monthly?: Array<{ __typename?: 'LOGBOOK_MONTHLY', startTs?: number | null, endTs?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type ProcessesListQueryVariables = Exact<{
  parkName: Scalars['String']['input'];
}>;


export type ProcessesListQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', processes?: Array<{ __typename?: 'PROCESSES', title?: string | null, description?: string | null, _id_parks?: Array<string | null> | null, creationTs?: number | null, status?: number | null, color?: string | null, estimatedStartTs?: number | null, estimatedEndTs?: number | null, id?: string | null, plannedEventsIds?: Array<string | null> | null, tClassBlocksIds?: Array<string | null> | null } | null> | null } | null } | null } | null } | null> | null };

export type GetParkIdQueryVariables = Exact<{
  parkName: Scalars['String']['input'];
}>;


export type GetParkIdQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', _id: string } | null> | null };

export type AddNewProcessMutationVariables = Exact<{
  _id_parks: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  estimatedStartTs?: InputMaybe<Scalars['Float']['input']>;
  estimatedEndTs?: InputMaybe<Scalars['Float']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddNewProcessMutation = { __typename?: 'Mutation', newProcess?: { __typename?: 'newProcessResponse', success?: boolean | null, error?: string | null, data?: { __typename?: 'newProcessData', _id: string, title: string, description: string, estimatedStartTs?: number | null, estimatedEndTs?: number | null, color?: string | null, status?: string | null, creationTs: number } | null } | null };

export type ChangeProcessMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  estimatedStartTs?: InputMaybe<Scalars['Float']['input']>;
  estimatedEndTs?: InputMaybe<Scalars['Float']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeProcessMutation = { __typename?: 'Mutation', updateProcess?: { __typename?: 'updateProcessResponse', success?: boolean | null, data?: { __typename?: 'updateProcessData', _id: string, title: string, status?: string | null, estimatedStartTs?: number | null, estimatedEndTs?: number | null, color?: string | null } | null } | null };

export type RemoveProcessMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type RemoveProcessMutation = { __typename?: 'Mutation', deleteProcess?: { __typename?: 'deleteProcessResponse', data?: { __typename?: 'deleteProcessData', _id: string } | null } | null };

export type TurbinesEventsListQueryVariables = Exact<{
  serialNumeric: Scalars['Float']['input'];
  start?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
}>;


export type TurbinesEventsListQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, _id: string, ratedPower: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', _id?: string | null, _id_turbine?: string | null, _id_park?: string | null, _id_process?: string | null, creationTs?: number | null, durationShort?: string | null, duration?: number | null, description?: string | null, category?: string | null, title?: string | null, productionLoss?: number | null, revenueLoss?: number | null, provider?: string | null, startDate?: string | null, endDate?: string | null, startTs?: number | null, endTs?: number | null, limitedTo?: number | null, plannedTCU?: string | null, reminderSettings?: { __typename?: 'ReminderSettings', recipients?: Array<string | null> | null, timeValue?: number | null, timeGranularity?: TimeGranularity | null } | null } | null> | null } | null } | null } | null, PARK?: { __typename?: 'PARK', _id: string, name: string, displayName: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', processes?: Array<{ __typename?: 'PROCESSES', _id?: string | null, _id_parks?: Array<string | null> | null, title?: string | null, description?: string | null, status?: number | null } | null> | null } | null } | null } | null } | null } | null> | null };

export type TurbinesEventsListByPlannedEventIdQueryVariables = Exact<{
  serialNumeric: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type TurbinesEventsListByPlannedEventIdQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, _id: string, ratedPower: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', _id?: string | null, _id_turbine?: string | null, _id_park?: string | null, _id_process?: string | null, creationTs?: number | null, durationShort?: string | null, duration?: number | null, description?: string | null, category?: string | null, title?: string | null, productionLoss?: number | null, revenueLoss?: number | null, startDate?: string | null, endDate?: string | null, startTs?: number | null, endTs?: number | null, limitedTo?: number | null, plannedTCU?: string | null, reminderSettings?: { __typename?: 'ReminderSettings', recipients?: Array<string | null> | null, timeValue?: number | null, timeGranularity?: TimeGranularity | null } | null } | null> | null } | null } | null } | null } | null> | null };

export type ComparisonChartQueryVariables = Exact<{
  code: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ComparisonChartQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', serial: string, ratedPower: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', isOpen?: number | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, TURBINE?: { __typename?: 'TURBINE', serial: string, code: string } | null } | null> | null } | null } | null } | null } | null> | null } | null> | null };

export type ComparativeTablePortfolioQueryVariables = Exact<{
  year: Scalars['Int']['input'];
  portfolioId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type ComparativeTablePortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_BGD?: { __typename?: 'TABLE_DATA_BGD', budget_by_park_month?: Array<{ __typename?: 'BUDGET_BY_PARK_MONTH', month?: number | null, year?: number | null, production?: number | null, revenue?: number | null, PARK?: { __typename?: 'PARK', _id: string } | null } | null> | null } | null } | null } | null } | null };

export type EventsReportsQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  parkName: Scalars['String']['input'];
}>;


export type EventsReportsQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', _id: string, name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_PLN?: { __typename?: 'TABLE_DATA_PLN', planned_events?: Array<{ __typename?: 'PLANNED_EVENTS', category?: string | null, startTs?: number | null, endTs?: number | null } | null> | null } | null } | null, TIMESERIES?: { __typename?: 'TIMESERIES_PARK', DATA_PLN?: { __typename?: 'TS_DATA_PLN', AVAILABILITY?: { __typename?: 'TS_AVL_PLN', availability?: { __typename?: 'TIMESERIES_RESULT', dataValue?: Array<number | null> | null } | null } | null, LOSSES?: { __typename?: 'TS_LSS_PLN', productionLossMaintenance?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null } | null> | null } | null, revenueLossMaintenance?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null } | null> | null } | null, productionLossRepairs?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null } | null> | null } | null, revenueLossRepairs?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null } | null> | null } | null, productionLossGridLimitation?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null } | null> | null } | null, revenueLossGridLimitation?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null } | null> | null } | null, productionLossEnvironmental?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null } | null> | null } | null, revenueLossEnvironmental?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null } | null> | null } | null, productionLossInspection?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null } | null> | null } | null, revenueLossInspection?: { __typename?: 'TIMESERIES_RESULT', dataJSON?: Array<{ __typename?: 'jsonMap', value?: number | null } | null> | null } | null } | null } | null } | null } | null } | null> | null };

export type SummaryQueryVariables = Exact<{
  park: Scalars['String']['input'];
}>;


export type SummaryQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', displayName: string, DATA?: { __typename?: 'DATA_PARK', SNAPSHOT?: { __typename?: 'SNAPSHOT_PARK', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', type: string, hubHeight: number, comissioningDate: string, ratedPower: number } | null> | null } | null> | null };

export type PortfolioSummaryQueryVariables = Exact<{
  portfolio: Scalars['String']['input'];
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortfolioSummaryQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', SNAPSHOT?: { __typename?: 'SNAPSHOT_PORTFOLIO', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null, PARKS?: Array<{ __typename?: 'PARK', displayName: string, DATA?: { __typename?: 'DATA_PARK', SNAPSHOT?: { __typename?: 'SNAPSHOT_PARK', DATA_30S?: { __typename?: 'DATA_30S', TURBINE?: { __typename?: 'TUR_30S', W_rated?: { __typename?: 'SNAPSHOT_RESULT', value?: number | null } | null } | null } | null } | null } | null, TURBINES?: Array<{ __typename?: 'TURBINE', _id: string } | null> | null } | null> | null } | null };

export type AlarmComparisonSubscriptionVariables = Exact<{
  serialNumeric: Scalars['Float']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type AlarmComparisonSubscription = { __typename?: 'Subscription', TURBINES: Array<{ __typename?: 'TURBINE', code: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', actualAlarm?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, duration?: number | null, count?: number | null, avgDuration?: number | null, productionLoss?: number | null, averageProductionLoss?: number | null } | null> | null, allAlarms?: Array<{ __typename?: 'ALARMS', duration?: number | null, count?: string | null, avgDuration?: number | null, productionLoss?: number | null, averageProductionLoss?: number | null } | null> | null } | null } | null } | null }> };

export type PortfolioAlarmStatisticsQueryVariables = Exact<{
  orderBy?: InputMaybe<Data_Alx_OrderByInput>;
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortfolioAlarmStatisticsQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, alarmCategory?: number | null, duration?: number | null, powerLosses?: number | null, count?: number | null, avgDuration?: number | null } | null> | null, totalAlarms?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, alarmCategory?: number | null, count?: number | null } | null> | null } | null } | null } | null } | null };

export type ParkAlarmStatisticsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  orderBy?: InputMaybe<Data_Alx_OrderByInput>;
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParkAlarmStatisticsQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, alarmCategory?: number | null, duration?: number | null, alarmCount?: number | null, avgDuration?: number | null, powerLossesSum?: number | null, powerLossesAvg?: number | null } | null> | null, totalAlarms?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, alarmCategory?: number | null, count?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type TurbineAlarmStatisticsQueryVariables = Exact<{
  serialNumeric: Scalars['Float']['input'];
  orderBy?: InputMaybe<Data_Alx_OrderByInput>;
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TurbineAlarmStatisticsQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, alarmCategory?: number | null, duration?: number | null, powerLosses?: number | null, count?: number | null, avgDuration?: number | null } | null> | null, totalAlarms?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, alarmCategory?: number | null, count?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type TurbineAlarmsKpIsQueryVariables = Exact<{
  serialNumeric: Scalars['Float']['input'];
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
}>;


export type TurbineAlarmsKpIsQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, count?: number | null, avgDuration?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type PortfolioAlarmsKpIsQueryVariables = Exact<{
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortfolioAlarmsKpIsQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, PARKS?: Array<{ __typename?: 'PARK', TURBINES?: Array<{ __typename?: 'TURBINE', name: string } | null> | null } | null> | null, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, count?: number | null, avgDuration?: number | null } | null> | null } | null } | null } | null } | null };

export type ParkAlarmsKpIsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ParkAlarmsKpIsQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, TURBINES?: Array<{ __typename?: 'TURBINE', name: string } | null> | null, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null, count?: number | null, avgDuration?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsGroupByCategoryQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
}>;


export type AlarmsGroupByCategoryQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', alarmCategory?: number | null, duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsGroupByCodeQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
  orderBy?: InputMaybe<Data_Alx_OrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AlarmsGroupByCodeQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', name: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkGroupByCodeQueryVariables = Exact<{
  name: Scalars['String']['input'];
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
  orderBy?: InputMaybe<Data_Alx_OrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkGroupByCodeQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsParkGroupByCategoryQueryVariables = Exact<{
  name: Scalars['String']['input'];
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsParkGroupByCategoryQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', alarmCategory?: number | null, duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null } | null> | null } | null } | null } | null } | null> | null };

export type AlarmsPortfolioGroupByCategoryQueryVariables = Exact<{
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioGroupByCategoryQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', alarmCategory?: number | null, duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null } | null> | null } | null } | null } | null } | null };

export type AlarmsPortfolioGroupByCodeQueryVariables = Exact<{
  filter?: InputMaybe<Data_Alx_TableWhereInput>;
  orderBy?: InputMaybe<Data_Alx_OrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AlarmsPortfolioGroupByCodeQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', alarms?: Array<{ __typename?: 'ALARMS', code?: string | null, description?: string | null, duration?: number | null, powerLosses?: number | null, totalRevenueLoss?: number | null } | null> | null } | null } | null } | null } | null };

export type AlarmStatsQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type AlarmStatsQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, PARKS?: Array<{ __typename?: 'PARK', name: string, TURBINES?: Array<{ __typename?: 'TURBINE', serialNumeric: number, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', DATA_ALX?: { __typename?: 'TABLE_DATA_ALX', actualAlarm?: Array<{ __typename?: 'ALARMS', code?: string | null, duration?: number | null, count?: number | null, avgDuration?: number | null } | null> | null } | null } | null } | null } | null> | null } | null> | null } | null };

export type OutageFactorPortfolioQueryVariables = Exact<{
  fromTs?: InputMaybe<Scalars['Float']['input']>;
  toTs?: InputMaybe<Scalars['Float']['input']>;
  rollingMonthFromTs?: InputMaybe<Scalars['Float']['input']>;
  rollingMonthToTs?: InputMaybe<Scalars['Float']['input']>;
  lastRollingMonthFromTs?: InputMaybe<Scalars['Float']['input']>;
  lastRollingMonthToTs?: InputMaybe<Scalars['Float']['input']>;
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type OutageFactorPortfolioQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', availabilityInfo?: { __typename?: 'TABLE_DATA_ALX_DAILY', totalPrevious30DaysPortfolio?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null, totalPortfolio?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null, Last30DaysPortfolio?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null } | null } | null } | null } | null };

export type OutageFactorPortfolioTurbineQueryVariables = Exact<{
  fromTs?: InputMaybe<Scalars['Float']['input']>;
  toTs?: InputMaybe<Scalars['Float']['input']>;
  rollingMonthFromTs?: InputMaybe<Scalars['Float']['input']>;
  rollingMonthToTs?: InputMaybe<Scalars['Float']['input']>;
  lastRollingMonthFromTs?: InputMaybe<Scalars['Float']['input']>;
  lastRollingMonthToTs?: InputMaybe<Scalars['Float']['input']>;
  portfolioId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OutageFactorPortfolioTurbineQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', availabilityInfo?: { __typename?: 'TABLE_DATA_ALX_DAILY', Last30DaysTurbine?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, TURBINE?: { __typename?: 'TURBINE', name: string, serialNumeric: number, code: string } | null } | null> | null, totalTurbine?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, TURBINE?: { __typename?: 'TURBINE', name: string, serialNumeric: number, code: string } | null } | null> | null, totalPrevious30DaysTurbine?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, TURBINE?: { __typename?: 'TURBINE', name: string, serialNumeric: number, code: string } | null } | null> | null } | null } | null } | null } | null };

export type OutageFactorPortfolioParkQueryVariables = Exact<{
  fromTs?: InputMaybe<Scalars['Float']['input']>;
  toTs?: InputMaybe<Scalars['Float']['input']>;
  rollingMonthFromTs?: InputMaybe<Scalars['Float']['input']>;
  rollingMonthToTs?: InputMaybe<Scalars['Float']['input']>;
  lastRollingMonthFromTs?: InputMaybe<Scalars['Float']['input']>;
  lastRollingMonthToTs?: InputMaybe<Scalars['Float']['input']>;
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type OutageFactorPortfolioParkQuery = { __typename?: 'Query', PORTFOLIO?: { __typename?: 'PORTFOLIO', _id: string, name: string, DATA?: { __typename?: 'DATA_PORTFOLIO', TABLE?: { __typename?: 'TABLE_PORTFOLIO', availabilityInfo?: { __typename?: 'TABLE_DATA_ALX_DAILY', totalPrevious30DaysPortfolio?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null, totalPortfolio?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null, Last30DaysPortfolio?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null, totalPark?: Array<{ __typename?: 'ALARMS', turbineCode?: string | null, alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, PARK?: { __typename?: 'PARK', name: string, code: string, displayCode?: string | null, TURBINES?: Array<{ __typename?: 'TURBINE', name: string } | null> | null } | null } | null> | null, Last30DaysPark?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, PARK?: { __typename?: 'PARK', name: string, code: string } | null } | null> | null, totalPrevious30DaysPark?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, PARK?: { __typename?: 'PARK', name: string, code: string } | null } | null> | null, Last30DaysTurbine?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, TURBINE?: { __typename?: 'TURBINE', name: string, serialNumeric: number, code: string } | null } | null> | null, totalTurbine?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, TURBINE?: { __typename?: 'TURBINE', name: string, serialNumeric: number, code: string } | null } | null> | null, totalPrevious30DaysTurbine?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, TURBINE?: { __typename?: 'TURBINE', name: string, serialNumeric: number, code: string } | null } | null> | null } | null } | null } | null } | null };

export type OutageFactorParkQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  fromTs?: InputMaybe<Scalars['Float']['input']>;
  toTs?: InputMaybe<Scalars['Float']['input']>;
  rollingMonthFromTs?: InputMaybe<Scalars['Float']['input']>;
  rollingMonthToTs?: InputMaybe<Scalars['Float']['input']>;
  lastRollingMonthFromTs?: InputMaybe<Scalars['Float']['input']>;
  lastRollingMonthToTs?: InputMaybe<Scalars['Float']['input']>;
  turbines?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type OutageFactorParkQuery = { __typename?: 'Query', PARKS?: Array<{ __typename?: 'PARK', name: string, code: string, displayCode?: string | null, DATA?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', availabilityInfo?: { __typename?: 'TABLE_DATA_ALX_DAILY', total?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null, totalLast30Days?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null, totalPrevious30Days?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null } | null } | null } | null, PERTURBINE?: { __typename?: 'DATA_PARK', TABLE?: { __typename?: 'TABLE_PARK', availabilityInfo?: { __typename?: 'TABLE_DATA_ALX_DAILY', total?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, TURBINE?: { __typename?: 'TURBINE', name: string, serialNumeric: number, code: string } | null } | null> | null, totalLast30Days?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, TURBINE?: { __typename?: 'TURBINE', name: string, serialNumeric: number, code: string } | null } | null> | null, totalPrevious30Days?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null, TURBINE?: { __typename?: 'TURBINE', name: string, serialNumeric: number, code: string } | null } | null> | null } | null } | null } | null } | null> | null };

export type OutageFactorTurbineQueryVariables = Exact<{
  serialNumeric: Scalars['Float']['input'];
  fromTs?: InputMaybe<Scalars['Float']['input']>;
  toTs?: InputMaybe<Scalars['Float']['input']>;
  rollingMonthFromTs?: InputMaybe<Scalars['Float']['input']>;
  rollingMonthToTs?: InputMaybe<Scalars['Float']['input']>;
  lastRollingMonthFromTs?: InputMaybe<Scalars['Float']['input']>;
  lastRollingMonthToTs?: InputMaybe<Scalars['Float']['input']>;
}>;


export type OutageFactorTurbineQuery = { __typename?: 'Query', TURBINES?: Array<{ __typename?: 'TURBINE', serialNumeric: number, code: string, DATA?: { __typename?: 'DATA_TURBINE', TABLE?: { __typename?: 'TABLE_TURBINE', availabilityInfo?: { __typename?: 'TABLE_DATA_ALX_DAILY', total?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null, totalLast30Days?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null, totalPrevious30Days?: Array<{ __typename?: 'ALARMS', alarmDurationTotal?: number | null, alarmCountTotal?: number | null, durationDurationAvg?: number | null } | null> | null } | null } | null } | null } | null> | null };

export const BudgetFollowUpParkManagementMutationDocument = gql`
    mutation BudgetFollowUpParkManagementMutation($invoiceData: InvoiceInput) {
  insertInvoice(invoice: $invoiceData) {
    success
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpParkManagementMutationGQL extends Apollo.Mutation<BudgetFollowUpParkManagementMutationMutation, BudgetFollowUpParkManagementMutationMutationVariables> {
    document = BudgetFollowUpParkManagementMutationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpRevenuesConfigurationDocument = gql`
    query BudgetFollowUpRevenuesConfiguration($parkIds: [String!]!) {
  PARKS(where: {_id: {IN: $parkIds}}) {
    _id
    useRevenuesV2InBudgets
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpRevenuesConfigurationGQL extends Apollo.Query<BudgetFollowUpRevenuesConfigurationQuery, BudgetFollowUpRevenuesConfigurationQueryVariables> {
    document = BudgetFollowUpRevenuesConfigurationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpParkDashboardMainKpisDocument = gql`
    query BudgetFollowUpParkDashboardMainKpis($year: Int!, $parkId: String!, $timezone: String, $useRevenuesV2: Boolean) {
  PARKS(where: {_id: {EQ: $parkId}}) {
    DATA {
      TABLE {
        DATA_BGD(year: $year, timezone: $timezone, useRevenuesV2: $useRevenuesV2) {
          budget_by_month {
            year
            month
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionBudget
            productionBudgetAcc
            revenueBudget
            revenueBudgetAcc
            productionTheoretical
            productionTheoreticalAcc
            revenueTheoretical
            revenueTheoreticalAcc
            productionBudgetYTD
            revenueBudgetYTD
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionLossLogbook
            productionLossLogbookAcc
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpParkDashboardMainKpisGQL extends Apollo.Query<BudgetFollowUpParkDashboardMainKpisQuery, BudgetFollowUpParkDashboardMainKpisQueryVariables> {
    document = BudgetFollowUpParkDashboardMainKpisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpParkDataDocument = gql`
    query BudgetFollowUpParkData($year: Int!, $parkId: String!, $timezone: String) {
  PARKS(where: {_id: {EQ: $parkId}}) {
    name
    code
    _id
    COUNTRY {
      _id
    }
    DATA {
      TABLE {
        DATA_BGD(year: $year, timezone: $timezone) {
          budget_by_month {
            year
            month
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionExpectedAcc
            revenueExpectedAcc
            productionBudget
            productionBudgetAcc
            revenueBudget
            revenueBudgetAcc
            productionTheoretical
            productionTheoreticalAcc
            revenueTheoretical
            revenueTheoreticalAcc
            productionBudgetYTD
            revenueBudgetYTD
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionScada
            productionScadaAcc
            productionGrid
            productionGridAcc
            revenueScada
            revenueScadaAcc
            revenueGrid
            revenueGridAcc
            isInvoiceDelivered
            isInvoiceCompensated
            productionCompensatedInvoiced
            productionCompensatedInvoicedAcc
            revenueCompensatedInvoiced
            revenueCompensatedInvoicedAcc
            productionDeliveredInvoiced
            productionDeliveredInvoicedAcc
            revenueDeliveredInvoiced
            revenueDeliveredInvoicedAcc
            commentText
            lastUpdatedUser
            lastUpdatedTs
            files
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpParkDataGQL extends Apollo.Query<BudgetFollowUpParkDataQuery, BudgetFollowUpParkDataQueryVariables> {
    document = BudgetFollowUpParkDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpParkProductionVsBudgetByDayDocument = gql`
    query BudgetFollowUpParkProductionVsBudgetByDay($month: Int!, $year: Int!, $parkId: String!, $timezone: String, $useRevenuesV2: Boolean) {
  PARKS(where: {_id: {EQ: $parkId}}) {
    DATA {
      TABLE {
        DATA_BGD(year: $year, timezone: $timezone, useRevenuesV2: $useRevenuesV2) {
          budget_by_day(month: $month, timezone: $timezone) {
            year
            month
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionExpectedAcc
            revenueExpectedAcc
            productionBudget
            productionBudgetAcc
            revenueBudget
            revenueBudgetAcc
            productionTheoretical
            revenueTheoretical
            productionBudgetYTD
            revenueBudgetYTD
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionScada
            productionScadaAcc
            productionGrid
            productionGridAcc
            revenueScada
            revenueScadaAcc
            revenueGrid
            revenueGridAcc
            isInvoiceDelivered
            isInvoiceCompensated
            productionCompensatedInvoiced
            productionCompensatedInvoicedAcc
            revenueCompensatedInvoiced
            revenueCompensatedInvoicedAcc
            productionDeliveredInvoiced
            productionDeliveredInvoicedAcc
            revenueDeliveredInvoiced
            revenueDeliveredInvoicedAcc
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpParkProductionVsBudgetByDayGQL extends Apollo.Query<BudgetFollowUpParkProductionVsBudgetByDayQuery, BudgetFollowUpParkProductionVsBudgetByDayQueryVariables> {
    document = BudgetFollowUpParkProductionVsBudgetByDayDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpParkProductionVsBudgetDocument = gql`
    query BudgetFollowUpParkProductionVsBudget($year: Int!, $parkId: String!, $timezone: String, $useRevenuesV2: Boolean) {
  PARKS(where: {_id: {EQ: $parkId}}) {
    DATA {
      TABLE {
        DATA_BGD(year: $year, timezone: $timezone, useRevenuesV2: $useRevenuesV2) {
          budget_by_month {
            year
            month
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionExpectedAcc
            revenueExpectedAcc
            productionBudget
            productionBudgetAcc
            revenueBudget
            revenueBudgetAcc
            productionTheoretical
            productionTheoreticalAcc
            revenueTheoretical
            revenueTheoreticalAcc
            productionBudgetYTD
            revenueBudgetYTD
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionScada
            productionScadaAcc
            productionGrid
            productionGridAcc
            revenueScada
            revenueScadaAcc
            revenueGrid
            revenueGridAcc
            isInvoiceDelivered
            isInvoiceCompensated
            productionCompensatedInvoiced
            productionCompensatedInvoicedAcc
            revenueCompensatedInvoiced
            revenueCompensatedInvoicedAcc
            productionDeliveredInvoiced
            productionDeliveredInvoicedAcc
            revenueDeliveredInvoiced
            revenueDeliveredInvoicedAcc
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpParkProductionVsBudgetGQL extends Apollo.Query<BudgetFollowUpParkProductionVsBudgetQuery, BudgetFollowUpParkProductionVsBudgetQueryVariables> {
    document = BudgetFollowUpParkProductionVsBudgetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpPortfolioDashboardMainKpisDocument = gql`
    query BudgetFollowUpPortfolioDashboardMainKpis($year: Int!, $parks: [String!], $timezone: String, $useRevenuesV2: Boolean) {
  PORTFOLIO(parks: $parks) {
    DATA {
      TABLE {
        DATA_BGD(year: $year, timezone: $timezone, useRevenuesV2: $useRevenuesV2) {
          budget_by_month {
            year
            month
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionBudget
            productionBudgetAcc
            revenueBudget
            revenueBudgetAcc
            productionTheoretical
            productionTheoreticalAcc
            revenueTheoretical
            revenueTheoreticalAcc
            productionBudgetYTD
            revenueBudgetYTD
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpPortfolioDashboardMainKpisGQL extends Apollo.Query<BudgetFollowUpPortfolioDashboardMainKpisQuery, BudgetFollowUpPortfolioDashboardMainKpisQueryVariables> {
    document = BudgetFollowUpPortfolioDashboardMainKpisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpPortfolioProductionVsBudgetByWindparkDocument = gql`
    query BudgetFollowUpPortfolioProductionVsBudgetByWindpark($year: Int!, $parks: [String!], $timezone: String, $useRevenuesV2: Boolean) {
  PORTFOLIO(parks: $parks) {
    DATA {
      TABLE {
        DATA_BGD(year: $year, timezone: $timezone, useRevenuesV2: $useRevenuesV2) {
          budget_by_park {
            PARK {
              _id
              name
              displayName
              code
              COUNTRY {
                code
                name
              }
            }
            year
            month
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionBudget
            productionBudgetAcc
            revenueBudget
            revenueBudgetAcc
            productionTheoretical
            productionTheoreticalAcc
            revenueTheoretical
            revenueTheoreticalAcc
            productionBudgetYTD
            revenueBudgetYTD
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionScada
            productionScadaAcc
            productionGrid
            productionGridAcc
            revenueScada
            revenueScadaAcc
            revenueGrid
            revenueGridAcc
            isInvoiceDelivered
            isInvoiceCompensated
            productionCompensatedInvoiced
            productionCompensatedInvoicedAcc
            revenueCompensatedInvoiced
            revenueCompensatedInvoicedAcc
            productionDeliveredInvoiced
            productionDeliveredInvoicedAcc
            revenueDeliveredInvoiced
            revenueDeliveredInvoicedAcc
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
          budget_by_park_month {
            PARK {
              _id
              name
              displayName
              code
              COUNTRY {
                code
                name
              }
            }
            year
            month
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionBudget
            productionBudgetAcc
            revenueBudget
            revenueBudgetAcc
            productionTheoretical
            productionTheoreticalAcc
            revenueTheoretical
            revenueTheoreticalAcc
            productionBudgetYTD
            revenueBudgetYTD
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionScada
            productionScadaAcc
            productionGrid
            productionGridAcc
            revenueScada
            revenueScadaAcc
            revenueGrid
            revenueGridAcc
            isInvoiceDelivered
            isInvoiceCompensated
            productionCompensatedInvoiced
            productionCompensatedInvoicedAcc
            revenueCompensatedInvoiced
            revenueCompensatedInvoicedAcc
            productionDeliveredInvoiced
            productionDeliveredInvoicedAcc
            revenueDeliveredInvoiced
            revenueDeliveredInvoicedAcc
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
          budget_by_country {
            year
            month
            COUNTRY {
              code
              name
            }
            revenueAcc
            revenue
            production
            productionAcc
            productionExpected
            revenueExpected
            productionBudget
            productionBudgetAcc
            revenueBudget
            revenueBudgetAcc
            productionTheoretical
            revenueTheoretical
            productionBudgetYTD
            revenueBudgetYTD
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            isInvoiceDelivered
            isInvoiceCompensated
            productionCompensatedInvoiced
            productionCompensatedInvoicedAcc
            revenueCompensatedInvoiced
            revenueCompensatedInvoicedAcc
            productionDeliveredInvoiced
            productionDeliveredInvoicedAcc
            revenueDeliveredInvoiced
            revenueDeliveredInvoicedAcc
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
          budget_by_country_month {
            year
            month
            COUNTRY {
              code
              name
            }
            revenueAcc
            revenue
            production
            productionAcc
            productionExpected
            revenueExpected
            productionBudget
            productionBudgetAcc
            revenueBudget
            revenueBudgetAcc
            productionTheoretical
            revenueTheoretical
            productionBudgetYTD
            revenueBudgetYTD
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            isInvoiceDelivered
            isInvoiceCompensated
            productionCompensatedInvoiced
            productionCompensatedInvoicedAcc
            revenueCompensatedInvoiced
            revenueCompensatedInvoicedAcc
            productionDeliveredInvoiced
            productionDeliveredInvoicedAcc
            revenueDeliveredInvoiced
            revenueDeliveredInvoicedAcc
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpPortfolioProductionVsBudgetByWindparkGQL extends Apollo.Query<BudgetFollowUpPortfolioProductionVsBudgetByWindparkQuery, BudgetFollowUpPortfolioProductionVsBudgetByWindparkQueryVariables> {
    document = BudgetFollowUpPortfolioProductionVsBudgetByWindparkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpPortfolioProductionVsBudgetDocument = gql`
    query BudgetFollowUpPortfolioProductionVsBudget($year: Int!, $parks: [String!], $timezone: String, $useRevenuesV2: Boolean) {
  PORTFOLIO(parks: $parks) {
    DATA {
      TABLE {
        DATA_BGD(year: $year, timezone: $timezone, useRevenuesV2: $useRevenuesV2) {
          budget_by_month {
            year
            month
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionExpectedAcc
            revenueExpectedAcc
            productionBudget
            productionBudgetAcc
            revenueBudget
            revenueBudgetAcc
            productionTheoretical
            productionTheoreticalAcc
            revenueTheoretical
            revenueTheoreticalAcc
            productionBudgetYTD
            revenueBudgetYTD
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionScada
            productionScadaAcc
            productionGrid
            productionGridAcc
            revenueScada
            revenueScadaAcc
            revenueGrid
            revenueGridAcc
            isInvoiceDelivered
            isInvoiceCompensated
            productionCompensatedInvoiced
            productionCompensatedInvoicedAcc
            revenueCompensatedInvoiced
            revenueCompensatedInvoicedAcc
            productionDeliveredInvoiced
            productionDeliveredInvoicedAcc
            revenueDeliveredInvoiced
            revenueDeliveredInvoicedAcc
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpPortfolioProductionVsBudgetGQL extends Apollo.Query<BudgetFollowUpPortfolioProductionVsBudgetQuery, BudgetFollowUpPortfolioProductionVsBudgetQueryVariables> {
    document = BudgetFollowUpPortfolioProductionVsBudgetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpPortfolioOverviewMainKpisDocument = gql`
    query BudgetFollowUpPortfolioOverviewMainKpis($year: Int!, $parks: [String!], $timezone: String, $useRevenuesV2: Boolean) {
  PORTFOLIO(parks: $parks) {
    DATA {
      TABLE {
        DATA_BGD(year: $year, timezone: $timezone, useRevenuesV2: $useRevenuesV2) {
          budget_by_country {
            year
            month
            COUNTRY {
              name
              code
            }
            PARK {
              name
              code
            }
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionBudget
            revenueBudget
            productionTheoretical
            revenueTheoretical
            productionBudgetYTD
            revenueBudgetYTD
            productionBudgetAcc
            revenueBudgetAcc
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
          budget_total {
            year
            month
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionBudget
            revenueBudget
            productionTheoretical
            revenueTheoretical
            productionBudgetYTD
            revenueBudgetYTD
            productionBudgetAcc
            revenueBudgetAcc
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpPortfolioOverviewMainKpisGQL extends Apollo.Query<BudgetFollowUpPortfolioOverviewMainKpisQuery, BudgetFollowUpPortfolioOverviewMainKpisQueryVariables> {
    document = BudgetFollowUpPortfolioOverviewMainKpisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpPortfolioOverviewParkKpisByCountryDocument = gql`
    query BudgetFollowUpPortfolioOverviewParkKpisByCountry($year: Int!, $parkIds: [String!], $timezone: String, $useRevenuesV2: Boolean) {
  PORTFOLIO(parks: $parkIds) {
    DATA {
      TABLE {
        DATA_BGD(year: $year, timezone: $timezone, useRevenuesV2: $useRevenuesV2) {
          budget_by_park {
            year
            month
            PARK {
              _id
              name
              displayName
              code
              COUNTRY {
                code
                name
              }
            }
            revenueAcc
            revenue
            totalRevenue
            totalRevenueAcc
            production
            productionAcc
            productionExpected
            revenueExpected
            productionBudget
            revenueBudget
            productionTheoretical
            revenueTheoretical
            productionBudgetYTD
            revenueBudgetYTD
            productionBudgetAcc
            revenueBudgetAcc
            productionDeliveredAcc
            productionDelivered
            revenueDeliveredAcc
            revenueDelivered
            productionCompensatedAcc
            productionCompensated
            revenueCompensatedAcc
            revenueCompensated
            productionLossLogbook
            productionLossLogbookAcc
            revenueLossLogbook
            revenueLossLogbookAcc
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpPortfolioOverviewParkKpisByCountryGQL extends Apollo.Query<BudgetFollowUpPortfolioOverviewParkKpisByCountryQuery, BudgetFollowUpPortfolioOverviewParkKpisByCountryQueryVariables> {
    document = BudgetFollowUpPortfolioOverviewParkKpisByCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpPortfolioOverviewSummaryKpisDocument = gql`
    query BudgetFollowUpPortfolioOverviewSummaryKpis($parks: [String!], $start: Float!, $end: Float!, $timezone: String, $useRevenuesV2: Boolean) {
  PARKS {
    _id
    displayName
  }
  PORTFOLIO(parks: $parks) {
    DATA {
      TABLE {
        DATA_BGD(timezone: $timezone, useRevenuesV2: $useRevenuesV2) {
          budget_summary(range: {start: $start, end: $end}, timezone: $timezone) {
            total {
              production
              productionBudget
              productionTheoretical
              revenue
              revenueBudget
              revenueTheoretical
              windSpeed
              windSpeedBudget
            }
            byPark {
              _id_park
              production
              productionBudget
              productionTheoretical
              revenue
              revenueBudget
              revenueTheoretical
              windSpeed
              windSpeedBudget
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpPortfolioOverviewSummaryKpisGQL extends Apollo.Query<BudgetFollowUpPortfolioOverviewSummaryKpisQuery, BudgetFollowUpPortfolioOverviewSummaryKpisQueryVariables> {
    document = BudgetFollowUpPortfolioOverviewSummaryKpisDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioDocument = gql`
    query AlarmsPortfolio($portfolioId: String!, $parks: [String!], $minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: DATA_ALX_OrderByInput!, $hideLimitedOperationAlarms: Int!, $tcus: [String!]!) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: $order
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {alarmCategory: {NEQ: $hideLimitedOperationAlarms}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
            }
            PARK {
              code
            }
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
          totalsTen: alarms(
            orderBy: $order
            offset: $offset
            limit: $limit
            aggrLimit: true
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {alarmCategory: {NEQ: $hideLimitedOperationAlarms}}, {tcu: {IN: $tcus}}]}
          ) {
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
            isOpen(aggregation: COUNT)
            tcu(aggregation: COUNT)
          }
          total: alarms(
            orderBy: $order
            offset: 0
            limit: 99999
            aggrLimit: true
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {alarmCategory: {NEQ: $hideLimitedOperationAlarms}}, {tcu: {IN: $tcus}}]}
          ) {
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
            isOpen(aggregation: COUNT)
            tcu(aggregation: COUNT)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioGQL extends Apollo.Query<AlarmsPortfolioQuery, AlarmsPortfolioQueryVariables> {
    document = AlarmsPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkDocument = gql`
    query AlarmsPark($parkCode: String!, $minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: DATA_ALX_OrderByInput!, $hideLimitedOperationAlarms: Int!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {code: {EQ: $parkCode}}, turbines: $turbines) {
    code
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: $order
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {alarmCategory: {NEQ: $hideLimitedOperationAlarms}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
            }
            turbineCode
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
          totalsTen: alarms(
            orderBy: $order
            offset: $offset
            limit: $limit
            aggrLimit: true
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {alarmCategory: {NEQ: $hideLimitedOperationAlarms}}, {tcu: {IN: $tcus}}]}
          ) {
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
            isOpen(aggregation: COUNT)
            tcu(aggregation: COUNT)
          }
          total: alarms(
            orderBy: $order
            offset: 0
            limit: 99999
            aggrLimit: true
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {alarmCategory: {NEQ: $hideLimitedOperationAlarms}}, {tcu: {IN: $tcus}}]}
          ) {
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
            isOpen(aggregation: COUNT)
            tcu(aggregation: COUNT)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkGQL extends Apollo.Query<AlarmsParkQuery, AlarmsParkQueryVariables> {
    document = AlarmsParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineDocument = gql`
    query AlarmsTurbine($serialNumeric: Float!, $minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: DATA_ALX_OrderByInput!, $hideLimitedOperationAlarms: Int!, $tcus: [String!]!) {
  TURBINES(where: {serialNumeric: {EQ: $serialNumeric}}) {
    PARK {
      code
    }
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: $order
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {alarmCategory: {NEQ: $hideLimitedOperationAlarms}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
            }
            turbineCode
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
          totalsTen: alarms(
            orderBy: $order
            offset: $offset
            limit: $limit
            aggrLimit: true
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {alarmCategory: {NEQ: $hideLimitedOperationAlarms}}, {tcu: {IN: $tcus}}]}
          ) {
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
            isOpen(aggregation: COUNT)
            tcu(aggregation: COUNT)
          }
          total: alarms(
            orderBy: $order
            offset: 0
            limit: 99999
            aggrLimit: true
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {alarmCategory: {NEQ: $hideLimitedOperationAlarms}}, {tcu: {IN: $tcus}}]}
          ) {
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
            isOpen(aggregation: COUNT)
            tcu(aggregation: COUNT)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineGQL extends Apollo.Query<AlarmsTurbineQuery, AlarmsTurbineQueryVariables> {
    document = AlarmsTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaxAlarmsPortDocument = gql`
    query MaxAlarmsPort($minCreated: Float!, $maxCreated: Float!, $tcus: [String!], $parks: [String!]) {
  PORTFOLIO(parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            nAlarms: _id(aggregation: COUNT)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaxAlarmsPortGQL extends Apollo.Query<MaxAlarmsPortQuery, MaxAlarmsPortQueryVariables> {
    document = MaxAlarmsPortDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaxAlarmsParkDocument = gql`
    query MaxAlarmsPark($minCreated: Float!, $maxCreated: Float!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            nAlarms: _id(aggregation: COUNT)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaxAlarmsParkGQL extends Apollo.Query<MaxAlarmsParkQuery, MaxAlarmsParkQueryVariables> {
    document = MaxAlarmsParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaxAlarmsTurbineDocument = gql`
    query MaxAlarmsTurbine($minCreated: Float!, $maxCreated: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}]}
          ) {
            nAlarms: _id(aggregation: COUNT)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaxAlarmsTurbineGQL extends Apollo.Query<MaxAlarmsTurbineQuery, MaxAlarmsTurbineQueryVariables> {
    document = MaxAlarmsTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioTcDocument = gql`
    query AlarmsPortfolioTc($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $tcus: [String!], $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {turbineCode: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioTcGQL extends Apollo.Query<AlarmsPortfolioTcQuery, AlarmsPortfolioTcQueryVariables> {
    document = AlarmsPortfolioTcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioRlDocument = gql`
    query AlarmsPortfolioRl($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $tcus: [String!], $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {totalRevenueLoss: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioRlGQL extends Apollo.Query<AlarmsPortfolioRlQuery, AlarmsPortfolioRlQueryVariables> {
    document = AlarmsPortfolioRlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioStDocument = gql`
    query AlarmsPortfolioSt($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $tcus: [String!], $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {createTS: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioStGQL extends Apollo.Query<AlarmsPortfolioStQuery, AlarmsPortfolioStQueryVariables> {
    document = AlarmsPortfolioStDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioAcDocument = gql`
    query AlarmsPortfolioAc($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $tcus: [String!], $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {code: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioAcGQL extends Apollo.Query<AlarmsPortfolioAcQuery, AlarmsPortfolioAcQueryVariables> {
    document = AlarmsPortfolioAcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioAdDocument = gql`
    query AlarmsPortfolioAd($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $tcus: [String!], $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {description: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioAdGQL extends Apollo.Query<AlarmsPortfolioAdQuery, AlarmsPortfolioAdQueryVariables> {
    document = AlarmsPortfolioAdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioEtDocument = gql`
    query AlarmsPortfolioEt($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $tcus: [String!], $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {closeTS: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioEtGQL extends Apollo.Query<AlarmsPortfolioEtQuery, AlarmsPortfolioEtQueryVariables> {
    document = AlarmsPortfolioEtDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioDurDocument = gql`
    query AlarmsPortfolioDur($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $tcus: [String!], $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {duration: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioDurGQL extends Apollo.Query<AlarmsPortfolioDurQuery, AlarmsPortfolioDurQueryVariables> {
    document = AlarmsPortfolioDurDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioAsDocument = gql`
    query AlarmsPortfolioAs($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $tcus: [String!], $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {isOpen: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioAsGQL extends Apollo.Query<AlarmsPortfolioAsQuery, AlarmsPortfolioAsQueryVariables> {
    document = AlarmsPortfolioAsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioTcuDocument = gql`
    query AlarmsPortfolioTCU($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $tcus: [String!], $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {tcu: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioTcuGQL extends Apollo.Query<AlarmsPortfolioTcuQuery, AlarmsPortfolioTcuQueryVariables> {
    document = AlarmsPortfolioTcuDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioPlDocument = gql`
    query AlarmsPortfolioPl($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $tcus: [String!], $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {powerLosses: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioPlGQL extends Apollo.Query<AlarmsPortfolioPlQuery, AlarmsPortfolioPlQueryVariables> {
    document = AlarmsPortfolioPlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkTcDocument = gql`
    query AlarmsParkTc($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {turbineCode: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkTcGQL extends Apollo.Query<AlarmsParkTcQuery, AlarmsParkTcQueryVariables> {
    document = AlarmsParkTcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkStDocument = gql`
    query AlarmsParkSt($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {createTS: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkStGQL extends Apollo.Query<AlarmsParkStQuery, AlarmsParkStQueryVariables> {
    document = AlarmsParkStDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkAcDocument = gql`
    query AlarmsParkAc($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {code: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkAcGQL extends Apollo.Query<AlarmsParkAcQuery, AlarmsParkAcQueryVariables> {
    document = AlarmsParkAcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkAdDocument = gql`
    query AlarmsParkAd($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {description: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkAdGQL extends Apollo.Query<AlarmsParkAdQuery, AlarmsParkAdQueryVariables> {
    document = AlarmsParkAdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkEtDocument = gql`
    query AlarmsParkEt($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {closeTS: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkEtGQL extends Apollo.Query<AlarmsParkEtQuery, AlarmsParkEtQueryVariables> {
    document = AlarmsParkEtDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkDurDocument = gql`
    query AlarmsParkDur($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {duration: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkDurGQL extends Apollo.Query<AlarmsParkDurQuery, AlarmsParkDurQueryVariables> {
    document = AlarmsParkDurDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkAsDocument = gql`
    query AlarmsParkAs($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {isOpen: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkAsGQL extends Apollo.Query<AlarmsParkAsQuery, AlarmsParkAsQueryVariables> {
    document = AlarmsParkAsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkTcuDocument = gql`
    query AlarmsParkTCU($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {tcu: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkTcuGQL extends Apollo.Query<AlarmsParkTcuQuery, AlarmsParkTcuQueryVariables> {
    document = AlarmsParkTcuDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkPlDocument = gql`
    query AlarmsParkPl($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {powerLosses: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkPlGQL extends Apollo.Query<AlarmsParkPlQuery, AlarmsParkPlQueryVariables> {
    document = AlarmsParkPlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkRlDocument = gql`
    query AlarmsParkRl($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $park: String!, $tcus: [String!]!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {totalRevenueLoss: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkRlGQL extends Apollo.Query<AlarmsParkRlQuery, AlarmsParkRlQueryVariables> {
    document = AlarmsParkRlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineTcDocument = gql`
    query AlarmsTurbineTc($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $turbine: String!, $tcus: [String!]!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {turbineCode: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineTcGQL extends Apollo.Query<AlarmsTurbineTcQuery, AlarmsTurbineTcQueryVariables> {
    document = AlarmsTurbineTcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineStDocument = gql`
    query AlarmsTurbineSt($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $turbine: String!, $tcus: [String!]!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {createTS: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineStGQL extends Apollo.Query<AlarmsTurbineStQuery, AlarmsTurbineStQueryVariables> {
    document = AlarmsTurbineStDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineAcDocument = gql`
    query AlarmsTurbineAc($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $turbine: String!, $tcus: [String!]!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {code: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineAcGQL extends Apollo.Query<AlarmsTurbineAcQuery, AlarmsTurbineAcQueryVariables> {
    document = AlarmsTurbineAcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineAdDocument = gql`
    query AlarmsTurbineAd($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $turbine: String!, $tcus: [String!]!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {description: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineAdGQL extends Apollo.Query<AlarmsTurbineAdQuery, AlarmsTurbineAdQueryVariables> {
    document = AlarmsTurbineAdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineEtDocument = gql`
    query AlarmsTurbineEt($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $turbine: String!, $tcus: [String!]!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {closeTS: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineEtGQL extends Apollo.Query<AlarmsTurbineEtQuery, AlarmsTurbineEtQueryVariables> {
    document = AlarmsTurbineEtDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineDurDocument = gql`
    query AlarmsTurbineDur($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $turbine: String!, $tcus: [String!]!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {duration: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineDurGQL extends Apollo.Query<AlarmsTurbineDurQuery, AlarmsTurbineDurQueryVariables> {
    document = AlarmsTurbineDurDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineAsDocument = gql`
    query AlarmsTurbineAs($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $turbine: String!, $tcus: [String!]!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {isOpen: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineAsGQL extends Apollo.Query<AlarmsTurbineAsQuery, AlarmsTurbineAsQueryVariables> {
    document = AlarmsTurbineAsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineTcuDocument = gql`
    query AlarmsTurbineTCU($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $turbine: String!, $tcus: [String!]!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {tcu: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineTcuGQL extends Apollo.Query<AlarmsTurbineTcuQuery, AlarmsTurbineTcuQueryVariables> {
    document = AlarmsTurbineTcuDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbinePlDocument = gql`
    query AlarmsTurbinePl($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $turbine: String!, $tcus: [String!]!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {powerLosses: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbinePlGQL extends Apollo.Query<AlarmsTurbinePlQuery, AlarmsTurbinePlQueryVariables> {
    document = AlarmsTurbinePlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineRlDocument = gql`
    query AlarmsTurbineRl($minCreated: Float!, $maxCreated: Float!, $offset: Int!, $limit: Int!, $order: Sort!, $turbine: String!, $tcus: [String!]!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {totalRevenueLoss: $order}
            offset: $offset
            limit: $limit
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}, {tcu: {IN: $tcus}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            code
            description
            createTS
            closeTS
            duration
            isOpen
            powerLosses
            totalRevenueLoss
            tcu
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineRlGQL extends Apollo.Query<AlarmsTurbineRlQuery, AlarmsTurbineRlQueryVariables> {
    document = AlarmsTurbineRlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TornadoPortfolioDocument = gql`
    query TornadoPortfolio($minCreated: Float!, $maxCreated: Float!, $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {turbineCode: ASC}
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}]}
          ) {
            PARK {
              code
              displayCode
              name
              displayName
            }
            turbineCode
            duration(aggregation: SUM)
            nAlarms: _id(aggregation: COUNT)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TornadoPortfolioGQL extends Apollo.Query<TornadoPortfolioQuery, TornadoPortfolioQueryVariables> {
    document = TornadoPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TornadoParkDocument = gql`
    query TornadoPark($minCreated: Float!, $maxCreated: Float!, $park: String!, $turbines: [String!]) {
  PARKS(
    where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}
    turbines: $turbines
  ) {
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TABLE {
          DATA_ALX {
            alarms(
              orderBy: {turbineCode: ASC}
              where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}]}
            ) {
              turbineCode
              code
              description
              duration(aggregation: SUM)
              nAlarms: _id(aggregation: COUNT)
              powerLosses(aggregation: SUM)
              totalRevenueLoss(aggregation: SUM)
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TornadoParkGQL extends Apollo.Query<TornadoParkQuery, TornadoParkQueryVariables> {
    document = TornadoParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TornadoTurbineDocument = gql`
    query TornadoTurbine($minCreated: Float!, $maxCreated: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    name
    serial
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            orderBy: {turbineCode: ASC}
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}]}
          ) {
            turbineCode
            code
            description
            duration(aggregation: SUM)
            nAlarms: _id(aggregation: COUNT)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TornadoTurbineGQL extends Apollo.Query<TornadoTurbineQuery, TornadoTurbineQueryVariables> {
    document = TornadoTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LollipopParkDocument = gql`
    query LollipopPark($minCreated: Float!, $maxCreated: Float!, $park: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            alarmCategory
            isOpen
            code
            description
            createTS
            closeTS
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LollipopParkGQL extends Apollo.Query<LollipopParkQuery, LollipopParkQueryVariables> {
    document = LollipopParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LollipopTurbineDocument = gql`
    query LollipopTurbine($minCreated: Float!, $maxCreated: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    DATA {
      TABLE {
        DATA_ALX {
          alarms(
            where: {AND: [{createTS: {GT: $minCreated}}, {createTS: {LT: $maxCreated}}]}
          ) {
            TURBINE {
              code: codeDisplay
              serial
              serialDisplay
            }
            _id
            alarmCategory
            isOpen
            code
            description
            createTS
            closeTS
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LollipopTurbineGQL extends Apollo.Query<LollipopTurbineQuery, LollipopTurbineQueryVariables> {
    document = LollipopTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindSpeedDocument = gql`
    query WindSpeed($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    name
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            NACELLE {
              windSpeed: WdSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindSpeedGQL extends Apollo.Query<WindSpeedQuery, WindSpeedQueryVariables> {
    document = WindSpeedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindDirDocument = gql`
    query WindDir($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    name
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            NACELLE {
              windDir: WdDir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindDirGQL extends Apollo.Query<WindDirQuery, WindDirQueryVariables> {
    document = WindDirDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NacDirDocument = gql`
    query NacDir($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    name
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            NACELLE {
              nacDir: Dir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NacDirGQL extends Apollo.Query<NacDirQuery, NacDirQueryVariables> {
    document = NacDirDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AmbTempDocument = gql`
    query AmbTemp($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    name
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            NACELLE {
              ambTemp: ExTmp_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AmbTempGQL extends Apollo.Query<AmbTempQuery, AmbTempQueryVariables> {
    document = AmbTempDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RotorSpeedDocument = gql`
    query RotorSpeed($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    name
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            ROTOR {
              rotorSpeed: RotSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RotorSpeedGQL extends Apollo.Query<RotorSpeedQuery, RotorSpeedQueryVariables> {
    document = RotorSpeedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GeneratorSpeedDocument = gql`
    query GeneratorSpeed($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    name
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            GENERATOR {
              generatorSpeed: Spd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GeneratorSpeedGQL extends Apollo.Query<GeneratorSpeedQuery, GeneratorSpeedQueryVariables> {
    document = GeneratorSpeedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PitchAngleParkDocument = gql`
    query PitchAnglePark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    name
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            ROTOR {
              pitchAngle1: PtAngValBl1_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
              pitchAngle2: PtAngValBl2_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
              pitchAngle3: PtAngValBl3_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PitchAngleParkGQL extends Apollo.Query<PitchAngleParkQuery, PitchAngleParkQueryVariables> {
    document = PitchAngleParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindSpeedTurbineDocument = gql`
    query WindSpeedTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          NACELLE {
            windSpeed: WdSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindSpeedTurbineGQL extends Apollo.Query<WindSpeedTurbineQuery, WindSpeedTurbineQueryVariables> {
    document = WindSpeedTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindDirTurbineDocument = gql`
    query WindDirTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          NACELLE {
            windDir: WdDir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindDirTurbineGQL extends Apollo.Query<WindDirTurbineQuery, WindDirTurbineQueryVariables> {
    document = WindDirTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NacDirTurbineDocument = gql`
    query NacDirTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          NACELLE {
            nacDir: Dir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NacDirTurbineGQL extends Apollo.Query<NacDirTurbineQuery, NacDirTurbineQueryVariables> {
    document = NacDirTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AmbTempTurbineDocument = gql`
    query AmbTempTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          NACELLE {
            ambTemp: ExTmp_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AmbTempTurbineGQL extends Apollo.Query<AmbTempTurbineQuery, AmbTempTurbineQueryVariables> {
    document = AmbTempTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RotorSpeedTurbineDocument = gql`
    query RotorSpeedTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          ROTOR {
            rotorSpeed: RotSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RotorSpeedTurbineGQL extends Apollo.Query<RotorSpeedTurbineQuery, RotorSpeedTurbineQueryVariables> {
    document = RotorSpeedTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GeneratorSpeedTurbineDocument = gql`
    query GeneratorSpeedTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          GENERATOR {
            generatorSpeed: Spd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GeneratorSpeedTurbineGQL extends Apollo.Query<GeneratorSpeedTurbineQuery, GeneratorSpeedTurbineQueryVariables> {
    document = GeneratorSpeedTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerCurveDocument = gql`
    query PowerCurve($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    POWER_CURVE {
      smallPowerCurve {
        windSpeed
        power
      }
    }
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            actualPower: W_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
              dataTimestamp
            }
          }
          NACELLE {
            ambTemp: ExTmp_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            windSpeed: WdSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            windDir: WdDir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerCurveGQL extends Apollo.Query<PowerCurveQuery, PowerCurveQueryVariables> {
    document = PowerCurveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NacVsWindDocument = gql`
    query NacVsWind($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          NACELLE {
            windDir: WdDir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            nacDir: Dir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NacVsWindGQL extends Apollo.Query<NacVsWindQuery, NacVsWindQueryVariables> {
    document = NacVsWindDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RpmVsPowerDocument = gql`
    query RpmVsPower($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            actualPower: W_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
              dataTimestamp
            }
          }
          ROTOR {
            rotorSpeed: RotSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RpmVsPowerGQL extends Apollo.Query<RpmVsPowerQuery, RpmVsPowerQueryVariables> {
    document = RpmVsPowerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RpmVsPitchDocument = gql`
    query RpmVsPitch($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          ROTOR {
            pitchAngle1: PtAngValBl1_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            pitchAngle2: PtAngValBl2_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            pitchAngle3: PtAngValBl3_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            rotorSpeed: RotSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RpmVsPitchGQL extends Apollo.Query<RpmVsPitchQuery, RpmVsPitchQueryVariables> {
    document = RpmVsPitchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PitchVsWindDocument = gql`
    query PitchVsWind($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          NACELLE {
            windSpeed: WdSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
          ROTOR {
            pitchAngle1: PtAngValBl1_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            pitchAngle2: PtAngValBl2_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            pitchAngle3: PtAngValBl3_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PitchVsWindGQL extends Apollo.Query<PitchVsWindQuery, PitchVsWindQueryVariables> {
    document = PitchVsWindDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PitchAngleDocument = gql`
    query PitchAngle($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    serial
    DATA {
      TIMESERIES {
        DATA_10M {
          ROTOR {
            pitchAngle1: PtAngValBl1_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            pitchAngle2: PtAngValBl2_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            pitchAngle3: PtAngValBl3_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PitchAngleGQL extends Apollo.Query<PitchAngleQuery, PitchAngleQueryVariables> {
    document = PitchAngleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineTypeDocument = gql`
    query TurbineType($turbine: String!) {
  PORTFOLIO {
    _id
    PARKS {
      name
      TURBINES(where: {serial: {EQ: $turbine}}) {
        name
        type
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineTypeGQL extends Apollo.Query<TurbineTypeQuery, TurbineTypeQueryVariables> {
    document = TurbineTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioKpiDocument = gql`
    query PortfolioKpi($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    PARKS {
      code
      name
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              W_avg_loss(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              revenueLosses(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              per_avg_availability(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              per_avg_efficiency(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioKpiGQL extends Apollo.Query<PortfolioKpiQuery, PortfolioKpiQueryVariables> {
    document = PortfolioKpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioKpiTotalDocument = gql`
    query PortfolioKpiTotal($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            revenueLosses(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            W_avg_loss(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            per_avg_availability(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            per_avg_efficiency(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioKpiTotalGQL extends Apollo.Query<PortfolioKpiTotalQuery, PortfolioKpiTotalQueryVariables> {
    document = PortfolioKpiTotalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParksKpiDocument = gql`
    query ParksKpi($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(
    where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}
    turbines: $turbines
  ) {
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              revenueLosses(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              W_avg_loss(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              per_avg_availability(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              per_avg_efficiency(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParksKpiGQL extends Apollo.Query<ParksKpiQuery, ParksKpiQueryVariables> {
    document = ParksKpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ComparativeTableReportParkDocument = gql`
    query ComparativeTableReportPark($starTs: Float!, $endTs: Float!, $park: String!) {
  PARKS(where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}) {
    name
    TURBINES {
      name
      code: codeDisplay
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              revenue(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              revenue(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              revenueLosses(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              Wh_avg_mag_f: Wh_avg_mag_f_corrected(
                convert: MWh
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              W_avg_theoretical(
                convert: MW
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              W_avg_loss(
                convert: MW
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              per_avg_availability(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              per_avg_efficiency(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ComparativeTableReportParkGQL extends Apollo.Query<ComparativeTableReportParkQuery, ComparativeTableReportParkQueryVariables> {
    document = ComparativeTableReportParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ComparativeTableReportPortfolioDocument = gql`
    query ComparativeTableReportPortfolio($starTs: Float!, $endTs: Float!, $month: Int!, $year: Int!, $portfolioId: String!) {
  PORTFOLIO(where: {_id: $portfolioId}) {
    _id
    PARKS(sort: {code: ASC}) {
      name
      code
      DATA {
        TABLE {
          DATA_BDG {
            budget(where: {AND: [{month: {EQ: $month}}, {year: {EQ: $year}}]}) {
              production
              revenue
            }
          }
        }
        TIMESERIES {
          DATA_10M {
            TURBINE {
              revenue(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              revenue(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              revenueLosses(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              Wh_avg_mag_f: Wh_avg_mag_f_corrected(
                convert: MWh
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              W_avg_theoretical(
                convert: MW
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              W_avg_loss(
                convert: MW
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              per_avg_availability(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              per_avg_efficiency(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ComparativeTableReportPortfolioGQL extends Apollo.Query<ComparativeTableReportPortfolioQuery, ComparativeTableReportPortfolioQueryVariables> {
    document = ComparativeTableReportPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParksKpiTotalDocument = gql`
    query ParksKpiTotal($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(
    where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}
    turbines: $turbines
  ) {
    code
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            revenueLosses(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            W_avg_loss(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            per_avg_availability(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            per_avg_efficiency(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParksKpiTotalGQL extends Apollo.Query<ParksKpiTotalQuery, ParksKpiTotalQueryVariables> {
    document = ParksKpiTotalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevLossPortfolioDocument = gql`
    query RevLossPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  PORTFOLIO(where: {_id: $portfolioId}) {
    _id
    PARKS {
      code
      name
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              revenueLosses(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevLossPortfolioGQL extends Apollo.Query<RevLossPortfolioQuery, RevLossPortfolioQueryVariables> {
    document = RevLossPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailabilityPortfolioDocument = gql`
    query AvailabilityPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  PORTFOLIO(where: {_id: $portfolioId}) {
    _id
    PARKS {
      code
      name
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              per_avg_availability(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailabilityPortfolioGQL extends Apollo.Query<AvailabilityPortfolioQuery, AvailabilityPortfolioQueryVariables> {
    document = AvailabilityPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProdLossPortfolioDocument = gql`
    query ProdLossPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  PORTFOLIO(where: {_id: $portfolioId}) {
    _id
    PARKS {
      code
      name
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              W_avg_loss(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProdLossPortfolioGQL extends Apollo.Query<ProdLossPortfolioQuery, ProdLossPortfolioQueryVariables> {
    document = ProdLossPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProdPortfolioDocument = gql`
    query ProdPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  PORTFOLIO(where: {_id: $portfolioId}) {
    _id
    PARKS {
      code
      name
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              Wh_avg_mag_f: Wh_avg_mag_f_corrected(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProdPortfolioGQL extends Apollo.Query<ProdPortfolioQuery, ProdPortfolioQueryVariables> {
    document = ProdPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevPortfolioDocument = gql`
    query RevPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  PORTFOLIO(where: {_id: $portfolioId}) {
    _id
    PARKS {
      code
      name
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              revenue(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevPortfolioGQL extends Apollo.Query<RevPortfolioQuery, RevPortfolioQueryVariables> {
    document = RevPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevLossParkDocument = gql`
    query RevLossPark($starTs: Float!, $endTs: Float!, $park: String!) {
  PARKS(where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}) {
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              revenueLosses(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevLossParkGQL extends Apollo.Query<RevLossParkQuery, RevLossParkQueryVariables> {
    document = RevLossParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailabilityParkDocument = gql`
    query AvailabilityPark($starTs: Float!, $endTs: Float!, $park: String!) {
  PARKS(where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}) {
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              per_avg_availability(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailabilityParkGQL extends Apollo.Query<AvailabilityParkQuery, AvailabilityParkQueryVariables> {
    document = AvailabilityParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProdLossParkDocument = gql`
    query ProdLossPark($starTs: Float!, $endTs: Float!, $park: String!) {
  PARKS(where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}) {
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              W_avg_loss(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProdLossParkGQL extends Apollo.Query<ProdLossParkQuery, ProdLossParkQueryVariables> {
    document = ProdLossParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProdParkDocument = gql`
    query ProdPark($starTs: Float!, $endTs: Float!, $park: String!) {
  PARKS(where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}) {
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              Wh_avg_mag_f: Wh_avg_mag_f_corrected(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProdParkGQL extends Apollo.Query<ProdParkQuery, ProdParkQueryVariables> {
    document = ProdParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevParkDocument = gql`
    query RevPark($starTs: Float!, $endTs: Float!, $park: String!) {
  PARKS(where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}) {
    code
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              revenue(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevParkGQL extends Apollo.Query<RevParkQuery, RevParkQueryVariables> {
    document = RevParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformancePortfolioDocument = gql`
    query PerformancePortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(range: {start: $starTs, end: $endTs}, convert: KW) {
              dataValue
            }
            W_avg_theoretical(range: {start: $starTs, end: $endTs}, convert: KW) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformancePortfolioGQL extends Apollo.Query<PerformancePortfolioQuery, PerformancePortfolioQueryVariables> {
    document = PerformancePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioRatedDocument = gql`
    query PortfolioRated($portfolioId: String!, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    PARKS {
      TURBINES {
        ratedPower
      }
    }
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: KW) {
              value
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioRatedGQL extends Apollo.Query<PortfolioRatedQuery, PortfolioRatedQueryVariables> {
    document = PortfolioRatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceParksDocument = gql`
    query PerformanceParks($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(
    where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}
    turbines: $turbines
  ) {
    TURBINES {
      ratedPower
    }
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(range: {start: $starTs, end: $endTs}, convert: KW) {
              dataValue
            }
            W_avg_theoretical(range: {start: $starTs, end: $endTs}, convert: KW) {
              dataValue
            }
          }
        }
      }
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: KW) {
              value
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceParksGQL extends Apollo.Query<PerformanceParksQuery, PerformanceParksQueryVariables> {
    document = PerformanceParksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkRatedDocument = gql`
    query parkRated($park: String!) {
  PARKS(where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}) {
    TURBINES {
      ratedPower
    }
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: KW) {
              value
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkRatedGQL extends Apollo.Query<ParkRatedQuery, ParkRatedQueryVariables> {
    document = ParkRatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceTurbineDocument = gql`
    query PerformanceTurbine($starTs: Float!, $endTs: Float!, $serial: String!) {
  TURBINES(where: {serial: {EQ: $serial}}) {
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(range: {start: $starTs, end: $endTs}, convert: KW) {
              dataValue
            }
            W_avg_theoretical(range: {start: $starTs, end: $endTs}, convert: KW) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceTurbineGQL extends Apollo.Query<PerformanceTurbineQuery, PerformanceTurbineQueryVariables> {
    document = PerformanceTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceGraphTurbineDocument = gql`
    query PerformanceGraphTurbine($starTs: Float!, $endTs: Float!, $serial: String!) {
  TURBINES(where: {serial: {EQ: $serial}}) {
    code: codeDisplay
    serial
    serialNumeric
    ratedPower
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(range: {start: $starTs, end: $endTs}, convert: KW) {
              dataValue
            }
            W_avg_theoretical(range: {start: $starTs, end: $endTs}, convert: KW) {
              dataValue
            }
            status(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
          }
          NACELLE {
            ambTemp: ExTmp_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            windSpeed: WdSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            windDir: WdDir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            nacDir: Dir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
          }
          ROTOR {
            rotorSpeed: RotSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: KW) {
              value
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceGraphTurbineGQL extends Apollo.Query<PerformanceGraphTurbineQuery, PerformanceGraphTurbineQueryVariables> {
    document = PerformanceGraphTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerPerTurbineDocument = gql`
    query PowerPerTurbine($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(
    where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}
    turbines: $turbines
  ) {
    TURBINES {
      name
      code: codeDisplay
      serialNumeric
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              W_avg_mag_f(range: {start: $starTs, end: $endTs}, convert: KW) {
                dataValue
              }
              W_avg_theoretical(range: {start: $starTs, end: $endTs}, convert: KW) {
                dataValue
              }
            }
          }
        }
      }
      DATA {
        SNAPSHOT {
          DATA_30S {
            TURBINE {
              W_rated(convert: KW) {
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerPerTurbineGQL extends Apollo.Query<PowerPerTurbineQuery, PowerPerTurbineQueryVariables> {
    document = PowerPerTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceTurbineByCodeDocument = gql`
    query PerformanceTurbineByCode($starTs: Float!, $endTs: Float!, $code: String!) {
  TURBINES(where: {code: {EQ: $code}}) {
    name
    code
    serial
    serialNumeric
    ratedPower
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(range: {start: $starTs, end: $endTs}, convert: KW) {
              dataValue
            }
            W_avg_theoretical(range: {start: $starTs, end: $endTs}, convert: KW) {
              dataValue
            }
          }
          NACELLE {
            ambTemp: ExTmp_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            windSpeed: WdSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            windDir: WdDir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            nacDir: Dir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
          }
          ROTOR {
            rotorSpeed: RotSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: KW) {
              value
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceTurbineByCodeGQL extends Apollo.Query<PerformanceTurbineByCodeQuery, PerformanceTurbineByCodeQueryVariables> {
    document = PerformanceTurbineByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineRatedDocument = gql`
    query turbineRated($serial: String!) {
  TURBINES(where: {serial: {EQ: $serial}}) {
    ratedPower
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: KW) {
              value
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineRatedGQL extends Apollo.Query<TurbineRatedQuery, TurbineRatedQueryVariables> {
    document = TurbineRatedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineRatedByCodeDocument = gql`
    query turbineRatedByCode($code: String!) {
  TURBINES(where: {code: {EQ: $code}}) {
    ratedPower
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: KW) {
              value
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineRatedByCodeGQL extends Apollo.Query<TurbineRatedByCodeQuery, TurbineRatedByCodeQueryVariables> {
    document = TurbineRatedByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductionByParkDocument = gql`
    query ProductionByPark($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    PARKS {
      code
      name
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              W_avg_loss(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              Wh_avg_mag_f: Wh_avg_mag_f_corrected(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {value: 35, unit: DAYS}
              ) {
                dataValue
              }
              W_avg_theoretical(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {value: 35, unit: DAYS}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductionByParkGQL extends Apollo.Query<ProductionByParkQuery, ProductionByParkQueryVariables> {
    document = ProductionByParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesByParkDocument = gql`
    query RevenuesByPark($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    PARKS {
      code
      name
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              revenue(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              revenueLosses(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {value: 35, unit: DAYS}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesByParkGQL extends Apollo.Query<RevenuesByParkQuery, RevenuesByParkQueryVariables> {
    document = RevenuesByParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesByTurbineDocument = gql`
    query RevenuesByTurbine($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(
    where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}
    turbines: $turbines
  ) {
    code
    name
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              revenue(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              revenueLosses(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {value: 35, unit: DAYS}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesByTurbineGQL extends Apollo.Query<RevenuesByTurbineQuery, RevenuesByTurbineQueryVariables> {
    document = RevenuesByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductionByTurbineDocument = gql`
    query ProductionByTurbine($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(
    where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}
    turbines: $turbines
  ) {
    code
    name
    TURBINES {
      code: codeDisplay
      serial
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              W_avg_loss(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 35}
              ) {
                dataValue
              }
              Wh_avg_mag_f: Wh_avg_mag_f_corrected(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {value: 35, unit: DAYS}
              ) {
                dataValue
              }
              W_avg_theoretical(
                range: {start: $starTs, end: $endTs}
                samplingInterval: {value: 35, unit: DAYS}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductionByTurbineGQL extends Apollo.Query<ProductionByTurbineQuery, ProductionByTurbineQueryVariables> {
    document = ProductionByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactsPortfolioDocument = gql`
    query FactsPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            Wh_avg_mag_f: Wh_avg_mag_f_corrected(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            W_avg_theoretical(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            W_avg_loss(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            co2Avoided(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            per_avg_loadFactor(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            revenue(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            revenueLosses(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactsPortfolioGQL extends Apollo.Query<FactsPortfolioQuery, FactsPortfolioQueryVariables> {
    document = FactsPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactsPortfolioFosenPpaModuleDocument = gql`
    query FactsPortfolioFosenPPAModule($starTs: Float!, $endTs: Float!) {
  PORTFOLIO {
    _id
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            Wh_avg_mag_f: Wh_avg_mag_f_corrected(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            W_avg_theoretical(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactsPortfolioFosenPpaModuleGQL extends Apollo.Query<FactsPortfolioFosenPpaModuleQuery, FactsPortfolioFosenPpaModuleQueryVariables> {
    document = FactsPortfolioFosenPpaModuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QualityPortfolioDocument = gql`
    query QualityPortfolio($starTs: Float!, $endTs: Float!, $parkIds: [String!]) {
  PORTFOLIO(parks: $parkIds) {
    _id
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(
              range: {start: $starTs, end: $endTs}
              aggregation: COUNT
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
          }
        }
      }
    }
    PARKS {
      code
      TURBINES {
        code: codeDisplay
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QualityPortfolioGQL extends Apollo.Query<QualityPortfolioQuery, QualityPortfolioQueryVariables> {
    document = QualityPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactsParkDocument = gql`
    query FactsPark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    TURBINES {
      comissioningDate
    }
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            Wh_avg_mag_f: Wh_avg_mag_f_corrected(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            W_avg_theoretical(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            W_avg_loss(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            co2Avoided(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            per_avg_loadFactor(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            revenue(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            revenueLosses(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactsParkGQL extends Apollo.Query<FactsParkQuery, FactsParkQueryVariables> {
    document = FactsParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactsParkFosenPpaModuleDocument = gql`
    query FactsParkFosenPPAModule($starTs: Float!, $endTs: Float!, $park: String!) {
  PARKS(where: {name: {EQ: $park}}) {
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            Wh_avg_mag_f: Wh_avg_mag_f_corrected(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            W_avg_theoretical(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactsParkFosenPpaModuleGQL extends Apollo.Query<FactsParkFosenPpaModuleQuery, FactsParkFosenPpaModuleQueryVariables> {
    document = FactsParkFosenPpaModuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QualityParkDocument = gql`
    query QualityPark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    code
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(
              range: {start: $starTs, end: $endTs}
              aggregation: COUNT
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
          }
        }
      }
    }
    TURBINES {
      code: codeDisplay
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QualityParkGQL extends Apollo.Query<QualityParkQuery, QualityParkQueryVariables> {
    document = QualityParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactsTurbineDocument = gql`
    query FactsTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    type
    comissioningDate
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            TotWh_actVal {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_10M {
          TURBINE {
            Wh_avg_mag_f: Wh_avg_mag_f_corrected(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            W_avg_theoretical(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            W_avg_loss(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            co2Avoided(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            per_avg_loadFactor(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            revenue(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
            revenueLosses(
              range: {start: $starTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
          }
        }
      }
    }
    PARK {
      TURBINES {
        code: codeDisplay
        serial
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactsTurbineGQL extends Apollo.Query<FactsTurbineQuery, FactsTurbineQueryVariables> {
    document = FactsTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QualityTurbineDocument = gql`
    query QualityTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {serial: {EQ: $turbine}}) {
    code: codeDisplay
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(
              range: {start: $starTs, end: $endTs}
              aggregation: COUNT
              samplingInterval: {unit: DAYS, value: 35}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QualityTurbineGQL extends Apollo.Query<QualityTurbineQuery, QualityTurbineQueryVariables> {
    document = QualityTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkListDocument = gql`
    query ParkList($portfolioId: String!, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    PARKS {
      code
      name
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkListGQL extends Apollo.Query<ParkListQuery, ParkListQueryVariables> {
    document = ParkListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineListDocument = gql`
    query TurbineList($park: String!, $turbines: [String!]) {
  PORTFOLIO {
    _id
    PARKS(
      where: {OR: [{name: {EQ: $park}}, {code: {EQ: $park}}]}
      turbines: $turbines
    ) {
      TURBINES {
        name
        code
        codeDisplay
        serial
        serialNumeric
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineListGQL extends Apollo.Query<TurbineListQuery, TurbineListQueryVariables> {
    document = TurbineListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerCurveFlagDocument = gql`
    query PowerCurveFlag($starTs: Float!, $endTs: Float!, $park: String!) {
  PARKS(where: {name: {EQ: $park}}) {
    name
    code
    TURBINES {
      code: codeDisplay
      serial
      POWER_CURVE {
        smallPowerCurve {
          windSpeed
          power
        }
      }
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              actualPower: W_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
                dataTimestamp
              }
            }
            NACELLE {
              ambTemp: ExTmp_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
              windSpeed: WdSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
              windDir: WdDir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerCurveFlagGQL extends Apollo.Query<PowerCurveFlagQuery, PowerCurveFlagQueryVariables> {
    document = PowerCurveFlagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToolTipInfoDocument = gql`
    query ToolTipInfo($unixTs: Float!, $turbineSerial: String!) {
  TURBINES(where: {serial: {EQ: $turbineSerial}}) {
    code: codeDisplay
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            status(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
            actualPower: W_avg_mag_f(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
            theoPower: W_avg_theoretical(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
          }
          NACELLE {
            ambTemp: ExTmp_avg_mag_f(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
            windSpeed: WdSpd_avg_mag_f(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
            windDir: WdDir_avg_mag_f(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
            nacDir: Dir_avg_mag_f(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
          }
          ROTOR {
            pitchAngle1: PtAngValBl1_avg_mag_f(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
            pitchAngle2: PtAngValBl2_avg_mag_f(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
            pitchAngle3: PtAngValBl3_avg_mag_f(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
            rotorSpeed: RotSpd_avg_mag_f(range: {start: $unixTs, end: $unixTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToolTipInfoGQL extends Apollo.Query<ToolTipInfoQuery, ToolTipInfoQueryVariables> {
    document = ToolTipInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerCurveByTurbineDocument = gql`
    query PowerCurveByTurbine($turbine: String!) {
  TURBINES(
    where: {OR: [{name: {EQ: $turbine}}, {code: {EQ: $turbine}}, {serial: {EQ: $turbine}}]}
  ) {
    code
    codeDisplay
    serial
    serialDisplay
    POWER_CURVE {
      smallPowerCurve {
        windSpeed
        power
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerCurveByTurbineGQL extends Apollo.Query<PowerCurveByTurbineQuery, PowerCurveByTurbineQueryVariables> {
    document = PowerCurveByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerCurveFlagByTurbineDocument = gql`
    query PowerCurveFlagByTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  TURBINES(where: {OR: [{name: {EQ: $turbine}}, {code: {EQ: $turbine}}]}) {
    code: codeDisplay
    serial
    POWER_CURVE {
      smallPowerCurve {
        windSpeed
        power
      }
    }
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            status(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            actualPower: W_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
              dataTimestamp
            }
          }
          NACELLE {
            ambTemp: ExTmp_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            windSpeed: WdSpd_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
            windDir: WdDir_avg_mag_f(range: {start: $starTs, end: $endTs}) {
              count
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerCurveFlagByTurbineGQL extends Apollo.Query<PowerCurveFlagByTurbineQuery, PowerCurveFlagByTurbineQueryVariables> {
    document = PowerCurveFlagByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StatusPortfolioDocument = gql`
    query StatusPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    PARKS {
      code
      name
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              status(range: {start: $starTs, end: $endTs}) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StatusPortfolioGQL extends Apollo.Query<StatusPortfolioQuery, StatusPortfolioQueryVariables> {
    document = StatusPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StatusParkDocument = gql`
    query StatusPark($starTs: Float!, $endTs: Float!, $parkName: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $parkName}}, turbines: $turbines) {
    TURBINES {
      serial
      code: codeDisplay
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              status(range: {start: $starTs, end: $endTs}) {
                count
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StatusParkGQL extends Apollo.Query<StatusParkQuery, StatusParkQueryVariables> {
    document = StatusParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStatusPortfolioDocument = gql`
    query LoadStatusPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    PARKS {
      code
      name
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              per_avg_loadFactor(range: {start: $starTs, end: $endTs}) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStatusPortfolioGQL extends Apollo.Query<LoadStatusPortfolioQuery, LoadStatusPortfolioQueryVariables> {
    document = LoadStatusPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStatusParkDocument = gql`
    query LoadStatusPark($starTs: Float!, $endTs: Float!, $parkName: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $parkName}}, turbines: $turbines) {
    TURBINES {
      serial
      code: codeDisplay
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              per_avg_loadFactor(range: {start: $starTs, end: $endTs}) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStatusParkGQL extends Apollo.Query<LoadStatusParkQuery, LoadStatusParkQueryVariables> {
    document = LoadStatusParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HeatmapDocument = gql`
    query Heatmap($starTs: Float!, $endTs: Float!, $turbine: Float!) {
  TURBINES(where: {serialNumeric: {EQ: $turbine}}) {
    name
    DATA {
      TIMESERIES {
        DATA_10M {
          TEMPERATURE_DEVIATION {
            WGEN1_GnTmpBrg1_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WGEN1_GnTmpBrg2_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WNAC1_IntlTmp_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRM1_TrmTmpGbxBrg1_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRM1_TrmTmpGbxOil_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WGEN1_GnTmpPhase1_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WGEN1_GnTmpPhase2_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WGEN1_GnTmpPhase3_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WCNV1_CnvTmpDclink_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WROT1_PtHyOilTmp_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WCNV1_CnvTmpWater_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRF1_TrfTmpPhase1_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRF1_TrfTmpPhase2_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRF1_TrfTmpPhase3_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WROT1_HubTmp_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WGEN1_GnTmpSta_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRM1_TrmTmpShfBrg1_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRM1_TrmTmpShfBrg2_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WCNV1_CnvTmpChokeCoil_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WGEN1_GnTmpInlet_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WNAC1_TopCtrCabTmp1_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WROT1_CtrCabTmp_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTF1_TrfAuxTmp_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRF1_TrfCoreTmp1_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRF1_TrfCoreTmp2_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRF1_TrfCoreTmp3_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRM1_TrmTmpWtr_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRM1_TrmTmpGbxBrg3_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRM1_TrmTmpGbxBrg4_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRM1_TrmTmpGbxBrg5_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTUR1_TurTmpUPS_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTRM1_TrmTmpGbxBrg2_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WNAC1_CtrCabTmp_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WGEN1_GnTmpOutlet_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WTOW1_CtrCabTmp_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WGEN1_GnTmpSlpRing1_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
            WGEN1_GnTmpRtr_avg_per_deviation(range: {start: $starTs, end: $endTs}) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HeatmapGQL extends Apollo.Query<HeatmapQuery, HeatmapQueryVariables> {
    document = HeatmapDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const KeepAliveDocument = gql`
    subscription KeepAlive {
  KEEP_ALIVE(subscriptionInterval: 60) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class KeepAliveGQL extends Apollo.Subscription<KeepAliveSubscription, KeepAliveSubscriptionVariables> {
    document = KeepAliveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserTurbineGroupsDocument = gql`
    query GetUserTurbineGroups {
  PORTFOLIO {
    USER_TURBINE_GROUPS {
      _id_park
      turbine_groups {
        _id
        name
        turbines {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserTurbineGroupsGQL extends Apollo.Query<GetUserTurbineGroupsQuery, GetUserTurbineGroupsQueryVariables> {
    document = GetUserTurbineGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPlantsAndTurbinesDocument = gql`
    query GetPlantsAndTurbines {
  PARKS {
    _id
    displayName
    TURBINES {
      _id
      displayName: codeDisplay
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlantsAndTurbinesGQL extends Apollo.Query<GetPlantsAndTurbinesQuery, GetPlantsAndTurbinesQueryVariables> {
    document = GetPlantsAndTurbinesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTurbineGroupDocument = gql`
    mutation CreateTurbineGroup($_id_park: ID!, $name: String!, $turbines: [ID!]!) {
  createCustomTurbineGroup(_id_park: $_id_park, name: $name, turbines: $turbines) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTurbineGroupGQL extends Apollo.Mutation<CreateTurbineGroupMutation, CreateTurbineGroupMutationVariables> {
    document = CreateTurbineGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTurbineGroupDocument = gql`
    mutation UpdateTurbineGroup($_id_park: ID!, $_id_group: ID!, $name: String, $turbines: [ID!]) {
  updateCustomTurbineGroup(
    _id_park: $_id_park
    _id_group: $_id_group
    name: $name
    turbines: $turbines
  ) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTurbineGroupGQL extends Apollo.Mutation<UpdateTurbineGroupMutation, UpdateTurbineGroupMutationVariables> {
    document = UpdateTurbineGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTurbineGroupDocument = gql`
    mutation DeleteTurbineGroup($_id_park: ID!, $_id_group: ID!) {
  deleteCustomTurbineGroup(_id_park: $_id_park, _id_group: $_id_group) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTurbineGroupGQL extends Apollo.Mutation<DeleteTurbineGroupMutation, DeleteTurbineGroupMutationVariables> {
    document = DeleteTurbineGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DimensionDataDocument = gql`
    query DimensionData($turbineIds: [String!]) {
  PARKS(sort: {name: ASC}, turbines: $turbineIds) {
    _id
    id: _id
    name
    displayName
    code
    displayCode
    COUNTRY {
      _id
      code
      name
      countryImage
    }
    latitude
    longitude
    timezone
    useRevenuesV2InBudgets
    TURBINES {
      _id
      id: _id
      name
      code
      codeDisplay
      serialNumeric
      serial
      serialDisplay
      ratedPower
      latitude
      longitude
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DimensionDataGQL extends Apollo.Query<DimensionDataQuery, DimensionDataQueryVariables> {
    document = DimensionDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllCountriesDocument = gql`
    query AllCountries {
  COUNTRIES {
    code
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllCountriesGQL extends Apollo.Query<AllCountriesQuery, AllCountriesQueryVariables> {
    document = AllCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DimensionDataCountriesDocument = gql`
    query DimensionDataCountries {
  COUNTRIES(sort: {name: ASC}) {
    name
    id: _id
    parks: PARKS(sort: {name: ASC}) {
      name: displayName
      id: _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DimensionDataCountriesGQL extends Apollo.Query<DimensionDataCountriesQuery, DimensionDataCountriesQueryVariables> {
    document = DimensionDataCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DimensionDataCountriesForPortfolioDocument = gql`
    query DimensionDataCountriesForPortfolio($portfolioId: String, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    COUNTRIES(sort: {name: ASC}) {
      name
      id: _id
      parks: PARKS(sort: {name: ASC}) {
        name: displayName
        id: _id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DimensionDataCountriesForPortfolioGQL extends Apollo.Query<DimensionDataCountriesForPortfolioQuery, DimensionDataCountriesForPortfolioQueryVariables> {
    document = DimensionDataCountriesForPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OneParkDimensionDataDocument = gql`
    query OneParkDimensionData($parkName: String!, $turbineIds: [String!]) {
  PARKS(where: {name: {EQ: $parkName}}, turbines: $turbineIds) {
    _id
    name
    displayName
    code
    latitude
    longitude
    COUNTRY {
      _id
      name
      code
    }
    TURBINES {
      _id
      name
      code: codeDisplay
      serialNumeric
      serial
      latitude
      longitude
      DATA {
        SNAPSHOT {
          DATA_30S {
            TURBINE {
              status {
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OneParkDimensionDataGQL extends Apollo.Query<OneParkDimensionDataQuery, OneParkDimensionDataQueryVariables> {
    document = OneParkDimensionDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OneParkDimensionDataByIdDocument = gql`
    query OneParkDimensionDataById($parkId: String!, $turbineIds: [String!]) {
  PARKS(where: {_id: {EQ: $parkId}}, turbines: $turbineIds) {
    _id
    name
    displayName
    code
    latitude
    longitude
    COUNTRY {
      _id
      name
      code
    }
    TURBINES {
      _id
      name
      code: codeDisplay
      serialNumeric
      serial
      latitude
      longitude
      DATA {
        SNAPSHOT {
          DATA_30S {
            TURBINE {
              status {
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OneParkDimensionDataByIdGQL extends Apollo.Query<OneParkDimensionDataByIdQuery, OneParkDimensionDataByIdQueryVariables> {
    document = OneParkDimensionDataByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OneTurbineDimensionDataDocument = gql`
    query OneTurbineDimensionData($turbineSerial: Float!) {
  TURBINES(where: {serialNumeric: {EQ: $turbineSerial}}) {
    _id
    name
    code: codeDisplay
    PARK {
      _id
      name
      code
      COUNTRY {
        _id
        name
        code
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OneTurbineDimensionDataGQL extends Apollo.Query<OneTurbineDimensionDataQuery, OneTurbineDimensionDataQueryVariables> {
    document = OneTurbineDimensionDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisplayNameByParkDocument = gql`
    query DisplayNameByPark($park: String!) {
  PARKS(where: {name: {EQ: $park}}) {
    displayName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisplayNameByParkGQL extends Apollo.Query<DisplayNameByParkQuery, DisplayNameByParkQueryVariables> {
    document = DisplayNameByParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllParksDocument = gql`
    query GetAllParks {
  PARKS {
    _id
    displayName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllParksGQL extends Apollo.Query<GetAllParksQuery, GetAllParksQueryVariables> {
    document = GetAllParksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastDataCountryDocument = gql`
    query ForecastDataCountry($code: String!, $startTs: Float!, $endTs: Float!, $samplingUnit: unitEnum!, $samplingValue: Float!, $portfolioId: String, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    COUNTRIES(where: {code: {EQ: $code}}) {
      DATA {
        SNAPSHOT {
          DATA_30S {
            TURBINE {
              W_rated {
                value
              }
            }
          }
        }
        TIMESERIES {
          DATA_10M {
            TURBINE {
              W_avg_mag_f(
                convert: MW
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: $samplingUnit, value: $samplingValue}
              ) {
                dataValue
              }
            }
          }
          DATA_WFC {
            WIND_LOG {
              theoreticalPower(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
              theoreticalPowerAmended(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
            OPEN_WEATHER {
              theoreticalPower(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
              theoreticalPowerAmended(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
            METEOBLUE {
              theoreticalPower(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
              theoreticalPowerAmended(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
            TRADING {
              theoreticalPower(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
              theoreticalPowerAmended(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
            METEOLOGICA {
              theoreticalPower(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
              theoreticalPowerAmended(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
            DNV_FORECASTER {
              theoreticalPower(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
              theoreticalPowerAmended(
                samplingInterval: {value: $samplingValue, unit: $samplingUnit}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastDataCountryGQL extends Apollo.Query<ForecastDataCountryQuery, ForecastDataCountryQueryVariables> {
    document = ForecastDataCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastDataParkDocument = gql`
    query ForecastDataPark($name: String!, $startTs: Float!, $endTs: Float!, $samplingUnitWeather: unitEnum!, $samplingValueWeather: Float!, $samplingUnit: unitEnum!, $samplingValue: Float!, $turbineIds: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbineIds) {
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
          }
        }
        DATA_WFC {
          DNV_FORECASTER {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            negativeImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          METEOLOGICA {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            negativeImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          WIND_LOG {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            negativeImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          OPEN_WEATHER {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            negativeImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          METEOBLUE {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            negativeImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          TRADING {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            negativeImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastDataParkGQL extends Apollo.Query<ForecastDataParkQuery, ForecastDataParkQueryVariables> {
    document = ForecastDataParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastDataParkReportWlDocument = gql`
    query ForecastDataParkReportWL($code: String!, $startTs: Float!, $endTs: Float!) {
  PARKS(where: {code: {EQ: $code}}) {
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: MW) {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_WFC {
          WIND_LOG {
            weather(
              aggregation: LAST
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
              convert: MW
            ) {
              dataValue
              dataTimestamp
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
              convert: MW
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastDataParkReportWlGQL extends Apollo.Query<ForecastDataParkReportWlQuery, ForecastDataParkReportWlQueryVariables> {
    document = ForecastDataParkReportWlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastDataParkReportMbDocument = gql`
    query ForecastDataParkReportMB($code: String!, $startTs: Float!, $endTs: Float!) {
  PARKS(where: {code: {EQ: $code}}) {
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: MW) {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_WFC {
          METEOBLUE {
            weather(
              aggregation: LAST
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
              convert: MW
            ) {
              dataValue
              dataTimestamp
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
              convert: MW
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastDataParkReportMbGQL extends Apollo.Query<ForecastDataParkReportMbQuery, ForecastDataParkReportMbQueryVariables> {
    document = ForecastDataParkReportMbDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastDataParkReportOwDocument = gql`
    query ForecastDataParkReportOW($code: String!, $startTs: Float!, $endTs: Float!) {
  PARKS(where: {code: {EQ: $code}}) {
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: MW) {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_WFC {
          OPEN_WEATHER {
            weather(
              aggregation: LAST
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: 12, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
              convert: MW
            ) {
              dataValue
              dataTimestamp
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
              convert: MW
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastDataParkReportOwGQL extends Apollo.Query<ForecastDataParkReportOwQuery, ForecastDataParkReportOwQueryVariables> {
    document = ForecastDataParkReportOwDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastDataPortfolioDocument = gql`
    query ForecastDataPortfolio($startTs: Float!, $endTs: Float!, $samplingUnit: unitEnum!, $samplingValue: Float!, $portfolioId: String, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
          }
        }
        DATA_WFC {
          WIND_LOG {
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          OPEN_WEATHER {
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          METEOBLUE {
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          TRADING {
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          METEOLOGICA {
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          DNV_FORECASTER {
            theoreticalPower(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: $samplingValue, unit: $samplingUnit}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastDataPortfolioGQL extends Apollo.Query<ForecastDataPortfolioQuery, ForecastDataPortfolioQueryVariables> {
    document = ForecastDataPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastDataTurbineInclWeatherDocument = gql`
    query ForecastDataTurbineInclWeather($turbineSerial: Float!, $startTs: Float!, $endTs: Float!, $samplingUnitWeather: unitEnum!, $samplingValueWeather: Float!, $samplingUnit: unitEnum!, $samplingValue: Float!) {
  TURBINES(where: {serialNumeric: {EQ: $turbineSerial}}) {
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
          }
        }
        DATA_WFC {
          WIND_LOG {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          OPEN_WEATHER {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          METEOBLUE {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          TRADING {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          DNV_FORECASTER {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          METEOLOGICA {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastDataTurbineInclWeatherGQL extends Apollo.Query<ForecastDataTurbineInclWeatherQuery, ForecastDataTurbineInclWeatherQueryVariables> {
    document = ForecastDataTurbineInclWeatherDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastDataTurbineDocument = gql`
    query ForecastDataTurbine($turbineSerial: Float!, $startTs: Float!, $endTs: Float!, $samplingUnit: unitEnum!, $samplingValue: Float!) {
  TURBINES(where: {serialNumeric: {EQ: $turbineSerial}}) {
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
          }
        }
        DATA_WFC {
          WIND_LOG {
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          OPEN_WEATHER {
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          METEOBLUE {
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          TRADING {
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          METEOLOGICA {
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
          DNV_FORECASTER {
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastDataTurbineGQL extends Apollo.Query<ForecastDataTurbineQuery, ForecastDataTurbineQueryVariables> {
    document = ForecastDataTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastPerformanceFactsParkDocument = gql`
    query ForecastPerformanceFactsPark($name: String!, $startTs: Float!, $endTs: Float!, $yearFirstTs: Float!, $days: Float!, $turbineIds: [String!], $getWindLog: Boolean!, $getOpenWeather: Boolean!, $getMeteoBlue: Boolean!, $getTrading: Boolean!, $getMeteologica: Boolean!, $getDNV: Boolean!) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbineIds) {
    name
    DATA {
      TIMESERIES {
        DATA_WFC {
          WIND_LOG @include(if: $getWindLog) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
          OPEN_WEATHER @include(if: $getOpenWeather) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
          METEOBLUE @include(if: $getMeteoBlue) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
          TRADING @include(if: $getTrading) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
          METEOLOGICA @include(if: $getMeteologica) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
          DNV_FORECASTER @include(if: $getDNV) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
        }
        DATA_10M {
          TURBINE {
            totalActualProduction: W_avg_mag_f(
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
        }
        DATA_PLN {
          AVAILABILITY {
            availability(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastPerformanceFactsParkGQL extends Apollo.Query<ForecastPerformanceFactsParkQuery, ForecastPerformanceFactsParkQueryVariables> {
    document = ForecastPerformanceFactsParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastPerformanceFactsPortfolioDocument = gql`
    query ForecastPerformanceFactsPortfolio($startTs: Float!, $endTs: Float!, $yearFirstTs: Float!, $days: Float!, $portfolioId: String, $parkIds: [String!], $getWindLog: Boolean!, $getOpenWeather: Boolean!, $getMeteoBlue: Boolean!, $getTrading: Boolean!, $getMeteologica: Boolean!, $getDNV: Boolean!) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    name
    DATA {
      TIMESERIES {
        DATA_WFC {
          WIND_LOG @include(if: $getWindLog) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
          OPEN_WEATHER @include(if: $getOpenWeather) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
          METEOBLUE @include(if: $getMeteoBlue) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
          TRADING @include(if: $getTrading) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
          METEOLOGICA @include(if: $getMeteologica) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
          DNV_FORECASTER @include(if: $getDNV) {
            theoreticalPowerAmended(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            theoreticalPower(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenuesAmended(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            revenues(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
            positiveImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
            negativeImbalance(
              convert: MW
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
        }
        DATA_10M {
          TURBINE {
            totalActualProduction: W_avg_mag_f(
              range: {start: $yearFirstTs, end: $startTs}
              samplingInterval: {unit: DAYS, value: 500}
            ) {
              dataValue
            }
          }
        }
        DATA_PLN {
          AVAILABILITY {
            availability(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: $days}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastPerformanceFactsPortfolioGQL extends Apollo.Query<ForecastPerformanceFactsPortfolioQuery, ForecastPerformanceFactsPortfolioQueryVariables> {
    document = ForecastPerformanceFactsPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastAndImbalanceDataParkDocument = gql`
    query ForecastAndImbalanceDataPark($name: String!, $startTs: Float!, $endTs: Float!, $samplingUnitWeather: unitEnum!, $samplingValueWeather: Float!, $samplingUnit: unitEnum!, $samplingValue: Float!, $turbineIds: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbineIds) {
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(
              convert: MW
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
          }
        }
        DATA_WFC {
          WIND_LOG {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            revenues(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
            negativeImbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
          }
          OPEN_WEATHER {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            revenues(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
            negativeImbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
          }
          METEOBLUE {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            revenues(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
            negativeImbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
          }
          TRADING {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            revenues(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
            negativeImbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
          }
          METEOLOGICA {
            weather(
              aggregation: LAST
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            temperature(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windSpeed(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            windDirection(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            revenues(
              samplingInterval: {value: $samplingValueWeather, unit: $samplingUnitWeather}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPower(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            theoreticalPowerAmended(
              samplingInterval: {value: 1, unit: HOURS}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            positiveImbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
            negativeImbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastAndImbalanceDataParkGQL extends Apollo.Query<ForecastAndImbalanceDataParkQuery, ForecastAndImbalanceDataParkQueryVariables> {
    document = ForecastAndImbalanceDataParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastImbalanceDataParkNoDetailsDocument = gql`
    query ForecastImbalanceDataParkNoDetails($name: String!, $startTs: Float!, $endTs: Float!, $samplingUnitTimeSeries: unitEnum!, $samplingValueTimeSeries: Float!, $turbineIds: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbineIds) {
    name
    DATA {
      TIMESERIES {
        DATA_WFC {
          METEOBLUE {
            imbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnitTimeSeries, value: $samplingValueTimeSeries}
            ) {
              dataValue
              dataTimestamp
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastImbalanceDataParkNoDetailsGQL extends Apollo.Query<ForecastImbalanceDataParkNoDetailsQuery, ForecastImbalanceDataParkNoDetailsQueryVariables> {
    document = ForecastImbalanceDataParkNoDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastImbalanceDataParkDocument = gql`
    query ForecastImbalanceDataPark($name: String!, $startTs: Float!, $endTs: Float!, $samplingUnitTimeSeries: unitEnum!, $samplingValueTimeSeries: Float!, $turbineIds: [String!], $hoursBefore: Int!, $analyzeType: analyzeTypeEnum) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbineIds) {
    name
    timezone
    TURBINES {
      ratedPower
    }
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_10M {
          TURBINE {
            W_avg_mag_f(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnitTimeSeries, value: $samplingValueTimeSeries}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
            SUM: W_avg_mag_f(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 100}
            ) {
              dataValue
            }
          }
        }
        DATA_WFC {
          WIND_LOG {
            theoreticalPowerAmendedPredicted(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: HOURS, value: 1}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
            imbalanceGroupedByPrediction(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: HOURS, value: 1}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
          }
          OPEN_WEATHER {
            theoreticalPowerAmendedPredicted(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: HOURS, value: 1}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
            imbalanceGroupedByPrediction(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: HOURS, value: 1}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
          }
          METEOBLUE {
            theoreticalPowerAmendedPredicted(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: HOURS, value: 1}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
            imbalanceGroupedByPrediction(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: HOURS, value: 1}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
          }
          TRADING {
            theoreticalPowerAmendedPredicted(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: HOURS, value: 1}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
            imbalanceGroupedByPrediction(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnitTimeSeries, value: $samplingValueTimeSeries}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
          }
          METEOLOGICA {
            theoreticalPowerAmendedPredicted(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: HOURS, value: 1}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
            imbalanceGroupedByPrediction(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnitTimeSeries, value: $samplingValueTimeSeries}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
          }
          DNV_FORECASTER {
            theoreticalPowerAmendedPredicted(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: HOURS, value: 1}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
            imbalanceGroupedByPrediction(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnitTimeSeries, value: $samplingValueTimeSeries}
              imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
            ) {
              dataJSON {
                value
                timestamp
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastImbalanceDataParkGQL extends Apollo.Query<ForecastImbalanceDataParkQuery, ForecastImbalanceDataParkQueryVariables> {
    document = ForecastImbalanceDataParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastImbalanceDataPortfolioNoDetailsDocument = gql`
    query ForecastImbalanceDataPortfolioNoDetails($startTs: Float!, $endTs: Float!, $samplingUnitTimeSeries: unitEnum!, $samplingValueTimeSeries: Float!, $parkIds: [String!]) {
  PORTFOLIO(parks: $parkIds) {
    _id
    DATA {
      TIMESERIES {
        DATA_WFC {
          METEOBLUE {
            imbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnitTimeSeries, value: $samplingValueTimeSeries}
            ) {
              dataValue
              dataTimestamp
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastImbalanceDataPortfolioNoDetailsGQL extends Apollo.Query<ForecastImbalanceDataPortfolioNoDetailsQuery, ForecastImbalanceDataPortfolioNoDetailsQueryVariables> {
    document = ForecastImbalanceDataPortfolioNoDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastImbalanceDataPortfolioNoDetailsForCustomPortfolioDocument = gql`
    query ForecastImbalanceDataPortfolioNoDetailsForCustomPortfolio($startTs: Float!, $endTs: Float!, $samplingUnitTimeSeries: unitEnum!, $samplingValueTimeSeries: Float!, $portfolioId: String, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    DATA {
      TIMESERIES {
        DATA_WFC {
          METEOBLUE {
            imbalance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: $samplingUnitTimeSeries, value: $samplingValueTimeSeries}
            ) {
              dataValue
              dataTimestamp
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastImbalanceDataPortfolioNoDetailsForCustomPortfolioGQL extends Apollo.Query<ForecastImbalanceDataPortfolioNoDetailsForCustomPortfolioQuery, ForecastImbalanceDataPortfolioNoDetailsForCustomPortfolioQueryVariables> {
    document = ForecastImbalanceDataPortfolioNoDetailsForCustomPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastImbalanceDataPortfolioDocument = gql`
    query ForecastImbalanceDataPortfolio($startTs: Float!, $endTs: Float!, $portfolioId: String, $parkIds: [String!], $hoursBefore: Int!, $analyzeType: analyzeTypeEnum!) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    PARKS {
      _id
      name
      code
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              SUM: W_avg_mag_f(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: DAYS, value: 100}
              ) {
                dataValue
              }
            }
          }
          DATA_WFC {
            WIND_LOG {
              imbalanceGroupedByPrediction(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: HOURS, value: 1}
                imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
              ) {
                dataValue
              }
              revenueImbalance(
                samplingInterval: {unit: HOURS, value: 1}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
            OPEN_WEATHER {
              imbalanceGroupedByPrediction(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: HOURS, value: 1}
                imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
              ) {
                dataValue
              }
              revenueImbalance(
                samplingInterval: {unit: HOURS, value: 1}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
            METEOBLUE {
              imbalanceGroupedByPrediction(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: HOURS, value: 1}
                imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
              ) {
                dataValue
              }
              revenueImbalance(
                samplingInterval: {unit: HOURS, value: 1}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
            TRADING {
              imbalanceGroupedByPrediction(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: HOURS, value: 1}
                imbalanceConfiguration: {hoursToLookBehind: $hoursBefore, analyzeType: $analyzeType}
              ) {
                dataValue
              }
              revenueImbalance(
                samplingInterval: {unit: HOURS, value: 1}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
            METEOLOGICA {
              imbalance(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: HOURS, value: 1}
              ) {
                dataValue
              }
              revenueImbalance(
                samplingInterval: {unit: HOURS, value: 1}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
            DNV_FORECASTER {
              imbalance(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: HOURS, value: 1}
              ) {
                dataValue
              }
              revenueImbalance(
                samplingInterval: {unit: HOURS, value: 1}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastImbalanceDataPortfolioGQL extends Apollo.Query<ForecastImbalanceDataPortfolioQuery, ForecastImbalanceDataPortfolioQueryVariables> {
    document = ForecastImbalanceDataPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastMapParkDocument = gql`
    query ForecastMapPark($parkName: String!, $startTs: Float!, $endTs: Float!, $turbineIds: [String!]) {
  PARKS(where: {name: {EQ: $parkName}}, turbines: $turbineIds) {
    name
    displayName
    code
    latitude
    longitude
    COUNTRY {
      _id
      name
      code
    }
    TURBINES {
      _id
      name
      code: codeDisplay
      serialNumeric
      serial
      latitude
      longitude
      DATA {
        TIMESERIES {
          DATA_10M {
            TURBINE {
              W_avg_mag_f(
                convert: MW
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: MINUTES, value: 10}
              ) {
                dataValue
              }
            }
          }
          DATA_PLN {
            AVAILABILITY {
              availability(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: MINUTES, value: 10}
              ) {
                dataValue
              }
              unavailableTurbines(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: MINUTES, value: 10}
              ) {
                dataValue
              }
              deratedTurbines(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: MINUTES, value: 10}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastMapParkGQL extends Apollo.Query<ForecastMapParkQuery, ForecastMapParkQueryVariables> {
    document = ForecastMapParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastMapPortfolioDocument = gql`
    query ForecastMapPortfolio($startTs: Float!, $endTs: Float!, $portfolioId: String, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    PARKS {
      name
      displayName
      code
      displayCode
      latitude
      longitude
      COUNTRY {
        _id
        name
        code
      }
      DATA {
        TIMESERIES {
          DATA_WFC {
            WIND_LOG {
              theoreticalPowerAmended(
                samplingInterval: {unit: HOURS, value: 1}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
                dataTimestamp
              }
            }
          }
          DATA_PLN {
            AVAILABILITY {
              availablePower(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: HOURS, value: 1}
              ) {
                dataValue
              }
              unavailableTurbines(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: HOURS, value: 1}
              ) {
                dataValue
              }
              deratedTurbines(
                range: {start: $startTs, end: $endTs}
                samplingInterval: {unit: HOURS, value: 1}
              ) {
                dataValue
              }
            }
          }
        }
      }
      TURBINES {
        _id
        name
        code: codeDisplay
        serialNumeric
        serial
        latitude
        longitude
        DATA {
          TIMESERIES {
            DATA_PLN {
              AVAILABILITY {
                unavailableTurbines(
                  range: {start: $startTs, end: $endTs}
                  samplingInterval: {unit: HOURS, value: 1}
                ) {
                  dataValue
                }
                deratedTurbines(
                  range: {start: $startTs, end: $endTs}
                  samplingInterval: {unit: HOURS, value: 1}
                ) {
                  dataValue
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastMapPortfolioGQL extends Apollo.Query<ForecastMapPortfolioQuery, ForecastMapPortfolioQueryVariables> {
    document = ForecastMapPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessDetailScheduleDocument = gql`
    query ProcessDetailSchedule($startRange: Float, $endRange: Float, $plannedEvents: [String!], $tclassBlocks: [String!]) {
  TURBINES {
    id: _id
    code: codeDisplay
    name
  }
  PORTFOLIO {
    _id
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            splittedLosess: true
            where: {AND: [{_id: {IN: $plannedEvents}}, {startTs: {LTE: $startRange}}, {endTs: {GTE: $endRange}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            category
            startTs
            endTs
          }
        }
        DATA_LGB {
          logbook_monthly(
            where: {AND: [{_id: {IN: $tclassBlocks}}, {startTS: {LTE: $startRange}}, {endTS: {GTE: $endRange}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            tcu
            startTs: startTS
            endTs: endTS
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessDetailScheduleGQL extends Apollo.Query<ProcessDetailScheduleQuery, ProcessDetailScheduleQueryVariables> {
    document = ProcessDetailScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkPlanningAnalyticsScheduleDocument = gql`
    query ParkPlanningAnalyticsSchedule($startRange: Float, $endRange: Float, $category: [String!], $parkName: String!, $turbineIds: [String!]) {
  PARKS(where: {name: {EQ: $parkName}}, turbines: $turbineIds) {
    name: displayName
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            splittedLosess: true
            where: {AND: [{startTs: {LTE: $startRange}}, {endTs: {GTE: $endRange}}, {category: {IN: $category}}]}
          ) {
            turbineId: _id_turbine
            category
            startTs
            endTs
          }
        }
        DATA_LGB {
          logbook_monthly(
            where: {AND: [{startTS: {LTE: $startRange}}, {endTS: {GTE: $endRange}}]}
          ) {
            turbineId: _id_turbine
            startTs: startTS
            endTs: endTS
          }
        }
      }
    }
    TURBINES {
      id: _id
      code: codeDisplay
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkPlanningAnalyticsScheduleGQL extends Apollo.Query<ParkPlanningAnalyticsScheduleQuery, ParkPlanningAnalyticsScheduleQueryVariables> {
    document = ParkPlanningAnalyticsScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkPlanningAnalyticsDocument = gql`
    query ParkPlanningAnalytics($parkId: String!, $planned_events: [DATA_PLE_TableWhereInput!], $logbook_monthly: [DATA_LGM_TableWhereInput!], $turbines: [String!]) {
  PARKS(where: {name: {EQ: $parkId}}, turbines: $turbines) {
    name: displayName
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(splittedLosess: true, where: {AND: $planned_events}) {
            plannedDuration: duration(aggregation: SUM)
            category
          }
        }
        DATA_LGB {
          logbook_monthly(where: {AND: $logbook_monthly}) {
            realizedDuration: duration(aggregation: SUM)
            totalProductionLoss(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
            userComment
          }
        }
      }
    }
    TURBINES {
      id: _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkPlanningAnalyticsGQL extends Apollo.Query<ParkPlanningAnalyticsQuery, ParkPlanningAnalyticsQueryVariables> {
    document = ParkPlanningAnalyticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkPlanningEventsAndTClassBlocksDocument = gql`
    query ParkPlanningEventsAndTClassBlocks($endRange: Float, $startRange: Float, $category: String, $parkId: String!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $parkId}}, turbines: $turbines) {
    name: displayName
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            splittedLosess: true
            where: {AND: [{startTs: {LTE: $endRange}}, {endTs: {GTE: $startRange}}, {category: {EQ: $category}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            title
            category
            startTs
            endTs
            duration
            durationShort
            productionLoss
            revenueLoss
            creationTs
          }
        }
        DATA_LGB {
          logbook_monthly(
            where: {AND: [{startTS: {LTE: $endRange}}, {endTS: {GTE: $startRange}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            tcu
            log
            startTS
            endTS
            duration
            totalProductionLoss
            totalRevenueLoss
            userComment
          }
        }
      }
    }
    TURBINES {
      id: _id
      code: codeDisplay
      name
      serialNumeric
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkPlanningEventsAndTClassBlocksGQL extends Apollo.Query<ParkPlanningEventsAndTClassBlocksQuery, ParkPlanningEventsAndTClassBlocksQueryVariables> {
    document = ParkPlanningEventsAndTClassBlocksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkProcessesAnalyticsDocument = gql`
    query ParkProcessesAnalytics($parkId: String!, $status: Int!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $parkId}}, turbines: $turbines) {
    name: displayName
    DATA {
      TABLE {
        DATA_PLN {
          processes_analytics(where: {status: {EQ: $status}}) {
            id: _id
            name: title
            status
            _id_plannedEvents
            _id_tClassBlocks
            description
            estimatedStartTs
            estimatedEndTs
            color
            durationPlanned
            durationRealized
            productionLossRealized
            revenueLossRealized
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkProcessesAnalyticsGQL extends Apollo.Query<ParkProcessesAnalyticsQuery, ParkProcessesAnalyticsQueryVariables> {
    document = ParkProcessesAnalyticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkProcessEventsAndTClassBlocksDocument = gql`
    query ParkProcessEventsAndTClassBlocks($parkId: String!, $plannedEvents: [String!], $tclassBlocks: [String!], $turbines: [String!]) {
  PARKS(where: {name: {EQ: $parkId}}, turbines: $turbines) {
    name: displayName
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(where: {_id: {IN: $plannedEvents}}) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            title
            description
            category
            startTs
            endTs
            duration
            productionLoss
            revenueLoss
            creationTs
          }
        }
        DATA_LGB {
          logbook_monthly(where: {_id: {IN: $tclassBlocks}}) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            mutTS
            tcu
            log
            startTS
            endTS
            duration
            totalProductionLoss
            totalRevenueLoss
            userComment
          }
        }
      }
    }
    TURBINES {
      id: _id
      code: codeDisplay
      name
      serialNumeric
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkProcessEventsAndTClassBlocksGQL extends Apollo.Query<ParkProcessEventsAndTClassBlocksQuery, ParkProcessEventsAndTClassBlocksQueryVariables> {
    document = ParkProcessEventsAndTClassBlocksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PlanningEventsAndTClassBlocksDocument = gql`
    query PlanningEventsAndTClassBlocks($endRange: Float, $startRange: Float, $parkIds: [String!], $category: String) {
  PORTFOLIO {
    _id
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            splittedLosess: true
            where: {AND: [{startTs: {LTE: $endRange}}, {endTs: {GTE: $startRange}}, {_id_park: {IN: $parkIds}}, {category: {EQ: $category}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            title
            category
            startTs
            endTs
            duration
            durationShort
            productionLoss
            revenueLoss
            creationTs
          }
        }
        DATA_LGB {
          logbook_monthly(
            where: {AND: [{startTS: {LTE: $endRange}}, {endTS: {GTE: $startRange}}, {_id_park: {IN: $parkIds}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            tcu
            log
            startTS
            endTS
            duration
            totalProductionLoss
            totalRevenueLoss
            userComment
          }
        }
      }
    }
    PARKS {
      id: _id
      name: displayName
      TURBINES {
        id: _id
        code: codeDisplay
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PlanningEventsAndTClassBlocksGQL extends Apollo.Query<PlanningEventsAndTClassBlocksQuery, PlanningEventsAndTClassBlocksQueryVariables> {
    document = PlanningEventsAndTClassBlocksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioPlanningAnalyticsDocument = gql`
    query PortfolioPlanningAnalytics($endRange: Float, $startRange: Float, $parkIds: [String!]) {
  PORTFOLIO {
    _id
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            splittedLosess: true
            where: {AND: [{startTs: {LTE: $endRange}}, {endTs: {GTE: $startRange}}, {_id_park: {IN: $parkIds}}]}
          ) {
            plannedDuration: duration(aggregation: SUM)
            category
          }
        }
        DATA_LGB {
          logbook_monthly(
            where: {AND: [{startTS: {LTE: $endRange}}, {endTS: {GTE: $startRange}}, {_id_park: {IN: $parkIds}}]}
          ) {
            realizedDuration: duration(aggregation: SUM)
            totalProductionLoss(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioPlanningAnalyticsGQL extends Apollo.Query<PortfolioPlanningAnalyticsQuery, PortfolioPlanningAnalyticsQueryVariables> {
    document = PortfolioPlanningAnalyticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioProcessAnalyticsDocument = gql`
    query PortfolioProcessAnalytics($status: Int!, $parkIds: [String!]) {
  PORTFOLIO {
    _id
    name
    DATA {
      TABLE {
        DATA_PLN {
          processes_analytics(
            orderBy: {creationTs: ASC}
            where: {AND: [{status: {EQ: $status}}, {_id_parks: {CONTAINS_ANY: $parkIds}}]}
          ) {
            id: _id
            name: title
            _id_parks
            _id_plannedEvents
            _id_tClassBlocks
            description
            estimatedStartTs
            status
            color
            estimatedEndTs
            durationPlanned
            durationRealized
            productionLossRealized
            revenueLossRealized
          }
        }
      }
    }
    PARKS {
      displayName
      name
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioProcessAnalyticsGQL extends Apollo.Query<PortfolioProcessAnalyticsQuery, PortfolioProcessAnalyticsQueryVariables> {
    document = PortfolioProcessAnalyticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessEventsAndTClassBlocksDocument = gql`
    query ProcessEventsAndTClassBlocks($plannedEvents: [String!], $tclassBlocks: [String!]) {
  PORTFOLIO {
    _id
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(where: {_id: {IN: $plannedEvents}}) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            title
            description
            category
            startTs
            endTs
            duration
            productionLoss
            revenueLoss
            creationTs
          }
        }
        DATA_LGB {
          logbook_monthly(where: {_id: {IN: $tclassBlocks}}) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            tcu
            log
            startTS
            endTS
            mutTS
            duration
            totalProductionLoss
            totalRevenueLoss
            userComment
          }
        }
      }
    }
    PARKS {
      id: _id
      name: displayName
      TURBINES {
        id: _id
        code: codeDisplay
        name
        serialNumeric
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessEventsAndTClassBlocksGQL extends Apollo.Query<ProcessEventsAndTClassBlocksQuery, ProcessEventsAndTClassBlocksQueryVariables> {
    document = ProcessEventsAndTClassBlocksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbinePlanningAnalyticsDocument = gql`
    query TurbinePlanningAnalytics($turbineId: Float!, $planned_events: [DATA_PLE_TableWhereInput!], $logbook_monthly: [DATA_LGM_TableWhereInput!]) {
  TURBINES(where: {serialNumeric: {EQ: $turbineId}}) {
    id: _id
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(splittedLosess: true, where: {AND: $planned_events}) {
            plannedDuration: duration(aggregation: SUM)
            category
          }
        }
        DATA_LGB {
          logbook_monthly(where: {AND: $logbook_monthly}) {
            realizedDuration: duration(aggregation: SUM)
            totalProductionLoss(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
            userComment
          }
        }
      }
    }
    PARK {
      name: displayName
      parkName: name
      id: _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbinePlanningAnalyticsGQL extends Apollo.Query<TurbinePlanningAnalyticsQuery, TurbinePlanningAnalyticsQueryVariables> {
    document = TurbinePlanningAnalyticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbinePlanningEventsAndTClassBlocksDocument = gql`
    query TurbinePlanningEventsAndTClassBlocks($endRange: Float, $startRange: Float, $category: String, $turbineId: Float!) {
  TURBINES(where: {serialNumeric: {EQ: $turbineId}}) {
    id: _id
    code: codeDisplay
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            splittedLosess: true
            where: {AND: [{startTs: {LTE: $endRange}}, {endTs: {GTE: $startRange}}, {category: {EQ: $category}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            title
            category
            startTs
            endTs
            durationShort
            productionLoss
            revenueLoss
            creationTs
          }
        }
        DATA_LGB {
          logbook_monthly(
            where: {AND: [{startTS: {LTE: $endRange}}, {endTS: {GTE: $startRange}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            tcu
            log
            startTS
            endTS
            duration
            totalProductionLoss
            totalRevenueLoss
            userComment
          }
        }
      }
    }
    PARK {
      name: displayName
      id: _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbinePlanningEventsAndTClassBlocksGQL extends Apollo.Query<TurbinePlanningEventsAndTClassBlocksQuery, TurbinePlanningEventsAndTClassBlocksQueryVariables> {
    document = TurbinePlanningEventsAndTClassBlocksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpPortfolioDocument = gql`
    query BudgetFollowUpPortfolio($portfolioId: String!, $year: Int!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    DATA {
      TABLE {
        DATA_BGD(year: $year) {
          budget_total {
            production
            productionBudget
            productionBudgetYTD
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpPortfolioGQL extends Apollo.Query<BudgetFollowUpPortfolioQuery, BudgetFollowUpPortfolioQueryVariables> {
    document = BudgetFollowUpPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpParkDocument = gql`
    query BudgetFollowUpPark($parkName: String!, $year: Int!) {
  PARKS(where: {name: {EQ: $parkName}}) {
    DATA {
      TABLE {
        DATA_BGD(year: $year) {
          budget_total {
            production
            productionBudget
            productionBudgetYTD
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpParkGQL extends Apollo.Query<BudgetFollowUpParkQuery, BudgetFollowUpParkQueryVariables> {
    document = BudgetFollowUpParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineYtdProductionDocument = gql`
    query TurbineYTDProduction($serialNav: Float!, $startTs: Float!, $endTs: Float!) {
  TURBINES(where: {serialNumeric: {EQ: $serialNav}}) {
    name
    DATA {
      TIMESERIES {
        DATA_10M {
          TURBINE {
            Wh_avg_mag_f: Wh_avg_mag_f_corrected(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 360}
              convert: GWh
            ) {
              dataKeyValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineYtdProductionGQL extends Apollo.Query<TurbineYtdProductionQuery, TurbineYtdProductionQueryVariables> {
    document = TurbineYtdProductionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkTurbinesAvailabilityDocument = gql`
    query ParkTurbinesAvailability($name: String!, $startTs: Float!, $endTs: Float!, $samplingUnit: unitEnum!, $samplingValue: Float!, $turbineIds: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbineIds) {
    name
    displayName
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: KW) {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_PLN {
          AVAILABILITY {
            availability(
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
              dataTimestamp
            }
            availablePower(
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
              dataTimestamp
            }
          }
        }
      }
    }
    TURBINES {
      _id
      name
      code: codeDisplay
      serialNumeric
      DATA {
        TIMESERIES {
          DATA_PLN {
            AVAILABILITY {
              availability(
                samplingInterval: {unit: $samplingUnit, value: $samplingValue}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
                dataTimestamp
              }
              unavailableTurbines(
                samplingInterval: {unit: $samplingUnit, value: $samplingValue}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
                dataTimestamp
              }
              deratedTurbines(
                samplingInterval: {unit: $samplingUnit, value: $samplingValue}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
                dataTimestamp
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkTurbinesAvailabilityGQL extends Apollo.Query<ParkTurbinesAvailabilityQuery, ParkTurbinesAvailabilityQueryVariables> {
    document = ParkTurbinesAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioParksAvailabilityDocument = gql`
    query PortfolioParksAvailability($startTs: Float!, $endTs: Float!, $samplingUnit: unitEnum!, $samplingValue: Float!, $portfolioId: String, $parkIds: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parkIds) {
    _id
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: KW) {
              value
            }
          }
        }
      }
      TIMESERIES {
        DATA_PLN {
          AVAILABILITY {
            availablePower(
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
              dataTimestamp
            }
          }
        }
      }
    }
    PARKS {
      code
      displayCode
      name
      displayName
      DATA {
        TIMESERIES {
          DATA_PLN {
            AVAILABILITY {
              availability(
                samplingInterval: {unit: $samplingUnit, value: $samplingValue}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
                dataTimestamp
              }
              unavailableTurbines(
                samplingInterval: {unit: $samplingUnit, value: $samplingValue}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
                dataTimestamp
              }
              deratedTurbines(
                samplingInterval: {unit: $samplingUnit, value: $samplingValue}
                range: {start: $startTs, end: $endTs}
              ) {
                dataValue
                dataTimestamp
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioParksAvailabilityGQL extends Apollo.Query<PortfolioParksAvailabilityQuery, PortfolioParksAvailabilityQueryVariables> {
    document = PortfolioParksAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DailyAvailabilitiesParkDocument = gql`
    query DailyAvailabilitiesPark($name: String!, $startTs: Float!, $endTs: Float!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbines) {
    name
    DATA {
      TIMESERIES {
        DATA_PLN {
          AVAILABILITY {
            availability(
              samplingInterval: {unit: HOURS, value: 1}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            availablePower(
              samplingInterval: {unit: HOURS, value: 1}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            unavailableTurbines(
              samplingInterval: {unit: HOURS, value: 1}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            deratedTurbines(
              samplingInterval: {unit: HOURS, value: 1}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DailyAvailabilitiesParkGQL extends Apollo.Query<DailyAvailabilitiesParkQuery, DailyAvailabilitiesParkQueryVariables> {
    document = DailyAvailabilitiesParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DailyAvailabilitiesTurbineDocument = gql`
    query DailyAvailabilitiesTurbine($turbineSerial: Float!, $startTs: Float!, $endTs: Float!) {
  TURBINES(where: {serialNumeric: {EQ: $turbineSerial}}) {
    name
    DATA {
      TIMESERIES {
        DATA_PLN {
          AVAILABILITY {
            availability(
              samplingInterval: {unit: HOURS, value: 1}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            availablePower(
              samplingInterval: {unit: HOURS, value: 1}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            unavailableTurbines(
              samplingInterval: {unit: HOURS, value: 1}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
            deratedTurbines(
              samplingInterval: {unit: HOURS, value: 1}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DailyAvailabilitiesTurbineGQL extends Apollo.Query<DailyAvailabilitiesTurbineQuery, DailyAvailabilitiesTurbineQueryVariables> {
    document = DailyAvailabilitiesTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScheduleEventsParkDocument = gql`
    query ScheduleEventsPark($name: String!, $startTs: Float!, $endTs: Float!, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbines) {
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            where: {AND: [{startTs: {LTE: $endTs}}, {endTs: {GTE: $startTs}}]}
          ) {
            _id
            _id_turbine
            _id_park
            _id_process
            category
            startTs
            endTs
            revenueLoss
            productionLoss
            category
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScheduleEventsParkGQL extends Apollo.Query<ScheduleEventsParkQuery, ScheduleEventsParkQueryVariables> {
    document = ScheduleEventsParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScheduleEventsTurbineDocument = gql`
    query ScheduleEventsTurbine($turbineSerial: Float!, $startTs: Float!, $endTs: Float!) {
  TURBINES(where: {serialNumeric: {EQ: $turbineSerial}}) {
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            where: {AND: [{startTs: {LTE: $endTs}}, {endTs: {GTE: $startTs}}]}
          ) {
            _id
            _id_turbine
            _id_park
            _id_process
            category
            startTs
            endTs
            revenueLoss
            productionLoss
            category
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScheduleEventsTurbineGQL extends Apollo.Query<ScheduleEventsTurbineQuery, ScheduleEventsTurbineQueryVariables> {
    document = ScheduleEventsTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineAvailabilityDocument = gql`
    query TurbineAvailability($turbineSerial: Float!, $startTs: Float!, $endTs: Float!, $samplingUnit: unitEnum!, $samplingValue: Float!) {
  TURBINES(where: {serialNumeric: {EQ: $turbineSerial}}) {
    _id
    code: codeDisplay
    name
    DATA {
      TIMESERIES {
        DATA_PLN {
          AVAILABILITY {
            availability(
              samplingInterval: {unit: $samplingUnit, value: $samplingValue}
              range: {start: $startTs, end: $endTs}
            ) {
              dataValue
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineAvailabilityGQL extends Apollo.Query<TurbineAvailabilityQuery, TurbineAvailabilityQueryVariables> {
    document = TurbineAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddNewPlannedEventDocument = gql`
    mutation addNewPlannedEvent($title: String!, $startTs: Float!, $endTs: Float!, $description: String!, $category: String!, $_id_turbine: [ID!]!, $debugMode: Boolean!, $_id_process: ID, $limitedTo: Float, $reminderSettings: ReminderSettingsInput, $startTsFullRange: Float, $endTsFullRange: Float, $provider: String, $plannedTCU: String) {
  newPlannedEvent(
    title: $title
    startTs: $startTs
    endTs: $endTs
    description: $description
    category: $category
    _id_turbine: $_id_turbine
    debugMode: $debugMode
    _id_process: $_id_process
    limitedTo: $limitedTo
    reminderSettings: $reminderSettings
    startTsFullRange: $startTsFullRange
    endTsFullRange: $endTsFullRange
    provider: $provider
    plannedTCU: $plannedTCU
  ) {
    success
    error
    data {
      _id_turbine
      title
      revenueLoss
      productionLoss
      productionArrWithTime {
        time
        value
      }
      productionLossArrWithTime {
        time
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNewPlannedEventGQL extends Apollo.Mutation<AddNewPlannedEventMutation, AddNewPlannedEventMutationVariables> {
    document = AddNewPlannedEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddNewPlannedEventFromTroubleshootModuleDocument = gql`
    mutation addNewPlannedEventFromTroubleshootModule($title: String!, $startTs: Float!, $endTs: Float!, $description: String!, $category: String!, $_id_turbine: [ID!]!, $debugMode: Boolean!, $_id_process: ID, $limitedTo: Float, $reminderSettings: ReminderSettingsInput, $_id_alarm: ID) {
  newPlannedEvent(
    title: $title
    startTs: $startTs
    endTs: $endTs
    description: $description
    category: $category
    _id_turbine: $_id_turbine
    debugMode: $debugMode
    _id_process: $_id_process
    limitedTo: $limitedTo
    reminderSettings: $reminderSettings
    _id_alarm: $_id_alarm
  ) {
    success
    error
    data {
      title
      revenueLoss
      productionLoss
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNewPlannedEventFromTroubleshootModuleGQL extends Apollo.Mutation<AddNewPlannedEventFromTroubleshootModuleMutation, AddNewPlannedEventFromTroubleshootModuleMutationVariables> {
    document = AddNewPlannedEventFromTroubleshootModuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePlannedEventDocument = gql`
    mutation updatePlannedEvent($_id: [ID!]!, $_id_process: ID, $title: String, $description: String, $startTs: Float, $endTs: Float, $debugMode: Boolean, $provider: String, $reminderSettings: ReminderSettingsInput, $startTsFullRange: Float, $endTsFullRange: Float, $plannedTCU: String) {
  updatePlannedEvent(
    _id: $_id
    _id_process: $_id_process
    title: $title
    description: $description
    startTs: $startTs
    endTs: $endTs
    debugMode: $debugMode
    provider: $provider
    reminderSettings: $reminderSettings
    startTsFullRange: $startTsFullRange
    endTsFullRange: $endTsFullRange
    plannedTCU: $plannedTCU
  ) {
    data {
      _id
      _id_turbine
      title
      revenueLoss
      productionLoss
      productionArrWithTime {
        time
        value
      }
      productionLossArrWithTime {
        time
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePlannedEventGQL extends Apollo.Mutation<UpdatePlannedEventMutation, UpdatePlannedEventMutationVariables> {
    document = UpdatePlannedEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePlannedEventUnassignProcessDocument = gql`
    mutation updatePlannedEventUnassignProcess($_id: [ID!]!, $_id_process: ID) {
  updatePlannedEvent(_id: $_id, _id_process: $_id_process) {
    data {
      _id
      title
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePlannedEventUnassignProcessGQL extends Apollo.Mutation<UpdatePlannedEventUnassignProcessMutation, UpdatePlannedEventUnassignProcessMutationVariables> {
    document = UpdatePlannedEventUnassignProcessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddNewPlannedEventRecurringDocument = gql`
    mutation addNewPlannedEventRecurring($newPlannedEvents: [NewPlannedEventsInput!]!) {
  newPlannedEvents(newPlannedEvents: $newPlannedEvents) {
    success
    error
    data {
      title
      revenueLoss
      productionLoss
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNewPlannedEventRecurringGQL extends Apollo.Mutation<AddNewPlannedEventRecurringMutation, AddNewPlannedEventRecurringMutationVariables> {
    document = AddNewPlannedEventRecurringDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventsListDocument = gql`
    query EventsList($park: String!, $start: Float, $end: Float, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbines) {
    name
    displayName
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(where: {AND: [{startTs: {LTE: $end}}, {endTs: {GTE: $start}}]}) {
            _id
            _id_turbine
            _id_park
            _id_process
            creationTs
            durationShort
            duration
            description
            category
            title
            productionLoss
            revenueLoss
            provider
            startDate
            startTs
            endDate
            endTs
            limitedTo
            plannedTCU
            reminderSettings {
              recipients
              timeValue
              timeGranularity
            }
          }
          processes {
            _id
            title
            description
            _id_parks
            creationTs
            status
            _id_plannedEvents
            estimatedStartTs
            estimatedEndTs
          }
        }
      }
    }
    TURBINES {
      name
      _id
      code: codeDisplay
      ratedPower
      PARK {
        _id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EventsListGQL extends Apollo.Query<EventsListQuery, EventsListQueryVariables> {
    document = EventsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventsListByDatePortfolioDocument = gql`
    query EventsListByDatePortfolio($endTs: Float!, $startTs: Float!, $portfolioId: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            where: {AND: [{startTs: {LTE: $endTs}}, {endTs: {GTE: $startTs}}]}
          ) {
            _id
            _id_turbine
            _id_park
            _id_process
            creationTs
            durationShort
            description
            category
            title
            productionLoss
            revenueLoss
            startDate
            startTs
            endDate
            endTs
            limitedTo
            plannedTCU
            reminderSettings {
              recipients
              timeValue
              timeGranularity
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EventsListByDatePortfolioGQL extends Apollo.Query<EventsListByDatePortfolioQuery, EventsListByDatePortfolioQueryVariables> {
    document = EventsListByDatePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventsListByDateParkDocument = gql`
    query EventsListByDatePark($park: String!, $endTs: Float!, $startTs: Float!, $turbineIds: [String!]) {
  PARKS(where: {name: {EQ: $park}}, turbines: $turbineIds) {
    name
    displayName
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            where: {AND: [{startTs: {LTE: $endTs}}, {endTs: {GTE: $startTs}}]}
          ) {
            _id
            _id_turbine
            _id_park
            _id_process
            creationTs
            durationShort
            description
            category
            title
            productionLoss
            revenueLoss
            startDate
            startTs
            endDate
            endTs
            limitedTo
            plannedTCU
            reminderSettings {
              recipients
              timeValue
              timeGranularity
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EventsListByDateParkGQL extends Apollo.Query<EventsListByDateParkQuery, EventsListByDateParkQueryVariables> {
    document = EventsListByDateParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePlannedEventDocument = gql`
    mutation deletePlannedEvent($_id: [ID!]!) {
  deletePlannedEvent(_id: $_id) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePlannedEventGQL extends Apollo.Mutation<DeletePlannedEventMutation, DeletePlannedEventMutationVariables> {
    document = DeletePlannedEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignProcessDocument = gql`
    mutation assignProcess($_id: [ID!]!, $_id_process: ID) {
  updatePlannedEvent(_id: $_id, _id_process: $_id_process) {
    data {
      _id
      _id_process
      title
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignProcessGQL extends Apollo.Mutation<AssignProcessMutation, AssignProcessMutationVariables> {
    document = AssignProcessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MassUpdateDocument = gql`
    mutation massUpdate($_id: [ID!]!, $title: String, $description: String, $startTs: Float, $endTs: Float) {
  updatePlannedEvent(
    _id: $_id
    title: $title
    description: $description
    startTs: $startTs
    endTs: $endTs
  ) {
    data {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MassUpdateGQL extends Apollo.Mutation<MassUpdateMutation, MassUpdateMutationVariables> {
    document = MassUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioEventsListDocument = gql`
    query PortfolioEventsList($start: Float!, $end: Float!, $portfolioId: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(where: {AND: [{startTs: {LTE: $end}}, {endTs: {GTE: $start}}]}) {
            _id
            _id_turbine
            _id_park
            _id_process
            creationTs
            durationShort
            description
            duration
            category
            title
            productionLoss
            revenueLoss
            provider
            startDate
            endDate
            startTs
            endTs
            limitedTo
            plannedTCU
            reminderSettings {
              recipients
              timeValue
              timeGranularity
            }
          }
          processes {
            _id
            title
            description
            _id_parks
            creationTs
            status
            _id_plannedEvents
            estimatedStartTs
            estimatedEndTs
          }
        }
      }
    }
    PARKS {
      _id
      name
      displayName
      TURBINES {
        name
        _id
        code: codeDisplay
        ratedPower
        PARK {
          _id
          displayName
          name
        }
      }
      COUNTRY {
        name
      }
      DATA {
        TIMESERIES {
          DATA_PLN {
            AVAILABILITY {
              availability(
                range: {start: $start, end: $end}
                samplingInterval: {unit: DAYS, value: 1}
              ) {
                dataValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioEventsListGQL extends Apollo.Query<PortfolioEventsListQuery, PortfolioEventsListQueryVariables> {
    document = PortfolioEventsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverviewPortfolioEventsDocument = gql`
    query OverviewPortfolioEvents($startTs: Float!, $endTs: Float!, $portfolioId: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            where: {AND: [{startTs: {LTE: $endTs}}, {endTs: {GTE: $startTs}}]}
          ) {
            _id
            _id_turbine
            _id_park
            _id_process
            category
            startTs
            endTs
            revenueLoss
            productionLoss
            category
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverviewPortfolioEventsGQL extends Apollo.Query<OverviewPortfolioEventsQuery, OverviewPortfolioEventsQueryVariables> {
    document = OverviewPortfolioEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverviewPortfolioLossesDocument = gql`
    query OverviewPortfolioLosses($startTs: Float!, $endTs: Float!, $portfolioId: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    name
    DATA {
      TIMESERIES {
        DATA_PLN {
          LOSSES {
            productionLossMaintenance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            revenueLossMaintenance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            productionLossRepairs(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            revenueLossRepairs(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            productionLossGridLimitation(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            revenueLossGridLimitation(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            productionLossEnvironmental(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            revenueLossEnvironmental(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            productionLossInspection(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            revenueLossInspection(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverviewPortfolioLossesGQL extends Apollo.Query<OverviewPortfolioLossesQuery, OverviewPortfolioLossesQueryVariables> {
    document = OverviewPortfolioLossesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverviewParkLossesDocument = gql`
    query OverviewParkLosses($startTs: Float!, $endTs: Float!, $parkName: String!) {
  PARKS(where: {name: {EQ: $parkName}}) {
    _id
    name
    DATA {
      TIMESERIES {
        DATA_PLN {
          AVAILABILITY {
            availability(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataValue
            }
          }
          LOSSES {
            productionLossMaintenance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            revenueLossMaintenance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            productionLossRepairs(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            revenueLossRepairs(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            productionLossGridLimitation(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            revenueLossGridLimitation(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            productionLossEnvironmental(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            revenueLossEnvironmental(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            productionLossInspection(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
            revenueLossInspection(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 7}
            ) {
              dataJSON {
                timestamp
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverviewParkLossesGQL extends Apollo.Query<OverviewParkLossesQuery, OverviewParkLossesQueryVariables> {
    document = OverviewParkLossesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessListPortfolioDocument = gql`
    query ProcessListPortfolio($portfolioId: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    DATA {
      TABLE {
        DATA_PLN {
          processes {
            _id
            id: _id
            title
            description
            _id_parks
            creationTs
            estimatedStartTs
            estimatedEndTs
            status
            plannedEventsIds: _id_plannedEvents
            tClassBlocksIds: _id_tClassBlocks
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessListPortfolioGQL extends Apollo.Query<ProcessListPortfolioQuery, ProcessListPortfolioQueryVariables> {
    document = ProcessListPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSelectedParksProcessesDocument = gql`
    query getSelectedParksProcesses($_id_parks: [String!]!) {
  PORTFOLIO {
    _id
    DATA {
      TABLE {
        DATA_PLN {
          processes(where: {_id_parks: {CONTAINS_ALL: $_id_parks}}) {
            _id
            title
            estimatedStartTs
            estimatedEndTs
            description
            status
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSelectedParksProcessesGQL extends Apollo.Query<GetSelectedParksProcessesQuery, GetSelectedParksProcessesQueryVariables> {
    document = GetSelectedParksProcessesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessParkListDocument = gql`
    query ProcessParkList($portfolioId: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    PARKS {
      _id
      name
      displayName
      COUNTRY {
        _id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessParkListGQL extends Apollo.Query<ProcessParkListQuery, ProcessParkListQueryVariables> {
    document = ProcessParkListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioProcessAnalyticsScheduleDocument = gql`
    query PortfolioProcessAnalyticsSchedule($startRange: Float, $endRange: Float, $_id_process: String!) {
  PORTFOLIO {
    _id
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            splittedLosess: true
            where: {AND: [{startTs: {LTE: $endRange}}, {endTs: {GTE: $startRange}}, {_id_process: {EQ: $_id_process}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            title
            description
            category
            startTs
            endTs
            duration
            productionLoss
            revenueLoss
            creationTs
          }
        }
        DATA_LGB {
          logbook_monthly(
            where: {AND: [{startTS: {LTE: $endRange}}, {endTS: {GTE: $startRange}}, {_id_process: {EQ: $_id_process}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            tcu
            log
            startTs: startTS
            endTs: endTS
            mutTS
            duration
            totalProductionLoss
            totalRevenueLoss
          }
        }
      }
    }
    PARKS {
      id: _id
      name: displayName
      TURBINES {
        id: _id
        name
        code: codeDisplay
        serialNumeric
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioProcessAnalyticsScheduleGQL extends Apollo.Query<PortfolioProcessAnalyticsScheduleQuery, PortfolioProcessAnalyticsScheduleQueryVariables> {
    document = PortfolioProcessAnalyticsScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessAnalyticsStartDatesDocument = gql`
    query ProcessAnalyticsStartDates($_id_process: String) {
  PORTFOLIO {
    _id
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(where: {_id_process: {EQ: $_id_process}}) {
            startTs
            endTs
          }
        }
        DATA_LGB {
          logbook_monthly(where: {_id_process: {EQ: $_id_process}}) {
            startTs: startTS
            endTs: endTS
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessAnalyticsStartDatesGQL extends Apollo.Query<ProcessAnalyticsStartDatesQuery, ProcessAnalyticsStartDatesQueryVariables> {
    document = ProcessAnalyticsStartDatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkProcessAnalyticsScheduleDocument = gql`
    query ParkProcessAnalyticsSchedule($startRange: Float, $endRange: Float, $_id_process: String!, $parkId: String) {
  PARKS(where: {_id: {EQ: $parkId}}) {
    name: displayName
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            splittedLosess: true
            where: {AND: [{startTs: {LTE: $endRange}}, {endTs: {GTE: $startRange}}, {_id_process: {EQ: $_id_process}}, {_id_park: {EQ: $parkId}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            title
            description
            category
            startTs
            endTs
            duration
            productionLoss
            revenueLoss
            creationTs
          }
        }
        DATA_LGB {
          logbook_monthly(
            where: {AND: [{startTS: {LTE: $endRange}}, {endTS: {GTE: $startRange}}, {_id_process: {EQ: $_id_process}}, {_id_park: {EQ: $parkId}}]}
          ) {
            id: _id
            turbineId: _id_turbine
            parkId: _id_park
            tcu
            log
            startTs: startTS
            endTs: endTS
            mutTS
            duration
            totalProductionLoss
            totalRevenueLoss
          }
        }
      }
    }
    TURBINES {
      id: _id
      name
      code: codeDisplay
      serialNumeric
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkProcessAnalyticsScheduleGQL extends Apollo.Query<ParkProcessAnalyticsScheduleQuery, ParkProcessAnalyticsScheduleQueryVariables> {
    document = ParkProcessAnalyticsScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessAnalyticsStartDatesParkDocument = gql`
    query ProcessAnalyticsStartDatesPark($_id_process: String, $parkId: String) {
  PARKS(where: {_id: {EQ: $parkId}}) {
    name: displayName
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(where: {_id_process: {EQ: $_id_process}}) {
            startTs
            endTs
          }
        }
        DATA_LGB {
          logbook_monthly(where: {_id_process: {EQ: $_id_process}}) {
            startTs: startTS
            endTs: endTS
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessAnalyticsStartDatesParkGQL extends Apollo.Query<ProcessAnalyticsStartDatesParkQuery, ProcessAnalyticsStartDatesParkQueryVariables> {
    document = ProcessAnalyticsStartDatesParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessesListDocument = gql`
    query ProcessesList($parkName: String!) {
  PARKS(where: {name: {EQ: $parkName}}) {
    name
    DATA {
      TABLE {
        DATA_PLN {
          processes {
            id: _id
            title
            description
            _id_parks
            creationTs
            status
            color
            plannedEventsIds: _id_plannedEvents
            tClassBlocksIds: _id_tClassBlocks
            estimatedStartTs
            estimatedEndTs
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessesListGQL extends Apollo.Query<ProcessesListQuery, ProcessesListQueryVariables> {
    document = ProcessesListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetParkIdDocument = gql`
    query getParkId($parkName: String!) {
  PARKS(where: {name: {EQ: $parkName}}) {
    _id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetParkIdGQL extends Apollo.Query<GetParkIdQuery, GetParkIdQueryVariables> {
    document = GetParkIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddNewProcessDocument = gql`
    mutation addNewProcess($_id_parks: [ID!]!, $title: String!, $description: String!, $estimatedStartTs: Float, $estimatedEndTs: Float, $color: String) {
  newProcess(
    _id_parks: $_id_parks
    title: $title
    description: $description
    estimatedStartTs: $estimatedStartTs
    estimatedEndTs: $estimatedEndTs
    color: $color
  ) {
    success
    error
    data {
      _id
      title
      description
      estimatedStartTs
      estimatedEndTs
      color
      status
      creationTs
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNewProcessGQL extends Apollo.Mutation<AddNewProcessMutation, AddNewProcessMutationVariables> {
    document = AddNewProcessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeProcessDocument = gql`
    mutation changeProcess($_id: ID!, $title: String, $description: String, $status: String, $estimatedStartTs: Float, $estimatedEndTs: Float, $color: String) {
  updateProcess(
    _id: $_id
    title: $title
    description: $description
    status: $status
    estimatedStartTs: $estimatedStartTs
    estimatedEndTs: $estimatedEndTs
    color: $color
  ) {
    success
    data {
      _id
      title
      status
      estimatedStartTs
      estimatedEndTs
      color
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeProcessGQL extends Apollo.Mutation<ChangeProcessMutation, ChangeProcessMutationVariables> {
    document = ChangeProcessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveProcessDocument = gql`
    mutation removeProcess($_id: ID!) {
  deleteProcess(_id: $_id) {
    data {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveProcessGQL extends Apollo.Mutation<RemoveProcessMutation, RemoveProcessMutationVariables> {
    document = RemoveProcessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbinesEventsListDocument = gql`
    query TurbinesEventsList($serialNumeric: Float!, $start: Float, $end: Float) {
  TURBINES(where: {serialNumeric: {EQ: $serialNumeric}}) {
    name
    _id
    code: codeDisplay
    ratedPower
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(where: {AND: [{startTs: {LTE: $end}}, {endTs: {GTE: $start}}]}) {
            _id
            _id_turbine
            _id_park
            _id_process
            creationTs
            durationShort
            duration
            description
            category
            title
            productionLoss
            revenueLoss
            provider
            startDate
            endDate
            startTs
            endTs
            limitedTo
            plannedTCU
            reminderSettings {
              recipients
              timeValue
              timeGranularity
            }
          }
        }
      }
    }
    PARK {
      _id
      name
      displayName
      DATA {
        TABLE {
          DATA_PLN {
            processes {
              _id
              _id_parks
              title
              description
              status
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbinesEventsListGQL extends Apollo.Query<TurbinesEventsListQuery, TurbinesEventsListQueryVariables> {
    document = TurbinesEventsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbinesEventsListByPlannedEventIdDocument = gql`
    query TurbinesEventsListByPlannedEventId($serialNumeric: Float!, $id: String) {
  TURBINES(where: {serialNumeric: {EQ: $serialNumeric}}) {
    name
    _id
    code: codeDisplay
    ratedPower
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(where: {_id: {EQ: $id}}) {
            _id
            _id_turbine
            _id_park
            _id_process
            creationTs
            durationShort
            duration
            description
            category
            title
            productionLoss
            revenueLoss
            startDate
            endDate
            startTs
            endTs
            limitedTo
            plannedTCU
            reminderSettings {
              recipients
              timeValue
              timeGranularity
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbinesEventsListByPlannedEventIdGQL extends Apollo.Query<TurbinesEventsListByPlannedEventIdQuery, TurbinesEventsListByPlannedEventIdQueryVariables> {
    document = TurbinesEventsListByPlannedEventIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ComparisonChartDocument = gql`
    query ComparisonChart($code: String!, $startTs: Float!, $endTs: Float!, $turbines: [String!]) {
  PARKS(where: {code: {EQ: $code}}, turbines: $turbines) {
    TURBINES {
      code: codeDisplay
      serial
      ratedPower
      DATA {
        TABLE {
          DATA_ALX {
            alarms(where: {AND: [{createTS: {GT: $startTs}}, {createTS: {LT: $endTs}}]}) {
              TURBINE {
                code: codeDisplay
                serial
              }
              isOpen
              code
              description
              createTS
              closeTS
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ComparisonChartGQL extends Apollo.Query<ComparisonChartQuery, ComparisonChartQueryVariables> {
    document = ComparisonChartDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ComparativeTablePortfolioDocument = gql`
    query ComparativeTablePortfolio($year: Int!, $portfolioId: String!, $timezone: String) {
  PORTFOLIO(where: {_id: $portfolioId}) {
    DATA {
      TABLE {
        DATA_BGD(timezone: $timezone, year: $year) {
          budget_by_park_month {
            production: productionBudget
            revenue: revenueBudget
            month
            year
            PARK {
              _id
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ComparativeTablePortfolioGQL extends Apollo.Query<ComparativeTablePortfolioQuery, ComparativeTablePortfolioQueryVariables> {
    document = ComparativeTablePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EventsReportsDocument = gql`
    query EventsReports($startTs: Float!, $endTs: Float!, $parkName: String!) {
  PARKS(where: {code: {EQ: $parkName}}) {
    _id
    name
    DATA {
      TABLE {
        DATA_PLN {
          planned_events(
            where: {AND: [{startTs: {LTE: $endTs}}, {endTs: {GTE: $startTs}}]}
          ) {
            category
            startTs
            endTs
          }
        }
      }
      TIMESERIES {
        DATA_PLN {
          AVAILABILITY {
            availability(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataValue
            }
          }
          LOSSES {
            productionLossMaintenance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataJSON {
                value
              }
            }
            revenueLossMaintenance(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataJSON {
                value
              }
            }
            productionLossRepairs(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataJSON {
                value
              }
            }
            revenueLossRepairs(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataJSON {
                value
              }
            }
            productionLossGridLimitation(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataJSON {
                value
              }
            }
            revenueLossGridLimitation(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataJSON {
                value
              }
            }
            productionLossEnvironmental(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataJSON {
                value
              }
            }
            revenueLossEnvironmental(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataJSON {
                value
              }
            }
            productionLossInspection(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataJSON {
                value
              }
            }
            revenueLossInspection(
              range: {start: $startTs, end: $endTs}
              samplingInterval: {unit: DAYS, value: 1}
            ) {
              dataJSON {
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EventsReportsGQL extends Apollo.Query<EventsReportsQuery, EventsReportsQueryVariables> {
    document = EventsReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SummaryDocument = gql`
    query summary($park: String!) {
  PARKS(where: {code: {EQ: $park}}) {
    displayName
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: MW) {
              value
            }
          }
        }
      }
    }
    TURBINES {
      type
      hubHeight
      comissioningDate
      ratedPower
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SummaryGQL extends Apollo.Query<SummaryQuery, SummaryQueryVariables> {
    document = SummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioSummaryDocument = gql`
    query portfolioSummary($portfolio: String!, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolio}, parks: $parks) {
    name
    DATA {
      SNAPSHOT {
        DATA_30S {
          TURBINE {
            W_rated(convert: MW) {
              value
            }
          }
        }
      }
    }
    PARKS {
      DATA {
        SNAPSHOT {
          DATA_30S {
            TURBINE {
              W_rated(convert: MW) {
                value
              }
            }
          }
        }
      }
      TURBINES {
        _id
      }
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioSummaryGQL extends Apollo.Query<PortfolioSummaryQuery, PortfolioSummaryQueryVariables> {
    document = PortfolioSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmComparisonDocument = gql`
    subscription AlarmComparison($serialNumeric: Float!, $code: String) {
  TURBINES(where: {serialNumeric: {EQ: $serialNumeric}}) {
    code: codeDisplay
    DATA {
      TABLE {
        DATA_ALX {
          actualAlarm: alarms(where: {code: {EQ: $code}}) {
            code
            description
            count: duration(aggregation: COUNT)
            duration(aggregation: SUM)
            avgDuration: duration(aggregation: AVG)
            productionLoss: powerLosses(aggregation: SUM)
            averageProductionLoss: powerLosses(aggregation: AVG)
          }
          allAlarms: alarms {
            count: code(aggregation: COUNT)
            duration(aggregation: SUM)
            avgDuration: duration(aggregation: AVG)
            productionLoss: powerLosses(aggregation: SUM)
            averageProductionLoss: powerLosses(aggregation: AVG)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmComparisonGQL extends Apollo.Subscription<AlarmComparisonSubscription, AlarmComparisonSubscriptionVariables> {
    document = AlarmComparisonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioAlarmStatisticsDocument = gql`
    query PortfolioAlarmStatistics($orderBy: DATA_ALX_OrderByInput = {duration: DESC}, $filter: DATA_ALX_TableWhereInput, $limit: Int, $offset: Int, $id: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $id}, parks: $parks) {
    _id
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(orderBy: $orderBy, where: $filter, limit: $limit, offset: $offset) {
            code
            description
            alarmCategory
            count: duration(aggregation: COUNT)
            avgDuration: duration(aggregation: AVG)
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
          }
          totalAlarms: alarms(where: $filter) {
            code
            description
            alarmCategory
            count: duration(aggregation: COUNT)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioAlarmStatisticsGQL extends Apollo.Query<PortfolioAlarmStatisticsQuery, PortfolioAlarmStatisticsQueryVariables> {
    document = PortfolioAlarmStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkAlarmStatisticsDocument = gql`
    query ParkAlarmStatistics($name: String!, $orderBy: DATA_ALX_OrderByInput = {duration: DESC}, $filter: DATA_ALX_TableWhereInput, $limit: Int, $offset: Int, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbines) {
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(orderBy: $orderBy, where: $filter, limit: $limit, offset: $offset) {
            code
            description
            alarmCategory
            alarmCount: duration(aggregation: COUNT)
            avgDuration: duration(aggregation: AVG)
            duration(aggregation: SUM)
            powerLossesSum: powerLosses(aggregation: SUM)
            powerLossesAvg: powerLosses(aggregation: AVG)
          }
          totalAlarms: alarms(where: $filter) {
            code
            description
            alarmCategory
            count: duration(aggregation: COUNT)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkAlarmStatisticsGQL extends Apollo.Query<ParkAlarmStatisticsQuery, ParkAlarmStatisticsQueryVariables> {
    document = ParkAlarmStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineAlarmStatisticsDocument = gql`
    query TurbineAlarmStatistics($serialNumeric: Float!, $orderBy: DATA_ALX_OrderByInput = {duration: DESC}, $filter: DATA_ALX_TableWhereInput, $limit: Int, $offset: Int) {
  TURBINES(where: {serialNumeric: {EQ: $serialNumeric}}) {
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(orderBy: $orderBy, where: $filter, limit: $limit, offset: $offset) {
            code
            description
            alarmCategory
            count: duration(aggregation: COUNT)
            avgDuration: duration(aggregation: AVG)
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
          }
          totalAlarms: alarms(where: $filter) {
            code
            description
            alarmCategory
            count: duration(aggregation: COUNT)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineAlarmStatisticsGQL extends Apollo.Query<TurbineAlarmStatisticsQuery, TurbineAlarmStatisticsQueryVariables> {
    document = TurbineAlarmStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineAlarmsKpIsDocument = gql`
    query TurbineAlarmsKPIs($serialNumeric: Float!, $filter: DATA_ALX_TableWhereInput) {
  TURBINES(where: {serialNumeric: {EQ: $serialNumeric}}) {
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(where: $filter) {
            count: duration(aggregation: COUNT)
            avgDuration: duration(aggregation: AVG)
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineAlarmsKpIsGQL extends Apollo.Query<TurbineAlarmsKpIsQuery, TurbineAlarmsKpIsQueryVariables> {
    document = TurbineAlarmsKpIsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioAlarmsKpIsDocument = gql`
    query PortfolioAlarmsKPIs($filter: DATA_ALX_TableWhereInput, $id: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $id}, parks: $parks) {
    _id
    name
    PARKS {
      TURBINES {
        name
      }
    }
    DATA {
      TABLE {
        DATA_ALX {
          alarms(where: $filter) {
            count: duration(aggregation: COUNT)
            avgDuration: duration(aggregation: AVG)
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioAlarmsKpIsGQL extends Apollo.Query<PortfolioAlarmsKpIsQuery, PortfolioAlarmsKpIsQueryVariables> {
    document = PortfolioAlarmsKpIsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkAlarmsKpIsDocument = gql`
    query ParkAlarmsKPIs($name: String!, $filter: DATA_ALX_TableWhereInput, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbines) {
    name
    TURBINES {
      name
    }
    DATA {
      TABLE {
        DATA_ALX {
          alarms(where: $filter) {
            count: duration(aggregation: COUNT)
            avgDuration: duration(aggregation: AVG)
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkAlarmsKpIsGQL extends Apollo.Query<ParkAlarmsKpIsQuery, ParkAlarmsKpIsQueryVariables> {
    document = ParkAlarmsKpIsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsGroupByCategoryDocument = gql`
    query AlarmsGroupByCategory($serialNav: Float!, $filter: DATA_ALX_TableWhereInput) {
  TURBINES(where: {serialNumeric: {EQ: $serialNav}}) {
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(where: $filter) {
            alarmCategory
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsGroupByCategoryGQL extends Apollo.Query<AlarmsGroupByCategoryQuery, AlarmsGroupByCategoryQueryVariables> {
    document = AlarmsGroupByCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsGroupByCodeDocument = gql`
    query AlarmsGroupByCode($serialNav: Float!, $filter: DATA_ALX_TableWhereInput, $orderBy: DATA_ALX_OrderByInput, $limit: Int) {
  TURBINES(where: {serialNumeric: {EQ: $serialNav}}) {
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(where: $filter, orderBy: $orderBy, limit: $limit) {
            code
            description
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsGroupByCodeGQL extends Apollo.Query<AlarmsGroupByCodeQuery, AlarmsGroupByCodeQueryVariables> {
    document = AlarmsGroupByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkGroupByCodeDocument = gql`
    query AlarmsParkGroupByCode($name: String!, $filter: DATA_ALX_TableWhereInput, $orderBy: DATA_ALX_OrderByInput, $limit: Int, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbines) {
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(where: $filter, orderBy: $orderBy, limit: $limit) {
            code
            description
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkGroupByCodeGQL extends Apollo.Query<AlarmsParkGroupByCodeQuery, AlarmsParkGroupByCodeQueryVariables> {
    document = AlarmsParkGroupByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkGroupByCategoryDocument = gql`
    query AlarmsParkGroupByCategory($name: String!, $filter: DATA_ALX_TableWhereInput, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbines) {
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(where: $filter) {
            alarmCategory
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkGroupByCategoryGQL extends Apollo.Query<AlarmsParkGroupByCategoryQuery, AlarmsParkGroupByCategoryQueryVariables> {
    document = AlarmsParkGroupByCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioGroupByCategoryDocument = gql`
    query AlarmsPortfolioGroupByCategory($filter: DATA_ALX_TableWhereInput, $id: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $id}, parks: $parks) {
    _id
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(where: $filter) {
            alarmCategory
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioGroupByCategoryGQL extends Apollo.Query<AlarmsPortfolioGroupByCategoryQuery, AlarmsPortfolioGroupByCategoryQueryVariables> {
    document = AlarmsPortfolioGroupByCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioGroupByCodeDocument = gql`
    query AlarmsPortfolioGroupByCode($filter: DATA_ALX_TableWhereInput, $orderBy: DATA_ALX_OrderByInput, $limit: Int, $id: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $id}, parks: $parks) {
    _id
    name
    DATA {
      TABLE {
        DATA_ALX {
          alarms(where: $filter, orderBy: $orderBy, limit: $limit) {
            code
            description
            duration(aggregation: SUM)
            powerLosses(aggregation: SUM)
            totalRevenueLoss(aggregation: SUM)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioGroupByCodeGQL extends Apollo.Query<AlarmsPortfolioGroupByCodeQuery, AlarmsPortfolioGroupByCodeQueryVariables> {
    document = AlarmsPortfolioGroupByCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmStatsDocument = gql`
    query AlarmStats($code: String!) {
  PORTFOLIO {
    _id
    PARKS {
      name
      TURBINES {
        serialNumeric
        DATA {
          TABLE {
            DATA_ALX {
              actualAlarm: alarms(where: {code: {EQ: $code}}) {
                code
                count: duration(aggregation: COUNT)
                duration(aggregation: SUM)
                avgDuration: duration(aggregation: AVG)
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmStatsGQL extends Apollo.Query<AlarmStatsQuery, AlarmStatsQueryVariables> {
    document = AlarmStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OutageFactorPortfolioDocument = gql`
    query OutageFactorPortfolio($fromTs: Float, $toTs: Float, $rollingMonthFromTs: Float, $rollingMonthToTs: Float, $lastRollingMonthFromTs: Float, $lastRollingMonthToTs: Float, $portfolioId: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    name
    DATA {
      TABLE {
        availabilityInfo: DATA_ALX_DAILY {
          totalPrevious30DaysPortfolio: alarms(
            where: {AND: [{createTS: {GTE: $lastRollingMonthFromTs}}, {closeTS: {LTE: $lastRollingMonthToTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalPortfolio: alarms(
            where: {AND: [{createTS: {GTE: $fromTs}}, {closeTS: {LTE: $toTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          Last30DaysPortfolio: alarms(
            where: {AND: [{createTS: {GTE: $rollingMonthFromTs}}, {closeTS: {LTE: $rollingMonthToTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OutageFactorPortfolioGQL extends Apollo.Query<OutageFactorPortfolioQuery, OutageFactorPortfolioQueryVariables> {
    document = OutageFactorPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OutageFactorPortfolioTurbineDocument = gql`
    query OutageFactorPortfolioTurbine($fromTs: Float, $toTs: Float, $rollingMonthFromTs: Float, $rollingMonthToTs: Float, $lastRollingMonthFromTs: Float, $lastRollingMonthToTs: Float, $portfolioId: String) {
  PORTFOLIO(where: {_id: $portfolioId}) {
    _id
    DATA {
      TABLE {
        availabilityInfo: DATA_ALX_DAILY {
          Last30DaysTurbine: alarms(
            where: {AND: [{createTS: {GTE: $rollingMonthFromTs}}, {closeTS: {LTE: $rollingMonthToTs}}]}
          ) {
            TURBINE {
              name
              serialNumeric
              code: codeDisplay
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalTurbine: alarms(
            where: {AND: [{createTS: {GTE: $fromTs}}, {closeTS: {LTE: $toTs}}]}
          ) {
            TURBINE {
              name
              serialNumeric
              code: codeDisplay
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalPrevious30DaysTurbine: alarms(
            where: {AND: [{createTS: {GTE: $lastRollingMonthFromTs}}, {closeTS: {LTE: $lastRollingMonthToTs}}]}
          ) {
            TURBINE {
              name
              serialNumeric
              code: codeDisplay
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OutageFactorPortfolioTurbineGQL extends Apollo.Query<OutageFactorPortfolioTurbineQuery, OutageFactorPortfolioTurbineQueryVariables> {
    document = OutageFactorPortfolioTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OutageFactorPortfolioParkDocument = gql`
    query OutageFactorPortfolioPark($fromTs: Float, $toTs: Float, $rollingMonthFromTs: Float, $rollingMonthToTs: Float, $lastRollingMonthFromTs: Float, $lastRollingMonthToTs: Float, $portfolioId: String, $parks: [String!]) {
  PORTFOLIO(where: {_id: $portfolioId}, parks: $parks) {
    _id
    name
    DATA {
      TABLE {
        availabilityInfo: DATA_ALX_DAILY {
          totalPrevious30DaysPortfolio: alarms(
            where: {AND: [{createTS: {GTE: $lastRollingMonthFromTs}}, {closeTS: {LTE: $lastRollingMonthToTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalPortfolio: alarms(
            where: {AND: [{createTS: {GTE: $fromTs}}, {closeTS: {LTE: $toTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          Last30DaysPortfolio: alarms(
            where: {AND: [{createTS: {GTE: $rollingMonthFromTs}}, {closeTS: {LTE: $rollingMonthToTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalPark: alarms(
            where: {AND: [{createTS: {LT: $toTs}}, {closeTS: {GT: $fromTs}}]}
          ) {
            PARK {
              name
              code
              displayCode
              TURBINES {
                name
              }
            }
            turbineCode(aggregation: COUNT)
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          Last30DaysPark: alarms(
            where: {AND: [{createTS: {LT: $rollingMonthToTs}}, {closeTS: {GT: $rollingMonthFromTs}}]}
          ) {
            PARK {
              name
              code
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalPrevious30DaysPark: alarms(
            where: {AND: [{createTS: {GTE: $lastRollingMonthFromTs}}, {closeTS: {LTE: $lastRollingMonthToTs}}]}
          ) {
            PARK {
              name
              code
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          Last30DaysTurbine: alarms(
            where: {AND: [{createTS: {GTE: $rollingMonthFromTs}}, {closeTS: {LTE: $rollingMonthToTs}}]}
          ) {
            TURBINE {
              name
              serialNumeric
              code: codeDisplay
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalTurbine: alarms(
            where: {AND: [{createTS: {GTE: $fromTs}}, {closeTS: {LTE: $toTs}}]}
          ) {
            TURBINE {
              name
              serialNumeric
              code: codeDisplay
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalPrevious30DaysTurbine: alarms(
            where: {AND: [{createTS: {GTE: $lastRollingMonthFromTs}}, {closeTS: {LTE: $lastRollingMonthToTs}}]}
          ) {
            TURBINE {
              name
              serialNumeric
              code: codeDisplay
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OutageFactorPortfolioParkGQL extends Apollo.Query<OutageFactorPortfolioParkQuery, OutageFactorPortfolioParkQueryVariables> {
    document = OutageFactorPortfolioParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OutageFactorParkDocument = gql`
    query OutageFactorPark($name: String, $fromTs: Float, $toTs: Float, $rollingMonthFromTs: Float, $rollingMonthToTs: Float, $lastRollingMonthFromTs: Float, $lastRollingMonthToTs: Float, $turbines: [String!]) {
  PARKS(where: {name: {EQ: $name}}, turbines: $turbines) {
    name
    code
    displayCode
    DATA {
      TABLE {
        availabilityInfo: DATA_ALX_DAILY {
          total: alarms(
            where: {AND: [{createTS: {GTE: $fromTs}}, {closeTS: {LTE: $toTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalLast30Days: alarms(
            where: {AND: [{createTS: {GTE: $rollingMonthFromTs}}, {closeTS: {LTE: $rollingMonthToTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalPrevious30Days: alarms(
            where: {AND: [{createTS: {GTE: $lastRollingMonthFromTs}}, {closeTS: {LTE: $lastRollingMonthToTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
        }
      }
    }
    PERTURBINE: DATA {
      TABLE {
        availabilityInfo: DATA_ALX_DAILY {
          total: alarms(
            where: {AND: [{createTS: {GTE: $fromTs}}, {closeTS: {LTE: $toTs}}]}
          ) {
            TURBINE {
              name
              code: codeDisplay
              serialNumeric
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalLast30Days: alarms(
            where: {AND: [{createTS: {GTE: $rollingMonthFromTs}}, {closeTS: {LTE: $rollingMonthToTs}}]}
          ) {
            TURBINE {
              name
              code: codeDisplay
              serialNumeric
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalPrevious30Days: alarms(
            where: {AND: [{createTS: {GTE: $lastRollingMonthFromTs}}, {closeTS: {LTE: $lastRollingMonthToTs}}]}
          ) {
            TURBINE {
              name
              code: codeDisplay
              serialNumeric
            }
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OutageFactorParkGQL extends Apollo.Query<OutageFactorParkQuery, OutageFactorParkQueryVariables> {
    document = OutageFactorParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OutageFactorTurbineDocument = gql`
    query OutageFactorTurbine($serialNumeric: Float!, $fromTs: Float, $toTs: Float, $rollingMonthFromTs: Float, $rollingMonthToTs: Float, $lastRollingMonthFromTs: Float, $lastRollingMonthToTs: Float) {
  TURBINES(where: {serialNumeric: {EQ: $serialNumeric}}) {
    serialNumeric
    code: codeDisplay
    DATA {
      TABLE {
        availabilityInfo: DATA_ALX_DAILY {
          total: alarms(
            where: {AND: [{createTS: {GTE: $fromTs}}, {closeTS: {LTE: $toTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalLast30Days: alarms(
            where: {AND: [{createTS: {GTE: $rollingMonthFromTs}}, {closeTS: {LTE: $rollingMonthToTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
          totalPrevious30Days: alarms(
            where: {AND: [{createTS: {GTE: $lastRollingMonthFromTs}}, {closeTS: {LTE: $lastRollingMonthToTs}}]}
          ) {
            alarmDurationTotal: duration(aggregation: SUM)
            alarmCountTotal: duration(aggregation: COUNT)
            durationDurationAvg: duration(aggregation: AVG)
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OutageFactorTurbineGQL extends Apollo.Query<OutageFactorTurbineQuery, OutageFactorTurbineQueryVariables> {
    document = OutageFactorTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }